
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired477"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired477"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("kDPMK", function(module, exports) {

$parcel$export(module.exports, "CatchupContentType", () => $d88abdc21cda6ee4$export$fe6033382a69eea9);
/* tslint:disable */ /* eslint-disable */ // This file was automatically generated and should not be edited.
//==============================================================
// START Enums and Input Objects
//==============================================================
var $d88abdc21cda6ee4$export$fe6033382a69eea9 = /*#__PURE__*/ function(CatchupContentType) {
    CatchupContentType["BLOGPOST"] = "BLOGPOST";
    CatchupContentType["PAGE"] = "PAGE";
    return CatchupContentType;
}({});

});

parcelRegister("c5UND", function(module, exports) {

$parcel$export(module.exports, "CatchupLastViewedTimeQuery", () => $9d85e6be56a29803$export$ac7d0fb8d79f29ea);

var $d2LG0 = parcelRequire("d2LG0");
const $9d85e6be56a29803$export$ac7d0fb8d79f29ea = (0, $d2LG0.default)`query CatchupLastViewedTimeQuery($contentId:ID!$contentType:CatchupContentType!){catchupGetLastViewedTime(contentId:$contentId contentType:$contentType){lastViewedTimeISO}}`;

});

parcelRegister("d282Z", function(module, exports) {

$parcel$export(module.exports, "ONBOARDING_INSIGHTS", () => $a18eeb1d05dccc62$export$fc9b2402bb5adac2);
const $a18eeb1d05dccc62$export$fc9b2402bb5adac2 = {
    CONTEXTUAL_FLOATING_BUTTON_NUDGE: 'onboarding-insights:hasContextualFloatingButtonBeenSeen',
    AUDIO_BRIEFING: 'onboarding-insights:hasAudioBriefingChangeboardingBeenSeen'
};

});

parcelRegister("8xyMM", function(module, exports) {

$parcel$export(module.exports, "AIFloatingContextMenuLoadable", () => $77cf0a7fedc3bcc9$export$9533f8bbe7f6f635);
$parcel$export(module.exports, "AIFloatingContextMenu", () => (parcelRequire("iIQbF")).AIFloatingContextMenu);
$parcel$export(module.exports, "useCreateObjectSidebarProp", () => (parcelRequire("13dFh")).useCreateObjectSidebarProp);
$parcel$export(module.exports, "AISmartButtonStateHandler", () => (parcelRequire("R0evY")).AISmartButtonStateHandler);
$parcel$export(module.exports, "AISmartButtonWrapper", () => (parcelRequire("5PobO")).AISmartButtonWrapper);

var $jmjWc = parcelRequire("jmjWc");

var $iIQbF = parcelRequire("iIQbF");


var $13dFh = parcelRequire("13dFh");

var $R0evY = parcelRequire("R0evY");

var $5PobO = parcelRequire("5PobO");

const $77cf0a7fedc3bcc9$export$9533f8bbe7f6f635 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "Fmwl8",
    name: "AIFloatingContextMenuLoadable",
    loader: async ()=>(await Promise.resolve((parcelRequire("iIQbF")))).AIFloatingContextMenu
});

});
parcelRegister("iIQbF", function(module, exports) {

$parcel$export(module.exports, "AIFloatingContextMenu", () => $b3acdd5624bc36ae$export$71951c424ee8d4c2);
/* AIFloatingContextMenu.tsx generated by @compiled/babel-plugin v0.36.1 */ /** @jsxFrag */ 
var $35pXk = parcelRequire("35pXk");

var $gwFzn = parcelRequire("gwFzn");

var $dBxQj = parcelRequire("dBxQj");

var $6f0Oj = parcelRequire("6f0Oj");
var $ecnYn = parcelRequire("ecnYn");

var $lGgRw = parcelRequire("lGgRw");

var $inPa6 = parcelRequire("inPa6");

var $6cnUO = parcelRequire("6cnUO");
var $5izcQ = parcelRequire("5izcQ");
var $2Fndw = parcelRequire("2Fndw");

var $lzcvT = parcelRequire("lzcvT");

var $3J7nf = parcelRequire("3J7nf");

var $1ytiN = parcelRequire("1ytiN");

var $euL71 = parcelRequire("euL71");

var $dIouf = parcelRequire("dIouf");

var $3Am3T = parcelRequire("3Am3T");

var $ly2zj = parcelRequire("ly2zj");

var $bQm3c = parcelRequire("bQm3c");

var $52id1 = parcelRequire("52id1");
var $6zNhq = parcelRequire("6zNhq");

var $7mpOv = parcelRequire("7mpOv");

var $jmjWc = parcelRequire("jmjWc");

var $2OYqV = parcelRequire("2OYqV");

var $5PeEy = parcelRequire("5PeEy");

var $94XxL = parcelRequire("94XxL");

var $8XJjZ = parcelRequire("8XJjZ");

var $7VRT3 = parcelRequire("7VRT3");

var $8E5UF = parcelRequire("8E5UF");

var $gHbiI = parcelRequire("gHbiI");

var $7nXd3 = parcelRequire("7nXd3");

const $b3acdd5624bc36ae$var$AIButtonSpotlight = (0, $jmjWc.LoadableBackground)({
    __loadable_id__: "5rWnu",
    name: "AIButtonSpotlight",
    loader: async ()=>(await (parcelRequire("3FvXy"))).AIButtonSpotlight
});
const $b3acdd5624bc36ae$var$absoluteWrapperStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    position: 'absolute',
    right: 'space.150',
    bottom: 'space.0'
});
const $b3acdd5624bc36ae$var$FloatingContextMenuStyles = null;
const $b3acdd5624bc36ae$var$dynamicActionTextMap = {
    [(0, $7nXd3.PopupStateTypes).QuickSummary]: (0, $8E5UF.i18n).summarizeSectionLabel,
    [(0, $7nXd3.PopupStateTypes).Comments]: (0, $8E5UF.i18n).inlineCommentsMenuItemLabel,
    [(0, $7nXd3.PopupStateTypes).PageCatchup]: (0, $8E5UF.i18n).pageCatchupMenuItemLabel,
    [(0, $7nXd3.PopupStateTypes).AIPresentationGeneration]: (0, $8E5UF.i18n).aiPresentationGenerationMenuItemLabel,
    [(0, $7nXd3.PopupStateTypes).BulkIssueCreate]: (0, $8E5UF.i18n).bulkIssueCreateMenuItemLabel
};
const $b3acdd5624bc36ae$var$AIFloatingContextMenuWrapped = ({ contentId: contentId, contentType: contentType, spaceKey: spaceKey, lastModifiedDate: lastModifiedDate = '', pageCommentsSectionInView: pageCommentsSectionInView = false, isLivePage: isLivePage = false, isInObjectSideBar: isInObjectSideBar = false })=>{
    const intl = (0, $dBxQj.default)();
    const [isOpen, setIsOpen] = (0, $gwFzn.useState)(false);
    const { edition: edition, isAdminHubAIEnabled: isAdminHubAIEnabled } = (0, $bQm3c.useSessionData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [popupState, setPopupState] = (0, $gwFzn.useState)((0, $7nXd3.PopupStateTypes).Menu);
    const { dynamicActionTarget: dynamicActionTarget, queryError: queryError } = (0, $5PeEy.useDynamicAIContext)(contentId, contentType, pageCommentsSectionInView && !isLivePage, isLivePage);
    const { pulseCount: pulseCount } = (0, $94XxL.useAIFloatingButtonNudge)(contentId, contentType);
    const { isSiteAdmin: isSiteAdmin } = (0, $gwFzn.useContext)((0, $1ytiN.SPAViewContext));
    const { isDismissed: isDismissed } = (0, $6zNhq.useQuickstartState)();
    const { isQuickstartEligible: isQuickstartEligible } = (0, $52id1.useQuickstartEligible)();
    const isQuickStartPillShowing = !isDismissed && isQuickstartEligible();
    const { isAIEnabledForContent: isAIEnabledForContent } = (0, $7mpOv.useIsAIEnabledForContent)({
        contentId: contentId
    });
    const isDynamicActionSelected = isOpen && popupState !== (0, $7nXd3.PopupStateTypes).Menu;
    const { aiButtonTour: { isVisible: isVisible, complete: completeSpotlight } } = (0, $3J7nf.useLiveDocChangeboarding)();
    const showSpotlight = isVisible && isAIEnabledForContent && !isQuickStartPillShowing;
    const isEnabled = !(0, $lzcvT.isFedRamp)() && (isAIEnabledForContent || isSiteAdmin && !isAdminHubAIEnabled || edition !== (0, $euL71.ConfluenceEdition).PREMIUM && !isAdminHubAIEnabled);
    const getDynamicActionText = ()=>{
        if (dynamicActionTarget && !isOpen) return intl.formatMessage($b3acdd5624bc36ae$var$dynamicActionTextMap[dynamicActionTarget]);
        else if (isOpen && (0, $7nXd3.isFeaturePopupState)(popupState)) return intl.formatMessage($b3acdd5624bc36ae$var$dynamicActionTextMap[popupState]);
        else return undefined;
    };
    const [prevDynamicActionTarget, setPrevDynamicActionTarget] = (0, $gwFzn.useState)(null);
    if (dynamicActionTarget !== prevDynamicActionTarget) {
        setPrevDynamicActionTarget(dynamicActionTarget);
        if (dynamicActionTarget) createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: 'shown',
                actionSubject: 'button',
                actionSubjectId: 'aiDynamicActionButton',
                source: 'page',
                attributes: {
                    contentId: contentId,
                    dynamicActionTarget: dynamicActionTarget,
                    isLivePage: isLivePage
                }
            }
        }).fire();
    }
    const onClose = (0, $gwFzn.useCallback)(()=>{
        setIsOpen(false);
        setPopupState((0, $7nXd3.PopupStateTypes).Menu);
    }, []);
    const onDynamicActionClick = (0, $gwFzn.useCallback)(()=>{
        if (isOpen) onClose();
        else if (dynamicActionTarget) {
            setIsOpen(true);
            setPopupState(dynamicActionTarget);
        }
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'page',
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'aiDynamicActionButton',
                attributes: {
                    contentId: contentId,
                    dynamicActionTarget: dynamicActionTarget,
                    toggleClose: isOpen,
                    isLivePage: isLivePage
                }
            }
        }).fire();
    }, [
        contentId,
        createAnalyticsEvent,
        isOpen,
        onClose,
        dynamicActionTarget,
        isLivePage
    ]);
    const onMenuButtonClick = (0, $gwFzn.useCallback)(()=>{
        if (isOpen && popupState !== (0, $7nXd3.PopupStateTypes).Menu && isAdminHubAIEnabled) setPopupState((0, $7nXd3.PopupStateTypes).Menu);
        else if (isOpen) onClose();
        else if (!isAdminHubAIEnabled && edition !== (0, $euL71.ConfluenceEdition).PREMIUM) {
            setIsOpen(true);
            setPopupState((0, $7nXd3.PopupStateTypes).Upsell);
        } else if (!isAdminHubAIEnabled && isSiteAdmin) {
            setIsOpen(true);
            setPopupState((0, $7nXd3.PopupStateTypes).OptIn);
        } else setIsOpen(true);
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'page',
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'aiActionMenuButton',
                attributes: {
                    contentId: contentId,
                    edition: edition,
                    toggleClose: isOpen,
                    isLivePage: isLivePage
                }
            }
        }).fire();
    }, [
        contentId,
        createAnalyticsEvent,
        edition,
        isOpen,
        onClose,
        popupState,
        isAdminHubAIEnabled,
        isSiteAdmin,
        isLivePage
    ]);
    const onSpotlightDismissed = (0, $gwFzn.useCallback)(()=>{
        completeSpotlight();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'aiButtonSpotlight',
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'dismiss',
                attributes: {
                    isLivePage: isLivePage
                }
            }
        }).fire();
    }, [
        completeSpotlight,
        isLivePage,
        createAnalyticsEvent
    ]);
    const popupComponent = ()=>{
        if (popupState === (0, $7nXd3.PopupStateTypes).Menu) return 0, $7VRT3.AIFloatingContextMenuPopupContainer;
        return 0, $ly2zj.CustomPopupContainer;
    };
    (0, $gwFzn.useEffect)(()=>{
        if (showSpotlight) createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'shown',
                actionSubject: 'spotlight',
                actionSubjectId: 'aiButtonSpotlight',
                source: 'aiButtonSpotlight'
            }
        }).fire();
    }, [
        showSpotlight,
        createAnalyticsEvent
    ]);
    if (isQuickStartPillShowing || !isEnabled) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6cnUO.default), null, queryError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.ErrorDisplay), {
        error: queryError
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $lGgRw.default), {
        isOpen: isOpen,
        onClose: onClose,
        offset: [
            0,
            6
        ],
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gHbiI.AIFloatingContextMenuPopupContent), {
                popupState: popupState,
                contentId: contentId,
                contentType: contentType,
                spaceKey: spaceKey,
                lastModifiedDate: lastModifiedDate ?? '',
                source: "view-page",
                onClose: onClose,
                setPopupState: setPopupState,
                setIsOpen: setIsOpen,
                isLivePage: isLivePage
            }),
        shouldRenderToParent: true,
        placement: "top-end",
        popupComponent: popupComponent(),
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $2OYqV.ContextualButtonPulse), {
                pulseCount: pulseCount,
                isInObjectSideBar: isInObjectSideBar
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5izcQ.default), {
                name: "ai-floating-button"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $8XJjZ.AIFloatingSplitButton), {
                isDynamicActionSelected: isDynamicActionSelected,
                triggerProps: triggerProps,
                onMenuButtonClick: onMenuButtonClick,
                onDynamicActionClick: onDynamicActionClick,
                dynamicActionText: getDynamicActionText(),
                isMenuOpen: isOpen && popupState === (0, $7nXd3.PopupStateTypes).Menu,
                isInObjectSideBar: isInObjectSideBar
            })))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $2Fndw.default), null, showSpotlight && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($b3acdd5624bc36ae$var$AIButtonSpotlight, {
        onSpotlightDismissed: onSpotlightDismissed
    }))));
};
const $b3acdd5624bc36ae$export$71951c424ee8d4c2 = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.ErrorBoundary), {
        attribution: (0, $dIouf.Attribution).SMARTS
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $3Am3T.CommentCountsProvider), {
        contentId: props.contentId
    }, props.isInObjectSideBar ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($b3acdd5624bc36ae$var$AIFloatingContextMenuWrapped, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: $b3acdd5624bc36ae$var$absoluteWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
        className: (0, $35pXk.default)([
            "_kqsw1n9t _94n5oahv _1pbyzo7u _t9ecjq3t"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($b3acdd5624bc36ae$var$AIFloatingContextMenuWrapped, props)))));
};

});
parcelRegister("2OYqV", function(module, exports) {

$parcel$export(module.exports, "ContextualButtonPulse", () => $af25143620373faf$export$cd20eff28c3c2c7f);
/* ContextualButtonPulse.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $7hpmn = parcelRequire("7hpmn");
const $af25143620373faf$var$baseShadow = `0 0 0 2px ${"var(--ds-border-brand, #0C66E4)"}`;
const $af25143620373faf$var$easing = 'cubic-bezier(0.55, 0.055, 0.675, 0.19)';
const $af25143620373faf$var$pulseKeyframes = null; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $af25143620373faf$var$SinglePulse = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_y44vx5kr",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $af25143620373faf$var$DoublePulse = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_y44v1nps",
            __cmplp.className
        ])
    });
});
const $af25143620373faf$var$defaultBorderRadius = null;
const $af25143620373faf$var$isInObjectSideBarBorderRadius = null;
const $af25143620373faf$export$cd20eff28c3c2c7f = ({ children: children, pulseCount: pulseCount = 0, isInObjectSideBar: isInObjectSideBar = false })=>{
    const isReducedMotion = (0, $7hpmn.useIsReducedMotion)();
    if (isReducedMotion) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
        "data-testid": "contextual-pulse-none"
    }, children);
    switch(pulseCount){
        case 1:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($af25143620373faf$var$SinglePulse, {
                "data-testid": "contextual-pulse-single",
                className: (0, $35pXk.default)([
                    "_2rkob7nn",
                    isInObjectSideBar && "_2rkovbgk"
                ])
            }, children);
        case 2:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($af25143620373faf$var$DoublePulse, {
                "data-testid": "contextual-pulse-double",
                className: (0, $35pXk.default)([
                    "_2rkob7nn",
                    isInObjectSideBar && "_2rkovbgk"
                ])
            }, children);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
        "data-testid": "contextual-pulse-none"
    }, children);
};

});

parcelRegister("5PeEy", function(module, exports) {

$parcel$export(module.exports, "useDynamicAIContext", () => $83cf8da53844c2d7$export$7571cdd921b49cc0);

var $gwFzn = parcelRequire("gwFzn");

var $3Am3T = parcelRequire("3Am3T");

var $bQm3c = parcelRequire("bQm3c");

var $i6XHY = parcelRequire("i6XHY");

var $7nXd3 = parcelRequire("7nXd3");

var $kDPMK = parcelRequire("kDPMK");

var $i1vUz = parcelRequire("i1vUz");
const $83cf8da53844c2d7$export$7571cdd921b49cc0 = (contentId, contentType, pageCommentsSectionInView, isLivePage)=>{
    const { scrollY: scrollY } = (0, $i6XHY.useDocumentScrollHeight)(isLivePage);
    const { unresolvedInlineCommentsCount: unresolvedInlineCommentsCount, footerCommentsCount: footerCommentsCount } = (0, $gwFzn.useContext)((0, $3Am3T.CommentCountsContext));
    const { isAdminHubAIEnabled: isAdminHubAIEnabled } = (0, $bQm3c.useSessionData)();
    const contentTypeEnum = contentType === 'page' ? (0, $kDPMK.CatchupContentType).PAGE : (0, $kDPMK.CatchupContentType).BLOGPOST;
    const { showCatchupAsDefault: showCatchupAsDefault, queryError: queryError } = (0, $i1vUz.useDynamicSplitButton)(contentId, contentTypeEnum);
    if (!isAdminHubAIEnabled) return {
        dynamicActionTarget: null
    };
    if (pageCommentsSectionInView && (unresolvedInlineCommentsCount > 0 || footerCommentsCount > 0)) return {
        dynamicActionTarget: (0, $7nXd3.FeatureStates).Comments
    };
    if (showCatchupAsDefault && scrollY !== null && scrollY < 400) return {
        dynamicActionTarget: (0, $7nXd3.FeatureStates).PageCatchup
    };
    if (scrollY !== null && scrollY < 400) return {
        dynamicActionTarget: (0, $7nXd3.FeatureStates).QuickSummary,
        queryError: queryError
    };
    return {
        dynamicActionTarget: null,
        queryError: queryError
    };
};

});
parcelRegister("i6XHY", function(module, exports) {

$parcel$export(module.exports, "useDocumentScrollHeight", () => $5d003355575f53c0$export$cbb5dd4e54f3bea9);

var $gwFzn = parcelRequire("gwFzn");

var $2jjxD = parcelRequire("2jjxD");

var $gz8ZY = parcelRequire("gz8ZY");
const $5d003355575f53c0$export$cbb5dd4e54f3bea9 = (isLivePage = false)=>{
    const isNav4Enabled = (0, $gz8ZY.useIsNav4Enabled)();
    {
        const newViewPageContainer = document.getElementById('AkMainContent');
        const [scrollHeightAttributes, setScrollHeightAttributes] = // eslint-disable-next-line react-hooks/rules-of-hooks
        (0, $gwFzn.useState)({
            scrollY: 0
        });
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const handleScroll = (0, $gwFzn.useCallback)(()=>{
            const livePageContainer = document.querySelector('.fabric-editor-popup-scroll-parent');
            const viewPageScrollY = newViewPageContainer && isNav4Enabled ? newViewPageContainer.scrollTop : window.scrollY;
            setScrollHeightAttributes({
                scrollY: isLivePage ? livePageContainer && livePageContainer.scrollTop : viewPageScrollY
            });
        }, [
            setScrollHeightAttributes,
            isLivePage,
            newViewPageContainer,
            isNav4Enabled
        ]);
        // eslint-disable-next-line react-hooks/rules-of-hooks
        (0, $gwFzn.useEffect)(()=>{
            const livePageContainer = document.querySelector('.fabric-editor-popup-scroll-parent');
            const debounceScroll = (0, (/*@__PURE__*/$parcel$interopDefault($2jjxD)))(handleScroll, 250);
            if (isLivePage) livePageContainer?.addEventListener('scroll', debounceScroll);
            else isNav4Enabled ? newViewPageContainer?.addEventListener('scroll', debounceScroll) : document.addEventListener('scroll', debounceScroll);
            return ()=>{
                if (isLivePage) livePageContainer?.removeEventListener('scroll', debounceScroll);
                else isNav4Enabled ? newViewPageContainer?.removeEventListener('scroll', debounceScroll) : document.removeEventListener('scroll', debounceScroll);
            };
        // eslint-disable-next-line react-hooks/exhaustive-deps
        }, []);
        return scrollHeightAttributes;
    }
};

});

parcelRegister("7nXd3", function(module, exports) {

$parcel$export(module.exports, "FeatureStates", () => $2c4fc9e48b4f3b02$export$881f3bfeb53afdcf);
$parcel$export(module.exports, "PopupStateTypes", () => $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c);
$parcel$export(module.exports, "isFeaturePopupState", () => $2c4fc9e48b4f3b02$export$4940a8f6968b63);
var $2c4fc9e48b4f3b02$export$881f3bfeb53afdcf = /*#__PURE__*/ function(FeatureStates) {
    FeatureStates["QuickSummary"] = "quick-summary";
    FeatureStates["Comments"] = "comments";
    FeatureStates["PageCatchup"] = "page-catchup";
    FeatureStates["AIPresentationGeneration"] = "ai-presentation-generation";
    FeatureStates["BulkIssueCreate"] = "bulk-issue-create";
    FeatureStates["QuickSummaryAudio"] = "quick-summary-audio";
    return FeatureStates;
}({});
var $2c4fc9e48b4f3b02$export$a913d22899a46b83 = /*#__PURE__*/ function(NonFeatureStates) {
    NonFeatureStates["Menu"] = "menu";
    NonFeatureStates["OptIn"] = "opt-in";
    NonFeatureStates["Upsell"] = "upsell";
    return NonFeatureStates;
}({});
const $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c = {
    ...$2c4fc9e48b4f3b02$export$881f3bfeb53afdcf,
    ...$2c4fc9e48b4f3b02$export$a913d22899a46b83
};
function $2c4fc9e48b4f3b02$export$4940a8f6968b63(popupState) {
    return Object.values($2c4fc9e48b4f3b02$export$881f3bfeb53afdcf).includes(popupState);
}

});

parcelRegister("i1vUz", function(module, exports) {

$parcel$export(module.exports, "useDynamicSplitButton", () => $649e6d4fa880ffb0$export$ca7c63318c849d7a);
/**
 * @graphql cc
 */ 
var $diswb = parcelRequire("diswb");

var $d2LG0 = parcelRequire("d2LG0");

var $bQm3c = parcelRequire("bQm3c");

var $6mKj3 = parcelRequire("6mKj3");

var $aSsfA = parcelRequire("aSsfA");

var $cD1qu = parcelRequire("cD1qu");

var $c5UND = parcelRequire("c5UND");

var $fT4aa = parcelRequire("fT4aa");
const $649e6d4fa880ffb0$var$useDynamicSplitButtonContentHistoryQuery = (0, $d2LG0.default)`query useDynamicSplitButtonContentHistoryQuery($contentId:ID!){contentHistory(contentId:$contentId first:1){nodes{collaborators{userAccountIds}}}}`;
const $649e6d4fa880ffb0$export$ca7c63318c849d7a = (contentId, contentType)=>{
    const { isAdminHubAIEnabled: isAdminHubAIEnabled, userId: userId } = (0, $bQm3c.useSessionData)();
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const isRovoButtonEnabled = (0, $fT4aa.useAIRovoButtonEnablement)();
    const { data: data, loading: catchupLastViewedLoading, error: queryError } = (0, $diswb.useQuery)(// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Preloaded GraphQL Operation
    (0, $c5UND.CatchupLastViewedTimeQuery), {
        variables: {
            contentId: contentId,
            contentType: contentType
        },
        skip: !(0, $6mKj3.expValEquals)('cc_ai_consumption_ux_button', 'button-placement', 'bottom') || !isAdminHubAIEnabled || pageMode === (0, $cD1qu.PageMode).EDIT
    });
    const { data: lastModifiedDateData, loading: lastModifiedLoading } = (0, $diswb.useQuery)((0, $d2LG0.default)`query useDynamicSplitButtonLastModifiedDateQuery($contentId:ID!){content(id:$contentId){nodes{id metadata{lastModifiedDate}}}}`, {
        variables: {
            contentId: contentId
        },
        skip: !(0, $6mKj3.expValEquals)('cc_ai_consumption_ux_button', 'button-placement', 'bottom') || !isAdminHubAIEnabled || pageMode === (0, $cD1qu.PageMode).EDIT
    });
    const { data: contentHistoryData, loading: contentHistoryLoading } = (0, $diswb.useQuery)($649e6d4fa880ffb0$var$useDynamicSplitButtonContentHistoryQuery, {
        variables: {
            contentId: contentId
        },
        skip: !isAdminHubAIEnabled || pageMode === (0, $cD1qu.PageMode).EDIT || !(0, $6mKj3.expValEquals)('cc_ai_consumption_ux_button', 'button-placement', 'bottom') || !isRovoButtonEnabled,
        fetchPolicy: 'network-only'
    });
    const lastModifiedDate = lastModifiedDateData?.content?.nodes?.[0]?.metadata?.lastModifiedDate ?? '';
    const lastViewedTime = data?.catchupGetLastViewedTime?.lastViewedTimeISO ?? '';
    const parsedLastViewedTime = Date.parse(lastViewedTime);
    const parsedLastModifiedDate = Date.parse(lastModifiedDate);
    const lastEditedCollaborators = contentHistoryData?.contentHistory?.nodes?.[0]?.collaborators?.userAccountIds ?? [];
    const isCurrentUserARecentCollaborator = lastEditedCollaborators.some((collaborator)=>collaborator === userId);
    const queryLoading = catchupLastViewedLoading || lastModifiedLoading || contentHistoryLoading;
    if (!parsedLastViewedTime || !parsedLastModifiedDate || queryError) return {
        showCatchupAsDefault: false,
        queryLoading: queryLoading,
        queryError: queryError
    };
    const showCatchupAsDefault = pageMode !== (0, $cD1qu.PageMode).EDIT && !queryLoading && parsedLastModifiedDate > parsedLastViewedTime && !isCurrentUserARecentCollaborator;
    return {
        showCatchupAsDefault: showCatchupAsDefault,
        queryLoading: queryLoading
    };
};

});


parcelRegister("94XxL", function(module, exports) {

$parcel$export(module.exports, "useAIFloatingButtonNudge", () => $874fd8abb2c90fe4$export$b938e63de8ec6cb1);

var $gwFzn = parcelRequire("gwFzn");

var $ivb8S = parcelRequire("ivb8S");

var $d282Z = parcelRequire("d282Z");

var $bQm3c = parcelRequire("bQm3c");

var $3J7nf = parcelRequire("3J7nf");

var $kDPMK = parcelRequire("kDPMK");

var $i1vUz = parcelRequire("i1vUz");
const $874fd8abb2c90fe4$export$b938e63de8ec6cb1 = (contentId, contentType)=>{
    const { setOnboardingState: setOnboardingState } = (0, $ivb8S.useSetOnboardingState)();
    const [pulseCount, setPulseCount] = (0, $gwFzn.useState)(0);
    const hasLoaded = (0, $gwFzn.useRef)(false);
    const { isAdminHubAIEnabled: isAdminHubAIEnabled } = (0, $bQm3c.useSessionData)();
    const { aiButtonTour: { isVisible: isChangeboardingVisible } } = (0, $3J7nf.useLiveDocChangeboarding)();
    const contentTypeEnum = contentType === 'page' ? (0, $kDPMK.CatchupContentType).PAGE : (0, $kDPMK.CatchupContentType).BLOGPOST;
    const { showCatchupAsDefault: showCatchupAsDefault, queryLoading: dynamicSplitButtonLoading } = (0, $i1vUz.useDynamicSplitButton)(contentId, contentTypeEnum);
    // Ignoring error state as we will just not show a pulse if this errors
    const { data: onboardingStateData, loading: onboardingStateLoading } = (0, $ivb8S.useGetOnboardingState)((0, $d282Z.ONBOARDING_INSIGHTS).CONTEXTUAL_FLOATING_BUTTON_NUDGE, !isAdminHubAIEnabled);
    (0, $gwFzn.useEffect)(()=>{
        if (!dynamicSplitButtonLoading && !onboardingStateLoading && !hasLoaded.current && isAdminHubAIEnabled && !isChangeboardingVisible) {
            // We only want this to execute once and only once when both hooks are finished loading
            hasLoaded.current = true;
            const { hasContextualFloatingButtonBeenSeen: hasContextualFloatingButtonBeenSeen } = (0, $ivb8S.deserializeState)(onboardingStateData);
            if (onboardingStateData != null && !hasContextualFloatingButtonBeenSeen) {
                setOnboardingState({
                    key: (0, $d282Z.ONBOARDING_INSIGHTS).CONTEXTUAL_FLOATING_BUTTON_NUDGE,
                    value: 'true'
                });
                setPulseCount(2);
            } else if (showCatchupAsDefault) setPulseCount(1);
        }
    }, [
        dynamicSplitButtonLoading,
        onboardingStateData,
        onboardingStateLoading,
        setPulseCount,
        setOnboardingState,
        showCatchupAsDefault,
        isAdminHubAIEnabled,
        isChangeboardingVisible
    ]);
    return {
        pulseCount: pulseCount
    };
};

});

parcelRegister("8XJjZ", function(module, exports) {

$parcel$export(module.exports, "AIFloatingSplitButton", () => $7b40fa145aa0c9d8$export$c226a072142c15e9);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $1qfLF = parcelRequire("1qfLF");

var $6f0Oj = parcelRequire("6f0Oj");
var $bUlM5 = parcelRequire("bUlM5");
var $dcJ7R = parcelRequire("dcJ7R");
var $2W0qg = parcelRequire("2W0qg");
var $ecnYn = parcelRequire("ecnYn");

var $g9Srd = parcelRequire("g9Srd");
var $fT2ta = parcelRequire("fT2ta");

var $gqhnZ = parcelRequire("gqhnZ");

var $e4o8D = parcelRequire("e4o8D");
const $7b40fa145aa0c9d8$var$i18n = (0, $2nPZH.defineMessages)({
    logoAltText: {
        id: "ai-floating-context-menu.floating-context-menu-button.logo-alt-text",
        defaultMessage: "Atlassian Intelligence"
    }
});
const $7b40fa145aa0c9d8$var$aiFloatingContextMenuStyles = (0, $ecnYn.xcss)({
    borderRadius: 'border.radius.300',
    padding: 'space.075',
    boxShadow: 'elevation.shadow.overlay',
    backgroundColor: 'elevation.surface.raised'
});
const $7b40fa145aa0c9d8$var$aiFloatingContextMenuStylesInObjectSidebar = (0, $ecnYn.xcss)({
    padding: 'space.100',
    boxShadow: 'elevation.shadow.raised',
    backgroundColor: 'elevation.surface.raised',
    borderRadius: 'border.radius.circle'
});
const $7b40fa145aa0c9d8$var$dividerStyles = (0, $ecnYn.xcss)({
    height: '100%',
    width: '1px',
    backgroundColor: 'color.background.neutral'
});
const $7b40fa145aa0c9d8$var$dividerStylesInObjectSidebar = (0, $ecnYn.xcss)({
    height: '24px',
    width: '1px',
    backgroundColor: 'color.background.neutral'
});
const $7b40fa145aa0c9d8$var$defaultPressableStyles = (0, $ecnYn.xcss)({
    display: 'inline-flex',
    background: "var(--ds-background-neutral-subtle, #00000000)",
    color: 'color.text.subtle',
    width: 'auto',
    maxWidth: '100%',
    boxSizing: 'border-box',
    position: 'relative',
    flexShrink: 0,
    font: 'font.body',
    fontWeight: 'font.weight.medium',
    paddingBlock: 'space.025',
    paddingInlineEnd: 'space.150',
    paddingInlineStart: 'space.150',
    verticalAlign: 'middle',
    borderRadius: 'border.radius.100',
    transition: 'background 0.1s ease-out',
    whiteSpace: 'nowrap',
    '::after': {
        borderRadius: 'inherit',
        inset: 'space.0',
        borderStyle: 'solid',
        borderWidth: "var(--ds-border-width, 1px)",
        pointerEvents: 'none',
        position: 'absolute'
    },
    ':hover': {
        background: "var(--ds-background-neutral-subtle-hovered, #091E420F)"
    }
});
const $7b40fa145aa0c9d8$var$selectedPressableStyles = (0, $ecnYn.xcss)({
    background: "var(--ds-background-selected, #E9F2FF)",
    color: 'color.text.selected',
    '::after': {
        content: '""',
        borderColor: 'color.border.selected',
        borderStyle: 'solid'
    },
    ':visited': {
        color: 'color.text.selected'
    },
    ':hover': {
        // @ts-expect-error
        color: "var(--ds-text-selected, #0C66E4)",
        background: "var(--ds-background-selected-hovered, #CCE0FF)"
    },
    ':active': {
        // @ts-expect-error
        color: "var(--ds-text-selected, #0C66E4)",
        background: "var(--ds-background-selected-pressed, #85B8FF)"
    }
});
const $7b40fa145aa0c9d8$var$sideBarPressableStyles = (0, $ecnYn.xcss)({
    borderRadius: '24px',
    paddingBlock: 'space.075'
});
const $7b40fa145aa0c9d8$export$c226a072142c15e9 = ({ dynamicActionText: dynamicActionText, isDynamicActionSelected: isDynamicActionSelected = false, onDynamicActionClick: onDynamicActionClick, onMenuButtonClick: onMenuButtonClick, triggerProps: triggerProps, isMenuOpen: isMenuOpen, isInObjectSideBar: isInObjectSideBar = false })=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $bUlM5.default), triggerProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dcJ7R.default), {
        xcss: [
            !isInObjectSideBar && $7b40fa145aa0c9d8$var$aiFloatingContextMenuStyles,
            isInObjectSideBar && $7b40fa145aa0c9d8$var$aiFloatingContextMenuStylesInObjectSidebar
        ],
        grow: "hug",
        space: "space.050",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $g9Srd.default), {
        appear: !renderServerPlaceholder,
        exitThenEnter: true
    }, dynamicActionText && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $fT2ta.default), {
        entranceDirection: "right",
        exitDirection: "right",
        duration: "medium"
    }, (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
            ...props,
            "aria-modal": true,
            "data-vc": "ai-floating-dynamic-action"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $2W0qg.default), {
            onClick: ()=>onDynamicActionClick?.(),
            xcss: [
                $7b40fa145aa0c9d8$var$defaultPressableStyles,
                isDynamicActionSelected && $7b40fa145aa0c9d8$var$selectedPressableStyles,
                isInObjectSideBar && $7b40fa145aa0c9d8$var$sideBarPressableStyles
            ]
        }, dynamicActionText))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: [
            !isInObjectSideBar && $7b40fa145aa0c9d8$var$dividerStyles,
            isInObjectSideBar && $7b40fa145aa0c9d8$var$dividerStylesInObjectSidebar
        ]
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1qfLF.default), {
        icon: (0, $gqhnZ.AtlassianIntelligenceLogoDark),
        label: formatMessage($7b40fa145aa0c9d8$var$i18n.logoAltText),
        onClick: ()=>onMenuButtonClick?.(),
        appearance: "subtle",
        isSelected: isMenuOpen,
        shape: isInObjectSideBar ? 'circle' : 'default'
    })));
};

});
parcelRegister("gqhnZ", function(module, exports) {

$parcel$export(module.exports, "AtlassianIntelligenceLogoDark", () => $e6e8ee54bcb9bd8a$export$2c6a5235f6e9fe39);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ /* eslint-disable @atlaskit/design-system/ensure-design-token-usage/preview */ 
var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $3Mg7y = parcelRequire("3Mg7y");
const $e6e8ee54bcb9bd8a$export$2c6a5235f6e9fe39 = (props)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3Mg7y))), {
        color: "var(--ds-icon, #44546F)",
        ...props
    });

});


parcelRegister("7VRT3", function(module, exports) {

$parcel$export(module.exports, "AIFloatingContextMenuPopupContainer", () => $44548221e1617185$export$2593be7073434b2d);
/* AIFloatingContextMenuPopupContainer.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $35pXk = parcelRequire("35pXk");

var $gwFzn = parcelRequire("gwFzn");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $44548221e1617185$var$PopupWrapper = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_19it1pfj _2rko1crf _bfhkhp5a _16qs1cd0 _1bsb1sum _nt751r31 _49pcglyw _1hvw1o36",
            __cmplp.className
        ])
    });
});
const $44548221e1617185$export$2593be7073434b2d = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ children: children, ...props }, ref)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($44548221e1617185$var$PopupWrapper, {
        ...props,
        ref: ref,
        role: "dialog"
    }, children);
});

});

parcelRegister("8E5UF", function(module, exports) {

$parcel$export(module.exports, "i18n", () => $790b3996dfce6541$export$a7357cdd1f0b0168);
$parcel$export(module.exports, "AIFloatingContextMenuGroup", () => $790b3996dfce6541$export$2b7899a440558a80);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $56M4r = parcelRequire("56M4r");
var $2SlZp = parcelRequire("2SlZp");
var $7rvPL = parcelRequire("7rvPL");

var $u9agA = parcelRequire("u9agA");

var $aIk0I = parcelRequire("aIk0I");

var $cUQMr = parcelRequire("cUQMr");

var $g5gZt = parcelRequire("g5gZt");

var $1yB28 = parcelRequire("1yB28");

var $9RVmI = parcelRequire("9RVmI");

var $kevJM = parcelRequire("kevJM");

var $lm1k2 = parcelRequire("lm1k2");

var $inPa6 = parcelRequire("inPa6");

var $3j1mV = parcelRequire("3j1mV");

var $lMYdq = parcelRequire("lMYdq");

var $8aF6s = parcelRequire("8aF6s");

var $bQm3c = parcelRequire("bQm3c");

var $9wGTI = parcelRequire("9wGTI");

var $3Am3T = parcelRequire("3Am3T");

var $jln20 = parcelRequire("jln20");

var $1QMs7 = parcelRequire("1QMs7");

var $aUTn5 = parcelRequire("aUTn5");

var $6mKj3 = parcelRequire("6mKj3");

var $feCcN = parcelRequire("feCcN");
var $2rT5l = parcelRequire("2rT5l");

var $iwjXf = parcelRequire("iwjXf");

var $7nXd3 = parcelRequire("7nXd3");
const $790b3996dfce6541$export$a7357cdd1f0b0168 = (0, $2nPZH.defineMessages)({
    inlineCommentsMenuItemLabel: {
        id: "ai-floating-context-menu.menu.item.label.inline-comments",
        defaultMessage: "Summarize comments"
    },
    pageCatchupMenuItemLabel: {
        id: "ai-floating-context-menu.menu.item.label.page-catchup",
        defaultMessage: "Summarize changes"
    },
    aiPresentationGenerationMenuItemLabel: {
        id: "ai-floating-context-menu.menu.item.label.ai-presentation-generation",
        defaultMessage: "Rewrite as presentation"
    },
    audioSummarySectionLabel: {
        id: "ai-floating-context-menu.menu.item.label.audio-summary",
        defaultMessage: "Listen to Page Summary"
    },
    bulkIssueCreateMenuItemLabel: {
        id: "ai-floating-context-menu.menu.item.label.bulk-issue-create",
        defaultMessage: "Create Jira issues"
    },
    bulkWorkItemsCreateMenuItemLabel: {
        id: "ai-floating-context-menu.menu.item.label.bulk-work-items-create",
        defaultMessage: "Create Jira work items"
    },
    betaLabel: {
        id: "ai-floating-context-menu.menu.item.lozenge.beta",
        defaultMessage: "Beta"
    },
    summarizeSectionLabel: {
        id: "ai-floating-context-menu.summarize.section.label",
        defaultMessage: "Summarize"
    },
    createSectionLabel: {
        id: "ai-floating-context-menu.create.section.label",
        defaultMessage: "Create"
    }
});
var $790b3996dfce6541$var$ContentActionsMenuSectionKey = /*#__PURE__*/ function(ContentActionsMenuSectionKey) {
    ContentActionsMenuSectionKey["Summarize"] = "Summarize";
    ContentActionsMenuSectionKey["Create"] = "Create";
    return ContentActionsMenuSectionKey;
}($790b3996dfce6541$var$ContentActionsMenuSectionKey || {});
const $790b3996dfce6541$export$2b7899a440558a80 = ({ contentId: contentId, contentType: contentType, spaceKey: spaceKey, isLivePage: isLivePage = false, setIsOpen: setIsOpen, setPopupState: setPopupState })=>{
    const intl = (0, $dBxQj.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { unresolvedInlineCommentsCount: unresolvedInlineCommentsCount, footerCommentsCount: footerCommentsCount } = (0, $gwFzn.useContext)((0, $3Am3T.CommentCountsContext));
    const { edition: edition, cloudId: cloudId, activationId: activationId } = (0, $bQm3c.useSessionData)();
    const { showModal: showModal } = (0, $8aF6s.useDialogs)();
    const rightSidebarContext = (0, $jln20.useRightSidebarContext)();
    const setIsCreatedWithAi = (0, $1QMs7.useSetIsCreatedWithAi)();
    const setIsCreatedFromTable = (0, $1QMs7.useSetIsCreatedFromTable)();
    const setInsertStorageFragmentRequestPayload = (0, $1QMs7.useSetInsertStorageFragmentRequestPayload)();
    const contentLastModifiedTimestamp = (0, $1QMs7.useGetContentLastModifiedTimestamp)();
    const { showWarningDialog: showWarningDialog } = (0, $1QMs7.useWarningDialogStateActions)();
    const { showAudioPanel: showAudioPanel } = (0, $2rT5l.useShowAudioPanel)();
    const { onPlayContent: onPlayContent } = (0, $feCcN.useAudioPlaybackStateActions)();
    const { pageAri: pageAri } = (0, $3j1mV.useConfluencePageAri)(cloudId, contentId, contentType);
    const activeContent = {
        id: contentId,
        contentType: contentType,
        spaceKey: spaceKey
    };
    const isSidePanelOpen = rightSidebarContext.getCurrent()?.panelId === (0, $1QMs7.BULK_ISSUE_CREATE_SIDE_PANEL_ID);
    const content = (0, $gwFzn.useRef)(typeof document !== 'undefined' ? document.querySelector('div#content') : null);
    const handleBulkIssueCreate = (0, $iwjXf.useBulkIssueCreate)({
        contentId: contentId,
        content: content
    });
    const menuItems = [
        {
            key: (0, $7nXd3.PopupStateTypes).QuickSummary,
            label: intl.formatMessage($790b3996dfce6541$export$a7357cdd1f0b0168.summarizeSectionLabel),
            showMenuItem: true,
            isDisabled: false,
            beta: false,
            section: "Summarize",
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cUQMr))), {
                label: ""
            })
        },
        {
            key: (0, $7nXd3.PopupStateTypes).QuickSummaryAudio,
            label: intl.formatMessage($790b3996dfce6541$export$a7357cdd1f0b0168.audioSummarySectionLabel),
            showMenuItem: (0, $6mKj3.expVal)('confluence_frontend_audio_ai_summary_web', 'isEnabled', false),
            isDisabled: false,
            beta: true,
            section: "Summarize",
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lm1k2))), {
                label: ""
            })
        },
        {
            key: (0, $7nXd3.PopupStateTypes).PageCatchup,
            label: intl.formatMessage($790b3996dfce6541$export$a7357cdd1f0b0168.pageCatchupMenuItemLabel),
            showMenuItem: true,
            isDisabled: false,
            beta: false,
            section: "Summarize",
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kevJM))), {
                label: ""
            })
        },
        {
            key: (0, $7nXd3.PopupStateTypes).Comments,
            label: intl.formatMessage($790b3996dfce6541$export$a7357cdd1f0b0168.inlineCommentsMenuItemLabel),
            showMenuItem: true,
            isDisabled: isLivePage ? unresolvedInlineCommentsCount === 0 : unresolvedInlineCommentsCount === 0 && footerCommentsCount === 0,
            beta: false,
            section: "Summarize",
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1yB28))), {
                label: ""
            })
        },
        {
            key: (0, $7nXd3.PopupStateTypes).AIPresentationGeneration,
            label: intl.formatMessage($790b3996dfce6541$export$a7357cdd1f0b0168.aiPresentationGenerationMenuItemLabel),
            showMenuItem: (0, $9wGTI.fg)('confluence_ai_presentation_generation'),
            isDisabled: false,
            beta: true,
            section: "Create",
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9RVmI))), {
                label: ""
            })
        },
        {
            key: (0, $7nXd3.PopupStateTypes).BulkIssueCreate,
            label: intl.formatMessage((0, $9wGTI.fg)('confluence-issue-terminology-refresh') ? $790b3996dfce6541$export$a7357cdd1f0b0168.bulkWorkItemsCreateMenuItemLabel : $790b3996dfce6541$export$a7357cdd1f0b0168.bulkIssueCreateMenuItemLabel),
            showMenuItem: (0, $9wGTI.fg)('confluence_ai_bulk_issue_creation'),
            isDisabled: false,
            beta: false,
            section: "Create",
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($g5gZt))), {
                label: ""
            })
        }
    ];
    const sectionItems = [
        {
            key: "Summarize",
            label: intl.formatMessage($790b3996dfce6541$export$a7357cdd1f0b0168.summarizeSectionLabel),
            showSection: menuItems.some((item)=>item.section === 'Summarize' && item.showMenuItem)
        },
        {
            key: "Create",
            label: intl.formatMessage($790b3996dfce6541$export$a7357cdd1f0b0168.createSectionLabel),
            showSection: !isLivePage && menuItems.some((item)=>item.section === 'Create' && item.showMenuItem)
        }
    ];
    const onMenuItemSelection = (key)=>{
        let additionalAnalyticsAttributes = {};
        if (key === (0, $7nXd3.PopupStateTypes).Comments) additionalAnalyticsAttributes = {
            numPageCommentsSummarized: footerCommentsCount,
            numInlineCommentsSummarized: unresolvedInlineCommentsCount
        };
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'page',
                action: 'clicked',
                actionSubject: 'menuItem',
                actionSubjectId: `aiActionsMenuItem-${key}`,
                attributes: {
                    contentId: contentId,
                    edition: edition,
                    ...additionalAnalyticsAttributes,
                    isLivePage: isLivePage
                }
            }
        }).fire();
        if (key === (0, $7nXd3.PopupStateTypes).BulkIssueCreate && (0, $9wGTI.fg)('confluence_ai_bulk_issue_creation')) {
            if (isSidePanelOpen) showWarningDialog((0, $1QMs7.WarningDialog).FLOATING);
            else if ((0, $9wGTI.fg)('jira-work-create-from-connie-without-edit-perms')) {
                setIsOpen(false);
                handleBulkIssueCreate();
            } else {
                setIsOpen(false);
                setIsCreatedWithAi(true);
                setIsCreatedFromTable(false);
                const range = (0, $1QMs7.getValidRange)((0, $1QMs7.getPageContentRange)());
                const payload = (0, $1QMs7.constructInsertStorageFragmentRequestPayload)(contentId, (0, $aUTn5.convertSelectionToLegacyFormat), range, content.current, contentLastModifiedTimestamp);
                setInsertStorageFragmentRequestPayload(payload);
                rightSidebarContext.open((0, $1QMs7.BULK_ISSUE_CREATE_SIDE_PANEL_ID), (0, $1QMs7.BULK_ISSUE_CREATE_SIDE_PANEL_WIDTH));
            }
        } else if (key === (0, $7nXd3.PopupStateTypes).QuickSummaryAudio) {
            showAudioPanel();
            const audioRequest = {
                pageAri: pageAri,
                locale: intl.locale,
                activationId: activationId
            };
            onPlayContent(audioRequest, activeContent);
        } else if (key === (0, $7nXd3.PopupStateTypes).AIPresentationGeneration) {
            showModal((0, $lMYdq.AIPresentationModalWrapper), {
                contentId: contentId,
                contentType: contentType,
                spaceKey: spaceKey
            });
            setIsOpen(false);
            setPopupState((0, $7nXd3.PopupStateTypes).Menu);
        } else setPopupState(key);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $2SlZp.default), {
        testId: "ai-uber-button-menu-group"
    }, sectionItems.map((section)=>section.showSection ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $7rvPL.default), {
            key: section.key,
            title: section.label
        }, menuItems.map((item)=>item.showMenuItem && item.section === section.key ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $56M4r.default), {
                iconBefore: item.icon,
                key: item.key,
                isDisabled: item.isDisabled,
                onClick: ()=>{
                    onMenuItemSelection(item.key);
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $u9agA.default), {
                spread: "space-between",
                alignBlock: "center"
            }, item.label, item.beta && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $aIk0I.default), null, intl.formatMessage($790b3996dfce6541$export$a7357cdd1f0b0168.betaLabel)))) : null)) : null));
};

});
parcelRegister("lm1k2", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4b0438824a8e962af0b238dcbe99fc6d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f8bcad9bd9936a5a$var$_react = $f8bcad9bd9936a5a$var$_interopRequireDefault((parcelRequire("gwFzn")));

var $f8bcad9bd9936a5a$var$_baseNew = $f8bcad9bd9936a5a$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $f8bcad9bd9936a5a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "VolumeHigh".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: 📦 @atlaskit/icon/core/volume-high
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f8bcad9bd9936a5a$var$VolumeHighIcon = (props)=>/*#__PURE__*/ $f8bcad9bd9936a5a$var$_react.default.createElement($f8bcad9bd9936a5a$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M7.233 1.434C8.125.672 9.5 1.307 9.5 2.48v11.04c0 1.174-1.375 1.808-2.267 1.047l-2.87-2.447A.5.5 0 0 0 4.04 12H2a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2.04a.5.5 0 0 0 .324-.12zM8 2.75 5.337 5.02a2 2 0 0 1-1.298.48H2a.5.5 0 0 0-.5.5v4a.5.5 0 0 0 .5.5h2.04a2 2 0 0 1 1.297.478L8 13.249zm4.97 8.719a4.907 4.907 0 0 0 0-6.94l1.06-1.06a6.407 6.407 0 0 1 0 9.06zm-2-2a2.08 2.08 0 0 0 0-2.94l1.06-1.06a3.58 3.58 0 0 1 0 5.06z" clip-rule="evenodd"/>`
    }, props));
$f8bcad9bd9936a5a$var$VolumeHighIcon.displayName = 'VolumeHighIcon';
var $f8bcad9bd9936a5a$var$_default = module.exports.default = $f8bcad9bd9936a5a$var$VolumeHighIcon;

});

parcelRegister("lMYdq", function(module, exports) {

$parcel$export(module.exports, "AIPresentationModalWrapper", () => $79bb63da5aefe6b8$export$3002a651e376e263);

var $jmjWc = parcelRequire("jmjWc");

const $79bb63da5aefe6b8$export$3002a651e376e263 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "Al-1J",
    name: "AIPresentationModalWrapper",
    loader: async ()=>(await (parcelRequire("aWonR"))).AIPresentationModalWrapperWithErrorBoundary
});

});
parcelRegister("aWonR", function(module, exports) {

let $7f723c437d3954df$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $7f723c437d3954df$var$load("cZgEZ"),
    $7f723c437d3954df$var$load("MrUJ0"),
    $7f723c437d3954df$var$load("3Eu7W"),
    $7f723c437d3954df$var$load("4g8hn")
]).then(()=>parcelRequire('l2PDp'));

});
parcelRegister("lhnSv", function(module, exports) {
"use strict";


let $f7ddb539c5788a9e$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("9WHwv")).shardUrl((parcelRequire("fzRTW")).resolve(id), maxShards));
    };
module.exports = $f7ddb539c5788a9e$var$load;

});
parcelRegister("9WHwv", function(module, exports) {

$parcel$export(module.exports, "shardUrl", () => $73db4aabb0664d41$export$2bf9932c19d6a5d2, (v) => $73db4aabb0664d41$export$2bf9932c19d6a5d2 = v);
$parcel$export(module.exports, "domainShardingKey", () => $73db4aabb0664d41$export$f6f4188f9108e61, (v) => $73db4aabb0664d41$export$f6f4188f9108e61 = v);
// TODO: convert this file to ESM once HMR issues are resolved
var $73db4aabb0664d41$export$2bf9932c19d6a5d2;
var $73db4aabb0664d41$export$1d37a31d51d1e3ed;
var $73db4aabb0664d41$export$b4cd98d62f81485f;
var $73db4aabb0664d41$export$108ff8fc702e621f;
var $73db4aabb0664d41$export$f6f4188f9108e61;
"use strict";
let $73db4aabb0664d41$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 *
 * @param {string} pathname
 * @returns {string}
 */ function $73db4aabb0664d41$var$getFilenameFromUrlPath(pathname) {
    let lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 *
 * @param {string} str
 * @param {number} maxShards
 * @returns {number}
 */ function $73db4aabb0664d41$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    let totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        let n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
let $73db4aabb0664d41$var$trailingShardRegex = /-\d+$/;
/**
 * @param {string} subdomain
 */ function $73db4aabb0664d41$var$removeTrailingShard(subdomain) {
    if (!$73db4aabb0664d41$var$trailingShardRegex.test(subdomain)) return subdomain;
    let shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 *
 * @param {string} domain
 * @param {number} shard
 */ function $73db4aabb0664d41$var$applyShardToDomain(domain, shard) {
    let i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    let shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$73db4aabb0664d41$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    let firstSubdomain = $73db4aabb0664d41$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 *
 * @param {string} url
 * @param {number} maxShards
 * @returns {string}
 */ function $73db4aabb0664d41$var$shardUrlUnchecked(url, maxShards) {
    let parsedUrl = new URL(url);
    let fileName = $73db4aabb0664d41$var$getFilenameFromUrlPath(parsedUrl.pathname);
    let shardNumber = $73db4aabb0664d41$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $73db4aabb0664d41$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 *
 * @param {string} url
 * @param {number} maxShards
 * @returns {string}
 */ function $73db4aabb0664d41$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$73db4aabb0664d41$var$globalKeyName]) return url;
    return $73db4aabb0664d41$var$shardUrlUnchecked(url, maxShards);
}
$73db4aabb0664d41$export$2bf9932c19d6a5d2 = $73db4aabb0664d41$var$shardUrl;
$73db4aabb0664d41$export$1d37a31d51d1e3ed = $73db4aabb0664d41$var$shardUrlUnchecked;
$73db4aabb0664d41$export$b4cd98d62f81485f = $73db4aabb0664d41$var$getDomainShardIndex;
$73db4aabb0664d41$export$108ff8fc702e621f = $73db4aabb0664d41$var$applyShardToDomain;
$73db4aabb0664d41$export$f6f4188f9108e61 = $73db4aabb0664d41$var$globalKeyName;

});

parcelRegister("fzRTW", function(module, exports) {

$parcel$export(module.exports, "register", () => $b573ef97cec72009$export$6503ec6e8aabbaf, (v) => $b573ef97cec72009$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $b573ef97cec72009$export$f7ad0328861e2f03, (v) => $b573ef97cec72009$export$f7ad0328861e2f03 = v);
var $b573ef97cec72009$export$6503ec6e8aabbaf;
var $b573ef97cec72009$export$f7ad0328861e2f03;
"use strict";
var $b573ef97cec72009$var$mapping = new Map();
function $b573ef97cec72009$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$b573ef97cec72009$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $b573ef97cec72009$var$resolve(id) {
    var resolved = $b573ef97cec72009$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$b573ef97cec72009$export$6503ec6e8aabbaf = $b573ef97cec72009$var$register;
$b573ef97cec72009$export$f7ad0328861e2f03 = $b573ef97cec72009$var$resolve;

});




parcelRegister("feCcN", function(module, exports) {

$parcel$export(module.exports, "useAudioPlaybackState", () => $987527e67857731e$export$dea55a6a8eb525b2);
$parcel$export(module.exports, "useAudioPlaybackStateActions", () => $987527e67857731e$export$4b0fb72c8346cd7b);

var $iFWZA = parcelRequire("iFWZA");
var $2S0Fz = parcelRequire("2S0Fz");
var $4ZoIm = parcelRequire("4ZoIm");

var $e9zUf = parcelRequire("e9zUf");
var $1UApO = parcelRequire("1UApO");

var $eRxem = parcelRequire("eRxem");
const $987527e67857731e$export$d8d9758fac839241 = {
    initialize: (initialState = {})=>async ({ setState: setState })=>{
            const emptyAudioPlaybackState = {
                stream: undefined,
                activeContent: undefined,
                isLoading: false,
                isPlaying: false,
                isClosed: false,
                isEnded: false,
                error: undefined,
                playbackSpeed: Number((0, $e9zUf.confluenceLocalStorageInstance).getItem((0, $1UApO.keys).AI_AUDIO_PLAYBACK_SPEED)) || 1
            };
            setState(Object.assign(emptyAudioPlaybackState, initialState));
        },
    updateActiveContent: (activeContent)=>({ setState: setState, getState: getState })=>{
            const { activeContent: activeContentFromState } = getState();
            if (activeContent) setState({
                activeContent: {
                    ...activeContentFromState,
                    ...activeContent
                }
            });
        },
    onLoadStart: (activeContent)=>({ setState: setState, getState: getState })=>{
            const { activeContent: activeContentFromState } = getState();
            setState({
                activeContent: {
                    ...activeContentFromState,
                    ...activeContent
                },
                isLoading: true
            });
        },
    onLoadEnd: ()=>({ setState: setState })=>{
            setState({
                isLoading: false
            });
        },
    onPlayContent: (audioRequest, activeContent)=>async ({ getState: getState, setState: setState, dispatch: dispatch })=>{
            dispatch($987527e67857731e$export$d8d9758fac839241.initialize({}));
            dispatch($987527e67857731e$export$d8d9758fac839241.onLoadStart(activeContent));
            try {
                // TODO: Temporarily subbing in narrations and summary for briefings
                // in a future PR we will allow the consumer of this hook to decide which
                // endpoint to use
                // const stream = await getSpeech(audioRequest);
                const stream = await (0, $eRxem.getNarration)(audioRequest);
                if (getState().isClosed) return;
                const { activeContent: activeContentFromState } = getState();
                setState({
                    activeContent: {
                        ...activeContentFromState,
                        ...activeContent
                    },
                    isPlaying: false,
                    isEnded: false,
                    stream: stream
                });
                return stream;
            } catch (e) {
                setState({
                    error: e,
                    activeContent: undefined,
                    stream: undefined
                });
                throw e;
            } finally{
                dispatch($987527e67857731e$export$d8d9758fac839241.onLoadEnd());
            }
        },
    onContentPaused: ()=>({ setState: setState })=>{
            setState({
                isPlaying: false
            });
        },
    onContentResumed: ()=>({ setState: setState })=>{
            setState({
                isPlaying: true,
                isEnded: false
            });
        },
    onContentPlaybackSpeedChanged: (speed)=>({ setState: setState })=>{
            (0, $e9zUf.confluenceLocalStorageInstance).setItem((0, $1UApO.keys).AI_AUDIO_PLAYBACK_SPEED, speed);
            setState({
                playbackSpeed: speed
            });
        },
    onContentStopped: ()=>async ({ dispatch: dispatch, setState: setState })=>{
            dispatch($987527e67857731e$export$d8d9758fac839241.initialize({}));
            setState({
                isClosed: true
            });
        },
    onContentEnded: ()=>({ setState: setState })=>{
            setState({
                isEnded: true,
                isPlaying: false
            });
        },
    onContentError: (error)=>({ setState: setState })=>{
            setState({
                error: error
            });
        }
};
const $987527e67857731e$var$Store = (0, $4ZoIm.createStore)({
    initialState: {
        activeContent: undefined,
        isLoading: false,
        isPlaying: false,
        isClosed: false,
        isEnded: false,
        playbackSpeed: 1,
        error: undefined
    },
    actions: $987527e67857731e$export$d8d9758fac839241,
    name: 'listenerState'
});
const $987527e67857731e$export$404fc8934ce14e5f = (0, $2S0Fz.createContainer)($987527e67857731e$var$Store, {
    onInit: ()=>async ({ dispatch: dispatch }, { initialAudioPlaybackState: initialAudioPlaybackState })=>{
            dispatch($987527e67857731e$export$d8d9758fac839241.initialize(initialAudioPlaybackState ?? {}));
        }
});
const $987527e67857731e$export$dea55a6a8eb525b2 = (0, $iFWZA.createHook)($987527e67857731e$var$Store);
const $987527e67857731e$export$4b0fb72c8346cd7b = (0, $iFWZA.createActionsHook)($987527e67857731e$var$Store);

});
parcelRegister("eRxem", function(module, exports) {

$parcel$export(module.exports, "getNarration", () => $a8c440a68b7f1d7a$export$98358e5f5de55fe1);
$parcel$export(module.exports, "getBriefing", () => $a8c440a68b7f1d7a$export$376975d31f493b5f);

var $f7B1p = parcelRequire("f7B1p");
const $a8c440a68b7f1d7a$export$b74ed40f1201d575 = '/gateway/api/v1/audio/summary';
const $a8c440a68b7f1d7a$export$6cb88531520814ca = '/gateway/api/v1/audio/narration';
const $a8c440a68b7f1d7a$export$6cea0b5571f5494d = '/gateway/api/v1/audio/briefing';
const $a8c440a68b7f1d7a$export$d12c91205ffb6498 = async ({ pageAri: pageAri, locale: locale, activationId: activationId })=>{
    const response = await (0, $f7B1p.cfetch)($a8c440a68b7f1d7a$export$b74ed40f1201d575, {
        method: 'POST',
        body: JSON.stringify({
            resource_ari: pageAri,
            locale: locale
        }),
        headers: {
            'Content-Type': 'application/json',
            'ATL-ActivationId': activationId
        }
    });
    if (!response.body) throw new Error('Response body is null');
    return response.body;
};
const $a8c440a68b7f1d7a$export$98358e5f5de55fe1 = async ({ pageAri: pageAri, locale: locale, activationId: activationId })=>{
    const response = await (0, $f7B1p.cfetch)($a8c440a68b7f1d7a$export$6cb88531520814ca, {
        method: 'POST',
        body: JSON.stringify({
            resource_ari: pageAri,
            locale: locale,
            transcriber_model: 'TEXT_ONLY'
        }),
        headers: {
            'Content-Type': 'application/json',
            'ATL-ActivationId': activationId
        }
    });
    if (!response.body) throw new Error('Response body is null');
    return response.body;
};
const $a8c440a68b7f1d7a$export$376975d31f493b5f = async ({ activeContentAri: activeContentAri, additionalResources: additionalResources, locale: locale, activationId: activationId, customization: customization })=>{
    const additionalResourcesBody = additionalResources.map((ari)=>({
            resource_ari: ari.toString(),
            activation_id: activationId
        }));
    const response = await (0, $f7B1p.cfetch)($a8c440a68b7f1d7a$export$6cea0b5571f5494d, {
        method: 'POST',
        body: JSON.stringify({
            resources: [
                {
                    resource_ari: activeContentAri,
                    activation_id: activationId
                },
                ...additionalResourcesBody
            ],
            locale: locale,
            user_instruction: customization
        }),
        headers: {
            'Content-Type': 'application/json',
            'ATL-ActivationId': activationId
        }
    });
    if (!response.body) throw new Error('Response body is null');
    return response.body;
};

});


parcelRegister("2rT5l", function(module, exports) {

$parcel$export(module.exports, "useShowAudioPanel", () => $5742c6ea3675b83b$export$80fda987e666d3c2);

var $2nPZH = parcelRequire("2nPZH");

var $jvYFk = parcelRequire("jvYFk");
var $aWwYt = parcelRequire("aWwYt");

var $lWCWt = parcelRequire("lWCWt");

var $feCcN = parcelRequire("feCcN");
const $5742c6ea3675b83b$var$i18n = (0, $2nPZH.defineMessages)({
    audioPanelTitle: {
        id: "audio.audio-panel.title",
        defaultMessage: "Summary Audio"
    }
});
const $5742c6ea3675b83b$export$80fda987e666d3c2 = ()=>{
    const { showObjectSidebar: showObjectSidebar } = (0, $aWwYt.useObjectSidebarActions)();
    const { onContentStopped: onContentStopped } = (0, $feCcN.useAudioPlaybackStateActions)();
    const showAudioPanel = ()=>{
        showObjectSidebar({
            id: (0, $jvYFk.PanelName).AIAudioPanel,
            headerComponentElements: {
                headerLabel: $5742c6ea3675b83b$var$i18n.audioPanelTitle
            },
            BodyComponent: (0, $lWCWt.AudioPanel),
            closeOptions: {
                onPanelClose: onContentStopped
            }
        }, 'push');
    };
    return {
        showAudioPanel: showAudioPanel
    };
};

});
parcelRegister("lWCWt", function(module, exports) {

$parcel$export(module.exports, "AudioPanel", () => $59212292d86b9252$export$95252ab2e5e7c8f8);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $diswb = parcelRequire("diswb");

var $d2LG0 = parcelRequire("d2LG0");

var $dcJ7R = parcelRequire("dcJ7R");
var $1GzhS = parcelRequire("1GzhS");
var $5dK2X = parcelRequire("5dK2X");
var $ecnYn = parcelRequire("ecnYn");

var $dpPtd = parcelRequire("dpPtd");

var $2Rith = parcelRequire("2Rith");
var $fYQcF = parcelRequire("fYQcF");

var $dIouf = parcelRequire("dIouf");

var $irVI7 = parcelRequire("irVI7");
var $1kHsc = parcelRequire("1kHsc");

var $ly2zj = parcelRequire("ly2zj");

var $feCcN = parcelRequire("feCcN");

var $j936f = parcelRequire("j936f");

var $kwNRu = parcelRequire("kwNRu");
const $59212292d86b9252$var$AudioPanelContentQuery = (0, $d2LG0.default)`query AudioPanelContentQuery($contentId:ID!){singleContent(id:$contentId){id title type subType space{name}}}`;
const $59212292d86b9252$var$feedbackContainer = (0, $ecnYn.xcss)({
    paddingInline: 'space.200'
});
const $59212292d86b9252$var$i18n = (0, $2nPZH.defineMessages)({
    sendFeedback: {
        id: "audio.panel.sendFeedbackLabel",
        defaultMessage: "Send feedback"
    }
});
const $59212292d86b9252$var$aiAnalyticsConfig = {
    product: 'confluence',
    subproduct: 'confluence',
    source: 'page',
    aiFeatureName: 'aiAudio',
    proactiveGeneratedAI: 0,
    userGeneratedAI: 1
};
const $59212292d86b9252$var$AUDIO_FEEDBACK_ENTRYPOINT_ID = 'cca5a6aa-d4e5-4195-8927-eb10c3620ff8';
const $59212292d86b9252$var$ANALYTICS_SOURCE = 'aiAudio';
const $59212292d86b9252$export$17f403dde0c4c145 = ()=>{
    const [{ activeContent: activeContent, isLoading: isLoading, error: error }, { updateActiveContent: updateActiveContent }] = (0, $feCcN.useAudioPlaybackState)();
    const experienceTracker = (0, $gwFzn.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { trackAIInteractionInit: trackAIInteractionInit, trackAIResultError: trackAIResultError } = (0, $fYQcF.useAIEventsInstrumentation)();
    const hasLoaded = (0, $gwFzn.useRef)(false);
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const { data: data, error: contentQueryError } = (0, $diswb.useQuery)($59212292d86b9252$var$AudioPanelContentQuery, {
        variables: {
            contentId: activeContent?.id ?? ''
        },
        skip: !activeContent?.id
    });
    (0, $gwFzn.useEffect)(()=>{
        if (data && data?.singleContent && data?.singleContent?.id) updateActiveContent({
            id: data.singleContent?.id,
            contentTitle: data?.singleContent?.title,
            spaceName: data?.singleContent?.space?.name,
            contentType: data?.singleContent?.type ?? 'page',
            contentSubType: data?.singleContent?.subType
        });
    }, [
        data,
        updateActiveContent
    ]);
    (0, $gwFzn.useEffect)(()=>{
        if (isLoading) {
            hasLoaded.current = true;
            experienceTracker.start({
                name: (0, $irVI7.AI_AUDIO),
                attributes: {
                    contentId: activeContent?.id
                }
            });
            trackAIInteractionInit();
        } else if (hasLoaded.current) {
            if (error) {
                experienceTracker.fail({
                    name: (0, $irVI7.AI_AUDIO),
                    error: error
                });
                trackAIResultError({
                    aiErrorMessage: error.message
                });
            } else experienceTracker.succeed({
                name: (0, $irVI7.AI_AUDIO)
            });
        }
    }, [
        activeContent,
        error,
        experienceTracker,
        isLoading,
        hasLoaded,
        trackAIInteractionInit,
        trackAIResultError
    ]);
    const combinedError = error || contentQueryError;
    if (combinedError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $kwNRu.AudioPanelErrorComponent), {
        error: combinedError
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1GzhS.default), {
        space: "space.600"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $j936f.Miniplayer), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dcJ7R.default), {
        alignBlock: "center",
        space: "space.100",
        xcss: $59212292d86b9252$var$feedbackContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5dK2X.default), {
        color: "color.text.subtlest",
        size: "small"
    }, formatMessage($59212292d86b9252$var$i18n.sendFeedback)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ly2zj.SmartsFeedbackComponent), {
        contentId: activeContent?.id ?? '',
        analyticsProperties: {
            source: $59212292d86b9252$var$ANALYTICS_SOURCE,
            additionalAnalyticsAttributes: {
                contentType: activeContent?.contentType ?? ''
            }
        }
    })));
};
const $59212292d86b9252$export$95252ab2e5e7c8f8 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.ErrorBoundary), {
        attribution: (0, $dIouf.Attribution).SMARTS
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dpPtd.FlagsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ly2zj.FeedbackCollectorPropertiesProvider), {
        entrypointId: $59212292d86b9252$var$AUDIO_FEEDBACK_ENTRYPOINT_ID
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $2Rith.AIEventsInstrumentationProvider), {
        config: $59212292d86b9252$var$aiAnalyticsConfig
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($59212292d86b9252$export$17f403dde0c4c145, null)))));

});
parcelRegister("j936f", function(module, exports) {

$parcel$export(module.exports, "Miniplayer", () => $7097928d09880072$export$860977b73959ce1c);

var $gwFzn = parcelRequire("gwFzn");

var $dBxQj = parcelRequire("dBxQj");

var $gdv5Z = parcelRequire("gdv5Z");
var $eyWa4 = parcelRequire("eyWa4");

var $inPa6 = parcelRequire("inPa6");

var $fYQcF = parcelRequire("fYQcF");

var $feCcN = parcelRequire("feCcN");

var $hVcXD = parcelRequire("hVcXD");

var $i6GHH = parcelRequire("i6GHH");

var $6vpdW = parcelRequire("6vpdW");

var $gJrae = parcelRequire("gJrae");
const $7097928d09880072$export$860977b73959ce1c = ({ showTimeIndicator: showTimeIndicator })=>{
    const intl = (0, $dBxQj.default)();
    const [{ activeContent: activeContent, playbackSpeed: playbackSpeed, stream: stream, isPlaying: isPlaying, isLoading: isLoading }, { onContentPaused: onContentPaused, onContentResumed: onContentResumed, onContentEnded: onContentEnded, onContentError: onContentError }] = (0, $feCcN.useAudioPlaybackState)();
    const containerRef = (0, $gwFzn.useRef)(null);
    const { trackAIResultAction: trackAIResultAction, trackAIResultView: trackAIResultView } = (0, $fYQcF.useAIEventsInstrumentation)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { audioRef: audioRef } = (0, $hVcXD.useAudioStream)(stream, onContentError);
    (0, $i6GHH.useAudioEventListener)({
        audioRef: audioRef,
        onContentPaused: onContentPaused,
        onContentResumed: onContentResumed,
        onContentEnded: onContentEnded
    });
    (0, $gwFzn.useEffect)(()=>{
        trackAIResultView();
        const container = containerRef.current;
        if (container) container.focus(); // Bring focus upon opening miniplayer
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const sendAnalyticsUIEvent = (0, $gwFzn.useCallback)((actionSubjectId, additionalAttributes)=>{
        const attributes = {
            audioType: activeContent?.sourceType,
            summaryLocale: intl.locale,
            ...additionalAttributes
        };
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'miniplayer',
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: actionSubjectId,
                attributes: attributes
            }
        }).fire();
        trackAIResultAction(`${actionSubjectId}Clicked`, {
            attributes: attributes
        });
    }, [
        activeContent?.sourceType,
        createAnalyticsEvent,
        intl.locale,
        trackAIResultAction
    ]);
    (0, $gwFzn.useEffect)(()=>{
        const audio = audioRef.current;
        if (audio) {
            sendAnalyticsUIEvent('audioPlayBackSpeed', {
                playbackSpeed: playbackSpeed
            });
            audio.playbackRate = playbackSpeed;
        }
    }, [
        playbackSpeed,
        sendAnalyticsUIEvent,
        audioRef
    ]);
    return(// eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gdv5Z.default), {
        paddingBlock: "space.050",
        tabIndex: 0,
        ref: containerRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gdv5Z.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("audio", {
        "data-testid": "miniplayer-audio",
        ref: audioRef
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $eyWa4.default), {
        space: "space.150"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gJrae.MiniplayerControls), {
        audioRef: audioRef,
        isPlaying: isPlaying,
        isLoading: isLoading
    }), showTimeIndicator && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6vpdW.AudioTimeIndicator), {
        audioRef: audioRef,
        isLoading: isLoading
    })))));
};

});
parcelRegister("hVcXD", function(module, exports) {

$parcel$export(module.exports, "useAudioStream", () => $d3cbd33be048c158$export$f376420620607c3e);

var $gwFzn = parcelRequire("gwFzn");
const $d3cbd33be048c158$var$AUDIO_TYPE = 'audio/mpeg';
const $d3cbd33be048c158$var$setupMediaSource = async (audio)=>{
    const mediaSource = new MediaSource();
    await new Promise((resolve, reject)=>{
        const handleSourceOpen = ()=>{
            mediaSource.removeEventListener('sourceopen', handleSourceOpen);
            mediaSource.removeEventListener('error', handleError);
            resolve();
        };
        const handleError = ()=>{
            mediaSource.removeEventListener('sourceopen', handleSourceOpen);
            mediaSource.removeEventListener('error', handleError);
            reject(new Error('MediaSource error'));
        };
        mediaSource.addEventListener('sourceopen', handleSourceOpen);
        mediaSource.addEventListener('error', handleError);
        audio.src = URL.createObjectURL(mediaSource);
        audio.load();
    });
    const sourceBuffer = mediaSource.addSourceBuffer($d3cbd33be048c158$var$AUDIO_TYPE);
    sourceBuffer.mode = 'sequence';
    return {
        mediaSource: mediaSource,
        sourceBuffer: sourceBuffer
    };
};
const $d3cbd33be048c158$var$cleanupMediaSource = (mediaSource)=>{
    if (mediaSource?.readyState === 'open') try {
        mediaSource.endOfStream();
    } catch (e) {
    // Ignore errors during cleanup but we don't actually want to propagate them
    }
};
const $d3cbd33be048c158$var$createNewMediaSource = async (audio, onSuccess, onError)=>{
    try {
        const { mediaSource: mediaSource, sourceBuffer: sourceBuffer } = await $d3cbd33be048c158$var$setupMediaSource(audio);
        onSuccess(mediaSource, sourceBuffer);
    } catch (e) {
        onError(e);
    }
};
const $d3cbd33be048c158$var$appendChunk = async (sourceBuffer, chunk, isFirstChunk, audio, onError)=>{
    return new Promise((resolve, reject)=>{
        if (sourceBuffer.updating) {
            sourceBuffer.addEventListener('updateend', ()=>{
                $d3cbd33be048c158$var$appendChunk(sourceBuffer, chunk, isFirstChunk, audio, onError).then(resolve).catch(reject);
            }, {
                once: true
            });
            return;
        }
        sourceBuffer.appendBuffer(chunk);
        sourceBuffer.addEventListener('updateend', ()=>{
            if (isFirstChunk && audio) isFirstChunk = false;
            resolve();
        }, {
            once: true
        });
    });
};
const $d3cbd33be048c158$export$f376420620607c3e = (stream, onError, setStreamEnded)=>{
    const audioRef = (0, $gwFzn.useRef)(null);
    const mediaSourceRef = (0, $gwFzn.useRef)(null);
    const sourceBufferRef = (0, $gwFzn.useRef)(null);
    const [isAudioMounted, setIsAudioMounted] = (0, $gwFzn.useState)(false);
    const [isMediaSourceReady, setIsMediaSourceReady] = (0, $gwFzn.useState)(false);
    const streamRef = (0, $gwFzn.useRef)(stream);
    const handleStreamChange = (0, $gwFzn.useCallback)((newStream)=>{
        if (!audioRef.current) return;
        // Update the stream reference
        streamRef.current = newStream;
        // Clean up existing MediaSource
        $d3cbd33be048c158$var$cleanupMediaSource(mediaSourceRef.current);
        // Reset state
        setIsMediaSourceReady(false);
        mediaSourceRef.current = null;
        sourceBufferRef.current = null;
        // Setup new MediaSource if we have a stream
        if (newStream) $d3cbd33be048c158$var$createNewMediaSource(audioRef.current, (mediaSource, sourceBuffer)=>{
            mediaSourceRef.current = mediaSource;
            sourceBufferRef.current = sourceBuffer;
            setIsMediaSourceReady(true);
        }, onError);
    }, [
        onError
    ]);
    // Detect when audio element is mounted
    (0, $gwFzn.useEffect)(()=>{
        const observer = new MutationObserver((mutations)=>{
            mutations.forEach((mutation)=>{
                if (mutation.type === 'childList') mutation.addedNodes.forEach((node)=>{
                    if (node === audioRef.current) {
                        setIsAudioMounted(true);
                        observer.disconnect();
                    }
                });
            });
        });
        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
        return ()=>{
            observer.disconnect();
        };
    }, []);
    // Check if stream changed and setup a new MediaSource if needed
    (0, $gwFzn.useEffect)(()=>{
        if (stream !== streamRef.current) handleStreamChange(stream);
    }, [
        stream,
        onError,
        handleStreamChange
    ]);
    // Setup MediaSource
    (0, $gwFzn.useEffect)(()=>{
        const setupAudio = async ()=>{
            const audio = audioRef.current;
            if (!audio) return;
            try {
                const { mediaSource: mediaSource, sourceBuffer: sourceBuffer } = await $d3cbd33be048c158$var$setupMediaSource(audio);
                mediaSourceRef.current = mediaSource;
                sourceBufferRef.current = sourceBuffer;
                setIsMediaSourceReady(true);
            } catch (e) {
                onError(e);
            }
        };
        setupAudio().catch(onError);
        return ()=>{
            $d3cbd33be048c158$var$cleanupMediaSource(mediaSourceRef.current);
            setIsMediaSourceReady(false);
            mediaSourceRef.current = null;
            sourceBufferRef.current = null;
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isAudioMounted
    ]);
    // Handle streaming
    (0, $gwFzn.useEffect)(()=>{
        let isMounted = true;
        const handleStream = async ()=>{
            try {
                if (!stream || !sourceBufferRef.current) return;
                const reader = stream.getReader();
                const isFirstChunk = true;
                while(isMounted){
                    const { done: done, value: value } = await reader.read();
                    if (done) {
                        setStreamEnded && setStreamEnded(true);
                        break;
                    }
                    if (!isMounted) break;
                    if (!sourceBufferRef.current) break;
                    await $d3cbd33be048c158$var$appendChunk(sourceBufferRef.current, value, isFirstChunk, audioRef.current, onError);
                }
                if (isMounted && mediaSourceRef.current?.readyState === 'open') mediaSourceRef.current.endOfStream();
            } catch (e) {
                if (isMounted) onError(e);
            }
        };
        if (stream && isMediaSourceReady && sourceBufferRef.current) handleStream();
        return ()=>{
            isMounted = false;
        };
    }, [
        stream,
        onError,
        isMediaSourceReady,
        setStreamEnded
    ]);
    return {
        audioRef: audioRef
    };
};

});

parcelRegister("i6GHH", function(module, exports) {

$parcel$export(module.exports, "useAudioEventListener", () => $5df2670243cbe9b5$export$32d74bbfb1c00b7c);

var $gwFzn = parcelRequire("gwFzn");
const $5df2670243cbe9b5$export$32d74bbfb1c00b7c = ({ audioRef: audioRef, onContentPaused: onContentPaused, onContentResumed: onContentResumed, onContentEnded: onContentEnded })=>{
    const audio = audioRef.current;
    const eventListenersWereAdded = (0, $gwFzn.useRef)(false);
    (0, $gwFzn.useEffect)(()=>{
        if (!audio || eventListenersWereAdded.current) return;
        eventListenersWereAdded.current = true;
        const onPaused = ()=>{
            onContentPaused();
        };
        const onPlayed = ()=>{
            onContentResumed();
        };
        const onEnded = ()=>{
            onContentEnded();
        };
        const onCanPlay = async ()=>{
            await audio.play();
        };
        audio.addEventListener('pause', onPaused);
        audio.addEventListener('play', onPlayed);
        audio.addEventListener('ended', onEnded);
        audio.addEventListener('canplay', onCanPlay);
        return ()=>{
            if (audio && eventListenersWereAdded.current) {
                audio.removeEventListener('pause', onPaused);
                audio.removeEventListener('play', onPlayed);
                audio.removeEventListener('ended', onEnded);
                audio.removeEventListener('canplay', onCanPlay);
            }
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        audio
    ]);
};

});

parcelRegister("6vpdW", function(module, exports) {

$parcel$export(module.exports, "AudioTimeIndicator", () => $56e8a8b546486d13$export$1ce816177bf69471);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $gdv5Z = parcelRequire("gdv5Z");
var $u9agA = parcelRequire("u9agA");
var $iXCQx = parcelRequire("iXCQx");

var $igbBp = parcelRequire("igbBp");
const $56e8a8b546486d13$var$DEFAULT_TIME_DISPLAY = '0:00';
// Extra padding ensures there is no spacing change when transitioning to/from the generating animation
const $56e8a8b546486d13$var$PaddedBox = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gdv5Z.default), {
        paddingBlock: "space.025"
    }, children);
const $56e8a8b546486d13$var$i18n = (0, $2nPZH.defineMessages)({
    generatingAudioAnimationAlt: {
        id: "audio.audio-time-indicator.generating-alt",
        defaultMessage: "Generating"
    },
    loadingStateMessage: {
        id: "audio.audio-time-indicator.loading-state-message",
        defaultMessage: "Generating briefing..."
    },
    generateAudioMessage: {
        id: "audio.audio-time-indicator.generate-audio-message",
        defaultMessage: "Press play to generate a briefing"
    }
});
const $56e8a8b546486d13$var$formatTime = (timeInSeconds)=>{
    const minutes = Math.floor(timeInSeconds / 60);
    const seconds = Math.floor(timeInSeconds % 60);
    return `${minutes}:${seconds.toString().padStart(2, '0')}`;
};
const $56e8a8b546486d13$var$TextWrapper = ({ children: children, variant: variant })=>{
    if (variant === 'blue') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $iXCQx.default), {
        color: "color.text.selected",
        weight: "medium"
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $iXCQx.default), {
        color: "color.text.subtle",
        weight: "regular"
    }, children);
};
const $56e8a8b546486d13$var$DividerWrapper = ({ children: children, variant: variant })=>{
    if (variant === 'blue') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $iXCQx.default), {
        color: "color.text.disabled",
        weight: "semibold"
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $iXCQx.default), {
        color: "color.text.subtlest",
        weight: "medium"
    }, children);
};
const $56e8a8b546486d13$var$AudioStatus = ({ hasFetched: hasFetched })=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const message = !hasFetched ? $56e8a8b546486d13$var$i18n.generateAudioMessage : $56e8a8b546486d13$var$i18n.loadingStateMessage;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($56e8a8b546486d13$var$PaddedBox, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $iXCQx.default), {
        color: "color.text.subtle"
    }, formatMessage(message)));
};
const $56e8a8b546486d13$export$1ce816177bf69471 = ({ audioRef: audioRef, isLoading: isLoading, hasFetched: hasFetched = true, variant: variant = 'default' })=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const [currentTimeDisplay, setCurrentTimeDisplay] = (0, $gwFzn.useState)($56e8a8b546486d13$var$DEFAULT_TIME_DISPLAY);
    const [totalTimeDisplay, setTotalTimeDisplay] = (0, $gwFzn.useState)($56e8a8b546486d13$var$DEFAULT_TIME_DISPLAY);
    const handleTimeUpdate = (0, $gwFzn.useCallback)(()=>{
        const audioEl = audioRef.current;
        if (!audioEl) return;
        const currentTime = Math.floor(audioEl.currentTime ?? 0);
        setCurrentTimeDisplay($56e8a8b546486d13$var$formatTime(currentTime));
    }, [
        audioRef
    ]);
    const handleDurationChange = (0, $gwFzn.useCallback)(()=>{
        const audioEl = audioRef.current;
        if (!audioEl) return;
        if (audioEl.duration !== Infinity) setTotalTimeDisplay($56e8a8b546486d13$var$formatTime(audioEl.duration));
        else setTotalTimeDisplay($56e8a8b546486d13$var$DEFAULT_TIME_DISPLAY);
    }, [
        audioRef
    ]);
    (0, $gwFzn.useEffect)(()=>{
        const audioEl = audioRef.current;
        if (!audioEl) {
            setCurrentTimeDisplay($56e8a8b546486d13$var$DEFAULT_TIME_DISPLAY);
            setTotalTimeDisplay($56e8a8b546486d13$var$DEFAULT_TIME_DISPLAY);
            return;
        }
        audioEl.addEventListener('durationchange', handleDurationChange);
        audioEl.addEventListener('timeupdate', handleTimeUpdate);
        return ()=>{
            audioEl.removeEventListener('durationchange', handleDurationChange);
            audioEl.removeEventListener('timeupdate', handleTimeUpdate);
        };
    }, [
        audioRef,
        handleTimeUpdate,
        handleDurationChange
    ]);
    const isAudioDurationUnknown = isLoading || totalTimeDisplay === $56e8a8b546486d13$var$DEFAULT_TIME_DISPLAY;
    if (isLoading || !hasFetched) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($56e8a8b546486d13$var$AudioStatus, {
        hasFetched: hasFetched
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gdv5Z.default), {
        testId: "audio-time-indicator"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $u9agA.default), {
        alignInline: "center",
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($56e8a8b546486d13$var$PaddedBox, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($56e8a8b546486d13$var$TextWrapper, {
        variant: variant
    }, isLoading ? $56e8a8b546486d13$var$DEFAULT_TIME_DISPLAY : currentTimeDisplay)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($56e8a8b546486d13$var$PaddedBox, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($56e8a8b546486d13$var$DividerWrapper, {
        variant: variant
    }, "/")), isAudioDurationUnknown ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $igbBp.GeneratingStreamAnimation), {
        alt: formatMessage($56e8a8b546486d13$var$i18n.generatingAudioAnimationAlt)
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($56e8a8b546486d13$var$PaddedBox, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($56e8a8b546486d13$var$TextWrapper, {
        variant: variant
    }, totalTimeDisplay))));
};

});

parcelRegister("gJrae", function(module, exports) {

$parcel$export(module.exports, "MiniplayerControls", () => $d18a72d7e87d3297$export$94d452cfe99f9aa);
/* MiniplayerControls.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gwFzn = parcelRequire("gwFzn");

var $1s5hv = parcelRequire("1s5hv");
var $d8SNb = parcelRequire("d8SNb");

var $8S7P4 = parcelRequire("8S7P4");

var $6w4MZ = parcelRequire("6w4MZ");

var $1fFIc = parcelRequire("1fFIc");

var $21Ue0 = parcelRequire("21Ue0");

var $luyqN = parcelRequire("luyqN");
const $d18a72d7e87d3297$var$gridStyles = {
    root: "_yv0e1n6q"
};
const $d18a72d7e87d3297$export$94d452cfe99f9aa = ({ audioRef: audioRef, isLoading: isLoading, isPlaying: isPlaying })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $d8SNb.default), {
        testId: "miniplayer-controls",
        xcss: $d18a72d7e87d3297$var$gridStyles.root
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1s5hv.default), {
        justifyContent: "space-evenly",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $luyqN.PlayFromBeginningButton), {
        audioRef: audioRef,
        isDisabled: isLoading
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $21Ue0.SkipBackButton), {
        audioRef: audioRef,
        isDisabled: isLoading
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $8S7P4.PlayPauseButton), {
        audioRef: audioRef,
        isPlaying: isPlaying,
        isLoading: isLoading
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $d8SNb.default), {
        xcss: $d18a72d7e87d3297$var$gridStyles.root
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1s5hv.default), {
        justifyContent: "center",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1fFIc.SkipForwardButton), {
        audioRef: audioRef,
        isDisabled: isLoading
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1s5hv.default), {
        justifyContent: "center",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6w4MZ.PlaybackSpeedControl), null))));
};

});
parcelRegister("8S7P4", function(module, exports) {

$parcel$export(module.exports, "PlayPauseButton", () => $f03ada0265d82981$export$e0201548afaa4886);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $2W0qg = parcelRequire("2W0qg");
var $ecnYn = parcelRequire("ecnYn");

var $dQMPp = parcelRequire("dQMPp");

var $6F6hl = parcelRequire("6F6hl");

var $3gadb = parcelRequire("3gadb");

var $hpDFj = parcelRequire("hpDFj");

var $hLeLq = parcelRequire("hLeLq");

var $9hlns = parcelRequire("9hlns");
const $f03ada0265d82981$var$i18n = (0, $2nPZH.defineMessages)({
    pauseButtonLabel: {
        id: "audio.play-pause-button.pause-label",
        defaultMessage: "Pause"
    },
    playButtonLabel: {
        id: "audio.play-pause-button.play-label",
        defaultMessage: "Play"
    },
    loadingButtonLabel: {
        id: "audio.play-pause-button.loading-label",
        defaultMessage: "Loading"
    }
});
// These styles "extend" the IconTile to give the appearance of more padding around the icon
const $f03ada0265d82981$var$buttonStyles = (0, $ecnYn.xcss)({
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'color.background.brand.bold',
    borderRadius: 'border.radius.circle',
    width: '2.75rem',
    height: '2.75rem'
});
const $f03ada0265d82981$export$e0201548afaa4886 = ({ audioRef: audioRef, isPlaying: isPlaying, isLoading: isLoading, hasFetched: hasFetched = true, fetchContent: fetchContent })=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const pressableRef = (0, $gwFzn.useRef)(null);
    (0, $gwFzn.useEffect)(()=>{
        if (pressableRef.current) pressableRef.current.focus();
    }, []);
    let labelValue;
    let buttonIcon;
    if (isLoading) {
        labelValue = formatMessage($f03ada0265d82981$var$i18n.loadingButtonLabel);
        buttonIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $9hlns.default), {
            appearance: "invert",
            label: labelValue,
            testId: "miniplayer-loading"
        });
    } else if (isPlaying) {
        labelValue = formatMessage($f03ada0265d82981$var$i18n.pauseButtonLabel);
        buttonIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dQMPp.default), {
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($hpDFj))),
            appearance: "blueBold",
            shape: "circle",
            size: "32",
            label: labelValue,
            testId: "miniplayer-pause"
        });
    } else {
        labelValue = formatMessage($f03ada0265d82981$var$i18n.playButtonLabel);
        buttonIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dQMPp.default), {
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($hLeLq))),
            appearance: "blueBold",
            shape: "circle",
            size: "32",
            label: labelValue,
            testId: "miniplayer-play"
        });
    }
    const handlePause = ()=>{
        if (audioRef.current) audioRef.current.pause();
    };
    const handlePlay = async ()=>{
        if (audioRef.current && hasFetched) await audioRef.current.play();
        else fetchContent?.();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $3gadb.default), {
        content: labelValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $2W0qg.default), {
        xcss: $f03ada0265d82981$var$buttonStyles,
        onClick: isPlaying ? handlePause : handlePlay,
        componentName: "PlayPauseButton",
        ref: pressableRef,
        isDisabled: isLoading
    }, buttonIcon, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6F6hl.default), null, labelValue)));
};

});
parcelRegister("hpDFj", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::73df1d388ecc854df8671cdf3cc68b05>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cad38a2b50edf218$var$_react = $cad38a2b50edf218$var$_interopRequireDefault((parcelRequire("gwFzn")));

var $cad38a2b50edf218$var$_baseNew = $cad38a2b50edf218$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $cad38a2b50edf218$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "VideoPauseOverlay".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for pause video when icon is overlayed on Media.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $cad38a2b50edf218$var$VideoPauseOverlayIcon = (props)=>/*#__PURE__*/ $cad38a2b50edf218$var$_react.default.createElement($cad38a2b50edf218$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 3a2 2 0 0 1 2-2h1a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2zm7 0a2 2 0 0 1 2-2h1a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2z" clip-rule="evenodd"/>`
    }, props));
$cad38a2b50edf218$var$VideoPauseOverlayIcon.displayName = 'VideoPauseOverlayIcon';
var $cad38a2b50edf218$var$_default = module.exports.default = $cad38a2b50edf218$var$VideoPauseOverlayIcon;

});

parcelRegister("hLeLq", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d2e3c8fcba4e62054ef71c09ada81e61>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cee2474668e13f28$var$_react = $cee2474668e13f28$var$_interopRequireDefault((parcelRequire("gwFzn")));

var $cee2474668e13f28$var$_baseNew = $cee2474668e13f28$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $cee2474668e13f28$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "VideoPlayOverlay".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for play video when icon is overlayed on Media.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $cee2474668e13f28$var$VideoPlayOverlayIcon = (props)=>/*#__PURE__*/ $cee2474668e13f28$var$_react.default.createElement($cee2474668e13f28$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 3.112C2 1.592 3.63.627 4.963 1.36l8.902 4.888c1.383.76 1.383 2.747 0 3.506l-8.902 4.888C3.63 15.373 2 14.408 2 12.888z" clip-rule="evenodd"/>`
    }, props));
$cee2474668e13f28$var$VideoPlayOverlayIcon.displayName = 'VideoPlayOverlayIcon';
var $cee2474668e13f28$var$_default = module.exports.default = $cee2474668e13f28$var$VideoPlayOverlayIcon;

});


parcelRegister("6w4MZ", function(module, exports) {

$parcel$export(module.exports, "PlaybackSpeedControl", () => $eaeaf3d1012d3e77$export$94e3bad7a674d259);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $1s5hv = parcelRequire("1s5hv");
var $iXCQx = parcelRequire("iXCQx");

var $52EPl = parcelRequire("52EPl");
var $dAYOx = parcelRequire("dAYOx");
var $ahaN7 = parcelRequire("ahaN7");

var $ccHMk = parcelRequire("ccHMk");

var $aVEh3 = parcelRequire("aVEh3");
const $eaeaf3d1012d3e77$var$i18n = (0, $2nPZH.defineMessages)({
    playbackSpeedLabel: {
        id: "audio.miniplayer-playback-speed-control.playback-speed-label",
        defaultMessage: "Playback Speed"
    },
    speedLabel08x: {
        id: "audio.miniplayer-playback-speed-control.speed-label-08x",
        defaultMessage: "0.8x"
    },
    speedLabel10x: {
        id: "audio.miniplayer-playback-speed-control.speed-label-10x",
        defaultMessage: "1x"
    },
    speedLabel12x: {
        id: "audio.miniplayer-playback-speed-control.speed-label-12x",
        defaultMessage: "1.2x"
    },
    speedLabel15x: {
        id: "audio.miniplayer-playback-speed-control.speed-label-15x",
        defaultMessage: "1.5x"
    },
    speedLabel17x: {
        id: "audio.miniplayer-playback-speed-control.speed-label-17x",
        defaultMessage: "1.7x"
    },
    speedLabel20x: {
        id: "audio.miniplayer-playback-speed-control.speed-label-20x",
        defaultMessage: "2x"
    }
});
const $eaeaf3d1012d3e77$export$94e3bad7a674d259 = ({ audioRef: audioRef, isDisabled: isDisabled })=>{
    const intl = (0, $dBxQj.default)();
    const [{ playbackSpeed: playbackSpeed }, { setContentPlaybackSpeed: setContentPlaybackSpeed }] = (0, $aVEh3.useAudioBriefing)();
    const handleSetSpeed = (0, $gwFzn.useCallback)((speed)=>{
        setContentPlaybackSpeed(speed);
        const audio = audioRef?.current;
        if (audio) audio.playbackRate = speed;
    }, [
        setContentPlaybackSpeed,
        audioRef
    ]);
    const PLAYBACK_RATES = (0, $gwFzn.useMemo)(()=>[
            {
                label: intl.formatMessage($eaeaf3d1012d3e77$var$i18n.speedLabel08x),
                value: 0.8
            },
            {
                label: intl.formatMessage($eaeaf3d1012d3e77$var$i18n.speedLabel10x),
                value: 1.0
            },
            {
                label: intl.formatMessage($eaeaf3d1012d3e77$var$i18n.speedLabel12x),
                value: 1.2
            },
            {
                label: intl.formatMessage($eaeaf3d1012d3e77$var$i18n.speedLabel15x),
                value: 1.5
            },
            {
                label: intl.formatMessage($eaeaf3d1012d3e77$var$i18n.speedLabel17x),
                value: 1.7
            },
            {
                label: intl.formatMessage($eaeaf3d1012d3e77$var$i18n.speedLabel20x),
                value: 2.0
            }
        ], [
        intl
    ]);
    const getLabel = (speed)=>PLAYBACK_RATES.find((item)=>item.value === speed)?.label;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $52EPl.default), {
        placement: "top-start",
        trigger: ({ triggerRef: triggerRef, ...triggerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1s5hv.default), {
                justifyContent: "center"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ccHMk.default), {
                ...triggerProps,
                ref: triggerRef,
                appearance: "subtle",
                isDisabled: isDisabled
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $iXCQx.default), {
                color: isDisabled ? 'color.text.disabled' : 'color.text.subtle',
                weight: "medium"
            }, getLabel(playbackSpeed))))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ahaN7.default), null, PLAYBACK_RATES.map(({ label: label, value: value })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dAYOx.default), {
            key: value,
            onClick: ()=>handleSetSpeed(value)
        }, label))));
};

});
parcelRegister("aVEh3", function(module, exports) {

$parcel$export(module.exports, "useAudioBriefing", () => $383af3bced28b02d$export$5f4418f41c33b771);

var $iFWZA = parcelRequire("iFWZA");
var $2S0Fz = parcelRequire("2S0Fz");
var $4ZoIm = parcelRequire("4ZoIm");

var $e9zUf = parcelRequire("e9zUf");
var $1UApO = parcelRequire("1UApO");

var $eRxem = parcelRequire("eRxem");

var $3KEcv = parcelRequire("3KEcv");

var $f6lSf = parcelRequire("f6lSf");
const $383af3bced28b02d$var$DEFAULT_CUSTOMIZATION = {
    tone: (0, $3KEcv.CustomTone).PROFESSIONAL,
    length: (0, $3KEcv.CustomLength).SHORT
};
const $383af3bced28b02d$var$DEFAULT_PLAYBACK_SPEED = 1;
const $383af3bced28b02d$var$safeParseJson = (json)=>{
    try {
        return JSON.parse(json);
    } catch (e) {
        return $383af3bced28b02d$var$DEFAULT_CUSTOMIZATION;
    }
};
const $383af3bced28b02d$var$initialAudioBriefingState = {
    activeContent: undefined,
    customization: $383af3bced28b02d$var$DEFAULT_CUSTOMIZATION,
    additionalResources: [],
    cloudId: '',
    activationId: '',
    locale: 'en-US',
    isLoading: false,
    isPlaying: false,
    isClosed: false,
    isEnded: false,
    hasFetched: false,
    playbackSpeed: $383af3bced28b02d$var$DEFAULT_PLAYBACK_SPEED,
    stream: undefined,
    error: undefined,
    streamEnded: false
};
const $383af3bced28b02d$export$924be06a1d1cfd91 = {
    initialize: (initialState)=>async ({ setState: setState })=>{
            const storedCustomization = (0, $e9zUf.confluenceLocalStorageInstance).getItem((0, $1UApO.keys).AI_AUDIO_BRIEFING_CUSTOMIZATION);
            const parsedCustomization = storedCustomization ? $383af3bced28b02d$var$safeParseJson(storedCustomization) : $383af3bced28b02d$var$DEFAULT_CUSTOMIZATION;
            const emptyAudioBriefingState = {
                stream: undefined,
                streamEnded: false,
                activeContent: undefined,
                customization: parsedCustomization,
                additionalResources: [],
                locale: 'en-US',
                cloudId: '',
                activationId: '',
                isLoading: false,
                isPlaying: false,
                isClosed: false,
                isEnded: false,
                hasFetched: false,
                error: undefined,
                playbackSpeed: Number((0, $e9zUf.confluenceLocalStorageInstance).getItem((0, $1UApO.keys).AI_AUDIO_PLAYBACK_SPEED)) || $383af3bced28b02d$var$DEFAULT_PLAYBACK_SPEED
            };
            setState(Object.assign(emptyAudioBriefingState, initialState));
        },
    reset: ()=>({ setState: setState })=>{
            setState($383af3bced28b02d$var$initialAudioBriefingState);
        },
    addAdditionalResource: (newAdditionalResource)=>({ getState: getState, setState: setState })=>{
            const { additionalResources: additionalResources } = getState();
            setState({
                additionalResources: [
                    ...additionalResources,
                    newAdditionalResource
                ]
            });
        },
    removeAdditionalResource: (urlToRemove)=>({ getState: getState, setState: setState })=>{
            const { additionalResources: additionalResources } = getState();
            const newResourcesList = additionalResources.filter((resource)=>resource.url !== urlToRemove);
            setState({
                additionalResources: newResourcesList
            });
        },
    fetchBriefing: ()=>async ({ getState: getState, setState: setState, dispatch: dispatch })=>{
            dispatch($383af3bced28b02d$export$924be06a1d1cfd91.onLoadStart());
            const { activeContent: activeContent, cloudId: cloudId, activationId: activationId, locale: locale, customization: customization } = getState();
            if (!activeContent) {
                dispatch($383af3bced28b02d$export$924be06a1d1cfd91.setContentError(new Error('Briefing container needs to be initialized')));
                return;
            }
            const activeContentAri = (0, $f6lSf.getConfluenceContentAri)(cloudId, activeContent.id, activeContent.contentType);
            if (!activeContentAri) {
                dispatch($383af3bced28b02d$export$924be06a1d1cfd91.setContentError(new Error('Content ARI failed to generate')));
                return;
            }
            const audioRequest = {
                activeContentAri: activeContentAri,
                // TODO: Implement new additional resources
                additionalResources: [],
                activationId: activationId,
                locale: locale,
                customization: customization
            };
            try {
                const stream = await (0, $eRxem.getBriefing)(audioRequest);
                if (getState().isClosed) return;
                setState({
                    isPlaying: false,
                    isEnded: false,
                    stream: stream
                });
            } catch (e) {
                setState({
                    error: e,
                    stream: undefined
                });
            } finally{
                dispatch($383af3bced28b02d$export$924be06a1d1cfd91.onLoadEnd());
            }
        },
    onLoadStart: ()=>({ setState: setState })=>{
            setState({
                isLoading: true,
                hasFetched: true,
                error: undefined,
                streamEnded: false
            });
        },
    onLoadEnd: ()=>({ setState: setState })=>{
            setState({
                isLoading: false
            });
        },
    pauseContent: ()=>({ setState: setState })=>{
            setState({
                isPlaying: false
            });
        },
    resumeContent: ()=>({ setState: setState, getState: getState })=>{
            const { stream: stream } = getState();
            if (!stream) throw new Error('Must fetch before playing');
            setState({
                isPlaying: true,
                isEnded: false
            });
        },
    setContentPlaybackSpeed: (speed)=>({ setState: setState })=>{
            (0, $e9zUf.confluenceLocalStorageInstance).setItem((0, $1UApO.keys).AI_AUDIO_PLAYBACK_SPEED, speed);
            setState({
                playbackSpeed: speed
            });
        },
    stopContent: ()=>async ({ dispatch: dispatch, setState: setState })=>{
            dispatch($383af3bced28b02d$export$924be06a1d1cfd91.reset());
            setState({
                isClosed: true
            });
        },
    endContent: ()=>({ setState: setState })=>{
            setState({
                isEnded: true,
                isPlaying: false
            });
        },
    setContentError: (error)=>({ setState: setState })=>{
            setState({
                error: error
            });
        },
    setStreamEnded: (streamEnded)=>({ setState: setState })=>{
            setState({
                streamEnded: streamEnded
            });
        },
    setCustomization: (newCustomization)=>({ setState: setState, getState: getState })=>{
            const { customization: customization } = getState();
            const updatedCustomization = {
                ...customization,
                ...newCustomization
            };
            (0, $e9zUf.confluenceLocalStorageInstance).setItem((0, $1UApO.keys).AI_AUDIO_BRIEFING_CUSTOMIZATION, JSON.stringify({
                tone: updatedCustomization.tone,
                length: updatedCustomization.length
            }));
            setState({
                customization: updatedCustomization
            });
        }
};
const $383af3bced28b02d$export$390f32400eaf98c9 = (0, $4ZoIm.createStore)({
    initialState: {
        activeContent: undefined,
        customization: $383af3bced28b02d$var$DEFAULT_CUSTOMIZATION,
        additionalResources: [],
        cloudId: '',
        activationId: '',
        locale: 'en-US',
        isLoading: false,
        isPlaying: false,
        isClosed: false,
        isEnded: false,
        hasFetched: false,
        playbackSpeed: 1,
        error: undefined,
        streamEnded: false
    },
    actions: $383af3bced28b02d$export$924be06a1d1cfd91,
    name: 'listenerState'
});
const $383af3bced28b02d$export$ff3c0e7d5b0100a7 = (0, $2S0Fz.createContainer)($383af3bced28b02d$export$390f32400eaf98c9, {
    onInit: ()=>async ({ dispatch: dispatch }, { initialAudioBriefingState: initialAudioPlaybackState })=>{
            dispatch($383af3bced28b02d$export$924be06a1d1cfd91.initialize(initialAudioPlaybackState));
        }
});
const $383af3bced28b02d$export$5f4418f41c33b771 = (0, $iFWZA.createHook)($383af3bced28b02d$export$390f32400eaf98c9);
const $383af3bced28b02d$export$722396384dacf938 = (0, $iFWZA.createActionsHook)($383af3bced28b02d$export$390f32400eaf98c9);

});
parcelRegister("3KEcv", function(module, exports) {

$parcel$export(module.exports, "CustomTone", () => $6babaf5010ad9ae0$export$22914fe597403470);
$parcel$export(module.exports, "CustomLength", () => $6babaf5010ad9ae0$export$91791b32a6f45c02);
const $6babaf5010ad9ae0$export$22914fe597403470 = {
    PLAYFUL: 'playful',
    PROFESSIONAL: 'professional',
    CONVERSATIONAL: 'conversational',
    SURPRISE: 'surprise'
};
const $6babaf5010ad9ae0$export$91791b32a6f45c02 = {
    SHORT: 'short',
    MEDIUM: 'medium',
    LONG: 'long'
};

});

parcelRegister("f6lSf", function(module, exports) {

$parcel$export(module.exports, "getConfluenceContentAri", () => $f16877b6875ebf37$export$6a2f2c83863e9bfe);

var $ayhth = parcelRequire("ayhth");
var $ixUm0 = parcelRequire("ixUm0");
var $iILKK = parcelRequire("iILKK");
const $f16877b6875ebf37$export$6a2f2c83863e9bfe = (siteId, contentId, contentType)=>{
    try {
        switch(contentType){
            case 'page':
                return (0, $ixUm0.ConfluencePageAri).create({
                    siteId: siteId,
                    pageId: contentId
                });
            case 'blogpost':
                return (0, $ayhth.ConfluenceBlogpostAri).create({
                    siteId: siteId,
                    blogpostId: contentId
                });
            case 'whiteboard':
                return (0, $iILKK.ConfluenceWhiteboardAri).create({
                    siteId: siteId,
                    whiteboardId: contentId
                });
        }
    } catch  {
        return undefined;
    }
    return undefined;
};

});



parcelRegister("1fFIc", function(module, exports) {

$parcel$export(module.exports, "SkipForwardButton", () => $e857fb858ffab4fd$export$28c69814f23535ab);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $1qfLF = parcelRequire("1qfLF");

var $7xRSp = parcelRequire("7xRSp");
const $e857fb858ffab4fd$var$SKIP_SECONDS = 15;
const $e857fb858ffab4fd$var$START_SECONDS = 0;
const $e857fb858ffab4fd$var$i18n = (0, $2nPZH.defineMessages)({
    skipForwardButtonLabel: {
        id: "audio.miniplayer-controls.skip-forward-label",
        defaultMessage: "Skip Forward"
    }
});
const $e857fb858ffab4fd$export$28c69814f23535ab = ({ audioRef: audioRef, isDisabled: isDisabled = false })=>{
    const intl = (0, $dBxQj.default)();
    const handleSkipForward = ()=>{
        const audio = audioRef.current;
        if (audio && audio.duration) {
            if (audio.currentTime >= audio.duration - $e857fb858ffab4fd$var$SKIP_SECONDS) {
                audio.currentTime = $e857fb858ffab4fd$var$START_SECONDS;
                setTimeout(()=>audio.pause(), 100); // Small delay to ensure current time is reset and rendered before pausing
            } else audio.currentTime += $e857fb858ffab4fd$var$SKIP_SECONDS;
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1qfLF.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($7xRSp))),
        label: intl.formatMessage($e857fb858ffab4fd$var$i18n.skipForwardButtonLabel),
        tooltip: {
            content: intl.formatMessage($e857fb858ffab4fd$var$i18n.skipForwardButtonLabel)
        },
        isTooltipDisabled: false,
        appearance: "subtle",
        testId: "miniplayer-skip-forward",
        onClick: handleSkipForward,
        isDisabled: isDisabled
    });
};

});
parcelRegister("7xRSp", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::26f8728404d627f91d86970013dafd0b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $57e5683831f661a1$var$_react = $57e5683831f661a1$var$_interopRequireDefault((parcelRequire("gwFzn")));

var $57e5683831f661a1$var$_baseNew = $57e5683831f661a1$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $57e5683831f661a1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "VideoSkipForwardFifteen".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for skipping video content forward by 15 seconds.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $57e5683831f661a1$var$VideoSkipForwardFifteenIcon = (props)=>/*#__PURE__*/ $57e5683831f661a1$var$_react.default.createElement($57e5683831f661a1$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m12.78.22 3 3a.75.75 0 0 1 0 1.06l-3 3-1.06-1.06 2.47-2.47-2.47-2.47z" clip-rule="evenodd"/><path fill="currentcolor" fill-rule="evenodd" d="m9.28.22 3 3a.75.75 0 0 1 0 1.06l-3 3-1.06-1.06L9.94 4.5H4.25A1.75 1.75 0 0 0 2.5 6.25v3.5c0 .967.784 1.75 1.75 1.75H5V13h-.75A3.25 3.25 0 0 1 1 9.75v-3.5A3.25 3.25 0 0 1 4.25 3h5.69L8.22 1.28z" clip-rule="evenodd"/><path fill="currentcolor" fill-rule="evenodd" d="M7 9.5h1.75a.75.75 0 0 1 .75.75V16H8v-5H7zm8 0h-3.25a.75.75 0 0 0-.75.75v2.5c0 .41.34.75.75.75h1.75v1H11V16h2.63c.76 0 1.38-.62 1.38-1.37v-1.25c0-.76-.62-1.37-1.37-1.37H12.5v-1H15z" clip-rule="evenodd"/>`
    }, props));
$57e5683831f661a1$var$VideoSkipForwardFifteenIcon.displayName = 'VideoSkipForwardFifteenIcon';
var $57e5683831f661a1$var$_default = module.exports.default = $57e5683831f661a1$var$VideoSkipForwardFifteenIcon;

});


parcelRegister("21Ue0", function(module, exports) {

$parcel$export(module.exports, "SkipBackButton", () => $d990e7ebd82b69f1$export$70885cced56339a);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $1qfLF = parcelRequire("1qfLF");

var $aolCq = parcelRequire("aolCq");
const $d990e7ebd82b69f1$var$SKIP_SECONDS = 15;
const $d990e7ebd82b69f1$var$START_SECONDS = 0;
const $d990e7ebd82b69f1$var$i18n = (0, $2nPZH.defineMessages)({
    skipBackButtonLabel: {
        id: "audio.miniplayer-controls.skip-back-label",
        defaultMessage: "Skip Back"
    }
});
const $d990e7ebd82b69f1$export$70885cced56339a = ({ audioRef: audioRef, isDisabled: isDisabled = false })=>{
    const intl = (0, $dBxQj.default)();
    const handleSkipBack = ()=>{
        const audio = audioRef.current;
        if (audio) {
            if (audio.currentTime <= $d990e7ebd82b69f1$var$SKIP_SECONDS) audio.currentTime = $d990e7ebd82b69f1$var$START_SECONDS;
            else audio.currentTime -= $d990e7ebd82b69f1$var$SKIP_SECONDS;
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1qfLF.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($aolCq))),
        label: intl.formatMessage($d990e7ebd82b69f1$var$i18n.skipBackButtonLabel),
        tooltip: {
            content: intl.formatMessage($d990e7ebd82b69f1$var$i18n.skipBackButtonLabel)
        },
        isTooltipDisabled: false,
        appearance: "subtle",
        testId: "miniplayer-skip-back",
        onClick: handleSkipBack,
        isDisabled: isDisabled
    });
};

});
parcelRegister("aolCq", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a21fc4c357261b228c91b1266339bdf4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $790cea4d01625bae$var$_react = $790cea4d01625bae$var$_interopRequireDefault((parcelRequire("gwFzn")));

var $790cea4d01625bae$var$_baseNew = $790cea4d01625bae$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $790cea4d01625bae$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "VideoSkipBackwardFifteen".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for skipping video content backward by 15 seconds.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $790cea4d01625bae$var$VideoSkipBackwardFifteenIcon = (props)=>/*#__PURE__*/ $790cea4d01625bae$var$_react.default.createElement($790cea4d01625bae$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m1.81 3.75 2.47-2.47L3.22.22l-3 3a.75.75 0 0 0 0 1.06l3 3 1.06-1.06z" clip-rule="evenodd"/><path fill="currentcolor" fill-rule="evenodd" d="m6.06 4.5 1.72 1.72-1.06 1.06-3-3a.75.75 0 0 1 0-1.06l3-3 1.06 1.06L6.06 3h5.69A3.25 3.25 0 0 1 15 6.25v3.5A3.25 3.25 0 0 1 11.75 13H11v-1.5h.75a1.75 1.75 0 0 0 1.75-1.75v-3.5a1.75 1.75 0 0 0-1.75-1.75zM1 9.5h1.75a.75.75 0 0 1 .75.75V16H2v-5H1z" clip-rule="evenodd"/><path fill="currentcolor" fill-rule="evenodd" d="M9 9.5H5.75a.75.75 0 0 0-.75.75v2.5c0 .414.336.75.75.75H7.5v1H5V16h2.625C8.385 16 9 15.384 9 14.625v-1.25C9 12.615 8.384 12 7.625 12H6.5v-1H9z" clip-rule="evenodd"/>`
    }, props));
$790cea4d01625bae$var$VideoSkipBackwardFifteenIcon.displayName = 'VideoSkipBackwardFifteenIcon';
var $790cea4d01625bae$var$_default = module.exports.default = $790cea4d01625bae$var$VideoSkipBackwardFifteenIcon;

});


parcelRegister("luyqN", function(module, exports) {

$parcel$export(module.exports, "PlayFromBeginningButton", () => $b0b472edf7018363$export$8c6adc17175bd77e);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $1qfLF = parcelRequire("1qfLF");

var $1f7Pm = parcelRequire("1f7Pm");
const $b0b472edf7018363$var$START_SECONDS = 0;
const $b0b472edf7018363$var$i18n = (0, $2nPZH.defineMessages)({
    playFromBeginningLabel: {
        id: "audio.miniplayer-controls.play-from-beginning-label",
        defaultMessage: "Play from beginning"
    }
});
const $b0b472edf7018363$export$8c6adc17175bd77e = ({ audioRef: audioRef, isDisabled: isDisabled = false })=>{
    const intl = (0, $dBxQj.default)();
    const handlePlayFromBeginning = async ()=>{
        const audio = audioRef.current;
        if (audio) {
            audio.currentTime = $b0b472edf7018363$var$START_SECONDS;
            if (audio.paused) await audio.play();
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1qfLF.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($1f7Pm))),
        label: intl.formatMessage($b0b472edf7018363$var$i18n.playFromBeginningLabel),
        tooltip: {
            content: intl.formatMessage($b0b472edf7018363$var$i18n.playFromBeginningLabel)
        },
        appearance: "subtle",
        testId: "miniplayer-play-from-beginning",
        onClick: handlePlayFromBeginning,
        isDisabled: isDisabled
    });
};

});
parcelRegister("1f7Pm", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8d9b11e6de0fde4449547e0c41b028c2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0e7d43897707ee94$var$_react = $0e7d43897707ee94$var$_interopRequireDefault((parcelRequire("gwFzn")));

var $0e7d43897707ee94$var$_baseNew = $0e7d43897707ee94$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $0e7d43897707ee94$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "VideoPrevious".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for previous video in Media.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0e7d43897707ee94$var$VideoPreviousIcon = (props)=>/*#__PURE__*/ $0e7d43897707ee94$var$_react.default.createElement($0e7d43897707ee94$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3 1v14h1.5V8.708c.147.336.404.633.77.831l6.148 3.323A1.75 1.75 0 0 0 14 11.322V4.678a1.75 1.75 0 0 0-2.582-1.54L5.27 6.462a1.73 1.73 0 0 0-.771.83V1zm9.131 3.457a.25.25 0 0 1 .369.22v6.646a.25.25 0 0 1-.369.22L5.984 8.22a.25.25 0 0 1 0-.44z" clip-rule="evenodd"/>`
    }, props));
$0e7d43897707ee94$var$VideoPreviousIcon.displayName = 'VideoPreviousIcon';
var $0e7d43897707ee94$var$_default = module.exports.default = $0e7d43897707ee94$var$VideoPreviousIcon;

});




parcelRegister("kwNRu", function(module, exports) {

$parcel$export(module.exports, "AudioPanelErrorComponent", () => $576b184ec4fe346f$export$98c4ac7c98d9d7c5);
/* AudioPanelErrorComponent.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $gdv5Z = parcelRequire("gdv5Z");
var $u9agA = parcelRequire("u9agA");
var $eyWa4 = parcelRequire("eyWa4");

var $gj7hi = parcelRequire("gj7hi");

var $7hXDW = parcelRequire("7hXDW");

var $dIouf = parcelRequire("dIouf");

var $2RVGw = parcelRequire("2RVGw");

var $l1LfY = parcelRequire("l1LfY");
const $576b184ec4fe346f$var$styles = {
    container: "_1rjcutpp _18zr1ejb",
    errorIllustrationContainer: "_1bsb53f4 _4t3i53f4",
    errorTextContainer: "_y3gn1h6o _o5726vc6"
};
const $576b184ec4fe346f$var$i18n = (0, $2nPZH.defineMessages)({
    errorMessage: {
        id: "audio.panel.error.message",
        defaultMessage: "The audio for this summary couldn\u2019t load. Please try again."
    },
    errorImgAlt: {
        id: "audio.panel.error.img.alt",
        defaultMessage: "Audio panel error illustration"
    }
});
const $576b184ec4fe346f$export$98c4ac7c98d9d7c5 = ({ error: error })=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $eyWa4.default), {
        alignInline: "center",
        xcss: $576b184ec4fe346f$var$styles.container,
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $u9agA.default), {
        xcss: $576b184ec4fe346f$var$styles.errorIllustrationContainer,
        alignInline: "center",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gj7hi.default), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($2RVGw))),
        alt: formatMessage($576b184ec4fe346f$var$i18n.errorImgAlt),
        srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($l1LfY)))
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $7hXDW.default), {
        size: "xsmall"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gdv5Z.default), {
        xcss: $576b184ec4fe346f$var$styles.errorTextContainer
    }, formatMessage($576b184ec4fe346f$var$i18n.errorMessage))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.ErrorDisplay), {
        error: error
    }));
};

});
parcelRegister("2RVGw", function(module, exports) {
module.exports = new URL("AudioPanelErrorIllustration.24fce6d6.svg", import.meta.url).toString();

});

parcelRegister("l1LfY", function(module, exports) {
module.exports = new URL("AudioPanelErrorIllustrationDark.fd4f5286.svg", import.meta.url).toString();

});




parcelRegister("iwjXf", function(module, exports) {

$parcel$export(module.exports, "useBulkIssueCreate", () => $4d055d79970682d8$export$ddc739fc0aea988a);

var $gwFzn = parcelRequire("gwFzn");

var $aUTn5 = parcelRequire("aUTn5");

var $1QMs7 = parcelRequire("1QMs7");

var $jln20 = parcelRequire("jln20");

var $cAdj8 = parcelRequire("cAdj8");
const $4d055d79970682d8$export$ddc739fc0aea988a = ({ contentId: contentId, content: content })=>{
    const rightSidebarContext = (0, $jln20.useRightSidebarContext)();
    const setIsCreatedWithAi = (0, $1QMs7.useSetIsCreatedWithAi)();
    const setIsCreatedFromTable = (0, $1QMs7.useSetIsCreatedFromTable)();
    const setInsertStorageFragmentRequestPayload = (0, $1QMs7.useSetInsertStorageFragmentRequestPayload)();
    const contentLastModifiedTimestamp = (0, $1QMs7.useGetContentLastModifiedTimestamp)();
    // eslint-disable-next-line confluence-sweet-state/sweet-state-prefer-actions-hook
    const [, issueCreateSidePanelActions] = (0, $1QMs7.useIssueCreateSidePanelContext)();
    const { pageInfo: pageInfo } = (0, $cAdj8.usePageInfo)({
        fetchPolicy: 'cache-first'
    });
    const hasEditPermission = (0, $gwFzn.useMemo)(()=>pageInfo?.operations?.some((op)=>op?.operation === 'update' && op?.targetType === pageInfo.type) || false, [
        pageInfo
    ]);
    return (0, $gwFzn.useCallback)(()=>{
        setIsCreatedWithAi(true);
        setIsCreatedFromTable(false);
        const range = (0, $1QMs7.getValidRange)((0, $1QMs7.getPageContentRange)());
        const payload = (0, $1QMs7.constructInsertStorageFragmentRequestPayload)(contentId, (0, $aUTn5.convertSelectionToLegacyFormat), range, content.current, contentLastModifiedTimestamp);
        setInsertStorageFragmentRequestPayload(payload);
        issueCreateSidePanelActions.setHasEditPermission(hasEditPermission);
        rightSidebarContext.open((0, $1QMs7.BULK_ISSUE_CREATE_SIDE_PANEL_ID), (0, $1QMs7.BULK_ISSUE_CREATE_SIDE_PANEL_WIDTH));
    }, [
        setIsCreatedWithAi,
        setIsCreatedFromTable,
        contentId,
        content,
        contentLastModifiedTimestamp,
        setInsertStorageFragmentRequestPayload,
        issueCreateSidePanelActions,
        hasEditPermission,
        rightSidebarContext
    ]);
};

});


parcelRegister("gHbiI", function(module, exports) {

$parcel$export(module.exports, "AIFloatingContextMenuPopupContent", () => $0eb3a6f6be084bf0$export$a5bda9e80ae7b12a);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $2Nwuj = parcelRequire("2Nwuj");

var $6f0Oj = parcelRequire("6f0Oj");
var $ecnYn = parcelRequire("ecnYn");

var $5kEnh = parcelRequire("5kEnh");

var $9wGTI = parcelRequire("9wGTI");
parcelRequire("1nIU4");
var $9VC5k = parcelRequire("9VC5k");
var $1nIU4 = parcelRequire("1nIU4");

var $JQEJY = parcelRequire("JQEJY");

var $ly2zj = parcelRequire("ly2zj");

var $bQm3c = parcelRequire("bQm3c");

var $8E5UF = parcelRequire("8E5UF");

var $7nXd3 = parcelRequire("7nXd3");
const $0eb3a6f6be084bf0$export$a7357cdd1f0b0168 = (0, $2nPZH.defineMessages)({
    aiFloatingContextMenuOptInDialogHeaderText: {
        id: "ai-floating-context-menu.opt-in.dialog.header.text",
        defaultMessage: "Work smarter, not harder"
    },
    aiFloatingContextMenuAdminOptInDialogBodyText: {
        id: "ai-floating-context-menu.admin.opt-in.dialog.body.text",
        defaultMessage: "Save your team time by reading an Al-generated summary instead of an entire page with <a>Atlassian Intelligence</a>. <br></br><br></br> Activate Atlassian Intelligence features for your users from Atlassian Administration."
    }
});
const $0eb3a6f6be084bf0$var$ATLASSIAN_INTELLIGENCE_LEARN_MORE_LINK = 'https://support.atlassian.com/organization-administration/docs/understand-atlassian-intelligence-features-in-products';
const $0eb3a6f6be084bf0$var$FeatureContentWidthStyles = (0, $ecnYn.xcss)({
    width: '500px'
});
const $0eb3a6f6be084bf0$export$a5bda9e80ae7b12a = /*#__PURE__*/ (0, $gwFzn.memo)(({ popupState: popupState, contentId: contentId, contentType: contentType, spaceKey: spaceKey, lastModifiedDate: lastModifiedDate, source: source, onClose: onClose, setIsOpen: setIsOpen, setPopupState: setPopupState, isLivePage: isLivePage = false })=>{
    const intl = (0, $dBxQj.default)();
    const { orgId: orgId } = (0, $bQm3c.useSessionData)();
    const adminLink = `https://admin.atlassian.com/o/${orgId}/atlassian-intelligence`;
    const formatOptInMessageValues = {
        a: (s)=>(0, $9wGTI.fg)('dst-a11y__replace-anchor-with-link__confluence-ai2') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $2Nwuj.default), {
                href: $0eb3a6f6be084bf0$var$ATLASSIAN_INTELLIGENCE_LEARN_MORE_LINK,
                target: "_blank"
            }, s) : // eslint-disable-next-line @atlaskit/design-system/no-html-anchor
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("a", {
                href: $0eb3a6f6be084bf0$var$ATLASSIAN_INTELLIGENCE_LEARN_MORE_LINK,
                target: "_blank"
            }, s),
        br: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("br", null)
    };
    const renderContent = ()=>{
        switch(popupState){
            case (0, $7nXd3.PopupStateTypes).Comments:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1nIU4.FooterCommentsSummaryCombined), {
                    contentId: contentId,
                    contentType: contentType,
                    source: (0, $9VC5k.CommentsSummarySource).Header,
                    spaceKey: spaceKey
                });
            case (0, $7nXd3.PopupStateTypes).PageCatchup:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $JQEJY.PageCatchupComponent), {
                    contentId: contentId,
                    contentType: contentType,
                    spaceKey: spaceKey
                });
            case (0, $7nXd3.PopupStateTypes).QuickSummary:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ly2zj.QuickSummaryStreamingComponent), {
                    contentId: contentId,
                    spaceKey: spaceKey,
                    contentType: contentType,
                    lastModifiedDate: lastModifiedDate,
                    setIsOpen: onClose,
                    source: source,
                    contentPath: window.location.pathname
                });
            case (0, $7nXd3.PopupStateTypes).Upsell:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ly2zj.QuickSummaryUpsell), null);
            case (0, $7nXd3.PopupStateTypes).OptIn:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5kEnh.default), {
                    source: "quickSummary",
                    product: "confluence",
                    isOrgAdmin: true,
                    headerText: intl.formatMessage($0eb3a6f6be084bf0$export$a7357cdd1f0b0168.aiFloatingContextMenuOptInDialogHeaderText),
                    adminBodyText: intl.formatMessage($0eb3a6f6be084bf0$export$a7357cdd1f0b0168.aiFloatingContextMenuAdminOptInDialogBodyText, formatOptInMessageValues),
                    adminLink: adminLink,
                    onAdminClose: ()=>setIsOpen(false)
                });
            default:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $8E5UF.AIFloatingContextMenuGroup), {
                    contentId: contentId,
                    contentType: contentType,
                    spaceKey: spaceKey,
                    setPopupState: setPopupState,
                    setIsOpen: setIsOpen,
                    isLivePage: isLivePage
                });
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: [
            (0, $7nXd3.isFeaturePopupState)(popupState) && $0eb3a6f6be084bf0$var$FeatureContentWidthStyles
        ]
    }, renderContent());
});

});
parcelRegister("1nIU4", function(module, exports) {

$parcel$export(module.exports, "FooterCommentsSummaryButton", () => $1e9b610eb1cdf77d$export$3a048a07ad083dab);
$parcel$export(module.exports, "FooterCommentsSummaryCombined", () => $1e9b610eb1cdf77d$export$33b519b7db786337);
$parcel$export(module.exports, "CommentsSummarySource", () => (parcelRequire("9VC5k")).CommentsSummarySource);

var $jmjWc = parcelRequire("jmjWc");

var $2Xvw9 = parcelRequire("2Xvw9");

var $9VC5k = parcelRequire("9VC5k");

const $1e9b610eb1cdf77d$export$3a048a07ad083dab = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "jDMq6",
    name: "FooterCommentsSummaryButton",
    loader: async ()=>(await (parcelRequire("hRIl6"))).FooterCommentsSummaryButton,
    loading: (0, $2Xvw9.FooterCommentsSummaryButtonPlaceholder)
});

const $1e9b610eb1cdf77d$export$33b519b7db786337 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "Rri5I",
    name: "FooterCommentsSummaryCombined",
    loader: async ()=>(await (parcelRequire("3WT1L"))).FooterCommentsSummaryCombinedWithErrorBoundary
});

});
parcelRegister("2Xvw9", function(module, exports) {

$parcel$export(module.exports, "FooterCommentsSummaryButtonPlaceholder", () => $d41e83e63ef9cc75$export$e3bdf22065c9715a);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $eEA8O = parcelRequire("eEA8O");

var $ly2zj = parcelRequire("ly2zj");

var $jhwJP = parcelRequire("jhwJP");
const $d41e83e63ef9cc75$var$i18nBase = (0, $2nPZH.defineMessages)({
    buttonLabel: {
        id: "ai-comments-summary.footer-comments-summary-button-placeholder.label.text",
        defaultMessage: "Summarize page comments"
    }
});
const $d41e83e63ef9cc75$var$i18nLiveDocs = (0, $2nPZH.defineMessages)({
    buttonLabel: {
        id: "ai-comments-summary.footer-comments-summary-button-placeholder.label.text.livedocs",
        defaultMessage: "Summarize general comments"
    }
});
const $d41e83e63ef9cc75$var$i18n = (0, $jhwJP.mergeLiveDocI18n)($d41e83e63ef9cc75$var$i18nBase, $d41e83e63ef9cc75$var$i18nLiveDocs);
const $d41e83e63ef9cc75$export$e3bdf22065c9715a = ()=>{
    const intl = (0, $dBxQj.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $eEA8O.default), {
        appearance: "subtle",
        isDisabled: true,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ly2zj.QuickSummaryIcon), {
            label: ""
        })
    }, intl.formatMessage($d41e83e63ef9cc75$var$i18n.buttonLabel));
};

});

parcelRegister("9VC5k", function(module, exports) {

$parcel$export(module.exports, "CommentsSummarySource", () => $28602bba7ed7c957$export$92985523ee81b88c);
$parcel$export(module.exports, "CommentsSummaryContent", () => $28602bba7ed7c957$export$dd076aaa63869f66);

var $gwFzn = parcelRequire("gwFzn");

var $gUu2y = parcelRequire("gUu2y");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $6f0Oj = parcelRequire("6f0Oj");
var $1GzhS = parcelRequire("1GzhS");
var $ecnYn = parcelRequire("ecnYn");

var $dpPtd = parcelRequire("dpPtd");

var $7hXDW = parcelRequire("7hXDW");

var $inPa6 = parcelRequire("inPa6");

var $fwDOR = parcelRequire("fwDOR");

var $fYQcF = parcelRequire("fYQcF");

var $dOOm2 = parcelRequire("dOOm2");
var $ajVmS = parcelRequire("ajVmS");
var $8LJEA = parcelRequire("8LJEA");

var $bQm3c = parcelRequire("bQm3c");

var $irVI7 = parcelRequire("irVI7");
var $1eaCJ = parcelRequire("1eaCJ");
var $1kHsc = parcelRequire("1kHsc");

var $3Am3T = parcelRequire("3Am3T");

var $ly2zj = parcelRequire("ly2zj");

var $9wGTI = parcelRequire("9wGTI");

var $jhwJP = parcelRequire("jhwJP");

var $jgs1o = parcelRequire("jgs1o");

var $hAXFW = parcelRequire("hAXFW");

var $7eOQq = parcelRequire("7eOQq");

var $jRog2 = parcelRequire("jRog2");

var $k6dR8 = parcelRequire("k6dR8");
const $28602bba7ed7c957$var$styles = (0, $ecnYn.xcss)({
    height: '100%',
    font: 'font.body.large'
});
const $28602bba7ed7c957$var$FooterObjectSidebarStyles = (0, $ecnYn.xcss)({
    // Object sidebar padding is 16px, this ensures that the footer isn't cutoff by parent padding
    width: 'calc(100% + 32px)',
    marginLeft: 'space.negative.200'
});
const $28602bba7ed7c957$var$i18nBase = (0, $2nPZH.defineMessages)({
    pageCommentsHeader: {
        id: "ai-comments-summary.combined-comments-summary.page-comments-header",
        defaultMessage: "Page comments"
    },
    inlineCommentsHeader: {
        id: "ai-comments-summary.combined-comments-summary.inline-comments-header",
        defaultMessage: "Inline comments"
    }
});
const $28602bba7ed7c957$var$i18nLiveDocs = (0, $2nPZH.defineMessages)({
    pageCommentsHeader: {
        id: "ai-comments-summary.combined-comments-summary.page-comments-header.livedocs",
        defaultMessage: "General comments"
    }
});
const $28602bba7ed7c957$var$i18n = (0, $jhwJP.mergeLiveDocI18n)($28602bba7ed7c957$var$i18nBase, $28602bba7ed7c957$var$i18nLiveDocs);
var $28602bba7ed7c957$export$92985523ee81b88c = /*#__PURE__*/ function(CommentsSummarySource) {
    CommentsSummarySource["Footer"] = "footer";
    CommentsSummarySource["Header"] = "header";
    CommentsSummarySource["Feed"] = "feed";
    return CommentsSummarySource;
}({});
const $28602bba7ed7c957$export$dd076aaa63869f66 = ({ contentId: contentId, contentType: contentType, spaceKey: spaceKey, onRefresh: onRefresh, shouldRefetchCommentsSummary: shouldRefetchCommentsSummary = false, source: source, isInObjectSidebar: isInObjectSidebar })=>{
    const intl = (0, $dBxQj.default)();
    const experienceTracker = (0, $gwFzn.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    const { footerCommentsCount: footerCommentsCount, unresolvedInlineCommentsCount: unresolvedInlineCommentsCount } = (0, $gwFzn.useContext)((0, $3Am3T.CommentCountsContext));
    const { trackAIInteractionInit: trackAIInteractionInit, trackAIResultView: trackAIResultView, trackAIInteractionDismiss: trackAIInteractionDismiss } = (0, $fYQcF.useAIEventsInstrumentation)();
    const contentTypeEnum = contentType === 'page' ? (0, $7eOQq.SummaryType).PAGE : (0, $7eOQq.SummaryType).BLOGPOST;
    const { data: data, errors: errors, loading: loading, refetch: refetch } = (0, $jgs1o.useCombinedCommentsSummariesQueries)({
        contentId: contentId,
        contentType: contentTypeEnum,
        shouldSkipFooterCommentsQuery: footerCommentsCount === 0,
        shouldSkipInlineCommentsQuery: unresolvedInlineCommentsCount === 0
    });
    const refreshHandler = ()=>{
        if (!loading) {
            refetch();
            onRefresh?.();
        }
    };
    const startExperienceTracking = (0, $gwFzn.useCallback)(()=>{
        experienceTracker.start({
            name: (0, $irVI7.COMMENTS_SUMMARY_EXPERIENCE),
            attributes: {
                contentId: contentId,
                source: source
            }
        });
        (0, $jRog2.COMMENTS_SUMMARY_INTERACTION_METRIC).start();
    }, [
        contentId,
        experienceTracker,
        source
    ]);
    (0, $gwFzn.useEffect)(()=>{
        if (loading) startExperienceTracking();
        if (!loading) (0, $jRog2.COMMENTS_SUMMARY_INTERACTION_METRIC).stop();
    }, [
        loading,
        startExperienceTracking
    ]);
    const footerCommentsSummary = data.footerCommentsSummaryData?.getCommentsSummary?.summary ?? '';
    const inlineCommentsSummary = data.inlineCommentsSummaryData?.getCommentsSummary?.summary ?? '';
    const loadingRef = (0, $gwFzn.useRef)(loading);
    (0, $gwFzn.useEffect)(()=>{
        loadingRef.current = loading;
    }, [
        loading
    ]);
    (0, $gwFzn.useEffect)(()=>{
        trackAIInteractionInit();
        if (shouldRefetchCommentsSummary) {
            refetch();
            onRefresh?.();
        }
        return ()=>{
            if (loadingRef.current) trackAIInteractionDismiss();
        };
    // Only check auto refetch on mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const summaryLocale = (0, $gwFzn.useMemo)(()=>{
        // Ok to just choose first of whichever is available from data team
        return data.footerCommentsSummaryData?.getCommentsSummary?.language || data.inlineCommentsSummaryData?.getCommentsSummary?.language;
    }, [
        data.footerCommentsSummaryData,
        data.inlineCommentsSummaryData
    ]);
    const commentsType = (0, $gwFzn.useMemo)(()=>{
        const commentsTypeCollection = [];
        if (data.footerCommentsSummaryData) commentsTypeCollection.push((0, $ly2zj.CommentsSummaryAnalyticsType).FOOTER);
        if (data.inlineCommentsSummaryData) commentsTypeCollection.push((0, $ly2zj.CommentsSummaryAnalyticsType).INLINE);
        return commentsTypeCollection;
    }, [
        data.footerCommentsSummaryData,
        data.inlineCommentsSummaryData
    ]);
    const feedbackContext = {
        commentsType: commentsType,
        source: source
    };
    const analyticsProperties = {
        source: 'commentsSummary',
        additionalAnalyticsAttributes: {
            commentsType: commentsType
        }
    };
    (0, $gwFzn.useEffect)(()=>{
        if (!loading) {
            if (!errors.footerCommentsSummaryError || !errors.inlineCommentsSummaryError) {
                createAnalyticsEvent({
                    type: 'sendScreenEvent',
                    data: {
                        name: 'commentsSummaryContainer',
                        attributes: {
                            contentId: contentId,
                            edition: edition,
                            commentsType: commentsType,
                            summaryLocale: summaryLocale,
                            numPageCommentsSummarized: footerCommentsCount,
                            numInlineCommentsSummarized: unresolvedInlineCommentsCount
                        }
                    }
                }).fire();
                trackAIResultView();
            }
        }
    }, [
        createAnalyticsEvent,
        contentId,
        edition,
        loading,
        commentsType,
        summaryLocale,
        errors.footerCommentsSummaryError,
        errors.inlineCommentsSummaryError,
        footerCommentsCount,
        trackAIResultView,
        unresolvedInlineCommentsCount
    ]);
    const fullTextToCopy = ()=>{
        return `${footerCommentsSummary && `${intl.formatMessage($28602bba7ed7c957$var$i18n.pageCommentsHeader)}\n${footerCommentsSummary}`}\n\n${inlineCommentsSummary && `${intl.formatMessage($28602bba7ed7c957$var$i18n.inlineCommentsHeader)}\n${inlineCommentsSummary}`}`;
    };
    const renderContentBody = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1GzhS.default), {
            space: "space.200"
        }, inlineCommentsSummary && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1GzhS.default), {
            space: "space.100"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $7hXDW.default), {
            size: "small"
        }, intl.formatMessage($28602bba7ed7c957$var$i18n.inlineCommentsHeader)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gUu2y.default), null, inlineCommentsSummary)), footerCommentsSummary && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1GzhS.default), {
            space: "space.100"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $7hXDW.default), {
            size: "small"
        }, intl.formatMessage($28602bba7ed7c957$var$i18n.pageCommentsHeader)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gUu2y.default), null, footerCommentsSummary)), (!errors.footerCommentsSummaryError || !errors.inlineCommentsSummaryError) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1eaCJ.ExperienceSuccess), {
            name: (0, $irVI7.COMMENTS_SUMMARY_EXPERIENCE),
            attributes: {
                contentId: contentId,
                source: source
            }
        }), (errors.footerCommentsSummaryError || errors.inlineCommentsSummaryError) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $k6dR8.CommentsSummariesError), {
            contentId: contentId,
            footerCommentsError: errors.footerCommentsSummaryError,
            inlineCommentsError: errors.inlineCommentsSummaryError,
            source: source
        }));
    };
    const renderContent = ()=>{
        if (loading) return isInObjectSidebar ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
            paddingInline: "space.100"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $8LJEA.AISummaryLoading), null)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ajVmS.AISkeletonLoading), null);
        const shouldShowFooterError = !!errors.footerCommentsSummaryError && !!errors.inlineCommentsSummaryError || !!errors.footerCommentsSummaryError && inlineCommentsSummary.length === 0 || !!errors.inlineCommentsSummaryError && footerCommentsSummary.length === 0;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1GzhS.default), {
            xcss: $28602bba7ed7c957$var$styles,
            spread: "space-between"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
            padding: isInObjectSidebar ? 'space.100' : 'space.250'
        }, source !== "footer" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ly2zj.SummaryPopupScrollableBody), {
            "data-testid": "scrollable-comments-summary"
        }, renderContentBody()) : renderContentBody()), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
            xcss: isInObjectSidebar && $28602bba7ed7c957$var$FooterObjectSidebarStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ly2zj.AISummaryFooter), {
            analyticsProperties: analyticsProperties,
            contentId: contentId,
            contentType: contentType,
            spaceKey: spaceKey,
            error: shouldShowFooterError,
            summaryText: fullTextToCopy(),
            showBetaLozenge: true,
            shouldHighlightRefresh: shouldRefetchCommentsSummary,
            refreshHandler: refreshHandler
        })));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dpPtd.FlagsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ly2zj.FeedbackCollectorPropertiesProvider), {
        entrypointId: (0, $hAXFW.FOOTER_COMMENTS_SUMMARY_FEEDBACK_ENTRYPOINT_ID),
        feedbackContext: feedbackContext
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $fwDOR.default), {
        name: "comments-summary-content",
        hold: (0, $9wGTI.fg)('ufo-manual-experimental-holds-confluence') && loading
    }), isInObjectSidebar ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, renderContent()) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dOOm2.AIBorder), {
        loading: loading
    }, renderContent())));
};

});
parcelRegister("dOOm2", function(module, exports) {

$parcel$export(module.exports, "AIBorder", () => $f64c374ed616824e$export$6ed1e39f4dbe0bbf);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/design-system/consistent-css-prop-usage */ 
var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $7hpmn = parcelRequire("7hpmn");

var $6f0Oj = parcelRequire("6f0Oj");
var $ecnYn = parcelRequire("ecnYn");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f64c374ed616824e$var$GradientPropertyContainer = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_1bsb1osq _kqswh2mm _c71l1kw7",
            __cmplp.className
        ])
    });
});
const $f64c374ed616824e$var$outerContainerStyles = (0, $ecnYn.xcss)({
    overflow: 'hidden',
    position: 'relative',
    background: `conic-gradient(
    from var(--gradient-angle, 45deg),
    #0065FF 10%,
    #0469FF 30%,
    #BF63F3 50%,
    #FFA900 70%,
    #0065FF 90%
  )`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    ...(0, $7hpmn.reduceMotionAsPerUserPreference),
    maxHeight: 'inherit'
});
const $f64c374ed616824e$var$animationStyles = (0, $ecnYn.xcss)({
    animation: 'rotationAnimation linear 2s infinite'
});
const $f64c374ed616824e$var$baseGlowStyles = (0, $ecnYn.xcss)({
    position: 'absolute',
    filter: 'blur(25px)',
    opacity: '0.5',
    height: '100%',
    width: '100%'
});
const $f64c374ed616824e$var$defaultBorderRadiusStyles = (0, $ecnYn.xcss)({
    borderRadius: 'border.radius.200'
});
const $f64c374ed616824e$var$modalBorderRadiusStyles = (0, $ecnYn.xcss)({
    borderRadius: 'border.radius.100'
});
const $f64c374ed616824e$var$innerContainerStyles = (0, $ecnYn.xcss)({
    backgroundColor: 'elevation.surface.overlay',
    maxHeight: 'inherit',
    display: 'flex',
    flexDirection: 'column',
    backgroundClip: 'content-box'
});
const $f64c374ed616824e$export$6ed1e39f4dbe0bbf = ({ loading: loading = false, children: children, useModalStyles: useModalStyles, hideGlow: hideGlow, customInnerContainerStyles: customInnerContainerStyles, customGlowStyles: customGlowStyles, ...props })=>{
    const isReducedMotion = (0, $7hpmn.useIsReducedMotion)();
    const shouldRotate = loading && !isReducedMotion;
    const containerStyles = shouldRotate ? [
        $f64c374ed616824e$var$outerContainerStyles,
        $f64c374ed616824e$var$animationStyles
    ] : [
        $f64c374ed616824e$var$outerContainerStyles
    ];
    const glowStyles = customGlowStyles ? [
        $f64c374ed616824e$var$baseGlowStyles,
        customGlowStyles
    ] : [
        $f64c374ed616824e$var$baseGlowStyles
    ];
    const borderRadiusStyles = useModalStyles ? $f64c374ed616824e$var$modalBorderRadiusStyles : $f64c374ed616824e$var$defaultBorderRadiusStyles;
    return /*#__PURE__*/ (0, $7UHDa.jsxs)($f64c374ed616824e$var$GradientPropertyContainer, {
        "data-testid": "ai-border-container",
        ...props,
        children: [
            shouldRotate && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                xcss: [
                    ...containerStyles,
                    borderRadiusStyles,
                    ...hideGlow ? [] : glowStyles
                ],
                testId: "loading-glow"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                xcss: [
                    ...containerStyles,
                    borderRadiusStyles
                ],
                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                    padding: "space.025",
                    xcss: [
                        $f64c374ed616824e$var$innerContainerStyles,
                        borderRadiusStyles,
                        customInnerContainerStyles
                    ],
                    children: children
                })
            })
        ]
    });
};

});

parcelRegister("ajVmS", function(module, exports) {

$parcel$export(module.exports, "AISkeletonLoading", () => $f2f4089003bbd13c$export$e93f99a4d30f6d75);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $6f0Oj = parcelRequire("6f0Oj");
var $1GzhS = parcelRequire("1GzhS");
var $ecnYn = parcelRequire("ecnYn");

var $kpYGL = parcelRequire("kpYGL");

var $7zZoq = parcelRequire("7zZoq");
const $f2f4089003bbd13c$var$i18n = (0, $2nPZH.defineMessages)({
    generatingSummary: {
        id: "ai-skeleton-loading.title",
        defaultMessage: "Atlassian Intelligence is generating a summary..."
    },
    logoAltText: {
        id: "ai-skeleton-loading.logo-alt",
        defaultMessage: "Atlassian Intelligence Logo"
    }
});
const $f2f4089003bbd13c$var$loadingTextContainer = (0, $ecnYn.xcss)({
    display: 'flex',
    alignItems: 'center',
    gap: 'space.050',
    marginBottom: 'space.200',
    font: 'font.body.UNSAFE_small',
    color: 'color.text.subtle'
});
const $f2f4089003bbd13c$export$e93f99a4d30f6d75 = ()=>{
    const intl = (0, $dBxQj.default)();
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $6f0Oj.default), {
        padding: "space.300",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $6f0Oj.default), {
                xcss: $f2f4089003bbd13c$var$loadingTextContainer,
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7zZoq.AtlassianIntelligenceLogo), {
                        alt: intl.formatMessage($f2f4089003bbd13c$var$i18n.logoAltText)
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
                        children: intl.formatMessage($f2f4089003bbd13c$var$i18n.generatingSummary)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $1GzhS.default), {
                space: "space.100",
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsx)((0, $kpYGL.default), {
                        height: 16,
                        width: '100%',
                        borderRadius: 8,
                        isShimmering: true
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)((0, $kpYGL.default), {
                        height: 16,
                        width: '100%',
                        borderRadius: 8,
                        isShimmering: true
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)((0, $kpYGL.default), {
                        height: 16,
                        width: '100%',
                        borderRadius: 8,
                        isShimmering: true
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)((0, $kpYGL.default), {
                        height: 16,
                        width: '100%',
                        borderRadius: 8,
                        isShimmering: true
                    })
                ]
            })
        ]
    });
};

});
parcelRegister("7zZoq", function(module, exports) {

$parcel$export(module.exports, "AtlassianIntelligenceLogo", () => $efb3204ef47358fa$export$b58d43d92d088553);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage/preview */ /* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");
const $efb3204ef47358fa$export$b58d43d92d088553 = ({ alt: alt })=>/*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("title", {
                children: alt
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M11.4473 7.99998C11.4473 7.63179 11.7457 7.33331 12.1139 7.33331H13.3339C13.7021 7.33331 14.0006 7.63179 14.0006 7.99998C14.0006 8.36817 13.7021 8.66665 13.3339 8.66665H12.1139C11.7457 8.66665 11.4473 8.36817 11.4473 7.99998Z",
                fill: "url(#paint0_linear_2378_7139)"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M8.00065 2C8.36884 2 8.66732 2.29848 8.66732 2.66667V3.88667C8.66732 4.25486 8.36884 4.55333 8.00065 4.55333C7.63246 4.55333 7.33398 4.25486 7.33398 3.88667V2.66667C7.33398 2.29848 7.63246 2 8.00065 2Z",
                fill: "url(#paint1_linear_2378_7139)"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M2 7.99998C2 7.63179 2.29848 7.33331 2.66667 7.33331H3.88667C4.25486 7.33331 4.55333 7.63179 4.55333 7.99998C4.55333 8.36817 4.25486 8.66665 3.88667 8.66665H2.66667C2.29848 8.66665 2 8.36817 2 7.99998Z",
                fill: "url(#paint2_linear_2378_7139)"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M8.00065 11.4467C8.36884 11.4467 8.66732 11.7451 8.66732 12.1133V13.3333C8.66732 13.7015 8.36884 14 8.00065 14C7.63246 14 7.33398 13.7015 7.33398 13.3333V12.1133C7.33398 11.7451 7.63246 11.4467 8.00065 11.4467Z",
                fill: "url(#paint3_linear_2378_7139)"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M9.52925 9.52858C9.7896 9.26823 10.2117 9.26823 10.4721 9.52858L13.1387 12.1952C13.3991 12.4556 13.3991 12.8777 13.1387 13.1381C12.8784 13.3984 12.4563 13.3984 12.1959 13.1381L9.52925 10.4714C9.2689 10.211 9.2689 9.78892 9.52925 9.52858Z",
                fill: "#2684FF"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M13.1387 2.86195C13.3991 3.1223 13.3991 3.54441 13.1387 3.80476L10.4721 6.47142C10.2117 6.73177 9.7896 6.73177 9.52925 6.47142C9.2689 6.21108 9.2689 5.78897 9.52925 5.52862L12.1959 2.86195C12.4563 2.6016 12.8784 2.6016 13.1387 2.86195Z",
                fill: "#2684FF"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M2.86128 2.86195C3.12163 2.6016 3.54374 2.6016 3.80409 2.86195L6.47075 5.52862C6.7311 5.78897 6.7311 6.21108 6.47075 6.47142C6.2104 6.73177 5.78829 6.73177 5.52794 6.47142L2.86128 3.80476C2.60093 3.54441 2.60093 3.1223 2.86128 2.86195Z",
                fill: "#2684FF"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M6.47075 9.52858C6.7311 9.78892 6.7311 10.211 6.47075 10.4714L3.80409 13.1381C3.54374 13.3984 3.12163 13.3984 2.86128 13.1381C2.60093 12.8777 2.60093 12.4556 2.86128 12.1952L5.52794 9.52858C5.78829 9.26823 6.2104 9.26823 6.47075 9.52858Z",
                fill: "#2684FF"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsxs)("linearGradient", {
                        id: "paint0_linear_2378_7139",
                        x1: "14.0006",
                        y1: "7.99998",
                        x2: "11.6672",
                        y2: "7.99998",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "0.270833",
                                stopColor: "#2684FF"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "1",
                                stopColor: "#0052CC"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsxs)("linearGradient", {
                        id: "paint1_linear_2378_7139",
                        x1: "8.33398",
                        y1: "2",
                        x2: "8.33398",
                        y2: "4.33333",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "0.1875",
                                stopColor: "#2684FF"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "1",
                                stopColor: "#0052CC"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsxs)("linearGradient", {
                        id: "paint2_linear_2378_7139",
                        x1: "4.5533",
                        y1: "7.99998",
                        x2: "2.21997",
                        y2: "7.99998",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                stopColor: "#0052CC"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "0.791667",
                                stopColor: "#2684FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsxs)("linearGradient", {
                        id: "paint3_linear_2378_7139",
                        x1: "8.33398",
                        y1: "11.3333",
                        x2: "8.33398",
                        y2: "14",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                stopColor: "#0052CC"
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)("stop", {
                                offset: "0.802083",
                                stopColor: "#2684FF"
                            })
                        ]
                    })
                ]
            })
        ]
    });

});


parcelRegister("8LJEA", function(module, exports) {

$parcel$export(module.exports, "AISummaryLoading", () => $c33e9757ca53561f$export$dd8c26521b6a2fec);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $4jR19 = parcelRequire("4jR19");
var $dBxQj = parcelRequire("dBxQj");

var $6f0Oj = parcelRequire("6f0Oj");
var $1GzhS = parcelRequire("1GzhS");
var $ecnYn = parcelRequire("ecnYn");

var $igbBp = parcelRequire("igbBp");
const $c33e9757ca53561f$var$BoxStyles = (0, $ecnYn.xcss)({
    color: 'color.text.subtlest',
    backgroundColor: 'elevation.surface.sunken',
    padding: 'space.150',
    borderRadius: '8px',
    borderBottomLeftRadius: '3px'
});
const $c33e9757ca53561f$var$i18n = (0, $2nPZH.defineMessages)({
    generatingSummaryText: {
        id: "ai-summary-loading.title",
        defaultMessage: "Writing a summary"
    },
    generatingSummaryAnimationAlt: {
        id: "ai-stream-loading.generation-animation",
        defaultMessage: "Generating"
    }
});
const $c33e9757ca53561f$export$dd8c26521b6a2fec = ()=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
        xcss: $c33e9757ca53561f$var$BoxStyles,
        children: /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $1GzhS.default), {
            space: "space.100",
            children: [
                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                    ...$c33e9757ca53561f$var$i18n.generatingSummaryText
                }),
                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $igbBp.GeneratingStreamAnimation), {
                    alt: formatMessage($c33e9757ca53561f$var$i18n.generatingSummaryAnimationAlt)
                })
            ]
        })
    });
};

});

parcelRegister("jgs1o", function(module, exports) {

$parcel$export(module.exports, "useCombinedCommentsSummariesQueries", () => $0edd62bded09ab4f$export$7bdbf0c72871fa1f);
/**
 * @graphql cc
 */ 
var $d2LG0 = parcelRequire("d2LG0");

var $j1Ss3 = parcelRequire("j1Ss3");

var $5D3ph = parcelRequire("5D3ph");
const $0edd62bded09ab4f$export$7bdbf0c72871fa1f = ({ contentId: contentId, contentType: contentType, shouldSkipFooterCommentsQuery: shouldSkipFooterCommentsQuery = false, shouldSkipInlineCommentsQuery: shouldSkipInlineCommentsQuery = false })=>{
    const { data: footerCommentsSummaryData, loading: footerCommentsQueryLoading, error: footerCommentsSummaryError, refetch: footerCommentsRefetch } = (0, $j1Ss3.useQuery)((0, $d2LG0.default)`query useCombinedCommentsSummariesQueriesCommentsSummaryQuery($contentId:ID!$contentType:SummaryType!$commentsType:CommentsType!){getCommentsSummary(contentId:$contentId contentType:$contentType commentsType:$commentsType){contentId summary summaryId language}}`, {
        variables: {
            contentId: contentId,
            contentType: contentType,
            commentsType: (0, $5D3ph.CommentsType).FOOTER
        },
        notifyOnNetworkStatusChange: true,
        skip: shouldSkipFooterCommentsQuery
    });
    const { data: inlineCommentsSummaryData, loading: inlineCommentsQueryLoading, error: inlineCommentsSummaryError, refetch: inlineCommentsRefetch } = (0, $j1Ss3.useQuery)((0, $d2LG0.default)`query useCombinedCommentsSummariesQueriesCommentsSummaryQuery($contentId:ID!$contentType:SummaryType!$commentsType:CommentsType!){getCommentsSummary(contentId:$contentId contentType:$contentType commentsType:$commentsType){contentId summary summaryId language}}`, {
        variables: {
            contentId: contentId,
            contentType: contentType,
            commentsType: (0, $5D3ph.CommentsType).INLINE
        },
        notifyOnNetworkStatusChange: true,
        skip: shouldSkipInlineCommentsQuery
    });
    const refetch = ()=>{
        footerCommentsRefetch();
        inlineCommentsRefetch();
    };
    return {
        data: {
            footerCommentsSummaryData: footerCommentsSummaryData,
            inlineCommentsSummaryData: inlineCommentsSummaryData
        },
        loading: footerCommentsQueryLoading || inlineCommentsQueryLoading,
        errors: {
            footerCommentsSummaryError: footerCommentsSummaryError,
            inlineCommentsSummaryError: inlineCommentsSummaryError
        },
        refetch: refetch
    };
};

});
parcelRegister("5D3ph", function(module, exports) {

$parcel$export(module.exports, "CommentsType", () => $b584d22d97de3aa6$export$e9466e0faeadf399);
/**
 * @generated SignedSource<<e750efbbf520557daadd3e49b62eafcd>>
 * This file was auto-generated by a codemod
 * @see https://go/connie-relay-migration-fyi
 **/ var $b584d22d97de3aa6$export$e9466e0faeadf399 = /*#__PURE__*/ function(CommentsType) {
    CommentsType["FOOTER"] = "FOOTER";
    CommentsType["INLINE"] = "INLINE";
    return CommentsType;
}({});
var $b584d22d97de3aa6$export$5bf35143f8d5729a = /*#__PURE__*/ function(SummaryType) {
    SummaryType["PAGE"] = "PAGE";
    SummaryType["BLOGPOST"] = "BLOGPOST";
    return SummaryType;
}({});

});


parcelRegister("hAXFW", function(module, exports) {

$parcel$export(module.exports, "FOOTER_COMMENTS_SUMMARY_FEEDBACK_ENTRYPOINT_ID", () => $ea0c56ea9695a839$export$2f5736e19049ec78);
const $ea0c56ea9695a839$export$2f5736e19049ec78 = '775fa156-8bed-4310-af75-c6d1148b88fb';

});

parcelRegister("7eOQq", function(module, exports) {

$parcel$export(module.exports, "CommentsType", () => $17fd4a0f0d6084c8$export$e9466e0faeadf399);
$parcel$export(module.exports, "SummaryType", () => $17fd4a0f0d6084c8$export$5bf35143f8d5729a);
/* tslint:disable */ /* eslint-disable */ // This file was automatically generated and should not be edited.
//==============================================================
// START Enums and Input Objects
//==============================================================
var $17fd4a0f0d6084c8$export$e9466e0faeadf399 = /*#__PURE__*/ function(CommentsType) {
    CommentsType["FOOTER"] = "FOOTER";
    CommentsType["INLINE"] = "INLINE";
    return CommentsType;
}({});
var $17fd4a0f0d6084c8$export$5bf35143f8d5729a = /*#__PURE__*/ function(SummaryType) {
    SummaryType["BLOGPOST"] = "BLOGPOST";
    SummaryType["PAGE"] = "PAGE";
    return SummaryType;
}({});

});

parcelRegister("jRog2", function(module, exports) {

$parcel$export(module.exports, "COMMENTS_SUMMARY_INTERACTION_METRIC", () => $f6bfaf9677f19070$export$9ad53c330569860e);

var $jIOyV = parcelRequire("jIOyV");
var $lSOAM = parcelRequire("lSOAM");
const $f6bfaf9677f19070$export$9ad53c330569860e = (0, $lSOAM.createInteractionMetric)({
    key: (0, $jIOyV.COMMENTS_SUMMARY_COMPONENT_INTERACTION)
});

});

parcelRegister("k6dR8", function(module, exports) {

$parcel$export(module.exports, "CommentsSummariesError", () => $6a674942f4f35f24$export$b0cd94004126f4ff);
// eslint-disable-next-line import/order

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $2Nwuj = parcelRequire("2Nwuj");

var $inPa6 = parcelRequire("inPa6");

var $6f0Oj = parcelRequire("6f0Oj");
var $5dK2X = parcelRequire("5dK2X");
var $ecnYn = parcelRequire("ecnYn");

var $fYQcF = parcelRequire("fYQcF");

var $9wGTI = parcelRequire("9wGTI");

var $dIouf = parcelRequire("dIouf");

var $ly2zj = parcelRequire("ly2zj");

var $3Am3T = parcelRequire("3Am3T");

var $jhwJP = parcelRequire("jhwJP");

var $81ldd = parcelRequire("81ldd");
const $6a674942f4f35f24$var$textStyles = (0, $ecnYn.xcss)({
    color: 'color.text.subtlest',
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
});
const $6a674942f4f35f24$var$i18nBase = (0, $2nPZH.defineMessages)({
    combinedErrorGeneral: {
        id: "ai-comments-summary.comments-summaries-error.combined-error-general",
        defaultMessage: "Atlassian Intelligence can\u2019t provide a summary right now. You can try again later or read more <a>in our support documentation</a>."
    },
    combinedErrorTooMuchContent: {
        id: "ai-comments-summary.comments-summaries-error.combined-error-too-much-content",
        defaultMessage: "There are too many comments for Atlassian Intelligence (AI) to summarize. Try again on content with fewer comments."
    },
    combinedErrorNotEnoughContent: {
        id: "ai-comments-summary.comments-summaries-error.combined-error-too-little-content",
        defaultMessage: "There aren\u2019t enough comments for Atlassian Intelligence (AI) to summarize. Try again when more comments have been added."
    },
    combinedErrorRateLimit: {
        id: "ai-comments-summary.comments-summaries-error.combined-error-rate-limit",
        defaultMessage: "We\u2019ve received too many recent requests for Atlassian Intelligence (AI). Try again in a few minutes or <a>read about excessive use of AI</a>."
    },
    combinedErrorAUPViolation: {
        id: "ai-comments-summary.comments-summaries-error.combined-error-aup-violation",
        defaultMessage: "Atlassian Intelligence (AI) can\u2019t provide a summary of the comments on this content, as some comments may not comply with our <a>Acceptable Use Policy</a>."
    },
    footerCommentsErrorGeneral: {
        id: "ai-comments-summary.comments-summaries-error.footer-comments-error-general",
        defaultMessage: "There is no summary of page comments at this time. You can try again later or read more <a>in our support documentation</a>."
    },
    footerCommentsErrorTooMuchContent: {
        id: "ai-comments-summary.comments-summaries-error.footer-comments-error-too-much-content",
        defaultMessage: "This summary only includes inline comments, as there are too many page comments for Atlassian Intelligence (AI) to summarize."
    },
    footerCommentsErrorNotEnoughContent: {
        id: "ai-comments-summary.comments-summaries-error.footer-comments-error-too-little-content",
        defaultMessage: "This summary only includes inline comments, as there aren\u2019t enough page comments for Atlassian Intelligence (AI) to summarize."
    },
    footerCommentsErrorRateLimit: {
        id: "ai-comments-summary.comments-summaries-error.footer-comments-error-rate-limit",
        defaultMessage: "This summary only includes inline comments, as we\u2019ve received too many page comment summary requests for Atlassian Intelligence (AI). Try again in a few minutes or <a>read about excessive use of AI</a>."
    },
    footerCommentsErrorAUPViolation: {
        id: "ai-comments-summary.comments-summaries-error.footer-comments-error-aup-violation",
        defaultMessage: "This summary only includes inline comments, as some page comments may not comply with Atlassian\u2019s <a>Acceptable Use Policy</a>."
    },
    inlineCommentsErrorGeneral: {
        id: "ai-comments-summary.comments-summaries-error.inline-comments-error-general",
        defaultMessage: "There is no summary of inline comments at this time. You can try again later or read more <a>in our support documentation</a>."
    },
    inlineCommentsErrorTooMuchContent: {
        id: "ai-comments-summary.comments-summaries-error.inline-comments-error-too-much-content",
        defaultMessage: "This summary only includes page comments, as there are too many inline comments for Atlassian Intelligence (AI) to summarize."
    },
    inlineCommentsErrorNotEnoughContent: {
        id: "ai-comments-summary.comments-summaries-error.inline-error-too-little-content",
        defaultMessage: "This summary only includes page comments, as there aren\u2019t enough inline comments for Atlassian Intelligence (AI) to summarize."
    },
    inlineCommentsErrorRateLimit: {
        id: "ai-comments-summary.comments-summaries-error.inline-comments-error-rate-limit",
        defaultMessage: "This summary only includes page comments, as we\u2019ve received too many inline comment summary requests for Atlassian Intelligence (AI). Try again in a few minutes or <a>read about excessive use of AI</a>."
    },
    inlineCommentsErrorAUPViolation: {
        id: "ai-comments-summary.comments-summaries-error.inline-comments-error-aup-violation",
        defaultMessage: "This summary only includes page comments, as some inline comments may not comply with Atlassian\u2019s <a>Acceptable Use Policy</a>."
    }
});
const $6a674942f4f35f24$var$i18nLiveDocs = (0, $2nPZH.defineMessages)({
    footerCommentsErrorGeneral: {
        id: "ai-comments-summary.comments-summaries-error.footer-comments-error-general.livedocs",
        defaultMessage: "There is no summary of general comments at this time. You can try again later or read more <a>in our support documentation</a>."
    },
    footerCommentsErrorTooMuchContent: {
        id: "ai-comments-summary.comments-summaries-error.footer-comments-error-too-much-content.livedocs",
        defaultMessage: "This summary only includes inline comments, as there are too many general comments for Atlassian Intelligence (AI) to summarize."
    },
    footerCommentsErrorNotEnoughContent: {
        id: "ai-comments-summary.comments-summaries-error.footer-comments-error-too-little-content.livedocs",
        defaultMessage: "This summary only includes inline comments, as there aren\u2019t enough general comments for Atlassian Intelligence (AI) to summarize."
    },
    footerCommentsErrorRateLimit: {
        id: "ai-comments-summary.comments-summaries-error.footer-comments-error-rate-limit.livedocs",
        defaultMessage: "This summary only includes inline comments, as we\u2019ve received too many general comment summary requests for Atlassian Intelligence (AI). Try again in a few minutes or <a>read about excessive use of AI</a>."
    },
    footerCommentsErrorAUPViolation: {
        id: "ai-comments-summary.comments-summaries-error.footer-comments-error-aup-violation.livedocs",
        defaultMessage: "This summary only includes inline comments, as some general comments may not comply with Atlassian\u2019s <a>Acceptable Use Policy</a>."
    },
    inlineCommentsErrorTooMuchContent: {
        id: "ai-comments-summary.comments-summaries-error.inline-comments-error-too-much-content.livedocs",
        defaultMessage: "This summary only includes general comments, as there are too many inline comments for Atlassian Intelligence (AI) to summarize."
    },
    inlineCommentsErrorNotEnoughContent: {
        id: "ai-comments-summary.comments-summaries-error.inline-error-too-little-content.livedocs",
        defaultMessage: "This summary only includes general comments, as there aren\u2019t enough inline comments for Atlassian Intelligence (AI) to summarize."
    },
    inlineCommentsErrorRateLimit: {
        id: "ai-comments-summary.comments-summaries-error.inline-comments-error-rate-limit.livedocs",
        defaultMessage: "This summary only includes general comments, as we\u2019ve received too many inline comment summary requests for Atlassian Intelligence (AI). Try again in a few minutes or <a>read about excessive use of AI</a>."
    },
    inlineCommentsErrorAUPViolation: {
        id: "ai-comments-summary.comments-summaries-error.inline-comments-error-aup-violation.livedocs",
        defaultMessage: "This summary only includes general comments, as some inline comments may not comply with Atlassian\u2019s <a>Acceptable Use Policy</a>."
    }
});
const $6a674942f4f35f24$var$i18n = (0, $jhwJP.mergeLiveDocI18n)($6a674942f4f35f24$var$i18nBase, $6a674942f4f35f24$var$i18nLiveDocs);
const $6a674942f4f35f24$export$b0cd94004126f4ff = ({ contentId: contentId, footerCommentsError: footerCommentsError, inlineCommentsError: inlineCommentsError, source: source })=>{
    const intl = (0, $dBxQj.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { trackAIResultError: trackAIResultError } = (0, $fYQcF.useAIEventsInstrumentation)();
    const { erredQueries: erredQueries, errorType: errorType, shouldCallErrorDisplayForFooterComments: shouldCallErrorDisplayForFooterComments, shouldCallErrorDisplayForInlineComments: shouldCallErrorDisplayForInlineComments } = (0, $81ldd.useCommentsSummaryErrorHandler)(contentId, source, footerCommentsError, inlineCommentsError);
    const { footerCommentsCount: footerCommentsCount, unresolvedInlineCommentsCount: unresolvedInlineCommentsCount } = (0, $gwFzn.useContext)((0, $3Am3T.CommentCountsContext));
    (0, $gwFzn.useEffect)(()=>{
        trackAIResultError({
            aiErrorMessage: errorType,
            // TODO Ideally we should pass the real code from the response
            aiErrorCode: 400
        }, {
            attributes: {
                contentId: contentId,
                errorType: errorType,
                commentsType: erredQueries,
                source: source
            }
        });
    }, [
        erredQueries,
        contentId,
        trackAIResultError,
        errorType,
        source
    ]);
    const onDocsLinkClicked = (linkName)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'commentsSummaryError',
                action: 'clicked',
                actionSubject: 'link',
                actionSubjectId: `atlassianIntelligence${linkName}DocsLink`,
                attributes: {
                    contentId: contentId,
                    errorType: errorType,
                    commentsType: erredQueries,
                    source: source
                }
            }
        }).fire();
    };
    const errorMessage = ()=>{
        let i18nPrefix = "combined";
        if (footerCommentsError && !inlineCommentsError && unresolvedInlineCommentsCount > 0) i18nPrefix = "footerComments";
        if (inlineCommentsError && !footerCommentsError && footerCommentsCount > 0) i18nPrefix = "inlineComments";
        switch(errorType){
            case (0, $ly2zj.HandledErrorType).TooMuchContent:
                return intl.formatMessage($6a674942f4f35f24$var$i18n[`${i18nPrefix}ErrorTooMuchContent`]);
            case (0, $ly2zj.HandledErrorType).NotEnoughContent:
                return intl.formatMessage($6a674942f4f35f24$var$i18n[`${i18nPrefix}ErrorNotEnoughContent`]);
            case (0, $ly2zj.HandledErrorType).AUPViolation:
                return intl.formatMessage($6a674942f4f35f24$var$i18n[`${i18nPrefix}ErrorAUPViolation`], {
                    a: (chunks)=>(0, $9wGTI.fg)('dst-a11y__replace-anchor-with-link__confluence-ai2') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $2Nwuj.default), {
                            href: (0, $ly2zj.ACCEPTABLE_USE_POLICY_URL),
                            target: "_blank",
                            onClick: ()=>onDocsLinkClicked('AupViolation')
                        }, chunks) : // eslint-disable-next-line @atlaskit/design-system/no-html-anchor
                        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("a", {
                            href: (0, $ly2zj.ACCEPTABLE_USE_POLICY_URL),
                            target: "_blank",
                            onClick: ()=>onDocsLinkClicked('AupViolation')
                        }, chunks)
                });
            case (0, $ly2zj.HandledErrorType).RateLimit:
                return intl.formatMessage($6a674942f4f35f24$var$i18n[`${i18nPrefix}ErrorRateLimit`], {
                    a: (chunks)=>(0, $9wGTI.fg)('dst-a11y__replace-anchor-with-link__confluence-ai2') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $2Nwuj.default), {
                            href: (0, $ly2zj.USAGE_LIMITS_DOCS_URL),
                            target: "_blank",
                            onClick: ()=>onDocsLinkClicked('RateLimit')
                        }, chunks) : // eslint-disable-next-line @atlaskit/design-system/no-html-anchor
                        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("a", {
                            href: (0, $ly2zj.USAGE_LIMITS_DOCS_URL),
                            target: "_blank",
                            onClick: ()=>onDocsLinkClicked('RateLimit')
                        }, chunks)
                });
            default:
                return intl.formatMessage($6a674942f4f35f24$var$i18n[`${i18nPrefix}ErrorGeneral`], {
                    a: (chunks)=>(0, $9wGTI.fg)('dst-a11y__replace-anchor-with-link__confluence-ai2') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $2Nwuj.default), {
                            href: (0, $ly2zj.TROUBLE_SHOOTING_DOCS_URL),
                            target: "_blank",
                            onClick: ()=>onDocsLinkClicked('Troubleshooting')
                        }, chunks) : // eslint-disable-next-line @atlaskit/design-system/no-html-anchor
                        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("a", {
                            href: (0, $ly2zj.TROUBLE_SHOOTING_DOCS_URL),
                            target: "_blank",
                            onClick: ()=>onDocsLinkClicked('Troubleshooting')
                        }, chunks)
                });
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: $6a674942f4f35f24$var$textStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5dK2X.default), {
        as: "p"
    }, errorMessage()), footerCommentsError && shouldCallErrorDisplayForFooterComments && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.ErrorDisplay), {
        error: footerCommentsError
    }), inlineCommentsError && shouldCallErrorDisplayForInlineComments && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.ErrorDisplay), {
        error: inlineCommentsError
    }));
};

});
parcelRegister("81ldd", function(module, exports) {

$parcel$export(module.exports, "useCommentsSummaryErrorHandler", () => $883f6dcc92761560$export$37675c48b66aa091);

var $gwFzn = parcelRequire("gwFzn");

var $irVI7 = parcelRequire("irVI7");
var $1kHsc = parcelRequire("1kHsc");

var $7Sm4c = parcelRequire("7Sm4c");

var $3Am3T = parcelRequire("3Am3T");

var $ly2zj = parcelRequire("ly2zj");

var $7eOQq = parcelRequire("7eOQq");
const $883f6dcc92761560$export$37675c48b66aa091 = (contentId, source, footerCommentsError, inlineCommentsError)=>{
    const experienceTracker = (0, $gwFzn.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { footerCommentsCount: footerCommentsCount, unresolvedInlineCommentsCount: unresolvedInlineCommentsCount } = (0, $gwFzn.useContext)((0, $3Am3T.CommentCountsContext));
    const { errorType: footerCommentsErrorType, isExpectedError: footerCommentsIsExpectedError } = (0, $ly2zj.useSummaryErrorHelper)((0, $irVI7.COMMENTS_SUMMARY_EXPERIENCE), footerCommentsError);
    const { errorType: inlineCommentsErrorType, isExpectedError: inlineCommentsIsExpectedError } = (0, $ly2zj.useSummaryErrorHelper)((0, $irVI7.COMMENTS_SUMMARY_EXPERIENCE), inlineCommentsError);
    const { errorType: errorType, commentsType: commentsType } = (0, $gwFzn.useMemo)(()=>{
        let memoErrorType;
        let memoCommentsType = [];
        if (footerCommentsError && inlineCommentsError) {
            if (footerCommentsErrorType === inlineCommentsErrorType) memoErrorType = footerCommentsErrorType;
            memoCommentsType = [
                (0, $7eOQq.CommentsType).FOOTER,
                (0, $7eOQq.CommentsType).INLINE
            ];
        } else if (footerCommentsError) {
            memoErrorType = footerCommentsErrorType;
            memoCommentsType = [
                (0, $7eOQq.CommentsType).FOOTER
            ];
        } else if (inlineCommentsError) {
            memoErrorType = inlineCommentsErrorType;
            memoCommentsType = [
                (0, $7eOQq.CommentsType).INLINE
            ];
        }
        return {
            errorType: memoErrorType || (0, $ly2zj.HandledErrorType).GeneralError,
            commentsType: memoCommentsType
        };
    }, [
        inlineCommentsError,
        inlineCommentsErrorType,
        footerCommentsError,
        footerCommentsErrorType
    ]);
    if (footerCommentsIsExpectedError) (0, $7Sm4c.markErrorAsHandled)(footerCommentsError);
    if (inlineCommentsIsExpectedError) (0, $7Sm4c.markErrorAsHandled)(inlineCommentsError);
    // Experience should only be a failure if both queries have erred
    // OR either query has failed when the other query was skipped due to 0 comments
    const isExperienceFailure = footerCommentsError && (inlineCommentsError || unresolvedInlineCommentsCount === 0) || inlineCommentsError && footerCommentsCount === 0;
    const isExpectedError = footerCommentsIsExpectedError && (inlineCommentsIsExpectedError || unresolvedInlineCommentsCount === 0) || inlineCommentsIsExpectedError && footerCommentsCount === 0;
    if (isExperienceFailure) {
        if (isExpectedError) experienceTracker.abort({
            name: (0, $irVI7.COMMENTS_SUMMARY_EXPERIENCE),
            reason: `Can not generate summary due to ${errorType}`,
            attributes: {
                contentId: contentId,
                source: source
            }
        });
        else // Experience tracker can only fail with a single error. Since both queries have failed we will use the footer
        // comments failure to end the experience and pass both types of failures as attributes for further debugging
        experienceTracker.fail({
            name: (0, $irVI7.COMMENTS_SUMMARY_EXPERIENCE),
            // TS does not interpret the isExperienceFailure logic above correctly. Letting the compiler know
            error: footerCommentsError || inlineCommentsError,
            attributes: {
                footerCommentsErrorType: footerCommentsErrorType,
                inlineCommentsErrorType: inlineCommentsErrorType
            }
        });
    }
    return {
        erredQueries: commentsType,
        errorType: errorType,
        shouldCallErrorDisplayForFooterComments: !!footerCommentsError && !footerCommentsIsExpectedError,
        shouldCallErrorDisplayForInlineComments: !!inlineCommentsError && !inlineCommentsIsExpectedError
    };
};

});



parcelRegister("hRIl6", function(module, exports) {

let $d019c7c8ad0f0cb8$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $d019c7c8ad0f0cb8$var$load("6cs5n").then(()=>parcelRequire('dg6OU'));

});

parcelRegister("3WT1L", function(module, exports) {

let $2e017930d15cbc38$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $2e017930d15cbc38$var$load("kK8Cc"),
    $2e017930d15cbc38$var$load("5lfr5")
]).then(()=>parcelRequire('ebALC'));

});


parcelRegister("JQEJY", function(module, exports) {

$parcel$export(module.exports, "PageCatchupComponent", () => $f625d855ba7548b9$export$c463287b61deee24);
$parcel$export(module.exports, "PageCatchupPopupForPageHistory", () => (parcelRequire("86vQj")).PageCatchupPopupForPageHistory);

var $gwFzn = parcelRequire("gwFzn");

var $dBxQj = parcelRequire("dBxQj");

var $9PrGG = parcelRequire("9PrGG");

var $jmjWc = parcelRequire("jmjWc");

var $gL2Cx = parcelRequire("gL2Cx");

var $86vQj = parcelRequire("86vQj");
const $f625d855ba7548b9$var$AISummarizeButtonPlaceholderWithText = ()=>{
    const intl = (0, $dBxQj.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $9PrGG.AISummarizeButtonPlaceholder), {
        summarizeText: intl.formatMessage((0, $gL2Cx.i18n).catchUpButtonText)
    });
};

const $f625d855ba7548b9$export$c463287b61deee24 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "DS85o",
    name: "PageCatchupComponent",
    loader: async ()=>(await Promise.resolve((parcelRequire("4RbVT")))).PageCatchupComponentWithErrorBoundary
});

const $f625d855ba7548b9$export$b8934fe6f5a65359 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "ZVEMJ",
    name: "PageCatchupPopup",
    loader: async ()=>(await Promise.resolve((parcelRequire("gL2Cx")))).PageCatchupPopupComponent,
    loading: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($f625d855ba7548b9$var$AISummarizeButtonPlaceholderWithText, null)
});

});
parcelRegister("gL2Cx", function(module, exports) {

$parcel$export(module.exports, "i18n", () => $3d9eb45e9938578d$export$a7357cdd1f0b0168);
$parcel$export(module.exports, "PageCatchupPopupComponent", () => $3d9eb45e9938578d$export$93a2b98265b32e4b);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $lGgRw = parcelRequire("lGgRw");

var $ccHMk = parcelRequire("ccHMk");

var $6f0Oj = parcelRequire("6f0Oj");
var $ecnYn = parcelRequire("ecnYn");

var $inPa6 = parcelRequire("inPa6");

var $3gadb = parcelRequire("3gadb");

var $ly2zj = parcelRequire("ly2zj");

var $4RbVT = parcelRequire("4RbVT");

var $kBab3 = parcelRequire("kBab3");
const $3d9eb45e9938578d$export$a7357cdd1f0b0168 = (0, $2nPZH.defineMessages)({
    catchUpButtonText: {
        id: "page-catchup.catchup.button.text",
        defaultMessage: "Summarize differences"
    }
});
const $3d9eb45e9938578d$var$ContentWidthStyles = (0, $ecnYn.xcss)({
    width: '500px'
});
const $3d9eb45e9938578d$export$93a2b98265b32e4b = ({ contentId: contentId, contentType: contentType, spaceKey: spaceKey, source: source, isDisabled: isDisabled, selectedVersions: selectedVersions })=>{
    const [isOpen, setIsOpen] = (0, $gwFzn.useState)(false);
    const intl = (0, $dBxQj.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    (0, $kBab3.usePageCatchupQueryParamOpen)(isOpen, setIsOpen, selectedVersions);
    const onClick = ()=>{
        setIsOpen(!isOpen);
        if (!isOpen) createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'pageCatchup',
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'pageCatchupButton',
                attributes: {
                    contentId: contentId,
                    source: source
                }
            }
        }).fire();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $lGgRw.default), {
        isOpen: isOpen,
        onClose: ()=>setIsOpen(false),
        placement: "bottom-start",
        popupComponent: (0, $ly2zj.CustomPopupContainer),
        shouldFlip: false,
        shouldRenderToParent: true,
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
                xcss: $3d9eb45e9938578d$var$ContentWidthStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4RbVT.PageCatchupComponentWithErrorBoundary), {
                contentId: contentId,
                contentType: contentType,
                spaceKey: spaceKey,
                source: source,
                selectedVersions: selectedVersions
            })),
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $3gadb.default), {
                hideTooltipOnMouseDown: true,
                position: "bottom",
                content: intl.formatMessage($3d9eb45e9938578d$export$a7357cdd1f0b0168.catchUpButtonText)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ccHMk.default), {
                ...triggerProps,
                "aria-haspopup": "dialog",
                onClick: onClick,
                isSelected: isOpen,
                iconBefore: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ly2zj.AIButtonIcon), {
                        label: ""
                    }),
                "aria-label": intl.formatMessage($3d9eb45e9938578d$export$a7357cdd1f0b0168.catchUpButtonText),
                isDisabled: isDisabled
            }, intl.formatMessage($3d9eb45e9938578d$export$a7357cdd1f0b0168.catchUpButtonText)))
    });
};

});
parcelRegister("4RbVT", function(module, exports) {

$parcel$export(module.exports, "PageCatchupComponentWithErrorBoundary", () => $82cc03f71f27d09d$export$22f83c0ec7a66a2);

var $gwFzn = parcelRequire("gwFzn");

var $2Rith = parcelRequire("2Rith");

var $dIouf = parcelRequire("dIouf");

var $9wGTI = parcelRequire("9wGTI");

var $4K3mj = parcelRequire("4K3mj");

var $a9eQ6 = parcelRequire("a9eQ6");
const $82cc03f71f27d09d$export$22f83c0ec7a66a2 = (props)=>{
    const aiAnalyticsConfig = {
        product: 'confluence',
        subproduct: 'confluence',
        source: props.source ?? 'confluencePage',
        aiFeatureName: 'pageCatchup',
        proactiveGeneratedAI: 0,
        userGeneratedAI: 1
    };
    const hasSelectedVersions = props.selectedVersions && props.selectedVersions.size > 1 && props.source === 'pageHistory';
    const pageCatchupComponent = hasSelectedVersions && (0, $9wGTI.fg)('confluence_ai_page_catchup_convo_ai_migration') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $a9eQ6.PageCatchupVersionDiffWrapperComponent), props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4K3mj.PageCatchupStreamingComponent), props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.ErrorBoundary), {
        attribution: (0, $dIouf.Attribution).SMARTS
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $2Rith.AIEventsInstrumentationProvider), {
        config: aiAnalyticsConfig
    }, pageCatchupComponent));
};

});
parcelRegister("4K3mj", function(module, exports) {

$parcel$export(module.exports, "PageCatchupStreamingComponent", () => $68e47fc55df08327$export$4c578b92894b49da);
/* PageCatchupStreamingComponent.tsx generated by @compiled/babel-plugin v0.36.1 */ /**
 * @graphql cc
 */ 
var $35pXk = parcelRequire("35pXk");

var $d2LG0 = parcelRequire("d2LG0");

var $gwFzn = parcelRequire("gwFzn");

var $dBxQj = parcelRequire("dBxQj");

var $diswb = parcelRequire("diswb");

var $kyKWe = parcelRequire("kyKWe");

var $inPa6 = parcelRequire("inPa6");

var $gdv5Z = parcelRequire("gdv5Z");

var $3j1mV = parcelRequire("3j1mV");

var $fXbFR = parcelRequire("fXbFR");

var $fYQcF = parcelRequire("fYQcF");

var $dOOm2 = parcelRequire("dOOm2");
var $au4KV = parcelRequire("au4KV");
var $8LJEA = parcelRequire("8LJEA");

var $ioNzo = parcelRequire("ioNzo");
var $ar5A7 = parcelRequire("ar5A7");

var $ly2zj = parcelRequire("ly2zj");

var $bQm3c = parcelRequire("bQm3c");

var $dIouf = parcelRequire("dIouf");

var $irVI7 = parcelRequire("irVI7");
var $1eaCJ = parcelRequire("1eaCJ");
var $1kHsc = parcelRequire("1kHsc");

var $dPJCf = parcelRequire("dPJCf");

var $6mKj3 = parcelRequire("6mKj3");

var $jZjxH = parcelRequire("jZjxH");

var $41usS = parcelRequire("41usS");

var $ifEd5 = parcelRequire("ifEd5");

var $3nYmf = parcelRequire("3nYmf");

var $2XwAb = parcelRequire("2XwAb");

var $555yk = parcelRequire("555yk");

var $5HlWa = parcelRequire("5HlWa");
const $68e47fc55df08327$var$PageCatchupWrapperComponentPageCatchupMetadataQuery = (0, $d2LG0.default)`query PageCatchupStreamingComponentMetadataQuery($contentId:ID!$contentType:CatchupContentType!$endTimeMs:Long!){catchupEditMetadataForContent(contentId:$contentId contentType:$contentType endTimeMs:$endTimeMs){lastVisitTimeISO hasVersionChangedSinceLastVisit users{displayName profilePicture{path}}}content(id:$contentId){nodes{version{number}}}}`;
const $68e47fc55df08327$var$PageCatchupWrapperComponentPageCatchupVersionDiffMetadataForContentQuery = (0, $d2LG0.default)`query PageCatchupStreamingComponentVersionDiffMetadataForContentQuery($contentId:ID!$contentType:CatchupContentType!$originalContentVersion:Int!$revisedContentVersion:Int!){catchupVersionDiffMetadataForContent(contentId:$contentId contentType:$contentType originalContentVersion:$originalContentVersion revisedContentVersion:$revisedContentVersion){isDiffEmpty users{displayName profilePicture{height isDefault width path}}}}`;
const $68e47fc55df08327$var$useOpenContentCatchupParam = (0, $dPJCf.createSingleQueryParamHook)('openContentCatchup'); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-important-styles, @atlaskit/design-system/use-tokens-typography
const $68e47fc55df08327$var$styles = null;
const $68e47fc55df08327$export$4c578b92894b49da = ({ contentId: contentId, contentType: contentType, spaceKey: spaceKey, source: source, selectedVersions: selectedVersions, isInObjectSidebar: isInObjectSidebar })=>{
    const { locale: locale } = (0, $dBxQj.default)();
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const { pageAri: pageAri } = (0, $3j1mV.useConfluencePageAri)(cloudId, contentId, contentType);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [aiInteractionId] = (0, $gwFzn.useState)((0, (/*@__PURE__*/$parcel$interopDefault($kyKWe)))());
    const experienceTracker = (0, $gwFzn.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const catchUpContentRef = (0, $gwFzn.useRef)(null);
    const { getDwellTime: getDwellTime } = (0, $fXbFR.usePopupDwellTime)(catchUpContentRef);
    const [dateInMs] = (0, $gwFzn.useState)(Date.now());
    const [hideMetadata, setHideMetadata] = (0, $gwFzn.useState)(true);
    const { inlineLinkingContent: inlineLinkingContent, updateBuffer: updateBuffer, lastProcessedLength: lastProcessedLength, setLastProcessedLength: setLastProcessedLength } = (0, $ly2zj.useInlineLinkingStreaming)();
    const analyticsProperties = {
        source: 'pageCatchup',
        additionalAnalyticsAttributes: {
            subSource: source
        }
    };
    const originalContentVersion = selectedVersions ? Math.min(...Array.from(selectedVersions)) : 0;
    const revisedContentVersion = selectedVersions ? Math.max(...Array.from(selectedVersions)) : 0;
    const hasSelectedVersions = selectedVersions && selectedVersions.size > 1 && source === 'pageHistory';
    const isStreamingDone = (0, $gwFzn.useRef)(false);
    const isStreamInitializationDone = (0, $gwFzn.useRef)(false);
    const timeToFirstAnswerPart = (0, $gwFzn.useRef)(0);
    const { trackAIInteractionInit: trackAIInteractionInit, trackAIResultView: trackAIResultView, trackAIResultError: trackAIResultError, trackAIResultAction: trackAIResultAction, trackAIInteractionDismiss: trackAIInteractionDismiss } = (0, $fYQcF.useAIEventsInstrumentation)();
    const hasQueryParamOpenSet = $68e47fc55df08327$var$useOpenContentCatchupParam() === 'true';
    const contentTypeEnum = contentType === 'page' ? (0, $ifEd5.CatchupContentType).PAGE : (0, $ifEd5.CatchupContentType).BLOGPOST;
    const { data: data, error: defaultMetaDataError } = (0, $diswb.useQuery)($68e47fc55df08327$var$PageCatchupWrapperComponentPageCatchupMetadataQuery, {
        variables: {
            contentId: contentId,
            contentType: contentTypeEnum,
            endTimeMs: dateInMs
        },
        skip: hasSelectedVersions
    });
    const { data: versionDiffMetadata, error: versionDiffMetadataError } = (0, $diswb.useQuery)($68e47fc55df08327$var$PageCatchupWrapperComponentPageCatchupVersionDiffMetadataForContentQuery, {
        variables: {
            contentId: contentId,
            contentType: contentTypeEnum,
            originalContentVersion: originalContentVersion,
            revisedContentVersion: revisedContentVersion
        },
        skip: !hasSelectedVersions
    });
    const metaDataError = defaultMetaDataError || versionDiffMetadataError;
    const isVersionDiffEmpty = versionDiffMetadata?.catchupVersionDiffMetadataForContent?.isDiffEmpty ?? false;
    const versionDiffUsers = versionDiffMetadata?.catchupVersionDiffMetadataForContent?.users ?? [];
    const versionDiffEditors = (0, $3nYmf.mapToEditors)(versionDiffUsers);
    const setIsStreamingDone = ()=>{
        isStreamingDone.current = true;
    };
    const setIsStreamInitializationDone = ()=>{
        isStreamInitializationDone.current = true;
    };
    const onShowMoreClick = (0, $gwFzn.useCallback)(()=>{
        trackAIResultAction('showMoreClicked');
    }, [
        trackAIResultAction
    ]);
    let agentNamedId = 'content_catchup_agent';
    let updateType = 'SINCE_LAST_VIEWED_MARKDOWN';
    if (hasSelectedVersions) {
        agentNamedId = 'content_catchup_version_diff_agent';
        updateType = 'BETWEEN_VERSIONS';
    } else if ((0, $6mKj3.expValEqualsNoExposure)('cc_ai_consumption_pc_streaming_inline_linking', 'cohort', 'inline_linking_stream')) {
        agentNamedId = 'content_catchup_streaming_inline_linking_agent';
        updateType = 'SINCE_LAST_VIEWED_MARKDOWN';
    }
    const request = (0, $gwFzn.useMemo)(()=>({
            recipient_agent_named_id: agentNamedId,
            agent_input_context: {
                content_ari: pageAri ?? '',
                locale: locale,
                end_time_ms: dateInMs,
                update_type: updateType,
                ...hasSelectedVersions && {
                    original_content_version: Math.min(...Array.from(selectedVersions)),
                    revised_content_version: Math.max(...Array.from(selectedVersions))
                }
            }
        }), [
        agentNamedId,
        pageAri,
        locale,
        dateInMs,
        updateType,
        hasSelectedVersions,
        selectedVersions
    ]);
    const onStateChange = (0, $gwFzn.useCallback)((state)=>{
        switch(state.responseState){
            case (0, $ioNzo.AIAgentResponseState).Initialization:
                if (state.content === null) {
                    experienceTracker.start({
                        name: (0, $irVI7.AI_CONTENT_CATCHUP_EXPERIENCE)
                    });
                    (0, $555yk.AI_CONTENT_CATCHUP_INTERACTION_METRIC).start();
                    trackAIInteractionInit();
                    timeToFirstAnswerPart.current = Date.now();
                }
                break;
            case (0, $ioNzo.AIAgentResponseState).Error:
                const { status_code: status_code, message_template: message_template } = state.error.message;
                (0, $555yk.AI_CONTENT_CATCHUP_INTERACTION_METRIC).stop();
                trackAIResultError({
                    aiErrorCode: status_code,
                    aiErrorMessage: message_template
                });
                setIsStreamingDone();
                break;
            case (0, $ioNzo.AIAgentResponseState).AnswerPart:
                if (!isStreamInitializationDone.current) {
                    setIsStreamInitializationDone();
                    createAnalyticsEvent({
                        type: 'sendTrackEvent',
                        data: {
                            action: 'streamReceived',
                            actionSubject: 'pageCatchup',
                            source: source ?? 'page',
                            actionSubjectId: 'pageCatchupDialog',
                            attributes: {
                                contentId: contentId,
                                timeToFirstAnswerPartInMs: Date.now() - timeToFirstAnswerPart.current,
                                agentNamedId: agentNamedId
                            }
                        }
                    }).fire();
                }
                const fullContent = (0, $jZjxH.mapInlineLinkingAgentResponseToMarkdown)(state.content);
                const newContent = fullContent.slice(lastProcessedLength);
                updateBuffer(newContent);
                setLastProcessedLength(fullContent.length);
                break;
            case (0, $ioNzo.AIAgentResponseState).FinalResponse:
                (0, $555yk.AI_CONTENT_CATCHUP_INTERACTION_METRIC).stop();
                createAnalyticsEvent({
                    type: 'sendScreenEvent',
                    data: {
                        name: 'pageCatchupDialog',
                        attributes: {
                            contentId: contentId,
                            aiInteractionId: aiInteractionId,
                            hasQueryParamOpenSet: hasQueryParamOpenSet
                        }
                    }
                }).fire();
                trackAIResultView();
                setIsStreamingDone();
                break;
            default:
                break;
        }
    }, [
        trackAIResultError,
        lastProcessedLength,
        updateBuffer,
        setLastProcessedLength,
        createAnalyticsEvent,
        contentId,
        aiInteractionId,
        hasQueryParamOpenSet,
        trackAIResultView,
        experienceTracker,
        trackAIInteractionInit,
        agentNamedId,
        source
    ]);
    const [{ content: content, responseState: responseState, error: streamSummaryError }] = (0, $ar5A7.useAIAgentStreaming)(request, {
        enablePartialJson: (0, $6mKj3.expValEqualsNoExposure)('cc_ai_consumption_pc_streaming_inline_linking', 'cohort', 'inline_linking_stream'),
        delayChunkUpdate: {
            gap: 10,
            time: 20
        },
        headers: {
            'x-experience-id': 'content-catchup',
            'x-product': 'confluence'
        }
    }, onStateChange);
    (0, $gwFzn.useEffect)(()=>{
        if (responseState === (0, $ioNzo.AIAgentResponseState).FinalResponse) {
            if (hideMetadata) setHideMetadata(false);
            if (source !== 'pageHistory') (0, $6mKj3.manuallyLogExpExposure)('cc_ai_consumption_pc_streaming_inline_linking');
        }
    }, [
        responseState,
        hideMetadata,
        source
    ]);
    const handleContainerClick = (0, $gwFzn.useCallback)((e)=>{
        const target = e.target;
        const linkElement = target.closest('a[id="#page-catchup-text-fragment"]');
        if (linkElement) trackAIResultAction('inlineLinkClicked');
    }, [
        trackAIResultAction
    ]);
    (0, $gwFzn.useEffect)(()=>{
        if (responseState === (0, $ioNzo.AIAgentResponseState).FinalResponse && (0, $6mKj3.expValEqualsNoExposure)('cc_ai_consumption_pc_streaming_inline_linking', 'cohort', 'inline_linking_stream')) {
            const container = document.querySelector('div[data-testid="ai-border-container"]');
            if (container) {
                container.addEventListener('click', handleContainerClick);
                return ()=>{
                    container.removeEventListener('click', handleContainerClick);
                };
            }
        }
    }, [
        responseState,
        handleContainerClick
    ]);
    (0, $gwFzn.useEffect)(()=>{
        return ()=>{
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'dwelled',
                    actionSubject: 'pageCatchup',
                    source: source ?? 'page',
                    actionSubjectId: 'pageCatchupDialog',
                    attributes: {
                        contentId: contentId,
                        dwellTime: getDwellTime(),
                        aiInteractionId: aiInteractionId,
                        hasQueryParamOpenSet: hasQueryParamOpenSet
                    }
                }
            }).fire();
            if (!isStreamInitializationDone.current) trackAIInteractionDismiss({
                attributes: {
                    dismissTiming: 'stream_initialization'
                }
            });
            else if (!isStreamingDone.current) trackAIInteractionDismiss({
                attributes: {
                    dismissTiming: 'answer_part_streaming'
                }
            });
        }; // we only want to run this effect on un-mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const lastVisitedOnDate = (0, $2XwAb.mapToFormattedDate)(data?.catchupEditMetadataForContent?.lastVisitTimeISO, locale);
    const hasVersionChangedSinceLastVisit = data?.catchupEditMetadataForContent?.hasVersionChangedSinceLastVisit ?? false;
    const users = data?.catchupEditMetadataForContent?.users ?? [];
    const defaultEditors = (0, $3nYmf.mapToEditors)(users);
    const editors = source === 'pageHistory' ? versionDiffEditors : defaultEditors;
    const pageVersion = data?.content?.nodes?.[0]?.version?.number ?? -1;
    const { versionHistoryLink: versionHistoryLink } = (0, $5HlWa.useGetVersionHistoryLink)(contentId, spaceKey, pageVersion);
    const onVersionHistoryLinkClick = (0, $gwFzn.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'pageCatchup',
                action: 'clicked',
                actionSubject: 'link',
                actionSubjectId: 'pageCatchupVersionHistoryLink',
                attributes: {
                    contentId: contentId,
                    aiInteractionId: aiInteractionId,
                    hasQueryParamOpenSet: hasQueryParamOpenSet
                }
            }
        }).fire();
        trackAIResultAction('versionHistoryLinkClick');
    }, [
        contentId,
        createAnalyticsEvent,
        aiInteractionId,
        hasQueryParamOpenSet,
        trackAIResultAction
    ]);
    const pageCatchupComponentProps = {
        contentId: contentId,
        contentType: contentType,
        spaceKey: spaceKey,
        lastVisitedOnDate: lastVisitedOnDate,
        editors: editors,
        ref: catchUpContentRef,
        hideMetadata: hideMetadata,
        versionHistoryLink: versionHistoryLink,
        onVersionHistoryLinkClick: onVersionHistoryLinkClick,
        hasVersionChangedSinceLastVisit: hasVersionChangedSinceLastVisit,
        onShowMoreClick: onShowMoreClick,
        source: source,
        isVersionDiffEmpty: isVersionDiffEmpty,
        isInObjectSidebar: isInObjectSidebar
    };
    const renderPageCatchupComponent = (contentToRender)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $41usS.PageCatchupComponent), {
            ...pageCatchupComponentProps,
            content: contentToRender
        });
    const renderContent = ()=>{
        const isInInlineLinkingExperiment = source !== 'pageHistory' && (0, $6mKj3.expValEqualsNoExposure)('cc_ai_consumption_pc_streaming_inline_linking', 'cohort', 'inline_linking_stream');
        switch(responseState){
            case (0, $ioNzo.AIAgentResponseState).Initialization:
                return isInObjectSidebar ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gdv5Z.default), {
                    paddingInline: "space.100"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $8LJEA.AISummaryLoading), null)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $au4KV.AIStreamLoading), null);
            case (0, $ioNzo.AIAgentResponseState).Error:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ly2zj.SmartsSummaryErrorComponent), {
                    analyticsProperties: analyticsProperties,
                    errorFromApolloOrStream: streamSummaryError,
                    contentId: contentId,
                    experienceName: (0, $irVI7.AI_CONTENT_CATCHUP_EXPERIENCE)
                });
            case (0, $ioNzo.AIAgentResponseState).AnswerPart:
                if (isInInlineLinkingExperiment) return renderPageCatchupComponent(inlineLinkingContent);
                return renderPageCatchupComponent(content);
            case (0, $ioNzo.AIAgentResponseState).FinalResponse:
                return renderPageCatchupComponent(content);
            default:
                break;
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
        className: (0, $35pXk.default)([
            "_ggmhs13h"
        ])
    }, isInObjectSidebar ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, metaDataError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.ErrorDisplay), {
        error: metaDataError
    }), renderContent(), responseState === (0, $ioNzo.AIAgentResponseState).FinalResponse && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1eaCJ.ExperienceSuccess), {
        name: (0, $irVI7.AI_CONTENT_CATCHUP_EXPERIENCE),
        attributes: {
            source: source
        }
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dOOm2.AIBorder), {
        loading: responseState === (0, $ioNzo.AIAgentResponseState).Initialization
    }, metaDataError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.ErrorDisplay), {
        error: metaDataError
    }), renderContent(), responseState === (0, $ioNzo.AIAgentResponseState).FinalResponse && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1eaCJ.ExperienceSuccess), {
        name: (0, $irVI7.AI_CONTENT_CATCHUP_EXPERIENCE),
        attributes: {
            source: source
        }
    })));
};

});
parcelRegister("jZjxH", function(module, exports) {

$parcel$export(module.exports, "mapInlineLinkingAgentResponseToMarkdown", () => $c393a02d5f46acb0$export$c476676a5dd91e06);
const $c393a02d5f46acb0$export$c476676a5dd91e06 = (responseContent)=>{
    if (!responseContent.response || responseContent.response.length === 0 || responseContent.response.length === 1 && Object.keys(responseContent.response[0]).length === 0) return '';
    return responseContent.response.map((item)=>{
        if ('heading' in item && 'changes' in item) {
            const changes = item.changes && item.changes.length > 0 ? item.changes.map((change)=>{
                let formattedChange = '';
                if (change.change) {
                    formattedChange = `* ${change.change}`;
                    if (change.snippet) formattedChange += ` ${change.snippet}`;
                }
                return formattedChange;
            }).filter(Boolean).join('\n') : '';
            return `### ${item.heading}\n${changes}\n`;
        }
        return '';
    }).join('\n');
};

});

parcelRegister("41usS", function(module, exports) {

$parcel$export(module.exports, "PageCatchupComponent", () => $b47380d9a1361e15$export$c463287b61deee24);
/* PageCatchupComponent.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $35pXk = parcelRequire("35pXk");

var $gUu2y = parcelRequire("gUu2y");

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $4jR19 = parcelRequire("4jR19");

var $6f0Oj = parcelRequire("6f0Oj");
var $bUlM5 = parcelRequire("bUlM5");
var $dcJ7R = parcelRequire("dcJ7R");
var $1GzhS = parcelRequire("1GzhS");
var $ecnYn = parcelRequire("ecnYn");

var $2Pg7f = parcelRequire("2Pg7f");

var $2Nwuj = parcelRequire("2Nwuj");

var $i26zO = parcelRequire("i26zO");
var $fooTI = parcelRequire("fooTI");

var $ly2zj = parcelRequire("ly2zj");

var $k9zyo = parcelRequire("k9zyo");

var $jU1R7 = parcelRequire("jU1R7");
const $b47380d9a1361e15$var$ScrollableBody = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_11c81ixg _18m91wug _1suq18uv _1ke8u2gc _155au2gc _aaynm7j4 _1ogl15ej",
            __cmplp.className
        ])
    });
});
const $b47380d9a1361e15$var$HeaderStyles = (0, $ecnYn.xcss)({
    backgroundColor: 'color.background.accent.gray.subtlest',
    borderRadius: '4px',
    padding: 'space.100'
});
const $b47380d9a1361e15$var$StackStyles = (0, $ecnYn.xcss)({
    overflowWrap: 'break-word',
    whiteSpace: 'normal',
    height: '100%'
});
const $b47380d9a1361e15$var$ContentStyles = (0, $ecnYn.xcss)({
    gap: 'space.200',
    height: '100%'
});
const $b47380d9a1361e15$var$ContentHeightStyles = (0, $ecnYn.xcss)({
    maxHeight: '350px'
});
const $b47380d9a1361e15$var$FooterObjectSidebarStyles = (0, $ecnYn.xcss)({
    // Object sidebar padding is 16px, this ensures that the footer isn't cutoff by parent padding
    width: 'calc(100% + 32px)',
    marginLeft: 'space.negative.200'
});
const $b47380d9a1361e15$var$i18n = (0, $2nPZH.defineMessages)({
    lastVisitedOn: {
        id: "page-catchup.last-visited-on-text",
        defaultMessage: "Changes since you last visited on {lastVisitedOnDate}."
    },
    firstTimeVisit: {
        id: "page-catchup.first-time-visit-text",
        defaultMessage: "Since this is your first time visiting this content, you\u2019re seeing a page summary instead of a summary of changes."
    },
    noChangesSinceLastVisit: {
        id: "page-catchup.no-changes-since-last-visit-text",
        defaultMessage: "There haven\u2019t been any changes since your last visit on {lastVisitedOnDate}. We\u2019ve generated this summary instead to help refresh your memory."
    },
    fullVersionHistoryLinkText: {
        id: "page-catchup.full.version.history.link.text",
        defaultMessage: "See changes in version history"
    },
    changesBetweenVersionsText: {
        id: "page-catchup.changes.between.versions.text",
        defaultMessage: "Changes between selected versions"
    }
});
const $b47380d9a1361e15$export$c463287b61deee24 = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ contentId: contentId, content: content, contentType: contentType, spaceKey: spaceKey, lastVisitedOnDate: lastVisitedOnDate, editors: editors, hideMetadata: hideMetadata, versionHistoryLink: versionHistoryLink, onVersionHistoryLinkClick: onVersionHistoryLinkClick, hasVersionChangedSinceLastVisit: hasVersionChangedSinceLastVisit, onShowMoreClick: onShowMoreClick, source: source, isVersionDiffEmpty: isVersionDiffEmpty, isInObjectSidebar: isInObjectSidebar }, catchUpContentRef)=>{
    const getHeaderText = ()=>{
        if (!hasVersionChangedSinceLastVisit && lastVisitedOnDate) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), {
            ...$b47380d9a1361e15$var$i18n.noChangesSinceLastVisit,
            values: {
                lastVisitedOnDate: lastVisitedOnDate
            }
        });
        else if (hasVersionChangedSinceLastVisit && lastVisitedOnDate) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), {
            ...$b47380d9a1361e15$var$i18n.lastVisitedOn,
            values: {
                lastVisitedOnDate: lastVisitedOnDate
            }
        });
        else if (source === 'pageHistory' && !isVersionDiffEmpty) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $b47380d9a1361e15$var$i18n.changesBetweenVersionsText);
        else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $b47380d9a1361e15$var$i18n.firstTimeVisit);
    };
    if (source === 'pageHistory' && isVersionDiffEmpty) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $jU1R7.VersionDiffEmptyComponent), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ly2zj.FeedbackCollectorPropertiesProvider), {
        entrypointId: "d4c9238b-d3d6-4298-83d9-10f6bddd4f2b"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1GzhS.default), {
        xcss: $b47380d9a1361e15$var$StackStyles,
        spread: "space-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        padding: isInObjectSidebar ? 'space.100' : 'space.200'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1GzhS.default), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1GzhS.default), {
        xcss: $b47380d9a1361e15$var$HeaderStyles,
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), null, getHeaderText()), (lastVisitedOnDate && hasVersionChangedSinceLastVisit || source === 'pageHistory') && editors.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dcJ7R.default), {
        space: "space.050",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $2Pg7f.default), {
        size: "small",
        data: editors,
        testId: "page-catchup",
        maxCount: 4
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $k9zyo.EditorsNameListComponent), {
        editors: editors
    }))), (source !== 'pageHistory' || !isVersionDiffEmpty) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $bUlM5.default), {
        direction: "column",
        xcss: [
            $b47380d9a1361e15$var$ContentStyles,
            !isInObjectSidebar && $b47380d9a1361e15$var$ContentHeightStyles
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $i26zO.AIContentBlur), {
        shouldOpenInCollapsedView: (!lastVisitedOnDate || !hasVersionChangedSinceLastVisit) && source !== 'pageHistory' && !isInObjectSidebar,
        onShowMore: onShowMoreClick,
        summaryLineHeight: 80
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($b47380d9a1361e15$var$ScrollableBody, {
        ref: catchUpContentRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $fooTI.AITelepointerWrapper), {
        hideTelepointer: !hideMetadata
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gUu2y.default), null, content))))), versionHistoryLink && !hideMetadata && hasVersionChangedSinceLastVisit && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $2Nwuj.default), {
        href: versionHistoryLink,
        onClick: onVersionHistoryLinkClick,
        target: "_blank"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $b47380d9a1361e15$var$i18n.fullVersionHistoryLinkText)))), !hideMetadata && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: isInObjectSidebar && $b47380d9a1361e15$var$FooterObjectSidebarStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ly2zj.AISummaryFooter), {
        analyticsProperties: {
            source: 'pageCatchup'
        },
        contentId: contentId,
        spaceKey: spaceKey,
        contentType: contentType,
        summaryText: content
    }))));
});

});
parcelRegister("i26zO", function(module, exports) {

$parcel$export(module.exports, "AIContentBlur", () => $2c4cc4d659a0f966$export$4a0c9e9f971c9d4);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $eEA8O = parcelRequire("eEA8O");

var $6f0Oj = parcelRequire("6f0Oj");
var $bUlM5 = parcelRequire("bUlM5");
var $dcJ7R = parcelRequire("dcJ7R");
var $ecnYn = parcelRequire("ecnYn");

var $6fnsQ = parcelRequire("6fnsQ");
const $2c4cc4d659a0f966$var$i18n = (0, $2nPZH.defineMessages)({
    showMore: {
        id: "ai-content-blur.show-more",
        defaultMessage: "Show more"
    }
});
const $2c4cc4d659a0f966$var$BodyStyles = (0, $ecnYn.xcss)({
    overflow: 'hidden',
    position: 'relative'
});
const $2c4cc4d659a0f966$var$BlurStyles = (0, $ecnYn.xcss)({
    position: 'absolute',
    background: `linear-gradient( 0deg, ${`var(--ds-surface-overlay, ${(0, $6fnsQ.N10)})`} 0%, ${"var(--ds-background-neutral-subtle, rgba(255, 255, 255, 0))"} 100% )`,
    height: '20px',
    width: '100%'
});
const $2c4cc4d659a0f966$export$4a0c9e9f971c9d4 = ({ children: children, onShowMore: onShowMore, shouldOpenInCollapsedView: shouldOpenInCollapsedView, summaryLineHeight: summaryLineHeight, padding: padding })=>{
    const intl = (0, $dBxQj.default)();
    const [isCollapsed, setIsCollapsed] = (0, $gwFzn.useState)(shouldOpenInCollapsedView);
    const handleShowMoreClick = ()=>{
        if (isCollapsed) {
            setIsCollapsed(false);
            onShowMore?.();
        }
    };
    if (!isCollapsed) return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7UHDa.Fragment), {
        children: children
    });
    return(// eslint-disable-next-line @atlassian/a11y/interactive-element-not-keyboard-focusable
    /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
        testId: "summary-blur-container",
        onClick: handleShowMoreClick,
        style: {
            padding: padding
        },
        children: /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $bUlM5.default), {
            alignItems: "end",
            gap: "space.050",
            children: [
                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $dcJ7R.default), {
                    grow: "fill",
                    children: /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $6f0Oj.default), {
                        xcss: $2c4cc4d659a0f966$var$BodyStyles,
                        style: {
                            maxHeight: summaryLineHeight ? `${summaryLineHeight}px` : '40px'
                        },
                        testId: "child-text-box-container",
                        children: [
                            children,
                            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                                xcss: $2c4cc4d659a0f966$var$BlurStyles,
                                style: {
                                    top: summaryLineHeight ? `${summaryLineHeight - 20}px` : '20px'
                                },
                                testId: "blur-styles-box-container"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $eEA8O.default), {
                    appearance: "link",
                    spacing: "none",
                    children: intl.formatMessage($2c4cc4d659a0f966$var$i18n.showMore)
                })
            ]
        })
    }));
};

});

parcelRegister("fooTI", function(module, exports) {

$parcel$export(module.exports, "AITelepointerWrapper", () => $3ef04317b5e4f55f$export$e372ffc7075fd6f3);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $6f0Oj = parcelRequire("6f0Oj");
var $ecnYn = parcelRequire("ecnYn");
const $3ef04317b5e4f55f$var$telepointerStyles = (0, $ecnYn.xcss)({
    display: 'inline-block',
    position: 'absolute',
    width: '1.5px',
    height: '25px',
    background: 'linear-gradient(45deg, #F8E6A0 -12.02%, #8BDBE5 19.18%, #0C66E4 71.87%)',
    marginLeft: 'space.025',
    marginTop: 'space.negative.100',
    '::after': {
        content: '"AI"',
        position: 'absolute',
        display: 'block',
        top: 'space.0',
        left: 'space.0',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: '10px',
        fontWeight: 'font.weight.bold',
        width: '12.5px',
        height: '13px',
        paddingTop: 'space.025',
        paddingLeft: 'space.025',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: 'initial',
        borderRadius: '0px 2px 2px 0px',
        color: 'color.text.inverse',
        background: 'linear-gradient(45deg, #8BDBE5 -57%, #0C66E4 71.87%)'
    }
});
const $3ef04317b5e4f55f$var$isAValidContainer = (node)=>{
    if (node.hasChildNodes() && node.lastChild?.nodeType !== Node.TEXT_NODE) return true;
    return false;
};
const $3ef04317b5e4f55f$var$getNestedLastChild = (originNode)=>{
    if ($3ef04317b5e4f55f$var$isAValidContainer(originNode) && originNode.lastChild) return $3ef04317b5e4f55f$var$getNestedLastChild(originNode.lastChild);
    else if (originNode.textContent === '' && originNode.parentNode) return originNode.parentNode;
    else return originNode;
};
const $3ef04317b5e4f55f$export$e372ffc7075fd6f3 = ({ hideTelepointer: hideTelepointer = false, children: children })=>{
    const containerRef = (0, $gwFzn.useRef)(null);
    const telepointerRef = (0, $gwFzn.useRef)(null);
    (0, $gwFzn.useEffect)(()=>{
        if (!hideTelepointer) {
            const renderer = containerRef.current;
            if (renderer.lastChild && telepointerRef.current) $3ef04317b5e4f55f$var$getNestedLastChild(renderer.lastChild).appendChild(telepointerRef.current);
        }
    }, [
        children,
        hideTelepointer
    ]);
    if (hideTelepointer) return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7UHDa.Fragment), {
        children: children
    });
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $6f0Oj.default), {
        ref: containerRef,
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                as: "span",
                ref: telepointerRef,
                xcss: $3ef04317b5e4f55f$var$telepointerStyles,
                testId: "ai-telepointer-cursor"
            }),
            children
        ]
    });
};

});

parcelRegister("k9zyo", function(module, exports) {

$parcel$export(module.exports, "EditorsNameListComponent", () => $f609a69515d1e116$export$d86d70bd36fbdafc);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $4jR19 = parcelRequire("4jR19");

var $6f0Oj = parcelRequire("6f0Oj");
var $ecnYn = parcelRequire("ecnYn");
const $f609a69515d1e116$var$i18n = (0, $2nPZH.defineMessages)({
    editorsNameListText: {
        id: "page-catchup.editors.name.list.text",
        defaultMessage: "{editorsCount, plural, one {{firstEditor} has} =2 {{firstEditor} and {secondEditor} have} =3 {{firstEditor}, {secondEditor}, and {thirdEditor} have} other {{firstEditor}, {secondEditor}, {thirdEditor} and {remainingEditorCount} others have}} edited this content"
    },
    editorsNameListTextNoVerbiage: {
        id: "page-catchup.editors.name.list.text.no.verbiage",
        defaultMessage: "{editorsCount, plural, one {{firstEditor}} =2 {{firstEditor} and {secondEditor}} =3 {{firstEditor}, {secondEditor}, and {thirdEditor}} other {{firstEditor}, {secondEditor}, {thirdEditor} and {remainingEditorCount} others}}"
    }
});
const $f609a69515d1e116$export$d86d70bd36fbdafc = ({ editors: editors, showNoVerbiage: showNoVerbiage })=>{
    const editorsCount = editors.length;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        testId: "editors-name-list",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        xcss: (0, $ecnYn.xcss)({
            font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), {
        ...showNoVerbiage ? $f609a69515d1e116$var$i18n.editorsNameListTextNoVerbiage : $f609a69515d1e116$var$i18n.editorsNameListText,
        values: {
            editorsCount: editorsCount,
            firstEditor: editorsCount > 0 ? editors[0].name : null,
            secondEditor: editorsCount > 1 ? editors[1].name : null,
            thirdEditor: editorsCount > 2 ? editors[2].name : null,
            remainingEditorCount: editorsCount - 3
        }
    }));
};

});

parcelRegister("jU1R7", function(module, exports) {

$parcel$export(module.exports, "VersionDiffEmptyComponent", () => $01c104751c4671cb$export$2f0d20c33235025e);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $4jR19 = parcelRequire("4jR19");

var $6f0Oj = parcelRequire("6f0Oj");
var $1GzhS = parcelRequire("1GzhS");
var $ecnYn = parcelRequire("ecnYn");

var $63blV = parcelRequire("63blV");
const $01c104751c4671cb$var$footerBoxStyles = (0, $ecnYn.xcss)({
    borderTop: `1px solid ${"var(--ds-border, #091E4224)"}`
});
const $01c104751c4671cb$var$boxTextStyles = (0, $ecnYn.xcss)({
    color: 'color.text.subtlest'
});
const $01c104751c4671cb$var$i18n = (0, $2nPZH.defineMessages)({
    diffEmptyBetweenVersionsText: {
        id: "page-catchup.diff.empty.between.versions.text",
        defaultMessage: "These versions are too similar for Atlassian Intelligence (AI) to generate a summary of the differences between them."
    }
});
const $01c104751c4671cb$export$2f0d20c33235025e = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1GzhS.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        padding: "space.250",
        xcss: $01c104751c4671cb$var$boxTextStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $01c104751c4671cb$var$i18n.diffEmptyBetweenVersionsText)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        paddingInline: "space.200",
        paddingBlock: "space.050",
        xcss: $01c104751c4671cb$var$footerBoxStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $63blV.AIAttributionFooter), null)));
};

});
parcelRegister("63blV", function(module, exports) {

$parcel$export(module.exports, "AIAttributionFooter", () => $75f4c452dbf67a05$export$c7fc4bd65402b494);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $dBxQj = parcelRequire("dBxQj");

var $3Mg7y = parcelRequire("3Mg7y");

var $b9sgO = parcelRequire("b9sgO");

var $aIk0I = parcelRequire("aIk0I");

var $fpGTa = parcelRequire("fpGTa");
var $dcJ7R = parcelRequire("dcJ7R");
var $5dK2X = parcelRequire("5dK2X");
var $ecnYn = parcelRequire("ecnYn");

var $4JDbp = parcelRequire("4JDbp");

var $ezYWs = parcelRequire("ezYWs");

var $jjneR = parcelRequire("jjneR");
const $75f4c452dbf67a05$var$footerContainerStyles = (0, $ecnYn.xcss)({
    position: 'relative'
});
const $75f4c452dbf67a05$var$footerDisclaimerStyles = (0, $ecnYn.xcss)({
    paddingBlock: 'space.050'
});
const $75f4c452dbf67a05$var$linkStyles = (0, $ecnYn.xcss)({
    color: 'color.text.subtlest',
    font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    textDecoration: 'none',
    ':hover': {
        color: 'color.text.selected',
        cursor: 'pointer',
        textDecoration: 'underline'
    }
});
const $75f4c452dbf67a05$export$c7fc4bd65402b494 = ({ onLinkClick: onLinkClick, showBetaLozenge: showBetaLozenge })=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const [footerWidth, setFooterWidth] = (0, $gwFzn.useState)(0);
    const betaLozengeText = formatMessage((0, $jjneR.i18n).betaLozenge);
    const attributionMessage = ()=>{
        if (footerWidth >= (0, $ezYWs.LARGE_BREAKPOINT)) return formatMessage((0, $jjneR.i18n).attributionFooterAttributionLabelLarge);
        else if (footerWidth >= (0, $ezYWs.MEDIUM_BREAKPOINT) && footerWidth < (0, $ezYWs.LARGE_BREAKPOINT)) return formatMessage((0, $jjneR.i18n).attributionFooterAttributionLabelMedium);
        else return null;
    };
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $dcJ7R.default), {
        alignBlock: "center",
        spread: "space-between",
        xcss: $75f4c452dbf67a05$var$footerContainerStyles,
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4JDbp.WidthObserver), {
                setWidth: setFooterWidth
            }),
            /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $dcJ7R.default), {
                alignBlock: "center",
                xcss: $75f4c452dbf67a05$var$footerDisclaimerStyles,
                space: "space.050",
                children: [
                    showBetaLozenge && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $aIk0I.default), {
                        children: betaLozengeText
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($b9sgO))), {
                        label: "",
                        color: "var(--ds-icon-subtle, #626F86)"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)((0, $fpGTa.default), {
                        xcss: $75f4c452dbf67a05$var$linkStyles,
                        href: (0, $ezYWs.LINK_HREF),
                        target: "_blank",
                        onClick: onLinkClick,
                        children: footerWidth >= (0, $ezYWs.LARGE_BREAKPOINT) ? formatMessage((0, $jjneR.i18n).attributionFooterDisclaimerLarge) : formatMessage((0, $jjneR.i18n).attributionFooterDisclaimer)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $dcJ7R.default), {
                space: "space.075",
                alignBlock: "center",
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsx)((0, $5dK2X.default), {
                        size: "small",
                        color: "color.text.subtlest",
                        children: attributionMessage()
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3Mg7y))), {
                        color: "var(--ds-icon, #44546F)",
                        label: formatMessage((0, $jjneR.i18n).atlassianIntelligenceIconAlt)
                    })
                ]
            })
        ]
    });
};

});
parcelRegister("ezYWs", function(module, exports) {

$parcel$export(module.exports, "LARGE_BREAKPOINT", () => $010c748f3ca601da$export$ba58b4d4ecb9b338);
$parcel$export(module.exports, "MEDIUM_BREAKPOINT", () => $010c748f3ca601da$export$3a75af9c02826b93);
$parcel$export(module.exports, "LINK_HREF", () => $010c748f3ca601da$export$e2297811c4a04978);
const $010c748f3ca601da$export$ba58b4d4ecb9b338 = 600;
const $010c748f3ca601da$export$3a75af9c02826b93 = 320;
const $010c748f3ca601da$export$e2297811c4a04978 = 'https://www.atlassian.com/trust/atlassian-intelligence';

});

parcelRegister("jjneR", function(module, exports) {

$parcel$export(module.exports, "i18n", () => $d509bd528a228fac$export$a7357cdd1f0b0168);

var $2nPZH = parcelRequire("2nPZH");
const $d509bd528a228fac$export$a7357cdd1f0b0168 = (0, $2nPZH.defineMessages)({
    attributionFooterDisclaimerLarge: {
        id: "attribution-footer.disclaimer.large.text",
        defaultMessage: "Content is based on your permissions and its quality may vary"
    },
    attributionFooterDisclaimer: {
        id: "attribution-footer.disclaimer.text",
        defaultMessage: "Content quality may vary"
    },
    attributionFooterAttributionLabelLarge: {
        id: "attribution-footer.attribution-label.large.text",
        defaultMessage: "Powered by Atlassian Intelligence"
    },
    attributionFooterAttributionLabelMedium: {
        id: "attribution-footer.attribution-label.medium.text",
        defaultMessage: "Powered by AI"
    },
    atlassianIntelligenceIconAlt: {
        id: "attribution-footer.atlassian-intelligence-icon.alt-text",
        defaultMessage: "Atlassian Intelligence"
    },
    betaLozenge: {
        id: "attribution-footer.beta-lozenge",
        defaultMessage: "Beta"
    }
});

});




parcelRegister("ifEd5", function(module, exports) {

$parcel$export(module.exports, "CatchupContentType", () => $551036f28c08b5b8$export$fe6033382a69eea9);
/* tslint:disable */ /* eslint-disable */ // This file was automatically generated and should not be edited.
//==============================================================
// START Enums and Input Objects
//==============================================================
var $551036f28c08b5b8$export$fe6033382a69eea9 = /*#__PURE__*/ function(CatchupContentType) {
    CatchupContentType["BLOGPOST"] = "BLOGPOST";
    CatchupContentType["PAGE"] = "PAGE";
    return CatchupContentType;
}({});

});

parcelRegister("3nYmf", function(module, exports) {

$parcel$export(module.exports, "mapToEditors", () => $676d15788c30fd82$export$2364cf53dded03dd);
function $676d15788c30fd82$export$2364cf53dded03dd(editors) {
    return editors.map((u)=>{
        return {
            name: u?.displayName ?? '',
            src: u && 'profilePicture' in u ? u?.profilePicture?.path : ''
        };
    });
}

});

parcelRegister("2XwAb", function(module, exports) {

$parcel$export(module.exports, "mapToFormattedDate", () => $b00440823166005e$export$757dbcc1bd42832);
function $b00440823166005e$export$757dbcc1bd42832(ISOdate, locale) {
    if (!ISOdate) return;
    const dateOptions = {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
    };
    return new Date(ISOdate).toLocaleDateString(locale, dateOptions);
}

});

parcelRegister("555yk", function(module, exports) {

$parcel$export(module.exports, "AI_CONTENT_CATCHUP_INTERACTION_METRIC", () => $f249c720b72bd2f9$export$42c905138efbcdac);

var $jIOyV = parcelRequire("jIOyV");
var $lSOAM = parcelRequire("lSOAM");
const $f249c720b72bd2f9$export$42c905138efbcdac = (0, $lSOAM.createInteractionMetric)({
    key: (0, $jIOyV.AI_CONTENT_CATCHUP_INTERACTION)
});

});

parcelRegister("5HlWa", function(module, exports) {

$parcel$export(module.exports, "useGetVersionHistoryLink", () => $dbb424c9806aaca2$export$3042bbbffe78f13c);

var $dPJCf = parcelRequire("dPJCf");

var $1NBp8 = parcelRequire("1NBp8");
var $jlIaF = parcelRequire("jlIaF");
const $dbb424c9806aaca2$var$usePrevVersionParam = (0, $dPJCf.createSingleQueryParamHook)('prevVersion');
const $dbb424c9806aaca2$var$useCurrentVersionParam = (0, $dPJCf.createSingleQueryParamHook)('currVersion');
const $dbb424c9806aaca2$export$3042bbbffe78f13c = (contentId, spaceKey, pageVersion)=>{
    const fallbackLink = (0, $1NBp8.CONTENT_HISTORY).toUrl({
        spaceKey: spaceKey,
        contentId: contentId
    });
    const prevVersionFromParam = parseInt($dbb424c9806aaca2$var$usePrevVersionParam() ?? '');
    const currVersionFromParam = parseInt($dbb424c9806aaca2$var$useCurrentVersionParam() ?? '');
    if (pageVersion < 0 && (isNaN(currVersionFromParam) || isNaN(prevVersionFromParam))) return {
        versionHistoryLink: fallbackLink
    };
    const currVersion = isNaN(currVersionFromParam) ? pageVersion : currVersionFromParam;
    const prevVersion = isNaN(prevVersionFromParam) ? pageVersion - 1 : prevVersionFromParam;
    const versionDiffLink = `${(0, $jlIaF.CONTEXT_PATH)}/pages/diffpagesbyversion.action?pageId=${contentId}&selectedPageVersions=${prevVersion}&selectedPageVersions=${currVersion}`;
    return {
        versionHistoryLink: versionDiffLink
    };
};

});


parcelRegister("a9eQ6", function(module, exports) {

$parcel$export(module.exports, "PageCatchupVersionDiffWrapperComponent", () => $9aed974a19335374$export$64a71206cb6a93be);
/* PageCatchupVersionDiffWrapperComponent.tsx generated by @compiled/babel-plugin v0.36.1 */ /**
 * @graphql cc
 */ 
var $35pXk = parcelRequire("35pXk");

var $d2LG0 = parcelRequire("d2LG0");

var $gwFzn = parcelRequire("gwFzn");

var $dBxQj = parcelRequire("dBxQj");

var $diswb = parcelRequire("diswb");

var $kyKWe = parcelRequire("kyKWe");

var $inPa6 = parcelRequire("inPa6");

var $gdv5Z = parcelRequire("gdv5Z");

var $3j1mV = parcelRequire("3j1mV");

var $fXbFR = parcelRequire("fXbFR");

var $fYQcF = parcelRequire("fYQcF");

var $dOOm2 = parcelRequire("dOOm2");
var $au4KV = parcelRequire("au4KV");
var $8LJEA = parcelRequire("8LJEA");

var $kAaxz = parcelRequire("kAaxz");
var $d3UlG = parcelRequire("d3UlG");

var $ly2zj = parcelRequire("ly2zj");

var $bQm3c = parcelRequire("bQm3c");

var $dIouf = parcelRequire("dIouf");

var $irVI7 = parcelRequire("irVI7");
var $1eaCJ = parcelRequire("1eaCJ");
var $1kHsc = parcelRequire("1kHsc");

var $dPJCf = parcelRequire("dPJCf");

var $41usS = parcelRequire("41usS");

var $ifEd5 = parcelRequire("ifEd5");

var $3nYmf = parcelRequire("3nYmf");

var $2XwAb = parcelRequire("2XwAb");

var $555yk = parcelRequire("555yk");

var $5HlWa = parcelRequire("5HlWa");

var $5cgqG = parcelRequire("5cgqG");
const $9aed974a19335374$var$PageCatchupVersionDiffWrapperComponentPageCatchupMetadataQuery = (0, $d2LG0.default)`query PageCatchupVersionDiffWrapperComponentPageCatchupMetadataQuery($contentId:ID!$contentType:CatchupContentType!$endTimeMs:Long!){catchupEditMetadataForContent(contentId:$contentId contentType:$contentType endTimeMs:$endTimeMs){lastVisitTimeISO hasVersionChangedSinceLastVisit users{displayName profilePicture{path}}}content(id:$contentId){nodes{version{number}}}}`;
const $9aed974a19335374$var$PageCatchupVersionDiffWrapperComponentPageCatchupVersionDiffMetadataForContentQuery = (0, $d2LG0.default)`query PageCatchupVersionDiffWrapperComponentPageCatchupVersionDiffMetadataForContentQuery($contentId:ID!$contentType:CatchupContentType!$originalContentVersion:Int!$revisedContentVersion:Int!){catchupVersionDiffMetadataForContent(contentId:$contentId contentType:$contentType originalContentVersion:$originalContentVersion revisedContentVersion:$revisedContentVersion){isDiffEmpty users{displayName profilePicture{height isDefault width path}}}}`;
const $9aed974a19335374$var$useOpenContentCatchupParam = (0, $dPJCf.createSingleQueryParamHook)('openContentCatchup');
const $9aed974a19335374$var$styles = null;
const $9aed974a19335374$export$64a71206cb6a93be = ({ contentId: contentId, contentType: contentType, spaceKey: spaceKey, source: source, selectedVersions: selectedVersions, isInObjectSidebar: isInObjectSidebar })=>{
    const { locale: locale } = (0, $dBxQj.default)();
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const { pageAri: pageAri } = (0, $3j1mV.useConfluencePageAri)(cloudId, contentId, contentType);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [aiInteractionId] = (0, $gwFzn.useState)((0, (/*@__PURE__*/$parcel$interopDefault($kyKWe)))());
    const experienceTracker = (0, $gwFzn.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const catchUpContentRef = (0, $gwFzn.useRef)(null);
    const { getDwellTime: getDwellTime } = (0, $fXbFR.usePopupDwellTime)(catchUpContentRef);
    const [dateInMs] = (0, $gwFzn.useState)(Date.now());
    const [hideMetadata, setHideMetadata] = (0, $gwFzn.useState)(true);
    const analyticsProperties = {
        source: 'pageCatchup',
        additionalAnalyticsAttributes: {
            subSource: source
        }
    };
    const originalContentVersion = selectedVersions ? Math.min(...Array.from(selectedVersions)) : 0;
    const revisedContentVersion = selectedVersions ? Math.max(...Array.from(selectedVersions)) : 0;
    const hasSelectedVersions = selectedVersions && selectedVersions.size > 1 && source === 'pageHistory';
    const isStreamingDone = (0, $gwFzn.useRef)(false);
    const isStreamInitializationDone = (0, $gwFzn.useRef)(false);
    const timeToFirstAnswerPart = (0, $gwFzn.useRef)(0);
    const { trackAIInteractionInit: trackAIInteractionInit, trackAIResultView: trackAIResultView, trackAIResultError: trackAIResultError, trackAIResultAction: trackAIResultAction, trackAIInteractionDismiss: trackAIInteractionDismiss } = (0, $fYQcF.useAIEventsInstrumentation)();
    const hasQueryParamOpenSet = $9aed974a19335374$var$useOpenContentCatchupParam() === 'true';
    const contentTypeEnum = contentType === 'page' ? (0, $ifEd5.CatchupContentType).PAGE : (0, $ifEd5.CatchupContentType).BLOGPOST;
    const { data: data, error: defaultMetaDataError } = (0, $diswb.useQuery)($9aed974a19335374$var$PageCatchupVersionDiffWrapperComponentPageCatchupMetadataQuery, {
        variables: {
            contentId: contentId,
            contentType: contentTypeEnum,
            endTimeMs: dateInMs
        },
        skip: hasSelectedVersions
    });
    const { data: versionDiffMetadata, error: versionDiffMetadataError } = (0, $diswb.useQuery)($9aed974a19335374$var$PageCatchupVersionDiffWrapperComponentPageCatchupVersionDiffMetadataForContentQuery, {
        variables: {
            contentId: contentId,
            contentType: contentTypeEnum,
            originalContentVersion: originalContentVersion,
            revisedContentVersion: revisedContentVersion
        },
        skip: !hasSelectedVersions
    });
    const metaDataError = defaultMetaDataError || versionDiffMetadataError;
    const isVersionDiffEmpty = versionDiffMetadata?.catchupVersionDiffMetadataForContent?.isDiffEmpty ?? false;
    const versionDiffUsers = versionDiffMetadata?.catchupVersionDiffMetadataForContent?.users ?? [];
    const versionDiffEditors = (0, $3nYmf.mapToEditors)(versionDiffUsers);
    const setIsStreamingDone = ()=>{
        isStreamingDone.current = true;
    };
    const setIsStreamInitializationDone = ()=>{
        isStreamInitializationDone.current = true;
    };
    const onShowMoreClick = (0, $gwFzn.useCallback)(()=>{
        trackAIResultAction('showMoreClicked');
    }, [
        trackAIResultAction
    ]);
    const [request, config] = (0, $gwFzn.useMemo)(()=>(0, $5cgqG.buildCatchupRequest)({
            contentAri: pageAri ?? '',
            locale: locale,
            updateType: 'BETWEEN_VERSIONS',
            endTimeMs: dateInMs,
            selectedVersions: selectedVersions
        }), [
        pageAri,
        locale,
        dateInMs,
        selectedVersions
    ]);
    const onStateChange = (0, $gwFzn.useCallback)((state)=>{
        switch(state.responseState){
            case (0, $kAaxz.ConvoAIResponseState).Initialization:
                if (state.content === null) {
                    experienceTracker.start({
                        name: (0, $irVI7.AI_CONTENT_CATCHUP_EXPERIENCE)
                    });
                    (0, $555yk.AI_CONTENT_CATCHUP_INTERACTION_METRIC).start();
                    trackAIInteractionInit();
                    timeToFirstAnswerPart.current = Date.now();
                }
                break;
            case (0, $kAaxz.ConvoAIResponseState).Error:
                const { status_code: status_code, message_template: message_template } = state.error.message;
                (0, $555yk.AI_CONTENT_CATCHUP_INTERACTION_METRIC).stop();
                trackAIResultError({
                    aiErrorCode: status_code,
                    aiErrorMessage: message_template
                });
                setIsStreamingDone();
                break;
            case (0, $kAaxz.ConvoAIResponseState).AnswerPart:
                if (!isStreamInitializationDone.current) {
                    setIsStreamInitializationDone();
                    createAnalyticsEvent({
                        type: 'sendTrackEvent',
                        data: {
                            action: 'streamReceived',
                            actionSubject: 'pageCatchup',
                            source: source ?? 'page',
                            actionSubjectId: 'pageCatchupDialog',
                            attributes: {
                                contentId: contentId,
                                timeToFirstAnswerPartInMs: Date.now() - timeToFirstAnswerPart.current
                            }
                        }
                    }).fire();
                }
                break;
            case (0, $kAaxz.ConvoAIResponseState).FinalResponse:
                (0, $555yk.AI_CONTENT_CATCHUP_INTERACTION_METRIC).stop();
                createAnalyticsEvent({
                    type: 'sendScreenEvent',
                    data: {
                        name: 'pageCatchupDialog',
                        attributes: {
                            contentId: contentId,
                            aiInteractionId: aiInteractionId,
                            hasQueryParamOpenSet: hasQueryParamOpenSet
                        }
                    }
                }).fire();
                trackAIResultView();
                setIsStreamingDone();
                break;
            default:
                break;
        }
    }, [
        trackAIResultError,
        createAnalyticsEvent,
        contentId,
        aiInteractionId,
        hasQueryParamOpenSet,
        trackAIResultView,
        experienceTracker,
        trackAIInteractionInit,
        source
    ]);
    const [{ content: content, responseState: responseState, error: streamSummaryError }] = (0, $d3UlG.useConvoAIStreaming)(request, config, onStateChange);
    (0, $gwFzn.useEffect)(()=>{
        return ()=>{
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'dwelled',
                    actionSubject: 'pageCatchup',
                    source: source ?? 'page',
                    actionSubjectId: 'pageCatchupDialog',
                    attributes: {
                        contentId: contentId,
                        dwellTime: getDwellTime(),
                        aiInteractionId: aiInteractionId,
                        hasQueryParamOpenSet: hasQueryParamOpenSet
                    }
                }
            }).fire();
            if (!isStreamInitializationDone.current) trackAIInteractionDismiss({
                attributes: {
                    dismissTiming: 'stream_initialization'
                }
            });
            else if (!isStreamingDone.current) trackAIInteractionDismiss({
                attributes: {
                    dismissTiming: 'answer_part_streaming'
                }
            });
        }; // we only want to run this effect on un-mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, $gwFzn.useEffect)(()=>{
        if (responseState === (0, $kAaxz.ConvoAIResponseState).FinalResponse) {
            if (hideMetadata) setHideMetadata(false);
        }
    }, [
        responseState,
        hideMetadata
    ]);
    const lastVisitedOnDate = (0, $2XwAb.mapToFormattedDate)(data?.catchupEditMetadataForContent?.lastVisitTimeISO, locale);
    const hasVersionChangedSinceLastVisit = data?.catchupEditMetadataForContent?.hasVersionChangedSinceLastVisit ?? false;
    const users = data?.catchupEditMetadataForContent?.users ?? [];
    const defaultEditors = (0, $3nYmf.mapToEditors)(users);
    const editors = source === 'pageHistory' ? versionDiffEditors : defaultEditors;
    const pageVersion = data?.content?.nodes?.[0]?.version?.number ?? -1;
    const { versionHistoryLink: versionHistoryLink } = (0, $5HlWa.useGetVersionHistoryLink)(contentId, spaceKey, pageVersion);
    const onVersionHistoryLinkClick = (0, $gwFzn.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'pageCatchup',
                action: 'clicked',
                actionSubject: 'link',
                actionSubjectId: 'pageCatchupVersionHistoryLink',
                attributes: {
                    contentId: contentId,
                    aiInteractionId: aiInteractionId,
                    hasQueryParamOpenSet: hasQueryParamOpenSet
                }
            }
        }).fire();
        trackAIResultAction('versionHistoryLinkClick');
    }, [
        contentId,
        createAnalyticsEvent,
        aiInteractionId,
        hasQueryParamOpenSet,
        trackAIResultAction
    ]);
    const pageCatchupComponentProps = {
        contentId: contentId,
        contentType: contentType,
        spaceKey: spaceKey,
        lastVisitedOnDate: lastVisitedOnDate,
        editors: editors,
        ref: catchUpContentRef,
        hideMetadata: hideMetadata,
        versionHistoryLink: versionHistoryLink,
        onVersionHistoryLinkClick: onVersionHistoryLinkClick,
        hasVersionChangedSinceLastVisit: hasVersionChangedSinceLastVisit,
        onShowMoreClick: onShowMoreClick,
        source: source,
        isVersionDiffEmpty: isVersionDiffEmpty,
        isInObjectSidebar: isInObjectSidebar
    };
    const renderPageCatchupComponent = (contentToRender)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $41usS.PageCatchupComponent), {
            ...pageCatchupComponentProps,
            content: contentToRender
        });
    const renderContent = ()=>{
        switch(responseState){
            case (0, $kAaxz.ConvoAIResponseState).Initialization:
                return isInObjectSidebar ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gdv5Z.default), {
                    paddingInline: "space.100"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $8LJEA.AISummaryLoading), null)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $au4KV.AIStreamLoading), null);
            case (0, $kAaxz.ConvoAIResponseState).Error:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ly2zj.SmartsSummaryErrorComponent), {
                    analyticsProperties: analyticsProperties,
                    errorFromApolloOrStream: streamSummaryError,
                    contentId: contentId,
                    experienceName: (0, $irVI7.AI_CONTENT_CATCHUP_EXPERIENCE)
                });
            case (0, $kAaxz.ConvoAIResponseState).AnswerPart:
            case (0, $kAaxz.ConvoAIResponseState).FinalResponse:
                return renderPageCatchupComponent(content);
            default:
                break;
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
        className: (0, $35pXk.default)([
            "_4t3i1osq _ggmhs13h"
        ])
    }, isInObjectSidebar ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, metaDataError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.ErrorDisplay), {
        error: metaDataError
    }), renderContent(), responseState === (0, $kAaxz.ConvoAIResponseState).FinalResponse && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1eaCJ.ExperienceSuccess), {
        name: (0, $irVI7.AI_CONTENT_CATCHUP_EXPERIENCE),
        attributes: {
            source: source
        }
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dOOm2.AIBorder), {
        loading: responseState === (0, $kAaxz.ConvoAIResponseState).Initialization
    }, metaDataError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.ErrorDisplay), {
        error: metaDataError
    }), renderContent(), responseState === (0, $kAaxz.ConvoAIResponseState).FinalResponse && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1eaCJ.ExperienceSuccess), {
        name: (0, $irVI7.AI_CONTENT_CATCHUP_EXPERIENCE),
        attributes: {
            source: source
        }
    })));
};

});
parcelRegister("5cgqG", function(module, exports) {

$parcel$export(module.exports, "buildCatchupRequest", () => $9ed1632df7d8fede$export$60847e9d6d4c2441);
const $9ed1632df7d8fede$export$60847e9d6d4c2441 = ({ contentAri: contentAri, locale: locale, updateType: updateType, endTimeMs: endTimeMs, selectedVersions: selectedVersions, enablePartialJson: enablePartialJson = false })=>{
    return [
        {
            ai_feature_input: {
                content_ari: contentAri,
                locale: locale,
                update_type: updateType,
                end_time_ms: endTimeMs,
                ...selectedVersions && {
                    original_content_version: Math.min(...Array.from(selectedVersions)),
                    revised_content_version: Math.max(...Array.from(selectedVersions))
                }
            }
        },
        {
            apiPath: 'v2/ai-feature/confluence-content-catchup',
            delayChunkUpdate: {
                gap: 10,
                time: 20
            },
            enablePartialJson: enablePartialJson,
            headers: {
                'x-experience-id': 'catchup-version-summary',
                'x-product': 'confluence'
            }
        }
    ];
};

});



parcelRegister("kBab3", function(module, exports) {

$parcel$export(module.exports, "usePageCatchupQueryParamOpen", () => $619d61f42437d205$export$a82675333a170ad7);

var $gwFzn = parcelRequire("gwFzn");

var $dPJCf = parcelRequire("dPJCf");
const $619d61f42437d205$var$useOpenPageCatchupParam = (0, $dPJCf.createSingleQueryParamHook)('openContentCatchup');
const $619d61f42437d205$export$a82675333a170ad7 = (isOpen, setIsOpen, selectedVersions)=>{
    const [hasSeen, setHasSeen] = (0, $gwFzn.useState)(false);
    const isOpenPageCatchupQueryParamValid = $619d61f42437d205$var$useOpenPageCatchupParam() === 'true';
    const hasSelectedVersions = selectedVersions && selectedVersions.size > 1;
    (0, $gwFzn.useEffect)(()=>{
        if (!isOpen && isOpenPageCatchupQueryParamValid && !hasSeen && hasSelectedVersions) {
            setIsOpen(true);
            setHasSeen(true);
        }
    }, [
        isOpen,
        setIsOpen,
        isOpenPageCatchupQueryParamValid,
        hasSeen,
        setHasSeen,
        hasSelectedVersions
    ]);
};

});


parcelRegister("86vQj", function(module, exports) {

$parcel$export(module.exports, "PageCatchupPopupForPageHistory", () => $331fad0aae4cd917$export$9321895a4e785c58);

var $gwFzn = parcelRequire("gwFzn");

var $bQm3c = parcelRequire("bQm3c");

var $9wGTI = parcelRequire("9wGTI");

var $gL2Cx = parcelRequire("gL2Cx");
const $331fad0aae4cd917$export$9321895a4e785c58 = ({ contentId: contentId, contentType: contentType, spaceKey: spaceKey, source: source, selectedVersions: selectedVersions })=>{
    const { isAdminHubAIEnabled: isAdminHubAIEnabled } = (0, $bQm3c.useSessionData)();
    const isDisabled = selectedVersions.size < 2;
    const shouldRenderPageCatchupPopup = isAdminHubAIEnabled && (0, $9wGTI.fg)('cc_ai_consumption_page_catchup_in_page_history');
    if (shouldRenderPageCatchupPopup) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gL2Cx.PageCatchupPopupComponent), {
        contentId: contentId,
        contentType: contentType,
        spaceKey: spaceKey ?? '',
        isDisabled: isDisabled,
        source: source,
        selectedVersions: selectedVersions
    });
    return null;
};

});



parcelRegister("3FvXy", function(module, exports) {

let $2abdfded192756ea$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $2abdfded192756ea$var$load("75RiE"),
    $2abdfded192756ea$var$load("3pwml")
]).then(()=>parcelRequire('jFrSc'));

});


parcelRegister("13dFh", function(module, exports) {

$parcel$export(module.exports, "useCreateObjectSidebarProp", () => $a072d3bccf713db6$export$361ea37af8e4cc24);

var $gwFzn = parcelRequire("gwFzn");

var $aWwYt = parcelRequire("aWwYt");
function $a072d3bccf713db6$export$361ea37af8e4cc24() {
    const isObjectSidebarShown = (0, $aWwYt.useIsObjectSidebarShown)();
    const panel = (0, $aWwYt.usePanel)();
    const { changeHeaderElements: changeHeaderElements, showObjectSidebar: showObjectSidebar, hideObjectSidebar: hideObjectSidebar, hideObjectSidebarByPanelId: hideObjectSidebarByPanelId } = (0, $aWwYt.useObjectSidebarActions)();
    /**
	 * DON'T REMOVE useMemo here, otherwise it will cause very very serious performance issue
	 */ return (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).useMemo(()=>{
        return {
            state: {
                isObjectSidebarShown: isObjectSidebarShown,
                panel: panel
            },
            actions: {
                changeHeaderElements: changeHeaderElements,
                showObjectSidebar: showObjectSidebar,
                hideObjectSidebar: hideObjectSidebar,
                hideObjectSidebarByPanelId: hideObjectSidebarByPanelId
            }
        };
    }, [
        isObjectSidebarShown,
        panel,
        changeHeaderElements,
        showObjectSidebar,
        hideObjectSidebar,
        hideObjectSidebarByPanelId
    ]);
}

});

parcelRegister("R0evY", function(module, exports) {

$parcel$export(module.exports, "AISmartButtonStateHandler", () => $906351cb5b9e9377$export$5a377ed2eaadeb9a);

var $gwFzn = parcelRequire("gwFzn");

var $8ETUZ = parcelRequire("8ETUZ");

var $3Am3T = parcelRequire("3Am3T");

var $1w7Oi = parcelRequire("1w7Oi");
function $906351cb5b9e9377$export$d534d7c2ee95a157(actions, context) {
    /**
	 * When there is selection in editor, need to show only editor actions.
	 * And if context with reference is there, that means there is selection in editor.
	 * So show only editor actions.
	 */ if (context?.reference) return actions.filter((action)=>action.sourceId === 'editor');
    return actions.sort((a, b)=>{
        // If source is same then maintain the order.
        if (a.sourceId === b.sourceId) return 0;
        return a.sourceId === 'editor' ? -1 : 1;
    });
}
function $906351cb5b9e9377$var$AISmartButtonStateHandlerInner({ contentId: contentId, contentType: contentType, spaceKey: spaceKey, lastModifiedDate: lastModifiedDate, contentTitle: contentTitle }) {
    const { setSelectors: setSelectors } = (0, $8ETUZ.useSurfaceAIActions)();
    (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).useEffect(()=>{
        setSelectors({
            actionsSelector: $906351cb5b9e9377$export$d534d7c2ee95a157
        });
    }, [
        setSelectors
    ]);
    (0, $1w7Oi.useAIConsumptionViewPage)({
        contentId: contentId,
        contentType: contentType ?? '',
        lastModifiedDate: lastModifiedDate,
        spaceKey: spaceKey ?? '',
        contentTitle: contentTitle
    });
    return null;
}
const $906351cb5b9e9377$export$5a377ed2eaadeb9a = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $3Am3T.CommentCountsProvider), {
        contentId: props.contentId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($906351cb5b9e9377$var$AISmartButtonStateHandlerInner, props));
};

});
parcelRegister("8ETUZ", function(module, exports) {

$parcel$export(module.exports, "useSurfaceAIActions", () => $5d7e3d9ca8f50cb2$export$75d7484b96e549ce);

var $gwFzn = parcelRequire("gwFzn");

var $4acD6 = parcelRequire("4acD6");
const $5d7e3d9ca8f50cb2$export$75d7484b96e549ce = ()=>{
    const { setSelectors: setSelectors, setSurfaceMetadata: setSurfaceMetadata } = (0, $4acD6.useAISmartButtonActions)();
    return (0, $gwFzn.useMemo)(()=>({
            setSelectors: /**
			 * Sets selectors for filtering actions, suggested actions, and nudges.
			 */ setSelectors,
            setSurfaceMetadata: /**
			 * Sets metadata about the surface where AI features are used.
			 */ setSurfaceMetadata
        }), [
        setSelectors,
        setSurfaceMetadata
    ]);
};

});

parcelRegister("1w7Oi", function(module, exports) {

$parcel$export(module.exports, "useAIConsumptionViewPage", () => $b7cda486489d46fc$export$50b9e9c7b93e05dc);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $cUQMr = parcelRequire("cUQMr");

var $kevJM = parcelRequire("kevJM");

var $1yB28 = parcelRequire("1yB28");

var $7ZcJJ = parcelRequire("7ZcJJ");

var $jXEWW = parcelRequire("jXEWW");

var $9j9JP = parcelRequire("9j9JP");

var $5aqrM = parcelRequire("5aqrM");

var $ly2zj = parcelRequire("ly2zj");

var $fQDx6 = parcelRequire("fQDx6");
parcelRequire("1nIU4");
var $9VC5k = parcelRequire("9VC5k");
var $1nIU4 = parcelRequire("1nIU4");

var $JQEJY = parcelRequire("JQEJY");

var $3Am3T = parcelRequire("3Am3T");

var $aWwYt = parcelRequire("aWwYt");

var $9wGTI = parcelRequire("9wGTI");

var $jln20 = parcelRequire("jln20");

var $1QMs7 = parcelRequire("1QMs7");

var $aUTn5 = parcelRequire("aUTn5");

var $kDPMK = parcelRequire("kDPMK");

var $i1vUz = parcelRequire("i1vUz");

var $13dFh = parcelRequire("13dFh");

var $aSsfA = parcelRequire("aSsfA");

var $cD1qu = parcelRequire("cD1qu");

var $iwjXf = parcelRequire("iwjXf");
const $b7cda486489d46fc$export$a7357cdd1f0b0168 = (0, $2nPZH.defineMessages)({
    inlineCommentsMenuItemLabel: {
        id: "ai-floating-context-menu.menu.item.label.inline-comments",
        defaultMessage: "Summarize comments"
    },
    pageCatchupMenuItemLabel: {
        id: "ai-floating-context-menu.menu.item.label.page-catchup",
        defaultMessage: "Summarize changes"
    },
    summarizeSectionLabel: {
        id: "ai-floating-context-menu.summarize.section.label",
        defaultMessage: "Summarize"
    },
    bulkIssueCreateMenuItemLabel: {
        id: "ai-floating-context-menu.menu.item.label.bulk-issue-create",
        defaultMessage: "Create Jira issues"
    },
    bulkWorkItemsCreateMenuItemLabel: {
        id: "ai-floating-context-menu.menu.item.label.bulk-work-items-create",
        defaultMessage: "Create Jira work items"
    }
});
const $b7cda486489d46fc$var$VIEW_PAGE_SOURCE_ID = 'view-page';
const $b7cda486489d46fc$export$50b9e9c7b93e05dc = ({ contentId: contentId, contentType: contentType, spaceKey: spaceKey, contentTitle: contentTitle, lastModifiedDate: lastModifiedDate })=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const { setActions: setActions, setNudges: setNudges, setAutomationsConfig: setAutomationsConfig } = (0, $5aqrM.useSourceAIActions)($b7cda486489d46fc$var$VIEW_PAGE_SOURCE_ID);
    const { unresolvedInlineCommentsCount: unresolvedInlineCommentsCount, footerCommentsCount: footerCommentsCount } = (0, $gwFzn.useContext)((0, $3Am3T.CommentCountsContext));
    const { showObjectSidebar: showObjectSidebar } = (0, $aWwYt.useObjectSidebarActions)();
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const { canManageAutomations: canManageAutomations } = (0, $jXEWW.useAutomationPermissionService)(spaceKey);
    const objectSidebar = (0, $13dFh.useCreateObjectSidebarProp)();
    const dynamicSurfacePanel = (0, $9j9JP.useDynamicSurfacePanel)(objectSidebar);
    const rightSidebarContext = (0, $jln20.useRightSidebarContext)();
    const setIsCreatedWithAi = (0, $1QMs7.useSetIsCreatedWithAi)();
    const setIsCreatedFromTable = (0, $1QMs7.useSetIsCreatedFromTable)();
    const setInsertStorageFragmentRequestPayload = (0, $1QMs7.useSetInsertStorageFragmentRequestPayload)();
    const { showWarningDialog: showWarningDialog } = (0, $1QMs7.useWarningDialogStateActions)();
    const contentLastModifiedTimestamp = (0, $1QMs7.useGetContentLastModifiedTimestamp)();
    const contentTypeEnum = contentType === 'page' ? (0, $kDPMK.CatchupContentType).PAGE : (0, $kDPMK.CatchupContentType).BLOGPOST;
    const { showCatchupAsDefault: showCatchupAsDefault } = (0, $i1vUz.useDynamicSplitButton)(contentId, contentTypeEnum);
    const isSidePanelOpen = rightSidebarContext.getCurrent()?.panelId === (0, $1QMs7.BULK_ISSUE_CREATE_SIDE_PANEL_ID);
    const content = (0, $gwFzn.useRef)(typeof document !== 'undefined' ? document.querySelector('div#content') : null);
    const handleBulkIssueCreate = (0, $iwjXf.useBulkIssueCreate)({
        contentId: contentId,
        content: content
    });
    const nudges = (0, $gwFzn.useMemo)(()=>[
            {
                id: 'summarize-changes-ai-action',
                title: formatMessage($b7cda486489d46fc$export$a7357cdd1f0b0168.pageCatchupMenuItemLabel),
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kevJM))), {
                    label: ""
                }),
                onClick: ()=>showObjectSidebar(dynamicSurfacePanel, 'push'),
                viewConfig: {
                    render: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $JQEJY.PageCatchupComponent), {
                            contentId: contentId,
                            contentType: contentType,
                            spaceKey: spaceKey,
                            isInObjectSidebar: true
                        })
                }
            }
        ], [
        formatMessage,
        contentId,
        contentType,
        spaceKey,
        dynamicSurfacePanel,
        showObjectSidebar
    ]);
    const onBulkIssueCreate = (0, $gwFzn.useCallback)(()=>{
        if (isSidePanelOpen) showWarningDialog((0, $1QMs7.WarningDialog).FLOATING);
        else if ((0, $9wGTI.fg)('jira-work-create-from-connie-without-edit-perms')) handleBulkIssueCreate();
        else {
            setIsCreatedWithAi(true);
            setIsCreatedFromTable(false);
            const range = (0, $1QMs7.getValidRange)((0, $1QMs7.getPageContentRange)());
            const payload = (0, $1QMs7.constructInsertStorageFragmentRequestPayload)(contentId, (0, $aUTn5.convertSelectionToLegacyFormat), range, content.current, contentLastModifiedTimestamp);
            setInsertStorageFragmentRequestPayload(payload);
            rightSidebarContext.open((0, $1QMs7.BULK_ISSUE_CREATE_SIDE_PANEL_ID), (0, $1QMs7.BULK_ISSUE_CREATE_SIDE_PANEL_WIDTH));
        }
    }, [
        contentId,
        contentLastModifiedTimestamp,
        isSidePanelOpen,
        rightSidebarContext,
        setInsertStorageFragmentRequestPayload,
        setIsCreatedFromTable,
        setIsCreatedWithAi,
        showWarningDialog,
        handleBulkIssueCreate
    ]);
    const actions = (0, $gwFzn.useMemo)(()=>{
        const baseActions = [
            {
                id: 'summarize-page-ai-action',
                title: formatMessage($b7cda486489d46fc$export$a7357cdd1f0b0168.summarizeSectionLabel),
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cUQMr))), {
                    label: ""
                }),
                viewConfig: {
                    render: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ly2zj.QuickSummaryStreamingComponent), {
                            contentId: contentId,
                            spaceKey: spaceKey,
                            contentType: contentType,
                            lastModifiedDate: lastModifiedDate ?? '',
                            source: "view-page",
                            setIsOpen: ()=>{},
                            contentPath: window.location.pathname,
                            isInObjectSidebar: true
                        })
                }
            },
            ...nudges
        ];
        if (unresolvedInlineCommentsCount > 0 || footerCommentsCount > 0) baseActions.push({
            id: 'summarize-comments-ai-action',
            title: formatMessage($b7cda486489d46fc$export$a7357cdd1f0b0168.inlineCommentsMenuItemLabel),
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1yB28))), {
                label: ""
            }),
            viewConfig: {
                render: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $3Am3T.CommentCountsProvider), {
                        contentId: contentId
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1nIU4.FooterCommentsSummaryCombined), {
                        contentId: contentId,
                        contentType: contentType,
                        source: (0, $9VC5k.CommentsSummarySource).Footer,
                        spaceKey: spaceKey,
                        isInObjectSidebar: true
                    }))
            }
        });
        if (pageMode === (0, $cD1qu.PageMode).VIEW && (0, $9wGTI.fg)('confluence_ai_bulk_issue_creation')) baseActions.push({
            id: 'bulk-issue-create-ai-action',
            title: formatMessage((0, $9wGTI.fg)('confluence-issue-terminology-refresh') ? $b7cda486489d46fc$export$a7357cdd1f0b0168.bulkWorkItemsCreateMenuItemLabel : $b7cda486489d46fc$export$a7357cdd1f0b0168.bulkIssueCreateMenuItemLabel),
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7ZcJJ))), {
                label: ""
            }),
            onClick: onBulkIssueCreate
        });
        return baseActions;
    }, [
        formatMessage,
        contentId,
        spaceKey,
        contentType,
        lastModifiedDate,
        unresolvedInlineCommentsCount,
        footerCommentsCount,
        nudges,
        onBulkIssueCreate,
        pageMode
    ]);
    (0, $gwFzn.useEffect)(()=>{
        setActions(actions);
        if (contentType === 'page' && (0, $9wGTI.fg)('confluence_ai_automations_in_rovo_button')) setAutomationsConfig({
            userAutomations: {
                render: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $fQDx6.PageAutomationRovoButton), {
                        spaceKey: spaceKey,
                        pageId: contentId,
                        contentTitle: contentTitle
                    })
            },
            ...canManageAutomations && {
                adminAutomations: {
                    onClick: ()=>window.open(`/wiki/spaces/${spaceKey}/settings/automation#rule/new`, '_blank')
                }
            }
        });
        if (showCatchupAsDefault) setNudges(nudges);
    }, [
        actions,
        nudges,
        setActions,
        setNudges,
        showCatchupAsDefault,
        setAutomationsConfig,
        contentType,
        spaceKey,
        contentId,
        contentTitle,
        canManageAutomations
    ]);
};

});
parcelRegister("9j9JP", function(module, exports) {

$parcel$export(module.exports, "i18n", () => $607aba175e755b54$export$a7357cdd1f0b0168);
$parcel$export(module.exports, "RovoLogo", () => $607aba175e755b54$export$a0f6cb8061290bbb);
$parcel$export(module.exports, "getDynamicSurfacePanelHeaderElements", () => $607aba175e755b54$export$250789dcea0cc08b);
$parcel$export(module.exports, "DYNAMIC_SURFACE_PANEL_ID", () => $607aba175e755b54$export$60427ff514432b28);
$parcel$export(module.exports, "useUpdateDynamicSurfacePanelHeaderComponents", () => $607aba175e755b54$export$a8d40a5b5c640f08);
$parcel$export(module.exports, "useDynamicSurfacePanel", () => $607aba175e755b54$export$2f42f9349929df0);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $1qfLF = parcelRequire("1qfLF");

var $bPdpL = parcelRequire("bPdpL");

var $lAFHW = parcelRequire("lAFHW");

var $u9agA = parcelRequire("u9agA");
var $iXCQx = parcelRequire("iXCQx");

var $4acD6 = parcelRequire("4acD6");
var $9QtOT = parcelRequire("9QtOT");

var $q7r2L = parcelRequire("q7r2L");

var $e35ac = parcelRequire("e35ac");
const $607aba175e755b54$export$a7357cdd1f0b0168 = (0, $2nPZH.defineMessages)({
    rovoPanelTitle: {
        id: "ai-floating-context-menu.ai-dynamic-surface.rovo-panel-title",
        defaultMessage: "Rovo"
    },
    referencingPanelTitle: {
        id: "ai-floating-context-menu.ai-dynamic-surface.referencing-panel-title",
        defaultMessage: "Referencing"
    },
    backButton: {
        id: "ai-floating-context-menu.ai-dynamic-surface.back",
        defaultMessage: "back"
    }
});
const $607aba175e755b54$export$a0f6cb8061290bbb = ()=>{
    const intl = (0, $dBxQj.default)();
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $u9agA.default), {
        alignBlock: "center",
        space: "space.050",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $lAFHW.RovoIcon), {
                size: "small",
                testId: "dy-rovo-icon"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $iXCQx.default), {
                size: "medium",
                weight: "bold",
                color: "color.text.subtle",
                children: intl.formatMessage($607aba175e755b54$export$a7357cdd1f0b0168.rovoPanelTitle)
            })
        ]
    });
};
const $607aba175e755b54$export$250789dcea0cc08b = ({ BackButton: BackButton, panelTitle: panelTitle })=>{
    const HeaderIcon = ()=>{
        if (BackButton) return /*#__PURE__*/ (0, $7UHDa.jsx)(BackButton, {});
        if (!panelTitle) return /*#__PURE__*/ (0, $7UHDa.jsx)($607aba175e755b54$export$a0f6cb8061290bbb, {});
    };
    return {
        ...(BackButton || !panelTitle) && {
            HeaderIcon: HeaderIcon
        },
        headerLabel: panelTitle,
        headerStyles: {
            setGrayBackground: !!panelTitle
        }
    };
};
const $607aba175e755b54$export$60427ff514432b28 = 'ai-dynamic-surface';
function $607aba175e755b54$export$a8d40a5b5c640f08(objectSidebar) {
    const intl = (0, $dBxQj.default)();
    const { activeAction: activeAction, setActiveAction: setActiveAction } = (0, $gwFzn.useContext)((0, $e35ac.AIDynamicSurfaceContext));
    const currentView = (0, $9QtOT.useAICurrentView)();
    const context = (0, $9QtOT.useAIContext)();
    const panelTitle = context?.reference ? $607aba175e755b54$export$a7357cdd1f0b0168.referencingPanelTitle : undefined;
    const { changeHeaderElements: changeHeaderElements } = objectSidebar.actions;
    /**
   * Don't move creating BackButton outside this hook.
   * Because it needs to use setActiveAction and can't use AIDynamicSurfaceContext there,
   * 	it will rendered outside of AIDynamicSurface render tree.
   */ const onBackButtonClick = (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).useCallback(()=>{
        setActiveAction(undefined);
    }, [
        setActiveAction
    ]);
    const BackButton = (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).useCallback(()=>{
        return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $1qfLF.default), {
            appearance: "subtle",
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($bPdpL))),
            label: intl.formatMessage($607aba175e755b54$export$a7357cdd1f0b0168.backButton),
            onClick: onBackButtonClick,
            testId: "dy-back-button"
        });
    }, [
        intl,
        onBackButtonClick
    ]);
    /**
   * Here it is assumed dynamic surface panel is already open.
   */ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).useEffect(()=>{
        if (currentView === (0, $4acD6.DynamicSurfaceView).Default) changeHeaderElements($607aba175e755b54$export$60427ff514432b28, $607aba175e755b54$export$250789dcea0cc08b({
            panelTitle: panelTitle,
            /**
         * Show back button when activeAction has children.
         * AIActions component shows children actions only.
         */ BackButton: activeAction && activeAction.children ? BackButton : undefined
        }));
    }, [
        activeAction,
        BackButton,
        panelTitle,
        currentView,
        changeHeaderElements
    ]);
}
function $607aba175e755b54$export$2f42f9349929df0(objectSidebar) {
    const dynamicSurfacePanel = (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).useMemo(()=>({
            id: $607aba175e755b54$export$60427ff514432b28,
            headerComponentElements: $607aba175e755b54$export$250789dcea0cc08b({}),
            BodyComponent: ()=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $q7r2L.AIDynamicSurface), {
                    objectSidebar: objectSidebar
                })
        }), [
        objectSidebar
    ]);
    return dynamicSurfacePanel;
}

});
parcelRegister("9QtOT", function(module, exports) {

$parcel$export(module.exports, "useAIContext", () => $9fe72367d410ea7b$export$69b8f052247c1626);
$parcel$export(module.exports, "useAINudges", () => $9fe72367d410ea7b$export$b854997b7299d67f);
$parcel$export(module.exports, "useAIActions", () => $9fe72367d410ea7b$export$a916dc6bee947aa3);
$parcel$export(module.exports, "useAISurfaceMetadata", () => $9fe72367d410ea7b$export$e4b00dbb0b70f9c2);
$parcel$export(module.exports, "useAICurrentView", () => $9fe72367d410ea7b$export$b068b01d46d2f61d);
$parcel$export(module.exports, "useAIProfileData", () => $9fe72367d410ea7b$export$22514df787c8eb15);
$parcel$export(module.exports, "useAIAutomationsConfig", () => $9fe72367d410ea7b$export$f23908d838fcc66a);

var $iFWZA = parcelRequire("iFWZA");

var $4acD6 = parcelRequire("4acD6");
const $9fe72367d410ea7b$export$69b8f052247c1626 = (0, $iFWZA.createStateHook)((0, $4acD6.AISmartButtonStore), {
    selector: (state)=>state.context
});
const $9fe72367d410ea7b$export$b854997b7299d67f = (0, $iFWZA.createStateHook)((0, $4acD6.AISmartButtonStore), {
    selector: (state)=>{
        const { nudges: nudges, selectors: selectors, context: context } = state;
        if (selectors?.nudgesSelector) return selectors.nudgesSelector(nudges, context);
        return nudges;
    }
});
const $9fe72367d410ea7b$export$a916dc6bee947aa3 = (0, $iFWZA.createStateHook)((0, $4acD6.AISmartButtonStore), {
    selector: (state)=>{
        const { actions: actions, selectors: selectors, context: context } = state;
        if (selectors?.actionsSelector) return selectors.actionsSelector(actions, context);
        return actions;
    }
});
const $9fe72367d410ea7b$export$e4b00dbb0b70f9c2 = (0, $iFWZA.createStateHook)((0, $4acD6.AISmartButtonStore), {
    selector: (state)=>state.surfaceMetadata
});
const $9fe72367d410ea7b$export$b068b01d46d2f61d = (0, $iFWZA.createStateHook)((0, $4acD6.AISmartButtonStore), {
    selector: (state)=>state.currentView
});
const $9fe72367d410ea7b$export$22514df787c8eb15 = (0, $iFWZA.createStateHook)((0, $4acD6.AISmartButtonStore), {
    selector: (state)=>state.profileData
});
const $9fe72367d410ea7b$export$f23908d838fcc66a = (0, $iFWZA.createStateHook)((0, $4acD6.AISmartButtonStore), {
    selector: (state)=>state.automationsConfig
});

});

parcelRegister("q7r2L", function(module, exports) {

$parcel$export(module.exports, "AIDynamicSurface", () => $6bef8512466ddf54$export$c8271ec4bd8d9300);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $eyWa4 = parcelRequire("eyWa4");

var $4acD6 = parcelRequire("4acD6");
var $9QtOT = parcelRequire("9QtOT");
var $glqpS = parcelRequire("glqpS");

var $1uunn = parcelRequire("1uunn");

var $l3Eda = parcelRequire("l3Eda");

var $8cOg1 = parcelRequire("8cOg1");

var $e35ac = parcelRequire("e35ac");

var $9j9JP = parcelRequire("9j9JP");
const $6bef8512466ddf54$var$styles = {
    container: "_4t3i1osq"
};
const $6bef8512466ddf54$export$de12f9c588afb7 = ({ objectSidebar: objectSidebar })=>{
    const { changeView: changeView } = (0, $glqpS.useViewAIActions)();
    const currentView = (0, $9QtOT.useAICurrentView)();
    (0, $9j9JP.useUpdateDynamicSurfacePanelHeaderComponents)(objectSidebar);
    (0, $gwFzn.useEffect)(()=>{
        return ()=>{
            changeView((0, $4acD6.DynamicSurfaceView).Default);
        };
    }, [
        changeView
    ]);
    const profileData = (0, $1uunn.useProfileController)();
    const name = profileData.name.split(' ')[0];
    if (currentView === (0, $4acD6.DynamicSurfaceView).Default) return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $eyWa4.default), {
        grow: "fill",
        testId: "ai-dynamic-surface",
        xcss: $6bef8512466ddf54$var$styles.container,
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $l3Eda.AIActions), {
            name: name,
            objectSidebar: objectSidebar
        })
    });
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $8cOg1.AIFeatureView), {
        objectSidebar: objectSidebar,
        view: currentView?.viewConfig
    });
};
const $6bef8512466ddf54$export$c8271ec4bd8d9300 = ({ objectSidebar: objectSidebar })=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $e35ac.AIDynamicSurfaceContextProvider), {
        children: /*#__PURE__*/ (0, $7UHDa.jsx)($6bef8512466ddf54$export$de12f9c588afb7, {
            objectSidebar: objectSidebar
        })
    });
};

});
parcelRegister("glqpS", function(module, exports) {

$parcel$export(module.exports, "useViewAIActions", () => $7ea9bbf63a271292$export$7c7acaa418085cd7);

var $gwFzn = parcelRequire("gwFzn");

var $4acD6 = parcelRequire("4acD6");
const $7ea9bbf63a271292$export$7c7acaa418085cd7 = ()=>{
    const { changeView: changeView, setProfileData: setProfileData } = (0, $4acD6.useAISmartButtonActions)();
    return (0, $gwFzn.useMemo)(()=>({
            changeView: /**
			 * Change the view of the ai actions.
			 */ changeView,
            setProfileData: /**
			 * Set the prefetched name for the ai actions.
			 */ setProfileData
        }), [
        changeView,
        setProfileData
    ]);
};

});

parcelRegister("1uunn", function(module, exports) {

$parcel$export(module.exports, "useProfileController", () => $90ef72367fab294b$export$68afc71177137005);

var $gwFzn = parcelRequire("gwFzn");

var $csnse = parcelRequire("csnse");

var $8gGM0 = parcelRequire("8gGM0");
const $90ef72367fab294b$var$fetchProfileData = (0, $csnse.default)(async ()=>{
    const data = await (0, $8gGM0.me)();
    return {
        aaid: data.account_id,
        name: data.name || '',
        displayName: data.nickname,
        avatarUrl: data.picture,
        email: data.email
    };
});
const $90ef72367fab294b$export$3c814b55c7cbb1fb = (0, $gwFzn.createContext)(null);
const $90ef72367fab294b$var$emptyProfileData = {
    name: '',
    displayName: '',
    avatarUrl: ''
};
const $90ef72367fab294b$export$68afc71177137005 = ()=>{
    const [profileData, setProfileData] = (0, $gwFzn.useState)($90ef72367fab294b$var$emptyProfileData);
    const profileContextData = (0, $gwFzn.useContext)($90ef72367fab294b$export$3c814b55c7cbb1fb);
    (0, $gwFzn.useEffect)(()=>{
        if (profileContextData) setProfileData(profileContextData);
        else $90ef72367fab294b$var$fetchProfileData().then((data)=>setProfileData(data)).catch(()=>setProfileData($90ef72367fab294b$var$emptyProfileData));
    }, [
        setProfileData,
        profileContextData
    ]);
    return profileData;
};

});
parcelRegister("8gGM0", function(module, exports) {

$parcel$export(module.exports, "me", () => $2f3ab166c93f3263$export$3e32638432616b6);

var $aYN6Z = parcelRequire("aYN6Z");
const $2f3ab166c93f3263$export$3e32638432616b6 = async ()=>{
    const response = await (0, $aYN6Z.performHttpFetch)({
        path: '/gateway/api/me',
        options: {
            method: 'GET'
        }
    });
    return response;
};

});
parcelRegister("aYN6Z", function(module, exports) {

$parcel$export(module.exports, "performHttpFetch", () => $17e0e2057f17f262$export$a38d93aa782475f6);
//Shared code with conversation-assistant-instrumentation/src/common/utils/fetch.ts

var $i8byp = parcelRequire("i8byp");
//TODO have this extend RovoInstrumentedError once that PR is merged
class $17e0e2057f17f262$var$HttpApiError extends Error {
    constructor(message, errorAttributes){
        super(message), this.message = message, this.errorAttributes = errorAttributes;
    }
}
const $17e0e2057f17f262$export$a38d93aa782475f6 = async ({ path: path, options: options })=>{
    try {
        const response = await fetch(path, options);
        if (!response.ok || response.status >= 400) await $17e0e2057f17f262$var$processHttpErrorResponse({
            response: response
        });
        return await response.json();
    } catch (err) {
        throw new (0, $i8byp.FetchError)(`performHttpFetch error whle fetching ${path}`, {
            cause: err
        });
    }
};
const $17e0e2057f17f262$var$processHttpErrorResponse = async ({ response: response })=>{
    throw new $17e0e2057f17f262$var$HttpApiError(`[Code ${response.status}] ${await response.text()}`, {
        statusCode: response.status
    });
};

});
parcelRegister("i8byp", function(module, exports) {

$parcel$export(module.exports, "FetchError", () => $d3034141a03c41f7$export$26e841bcf1aeb894);
class $d3034141a03c41f7$export$26e841bcf1aeb894 extends Error {
    constructor(message, cause){
        super(message), this.cause = cause;
        this.name = 'FetchError';
        if (cause) this.cause = cause;
    }
}

});




parcelRegister("l3Eda", function(module, exports) {

$parcel$export(module.exports, "AIActions", () => $34dac63186fafd3e$export$6b8dbfcf8cdc5119);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /**
 * @jsxFrag
 */ 
var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $inPa6 = parcelRequire("inPa6");

var $2SlZp = parcelRequire("2SlZp");
var $7rvPL = parcelRequire("7rvPL");

var $dh538 = parcelRequire("dh538");

var $gdv5Z = parcelRequire("gdv5Z");
var $eyWa4 = parcelRequire("eyWa4");

var $i25hX = parcelRequire("i25hX");

var $9QtOT = parcelRequire("9QtOT");
var $glqpS = parcelRequire("glqpS");

var $fQF1W = parcelRequire("fQF1W");

var $e35ac = parcelRequire("e35ac");

var $9j9JP = parcelRequire("9j9JP");

var $7TMNL = parcelRequire("7TMNL");

var $fAhtO = parcelRequire("fAhtO");

var $hjyG8 = parcelRequire("hjyG8");

var $b5Yo2 = parcelRequire("b5Yo2");

var $izicj = parcelRequire("izicj");

var $6X9ch = parcelRequire("6X9ch");

var $6yGtw = parcelRequire("6yGtw");
const $34dac63186fafd3e$export$a7357cdd1f0b0168 = (0, $2nPZH.defineMessages)({
    aiActionsSectionText: {
        id: "ai-smart-button.ai-actions.actions.section.text",
        defaultMessage: "Actions"
    },
    aiStudioSectionText: {
        id: "ai-smart-button.ai-actions.rovo-agents.section.text",
        defaultMessage: "Studio"
    },
    aiHelpSectionText: {
        id: "ai-smart-button.ai-actions.help.section.text",
        defaultMessage: "Help"
    },
    giveFeedbackActionTitle: {
        id: "ai-smart-button.ai-actions.give-feedback-action.title",
        defaultMessage: "Give feedback"
    }
});
const $34dac63186fafd3e$var$styles = {
    container: "_4t3i1osq",
    sectionHeader: "_18zr1ejb _syaz131l _k48p1wq8 _ca0qutpp _n3td1b66",
    scrollContainer: "_1reo1wug _18m91wug"
};
const $34dac63186fafd3e$var$SectionHeader = ({ title: title })=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gdv5Z.default), {
        xcss: $34dac63186fafd3e$var$styles.sectionHeader,
        children: title
    });
};
const $34dac63186fafd3e$export$6b8dbfcf8cdc5119 = ({ name: name, objectSidebar: objectSidebar })=>{
    const intl = (0, $dBxQj.default)();
    const { changeView: changeView } = (0, $glqpS.useViewAIActions)();
    const surfaceMetadata = (0, $9QtOT.useAISurfaceMetadata)();
    const profileData = (0, $9QtOT.useAIProfileData)();
    const automationsConfig = (0, $9QtOT.useAIAutomationsConfig)();
    const actions = (0, $9QtOT.useAIActions)();
    const context = (0, $9QtOT.useAIContext)();
    const { activeAction: activeAction, setActiveAction: setActiveAction } = (0, $gwFzn.useContext)((0, $e35ac.AIDynamicSurfaceContext));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const showFeedbackAction = (0, $dh538.fg)('smart_ai_button_feedback_action'); /**
                                                                     * If active action has children that render all children actions.
                                                                     * AIDynamicSurface component will take care of showing back button in panel header.
                                                                     */ 
    const isActionWithChildren = !!activeAction?.children;
    const selectedActions = !!activeAction?.children ? activeAction.children : actions; /**
                                                                                       * We want to hide the main AI actions for databases since they currently do not support AI features yet
                                                                                       */ 
    const isMainAiActionsShown = surfaceMetadata.contentType !== 'database';
    const helpActions = (0, $gwFzn.useMemo)(()=>showFeedbackAction ? [
            {
                component: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $hjyG8.FeedbackActionItem), {
                    surfaceMetadata: surfaceMetadata,
                    profileData: profileData
                }),
                title: intl.formatMessage($34dac63186fafd3e$export$a7357cdd1f0b0168.giveFeedbackActionTitle)
            }
        ] : [], [
        surfaceMetadata,
        showFeedbackAction,
        profileData,
        intl
    ]);
    const [input, setInput] = (0, $gwFzn.useState)('');
    const handleAction = (0, $gwFzn.useCallback)((action)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: surfaceMetadata.contentType,
                action: 'clicked',
                actionSubject: 'rovoButton',
                actionSubjectId: 'aiRovoDynamicSurfaceMenuItem',
                attributes: {
                    pageMode: surfaceMetadata.pageMode,
                    id: action.id,
                    itemType: 'action'
                }
            }
        }).fire(); //if the user has typed something in the input field to filter menu actions, we want to fire an additional analytics event
        if (input.length) createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: surfaceMetadata.contentType,
                action: 'clicked',
                actionSubject: 'rovoButton',
                actionSubjectId: 'aiRovoDynamicSurfaceChatFilteredMenuItem',
                attributes: {
                    product: surfaceMetadata.product,
                    productPage: surfaceMetadata.contentType,
                    pageMode: surfaceMetadata.pageMode,
                    id: action.id,
                    itemType: 'action'
                }
            }
        }).fire();
         /**
       * If the action has children, set the active action so that
       * we can display the children action
       */ 
        if ('children' in action) setActiveAction(action);
        if ('viewConfig' in action) {
            changeView(action);
            return;
        }
        if (action.onClick) action.onClick();
        if ('closePanelOnSelection' in action) objectSidebar.actions.hideObjectSidebarByPanelId((0, $9j9JP.DYNAMIC_SURFACE_PANEL_ID));
    }, [
        changeView,
        objectSidebar.actions,
        setActiveAction,
        createAnalyticsEvent,
        surfaceMetadata,
        input
    ]);
    const handleInput = (0, $gwFzn.useCallback)((text)=>{
        setInput(text);
    }, []);
    const filteredAIActions = (0, $gwFzn.useMemo)(()=>selectedActions.filter(({ title: title })=>{
            return title.toLowerCase().includes(input.toLowerCase());
        }), [
        selectedActions,
        input
    ]);
    const publish = (0, $i25hX.usePublish)('ai-mate');
    const createAgentUrl = (0, $fQF1W.useCreateAgentAtlasURL)(surfaceMetadata?.siteId || '');
    const handleBrowseAgent = (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).useCallback(()=>{
        if (!surfaceMetadata) return;
        publish({
            type: 'open-browse-agent-sidebar',
            product: surfaceMetadata.product,
            source: 'ai-smart-button-dynamic-surface'
        });
    }, [
        publish,
        surfaceMetadata
    ]);
    const studioActions = (0, $gwFzn.useMemo)(()=>{
        /**
     * Don't show studio section when;
     * - children action of active actions is shown.
     * - when there is editor selection.
     * Need to create separate studio actions and pass them along with
     * 	consumption and editing actions.
     * So that don't need to handle separate logic for studio actions.
     */ if (context?.reference || isActionWithChildren || !surfaceMetadata) return [];
        return (0, $6yGtw.getStudioActions)({
            intl: intl,
            createAgentUrl: createAgentUrl,
            handleBrowseAgent: handleBrowseAgent,
            renderUserAutomations: automationsConfig?.userAutomations?.render,
            onCreateAutomation: automationsConfig?.adminAutomations?.onClick
        });
    }, [
        intl,
        createAgentUrl,
        handleBrowseAgent,
        context?.reference,
        isActionWithChildren,
        surfaceMetadata,
        automationsConfig?.userAutomations?.render,
        automationsConfig?.adminAutomations?.onClick
    ]);
    const filteredStudioActions = (0, $gwFzn.useMemo)(()=>studioActions.filter(({ title: title })=>{
            return title.toLowerCase().includes(input.toLowerCase());
        }), [
        input,
        studioActions
    ]);
    const filteredHelpActions = (0, $gwFzn.useMemo)(()=>helpActions.filter(({ title: title })=>{
            return title.toLowerCase().includes(input.toLowerCase());
        }), [
        input,
        helpActions
    ]);
    const filteredFullList = (0, $gwFzn.useMemo)(()=>[].concat(filteredAIActions, filteredStudioActions), [
        filteredAIActions,
        filteredStudioActions
    ]);
    const filteredFullListValues = (0, $gwFzn.useMemo)(()=>filteredFullList.map(({ id: id })=>id), [
        filteredFullList
    ]);
    const { handleArrowDown: handleArrowDown, handleArrowUp: handleArrowUp, selectedIndex: selectedIndex } = (0, $6X9ch.useNavigateActions)(filteredFullListValues.length);
    const handleSelect = (0, $gwFzn.useCallback)((adf)=>{
        if (filteredFullList.length && selectedIndex !== undefined) {
            const filteredAction = filteredFullList?.[selectedIndex];
            if (filteredAction) handleAction(filteredAction);
        } else if (input.length) {
            publish({
                type: 'chat-new',
                product: surfaceMetadata?.product,
                source: 'ai-smart-button-dynamic-surface',
                data: {
                    name: input,
                    dialogues: [],
                    prompt: adf
                }
            });
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    source: surfaceMetadata.contentType,
                    action: 'invoked',
                    actionSubject: 'rovoButton',
                    actionSubjectId: 'aiRovoDynamicSurfaceChatInput',
                    attributes: {
                        pageMode: surfaceMetadata.pageMode
                    }
                }
            }).fire();
        }
    }, [
        filteredFullList,
        selectedIndex,
        handleAction,
        input,
        publish,
        surfaceMetadata,
        createAnalyticsEvent
    ]);
    const handleBack = (0, $gwFzn.useCallback)(()=>{
        if (!activeAction) return;
        setActiveAction(undefined);
    }, [
        setActiveAction,
        activeAction
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $eyWa4.default), {
        grow: "fill",
        xcss: $34dac63186fafd3e$var$styles.container,
        children: [
            filteredFullList.length || filteredHelpActions.length ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7UHDa.Fragment), {
                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $eyWa4.default), {
                    grow: "fill",
                    xcss: $34dac63186fafd3e$var$styles.scrollContainer,
                    children: /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $2SlZp.default), {
                        children: [
                            !isActionWithChildren && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $b5Yo2.HeadingSection), {
                                name: name
                            }),
                            filteredAIActions.length && isMainAiActionsShown ? /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $7rvPL.default), {
                                children: [
                                    /*#__PURE__*/ (0, $7UHDa.jsx)($34dac63186fafd3e$var$SectionHeader, {
                                        title: isActionWithChildren ? activeAction.title : intl.formatMessage($34dac63186fafd3e$export$a7357cdd1f0b0168.aiActionsSectionText)
                                    }),
                                    filteredAIActions.map((action, index)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $7TMNL.DynamicSurfaceActionItem), {
                                            onClick: ()=>handleAction(action),
                                            title: action.title,
                                            icon: action.icon,
                                            isSelected: selectedIndex === index,
                                            status: action.status
                                        }, action.id))
                                ]
                            }) : null,
                            filteredStudioActions.length ? /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $7rvPL.default), {
                                children: [
                                    /*#__PURE__*/ (0, $7UHDa.jsx)($34dac63186fafd3e$var$SectionHeader, {
                                        title: intl.formatMessage($34dac63186fafd3e$export$a7357cdd1f0b0168.aiStudioSectionText)
                                    }),
                                    filteredStudioActions.map((action, index)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $7TMNL.DynamicSurfaceActionItem), {
                                            title: action.title,
                                            icon: action.icon,
                                            isSelected: selectedIndex === filteredAIActions.length + index,
                                            ...'href' in action && action?.href ? {
                                                href: action.href,
                                                onClick: ()=>handleAction(action)
                                            } : {
                                                onClick: ()=>handleAction(action)
                                            }
                                        }, action.id))
                                ]
                            }) : null,
                            filteredHelpActions.length ? /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $7rvPL.default), {
                                children: [
                                    /*#__PURE__*/ (0, $7UHDa.jsx)($34dac63186fafd3e$var$SectionHeader, {
                                        title: intl.formatMessage($34dac63186fafd3e$export$a7357cdd1f0b0168.aiHelpSectionText)
                                    }),
                                    filteredHelpActions.map(({ component: component }, index)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, {
                                            children: component
                                        }, index))
                                ]
                            }) : null
                        ]
                    })
                })
            }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $eyWa4.default), {
                alignInline: "center",
                grow: "fill",
                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $izicj.NoResults), {})
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $fAhtO.AIInput), {
                surfaceMetadata: surfaceMetadata,
                onSelect: handleSelect,
                onInputChange: handleInput,
                handleArrowDown: handleArrowDown,
                handleArrowUp: handleArrowUp,
                handleBack: handleBack
            })
        ]
    });
};

});
parcelRegister("fQF1W", function(module, exports) {

$parcel$export(module.exports, "useAtlasURL", () => $2a6bb271c0fd2ecb$export$8a1abb7c176bd202);
$parcel$export(module.exports, "useCreateAgentAtlasURL", () => $2a6bb271c0fd2ecb$export$b61b99f9ac0264be);

var $gwFzn = parcelRequire("gwFzn");

var $827Ne = parcelRequire("827Ne");

var $dYtRL = parcelRequire("dYtRL");
const $2a6bb271c0fd2ecb$export$8a1abb7c176bd202 = (siteId)=>{
    const { data: tenantData } = (0, $dYtRL.useTenantDataController)(siteId);
    const atlasURL = (0, $gwFzn.useCallback)((path)=>(0, $827Ne.getAtlasURL)(siteId, path, tenantData?.orgId), [
        siteId,
        tenantData?.orgId
    ]);
    return {
        atlasURL: atlasURL
    };
};
const $2a6bb271c0fd2ecb$export$b61b99f9ac0264be = (siteId)=>{
    const { atlasURL: atlasURL } = $2a6bb271c0fd2ecb$export$8a1abb7c176bd202(siteId);
    return atlasURL('/chat/agents/new');
};

});
parcelRegister("827Ne", function(module, exports) {

$parcel$export(module.exports, "getAtlasHost", () => $5ae4133df3384b49$export$5105758c0e772381);
$parcel$export(module.exports, "getAtlasURL", () => $5ae4133df3384b49$export$bfee0f88bf621ad3);

var $6FQwA = parcelRequire("6FQwA");
const $5ae4133df3384b49$var$ATLAS_PROD_URL = 'https://home.atlassian.com';
const $5ae4133df3384b49$var$ATLAS_STAGING_URL = 'https://home.stg.atlassian.com';
const $5ae4133df3384b49$export$5105758c0e772381 = ()=>{
    const host = window.location.host;
    const isStaging = host.includes('localhost') || host.includes('.stg.atlassian') || host.includes('.stg-east.frontend.public.atl-paas.net') || host.includes('jira-dev.com');
    return isStaging ? $5ae4133df3384b49$var$ATLAS_STAGING_URL : $5ae4133df3384b49$var$ATLAS_PROD_URL;
};
const $5ae4133df3384b49$export$bfee0f88bf621ad3 = (siteId, path, orgId)=>{
    let argConcat = '?';
    let processedPath = path.startsWith('/') ? path : `/${path}`;
    if (processedPath.includes('?')) argConcat = '&';
    const basePath = orgId ? `${$5ae4133df3384b49$export$5105758c0e772381()}/o/${orgId}` : $5ae4133df3384b49$export$5105758c0e772381();
    return (0, $6FQwA.addRovoParamsToUrl)(`${basePath}${processedPath}${argConcat}cloudId=${siteId}`, {
        cloudId: siteId
    });
};

});
parcelRegister("6FQwA", function(module, exports) {

$parcel$export(module.exports, "getRovoParams", () => $fba4647064c9da0b$export$6405071f390601f7);
$parcel$export(module.exports, "addRovoParamsToUrl", () => $fba4647064c9da0b$export$ef04687636c850fe);
$parcel$export(module.exports, "encodeRovoParams", () => $fba4647064c9da0b$export$eddc20a009406015);

var $kGZ7I = parcelRequire("kGZ7I");
const $fba4647064c9da0b$export$fda91e425d265029 = (str)=>str.charAt(0).toUpperCase() + str.slice(1);
const $fba4647064c9da0b$export$858653b7ee3cbb17 = (str)=>str.charAt(0).toLowerCase() + str.slice(1);
const $fba4647064c9da0b$var$isValidURL = (url)=>{
    try {
        new URL(url);
        return true;
    } catch (error) {
        return false;
    }
};
const $fba4647064c9da0b$export$9748efee331ec573 = (param)=>`${0, $kGZ7I.ROVO_PARAM_PREFIX}${$fba4647064c9da0b$export$fda91e425d265029(param)}`;
const $fba4647064c9da0b$export$f2888183a34644d4 = (param)=>{
    return $fba4647064c9da0b$export$858653b7ee3cbb17(param.replace((0, $kGZ7I.ROVO_PARAM_PREFIX), ''));
};
// Creates RovoChatParams from URLSearchParams
// Optionally filter to specific params
const $fba4647064c9da0b$var$processParams = (input, options = {
    filter: []
})=>{
    const output = {};
    const safeSearchParamsInput = typeof input === 'string' ? $fba4647064c9da0b$var$isValidURL(input) ? new URLSearchParams(new URL(input).search) : new URLSearchParams(input) : input;
    const processedInput = new URLSearchParams(safeSearchParamsInput);
    const extracted = new URLSearchParams();
    safeSearchParamsInput.forEach((value, key)=>{
        // Only look at rovoChat params
        if (!key.startsWith((0, $kGZ7I.ROVO_PARAM_PREFIX))) return;
        const paramKey = $fba4647064c9da0b$export$f2888183a34644d4(key);
        if (options?.filter?.length) {
            if (options.filter.includes(paramKey)) {
                output[paramKey] = decodeURIComponent(value);
                extracted.append(key, value);
            }
        } else output[paramKey] = decodeURIComponent(value);
        // Remove rovoParam from processed input
        processedInput.delete(key);
    });
    const combinedQueryString = [
        processedInput,
        extracted
    ].map((params)=>params.toString()).filter((part)=>part.length > 0).join('&');
    return {
        processed: processedInput,
        rovoParams: output,
        combinedQueryString: combinedQueryString
    };
};
const $fba4647064c9da0b$export$6405071f390601f7 = (url)=>{
    try {
        const search = url ? new URL(url).search : window.location.search;
        const q = new URLSearchParams(search);
        return $fba4647064c9da0b$var$processParams(q).rovoParams;
    } catch (error) {
        return {};
    }
};
const $fba4647064c9da0b$export$4a302fc7d977f7b3 = (params)=>{
    window.history.pushState({}, '', $fba4647064c9da0b$export$ef04687636c850fe(window.location.pathname, params));
};
const $fba4647064c9da0b$export$ef04687636c850fe = (url, params)=>{
    const { processed: processed, rovoParams: rovoParams } = $fba4647064c9da0b$var$processParams(url);
    const rovoParamsWithExisting = {
        ...rovoParams,
        ...params
    };
    const baseUrl = url.includes('?') ? url.split('?')[0] : url;
    const baseQuery = Array.from(processed).length ? `?${processed.toString()}&` : '?';
    const updatedRovoParamsString = $fba4647064c9da0b$export$eddc20a009406015(rovoParamsWithExisting);
    return `${baseUrl}${baseQuery}${updatedRovoParamsString}`;
};
const $fba4647064c9da0b$export$eddc20a009406015 = (params, encodeAsObject)=>{
    if (encodeAsObject) return Object.entries(params).reduce((acc, [key, value])=>{
        acc[$fba4647064c9da0b$export$9748efee331ec573(key)] = encodeURIComponent(value);
        return acc;
    }, {});
    return Object.entries(params).map(([key, value])=>{
        return `${$fba4647064c9da0b$export$9748efee331ec573(key)}=${encodeURIComponent(value)}`;
    }).join('&');
};
const $fba4647064c9da0b$export$ad5179fba4239081 = (params, fields)=>{
    return Object.entries(params).every(([key, value])=>{
        const field = fields.find((field)=>field === key);
        if (field) return value !== undefined;
        else return value === undefined;
    });
};
const $fba4647064c9da0b$export$9c55b0deb4e0c7df = ({ resourceRouterQuery: resourceRouterQuery = false } = {})=>{
    /*
	For products using react-resource-router (e.g Atlas) to
	pass as the value of `query` on the route definition. It ensures that our parameters
	are not stripped from the URL when loading the page, or through redirect hops
	Any new parameters we want to maintain should be added here as well, which means
	only a version bump is needed in those products to support the latest param list
	The !=false simply means that the parameter is supported but is optional, and should
	not contain a value of 'false'
	*/ const suffix = resourceRouterQuery ? '!=false' : '';
    return (0, $kGZ7I.ROVO_VALID_PARAMS).map((param)=>`${$fba4647064c9da0b$export$9748efee331ec573(param)}${suffix}`);
};

});
parcelRegister("kGZ7I", function(module, exports) {

$parcel$export(module.exports, "ROVO_PARAM_PREFIX", () => $0075612de7c1f282$export$5a550907ffbc9119);
$parcel$export(module.exports, "ROVO_VALID_PARAMS", () => $0075612de7c1f282$export$3cd6b610e7ede579);
const $0075612de7c1f282$export$5a550907ffbc9119 = 'rovoChat';
const $0075612de7c1f282$export$3cd6b610e7ede579 = [
    'pathway',
    'agentId',
    'conversationId',
    'prompt',
    'cloudId',
    'triggerOpen'
];

});



parcelRegister("dYtRL", function(module, exports) {

$parcel$export(module.exports, "useTenantDataController", () => $63d59501eb65c4db$export$b863fec6791eae25);

var $16lEl = parcelRequire("16lEl");
var $7pmZw = parcelRequire("7pmZw");

var $9eLw5 = parcelRequire("9eLw5");

var $hGGLc = parcelRequire("hGGLc");
const $63d59501eb65c4db$export$b863fec6791eae25 = (siteId)=>{
    const experience = (0, $7pmZw.useAIMateExperienceTracker)();
    const { data: data, isFetching: isFetching, error: error } = (0, $9eLw5.useQuery)({
        queryKey: [
            'viewAgentTenantData',
            siteId
        ],
        queryFn: async ()=>{
            experience.start({
                id: (0, $16lEl.ExperienceName).FETCH_AGENT_TENANT_DATA,
                name: (0, $16lEl.ExperienceName).FETCH_AGENT_TENANT_DATA
            });
            const result = await (0, $hGGLc.getCloudUrlFromId)(siteId);
            return result;
        },
        onSuccess: ()=>{
            experience.succeed({
                name: (0, $16lEl.ExperienceName).FETCH_AGENT_TENANT_DATA
            });
        },
        onError: (error)=>{
            experience.fail({
                name: (0, $16lEl.ExperienceName).FETCH_AGENT_TENANT_DATA,
                error: error
            });
        }
    });
    return {
        data: data,
        isFetching: isFetching,
        error: error
    };
};

});
parcelRegister("hGGLc", function(module, exports) {

$parcel$export(module.exports, "getCloudUrlFromId", () => $0fc4c72c92b990ea$export$d4ace54df9bd6bb1);

var $b62XF = parcelRequire("b62XF");
const $0fc4c72c92b990ea$var$CloudIdLookupQuery = `
query tenantQuery($cloudIds: [ID!]) {
  tenantContexts(cloudIds: $cloudIds) {
    cloudUrl
	orgId
  }
}
`;
const $0fc4c72c92b990ea$export$d4ace54df9bd6bb1 = async (cloudId)=>{
    const response = await (0, $b62XF.performGqlFetch)({
        gqlQuery: $0fc4c72c92b990ea$var$CloudIdLookupQuery,
        variables: {
            cloudIds: [
                cloudId
            ]
        }
    });
    return response.data?.tenantContexts?.[0];
};

});
parcelRegister("b62XF", function(module, exports) {

$parcel$export(module.exports, "performGqlFetch", () => $37e96b9c44d16228$export$f602b5befecb0b84);

var $i8byp = parcelRequire("i8byp");
const $37e96b9c44d16228$var$extractQueryName = (gqlQuery)=>{
    const operationMatch = gqlQuery.match(/(?:query|mutation)\s+(\w+)/);
    return operationMatch ? operationMatch[1] : null;
};
const $37e96b9c44d16228$export$f602b5befecb0b84 = async ({ gqlQuery: gqlQuery, headerOptions: headerOptions, variables: variables })=>{
    try {
        const response = await fetch('/gateway/api/graphql', {
            headers: {
                'Content-Type': 'application/json',
                ...headerOptions
            },
            method: 'POST',
            body: JSON.stringify({
                query: gqlQuery,
                variables: variables
            })
        });
        const json = await response.json();
        if (json?.errors?.length) await $37e96b9c44d16228$var$processGqlErrorResponse({
            errors: json.errors,
            gqlQuery: gqlQuery
        });
        return json;
    } catch (err) {
        throw new (0, $i8byp.FetchError)('GraphQL query failed', {
            cause: err
        });
    }
};
class $37e96b9c44d16228$export$ba203f24e0131ba7 extends Error {
    constructor(message, { errors: errors, queryName: queryName }){
        super(message);
        this.errors = void 0;
        this.queryName = void 0;
        this.name = 'GraphQLError';
        this.errors = errors;
        this.queryName = queryName;
    }
}
const $37e96b9c44d16228$var$processGqlErrorResponse = async ({ errors: errors, gqlQuery: gqlQuery })=>{
    const errorsToThrow = [];
    errors.forEach((error)=>{
        errorsToThrow.push({
            message: error.message,
            status_code: error.extensions.statusCode,
            classification: error.extensions.classification
        });
    });
    throw new $37e96b9c44d16228$export$ba203f24e0131ba7('GraphQL API error', {
        errors: errorsToThrow,
        queryName: $37e96b9c44d16228$var$extractQueryName(gqlQuery)
    });
};

});




parcelRegister("e35ac", function(module, exports) {

$parcel$export(module.exports, "AIDynamicSurfaceContext", () => $5fffa5ff45c91b6b$export$d0b6fcb7b4503c7e);
$parcel$export(module.exports, "AIDynamicSurfaceContextProvider", () => $5fffa5ff45c91b6b$export$956fee2bbbf40232);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");
const $5fffa5ff45c91b6b$export$d0b6fcb7b4503c7e = /*#__PURE__*/ (0, $gwFzn.createContext)({
    setActiveAction: (action)=>{}
});
const $5fffa5ff45c91b6b$export$956fee2bbbf40232 = ({ children: children })=>{
    const [activeAction, setActiveAction] = (0, $gwFzn.useState)();
    const contextValue = (0, $gwFzn.useMemo)(()=>({
            activeAction: activeAction,
            setActiveAction: setActiveAction
        }), [
        activeAction,
        setActiveAction
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsx)($5fffa5ff45c91b6b$export$d0b6fcb7b4503c7e.Provider, {
        value: contextValue,
        children: children
    });
};

});

parcelRegister("7TMNL", function(module, exports) {

$parcel$export(module.exports, "DynamicSurfaceActionItem", () => $579959063a115ca3$export$d4f9d1fefcbcface);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $aIk0I = parcelRequire("aIk0I");

var $56M4r = parcelRequire("56M4r");
var $cGtPE = parcelRequire("cGtPE");

var $gdv5Z = parcelRequire("gdv5Z");
var $1s5hv = parcelRequire("1s5hv");
var $u9agA = parcelRequire("u9agA");
var $iXCQx = parcelRequire("iXCQx");
const $579959063a115ca3$export$a7357cdd1f0b0168 = (0, $2nPZH.defineMessages)({
    aiActionStatusBeta: {
        id: "ai-smart-button.ai-actions.item.betaLozenge",
        defaultMessage: "BETA"
    },
    aiActionStatusNew: {
        id: "ai-smart-button.ai-actions.item.newLozenge",
        defaultMessage: "NEW"
    }
});
const $579959063a115ca3$var$styles = {
    buttonContentStyles: "_zulputpp _18zrutpp _1e0c1txw _4cvr1h6o",
    inlineItemStyles: "_zulpu2gc _syaz1gjq",
    iconBoxStyles: "_2rkoglpi _1dqonqa1 _189ee4h9 _1h6dmuej _1bsbzwfg _4t3izwfg _1ul9zwfg"
};
const $579959063a115ca3$var$statusLozengeMessages = {
    beta: $579959063a115ca3$export$a7357cdd1f0b0168.aiActionStatusBeta,
    new: $579959063a115ca3$export$a7357cdd1f0b0168.aiActionStatusNew
};
const $579959063a115ca3$var$BaseActionItem = ({ title: title, icon: icon, status: status })=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const statusText = status && ($579959063a115ca3$var$statusLozengeMessages[status] ? formatMessage($579959063a115ca3$var$statusLozengeMessages[status]) : null) || status;
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $gdv5Z.default), {
        xcss: $579959063a115ca3$var$styles.buttonContentStyles,
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $1s5hv.default), {
                justifyContent: "center",
                alignItems: "center",
                xcss: $579959063a115ca3$var$styles.iconBoxStyles,
                children: icon
            }),
            /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $u9agA.default), {
                xcss: $579959063a115ca3$var$styles.inlineItemStyles,
                alignBlock: "center",
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsx)((0, $iXCQx.default), {
                        children: title
                    }),
                    statusText && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $aIk0I.default), {
                        appearance: "default",
                        children: statusText
                    })
                ]
            })
        ]
    });
};
function $579959063a115ca3$export$d4f9d1fefcbcface({ title: title, icon: icon, isSelected: isSelected, onClick: onClick, href: href, status: status }) {
    const ref = (0, $gwFzn.useRef)(null);
    (0, $gwFzn.useEffect)(()=>{
        if (isSelected && ref.current) ref.current.scrollIntoView({
            behavior: 'instant',
            block: 'nearest'
        });
    }, [
        isSelected,
        ref
    ]);
    const item = /*#__PURE__*/ (0, $7UHDa.jsx)($579959063a115ca3$var$BaseActionItem, {
        title: title,
        icon: icon,
        status: status
    });
    if (href) return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $cGtPE.default), {
        ref: ref,
        target: "_blank",
        isSelected: isSelected,
        href: href,
        onClick: onClick,
        children: item
    });
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $56M4r.default), {
        ref: ref,
        onClick: onClick,
        isSelected: isSelected,
        children: item
    });
}

});

parcelRegister("fAhtO", function(module, exports) {

$parcel$export(module.exports, "AIInput", () => $e678641afc90aec9$export$82cac4adfb3fa95e);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $35pXk = parcelRequire("35pXk");

var $gwFzn = parcelRequire("gwFzn");

var $2jjxD = parcelRequire("2jjxD");

var $1SjNi = parcelRequire("1SjNi");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $1qfLF = parcelRequire("1qfLF");

var $dLvRS = parcelRequire("dLvRS");

var $d925B = parcelRequire("d925B");

var $574ry = parcelRequire("574ry");
var $1Oo9w = parcelRequire("1Oo9w");

var $b3YrF = parcelRequire("b3YrF");

var $2pjJ5 = parcelRequire("2pjJ5");
var $7iE7T = parcelRequire("7iE7T");

var $e6Iiv = parcelRequire("e6Iiv");

var $auTg8 = parcelRequire("auTg8");

var $1JdaQ = parcelRequire("1JdaQ");

var $1bY7o = parcelRequire("1bY7o");

var $b4wUN = parcelRequire("b4wUN");

var $4fdTR = parcelRequire("4fdTR");

var $u9agA = parcelRequire("u9agA");

var $kw19Z = parcelRequire("kw19Z");

var $jhcFr = parcelRequire("jhcFr");

var $aY6zh = parcelRequire("aY6zh");

var $gfcdN = parcelRequire("gfcdN");
const $e678641afc90aec9$export$a7357cdd1f0b0168 = (0, $2nPZH.defineMessages)({
    inputPlaceholder: {
        id: "ai-smart-button.ai-actions.input.placeholder",
        defaultMessage: "Type what you need"
    },
    linkPickerButtonLabel: {
        id: "ai-smart-button.ai-actions.input.link-picker-button-label",
        defaultMessage: "Link"
    },
    mentionButtonLabel: {
        id: "ai-smart-button.ai-actions.input.mention-button-label",
        defaultMessage: "Mention"
    },
    sendButtonLabel: {
        id: "ai-smart-button.ai-actions.input.send-button-label",
        defaultMessage: "Send"
    }
});
const $e678641afc90aec9$var$styles = {
    container: "_189ee4h9 _1i53muej _15a5nqa1",
    hiddenCaret: "_1n5d3acm",
    editor: "_1e0c1txw _16jlkb7n",
    fullWidthEditor: "_1bsb1osq",
    buttonsContainer: "_kqswstnw _1xi2utpp",
    prosemirrorOverrides: "_w79o1m6u _hmumidpf _12k3idpf _q5yz1wug _dcw6idpf _2ih3idpf",
    promptInput: "_zulpu2gc _2rkoglpi _189ee4h9 _1dqonqa1 _1h6d1elr _kqswh2mm _1o9zidpf _1e0c1txw _1n261g80 _19bvutpp _u5f3utpp _ca0qu2gc _n3tdu2gc _18u01ejb _2hwx1ejb _19pkutpp _otyrutpp",
    focused: "_1h6d1p6i"
}; // Extract the API type to avoid self-referencing in the parameter type
const $e678641afc90aec9$var$useSharedState = (0, $574ry.sharedPluginStateHookMigratorFactory)((api)=>{
    const mentionsTypeAheadHandler = (0, $b3YrF.useSharedPluginStateSelector)(api, 'mention.typeAheadHandler');
    const hasFocus = (0, $b3YrF.useSharedPluginStateSelector)(api, 'focus.hasFocus');
    const activeLinkMark = (0, $b3YrF.useSharedPluginStateSelector)(api, 'hyperlink.activeLinkMark');
    const typeAheadCurrentHandler = (0, $b3YrF.useSharedPluginStateSelector)(api, 'typeAhead.currentHandler');
    return {
        hasFocus: hasFocus,
        activeLinkMark: activeLinkMark,
        mentionTypeAheadHandlerId: typeAheadCurrentHandler?.id,
        typeAheadCurrentHandlerId: mentionsTypeAheadHandler?.id
    };
}, (api)=>{
    const { focusState: focusState, mentionState: mentionState, hyperlinkState: hyperlinkState, typeAheadState: typeAheadState } = (0, $1Oo9w.useSharedPluginState)(api, [
        'focus',
        'mention',
        'hyperlink',
        'typeAhead'
    ]);
    return {
        mentionTypeAheadHandlerId: mentionState?.typeAheadHandler?.id,
        typeAheadCurrentHandlerId: typeAheadState?.currentHandler?.id,
        hasFocus: focusState?.hasFocus,
        activeLinkMark: hyperlinkState?.activeLinkMark
    };
});
function $e678641afc90aec9$export$82cac4adfb3fa95e({ onADFChange: onADFChange, onInputChange: onInputChange, onSelect: onSelect, handleArrowDown: handleArrowDown, handleArrowUp: handleArrowUp, handleBack: handleBack, surfaceMetadata: surfaceMetadata }) {
    const intl = (0, $dBxQj.default)();
    const onSaveRef = (0, $gwFzn.useRef)();
    const mousetrapRef = (0, $gwFzn.useRef)(null);
    const mentionResource = (0, $gwFzn.useMemo)(()=>{
        if (!surfaceMetadata) return undefined;
        return Promise.resolve(new (0, $aY6zh.default)({
            productKey: surfaceMetadata.product,
            siteId: surfaceMetadata.siteId,
            includeTeams: true,
            includeUsers: true
        }));
    }, [
        surfaceMetadata
    ]);
    const linkPicker = (0, $jhcFr.useLinkPickerEditorProps)(undefined, {
        cloudId: surfaceMetadata?.siteId,
        product: surfaceMetadata?.product
    });
    const { preset: preset, editorApi: editorApi } = (0, $1JdaQ.usePreset)(()=>(0, $gfcdN.createAIPromptPreset)({
            placeholder: {
                placeholder: intl.formatMessage($e678641afc90aec9$export$a7357cdd1f0b0168.inputPlaceholder)
            },
            linkPicker: linkPicker,
            cardProvider: Promise.resolve((0, $dLvRS.editorCardProvider)),
            mentionProvider: mentionResource,
            onSave: ()=>onSaveRef.current?.()
        }), [
        intl
    ]);
    const handleSelect = (0, $gwFzn.useCallback)(()=>{
        if (onSelect) editorApi?.core.actions.requestDocument((adf)=>onSelect(adf));
    }, [
        onSelect,
        editorApi
    ]);
    (0, $gwFzn.useEffect)(()=>{
        onSaveRef.current = handleSelect;
    }, [
        handleSelect
    ]);
    const { mentionTypeAheadHandlerId: mentionTypeAheadHandlerId, typeAheadCurrentHandlerId: typeAheadCurrentHandlerId, activeLinkMark: activeLinkMark, hasFocus: hasFocus } = $e678641afc90aec9$var$useSharedState(editorApi);
    const currentTypeAhead = (0, $gwFzn.useMemo)(()=>{
        if (typeAheadCurrentHandlerId === 'quickInsertTypeAhead') return 'quickInsert';
        if (typeAheadCurrentHandlerId === mentionTypeAheadHandlerId) return 'mention';
        if (!!activeLinkMark) return 'link';
    }, [
        activeLinkMark,
        mentionTypeAheadHandlerId,
        typeAheadCurrentHandlerId
    ]);
    const [isInputEmpty, setIsInputEmpty] = (0, $gwFzn.useState)(true);
    const handleChange = (0, $gwFzn.useCallback)((editorView)=>{
        if ((0, $2pjJ5.isEmptyDocument)(editorView.state.doc)) setIsInputEmpty(true);
        else setIsInputEmpty(false);
        if (onInputChange) {
            const textSerializer = (0, $kw19Z.default).fromSchema(editorView.state.schema);
            const text = textSerializer.serializeFragment(editorView.state.doc.content);
            onInputChange(text);
        }
        if (onADFChange) {
            const adf = (0, $7iE7T.toJSON)(editorView.state.doc);
            onADFChange(adf);
        }
    }, [
        onADFChange,
        onInputChange
    ]);
    const setMousetrapRef = (0, $gwFzn.useCallback)((node)=>{
        mousetrapRef.current?.reset();
        if (!node) return;
        mousetrapRef.current = new (0, (/*@__PURE__*/$parcel$interopDefault($1SjNi)))(node);
    }, []); /**
           * Prevent Editor keystrokes from triggering global shortcuts.
           * Could potentially move this logic outside of platform later.
           */ 
    // Prevent editor key presses from triggering global shortcuts
    const suppressGlobalShortcuts = (0, $gwFzn.useCallback)((event)=>{
        mousetrapRef.current?.bind(event.key.toLocaleLowerCase(), (e)=>e.stopPropagation());
    }, []);
    const [isCaretHidden, setIsCaretHidden] = (0, $gwFzn.useState)(false);
    const debouncedSetIsCaretHidden = (0, $gwFzn.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($2jjxD)))(()=>{
            setIsCaretHidden(false);
        }, 300), []);
    const handleKeyUp = (0, $gwFzn.useCallback)(()=>{
        debouncedSetIsCaretHidden();
    }, [
        debouncedSetIsCaretHidden
    ]);
    const handleKeyDown = (0, $gwFzn.useCallback)((event)=>{
        if (currentTypeAhead) // Prevent this handler from interacting when typeahead is open
        return;
        switch(event.key){
            case 'ArrowUp':
                setIsCaretHidden(true);
                handleArrowUp?.();
                event.preventDefault();
                event.stopPropagation();
                break;
            case 'ArrowDown':
                setIsCaretHidden(true);
                handleArrowDown?.();
                event.preventDefault();
                event.stopPropagation();
                break;
            case 'Backspace':
                if (isInputEmpty) {
                    event.preventDefault();
                    event.stopPropagation();
                    handleBack?.();
                }
                break;
            case 'Escape':
                event.preventDefault();
                event.stopPropagation();
                handleBack?.();
                break;
            default:
                return;
        }
    }, [
        handleArrowDown,
        handleArrowUp,
        handleBack,
        isInputEmpty,
        currentTypeAhead
    ]);
    const closeTypeAhead = (0, $gwFzn.useCallback)(()=>{
        editorApi?.typeAhead?.actions.close({
            insertCurrentQueryAsRawText: false
        });
    }, [
        editorApi
    ]);
    const openMentionTypeAhead = (0, $gwFzn.useCallback)(()=>{
        closeTypeAhead();
        editorApi?.mention?.actions.openTypeAhead((0, $d925B.INPUT_METHOD).QUICK_INSERT);
    }, [
        closeTypeAhead,
        editorApi
    ]);
    const openLinkTypeAhead = (0, $gwFzn.useCallback)(()=>{
        closeTypeAhead();
        const command = editorApi?.hyperlink?.commands.showLinkToolbar((0, $d925B.INPUT_METHOD).QUICK_INSERT);
        editorApi?.core.actions.execute(command);
    }, [
        closeTypeAhead,
        editorApi
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $auTg8.default), {
        children: /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
            ref: setMousetrapRef,
            onKeyDown: suppressGlobalShortcuts,
            className: (0, $35pXk.default)([
                $e678641afc90aec9$var$styles.container
            ]),
            children: /*#__PURE__*/ (0, $7UHDa.jsxs)("div", {
                className: (0, $35pXk.default)([
                    $e678641afc90aec9$var$styles.promptInput,
                    hasFocus && $e678641afc90aec9$var$styles.focused,
                    isCaretHidden && $e678641afc90aec9$var$styles.hiddenCaret
                ]),
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
                        onKeyUp: handleKeyUp,
                        onKeyDown: handleKeyDown,
                        className: (0, $35pXk.default)([
                            $e678641afc90aec9$var$styles.editor,
                            $e678641afc90aec9$var$styles.prosemirrorOverrides,
                            $e678641afc90aec9$var$styles.fullWidthEditor
                        ]),
                        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $e6Iiv.ComposableEditor), {
                            mentionProvider: mentionResource,
                            shouldFocus: true,
                            preset: preset,
                            maxHeight: 160,
                            appearance: "chromeless",
                            minHeight: 20,
                            onChange: handleChange
                        })
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $u9agA.default), {
                        space: "space.050",
                        alignInline: "end",
                        spread: linkPicker || mentionResource ? 'space-between' : undefined,
                        alignBlock: "end",
                        grow: isInputEmpty ? 'hug' : 'fill',
                        xcss: isInputEmpty && $e678641afc90aec9$var$styles.buttonsContainer,
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $u9agA.default), {
                                space: "space.050",
                                children: [
                                    linkPicker && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $1qfLF.default), {
                                        appearance: "subtle",
                                        spacing: "compact",
                                        label: intl.formatMessage($e678641afc90aec9$export$a7357cdd1f0b0168.linkPickerButtonLabel),
                                        icon: (0, (/*@__PURE__*/$parcel$interopDefault($1bY7o))),
                                        onMouseDown: (e)=>e.preventDefault(),
                                        isSelected: currentTypeAhead === 'link',
                                        onClick: openLinkTypeAhead
                                    }),
                                    mentionResource && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $1qfLF.default), {
                                        appearance: "subtle",
                                        spacing: "compact",
                                        label: intl.formatMessage($e678641afc90aec9$export$a7357cdd1f0b0168.mentionButtonLabel),
                                        icon: (0, (/*@__PURE__*/$parcel$interopDefault($b4wUN))),
                                        onMouseDown: (e)=>e.preventDefault(),
                                        isSelected: currentTypeAhead === 'mention',
                                        onClick: openMentionTypeAhead
                                    })
                                ]
                            }),
                            !isInputEmpty && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $1qfLF.default), {
                                appearance: "subtle",
                                spacing: "compact",
                                onClick: handleSelect,
                                type: "submit",
                                icon: (0, (/*@__PURE__*/$parcel$interopDefault($4fdTR))),
                                label: intl.formatMessage($e678641afc90aec9$export$a7357cdd1f0b0168.sendButtonLabel)
                            })
                        ]
                    })
                ]
            })
        })
    });
}

});
parcelRegister("1SjNi", function(module, exports) {
/*global define:false */ /**
 * Copyright 2012-2017 Craig Campbell
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Mousetrap is a simple keyboard shortcut library for Javascript with
 * no external dependencies
 *
 * @version 1.6.1
 * @url craig.is/killing/mice
 */ (function(window1, document1, undefined) {
    // Check if mousetrap is used inside browser, if not, return
    if (!window1) return;
    /**
   * mapping of special keycodes to their corresponding keys
   *
   * everything in this dictionary cannot use keypress events
   * so it has to be here to map to the correct keycodes for
   * keyup/keydown events
   *
   * @type {Object}
   */ var _MAP = {
        8: 'backspace',
        9: 'tab',
        13: 'enter',
        16: 'shift',
        17: 'ctrl',
        18: 'alt',
        20: 'capslock',
        27: 'esc',
        32: 'space',
        33: 'pageup',
        34: 'pagedown',
        35: 'end',
        36: 'home',
        37: 'left',
        38: 'up',
        39: 'right',
        40: 'down',
        45: 'ins',
        46: 'del',
        91: 'meta',
        93: 'meta',
        224: 'meta'
    };
    /**
   * mapping for special characters so they can support
   *
   * this dictionary is only used incase you want to bind a
   * keyup or keydown event to one of these keys
   *
   * @type {Object}
   */ var _KEYCODE_MAP = {
        106: '*',
        107: '+',
        109: '-',
        110: '.',
        111: '/',
        186: ';',
        187: '=',
        188: ',',
        189: '-',
        190: '.',
        191: '/',
        192: '`',
        219: '[',
        220: '\\',
        221: ']',
        222: '\''
    };
    /**
   * this is a mapping of keys that require shift on a US keypad
   * back to the non shift equivelents
   *
   * this is so you can use keyup events with these keys
   *
   * note that this will only work reliably on US keyboards
   *
   * @type {Object}
   */ var _SHIFT_MAP = {
        '~': '`',
        '!': '1',
        '@': '2',
        '#': '3',
        '$': '4',
        '%': '5',
        '^': '6',
        '&': '7',
        '*': '8',
        '(': '9',
        ')': '0',
        '_': '-',
        '+': '=',
        ':': ';',
        '\"': '\'',
        '<': ',',
        '>': '.',
        '?': '/',
        '|': '\\'
    };
    /**
   * this is a list of special strings you can use to map
   * to modifier keys when you specify your keyboard shortcuts
   *
   * @type {Object}
   */ var _SPECIAL_ALIASES = {
        'option': 'alt',
        'command': 'meta',
        'return': 'enter',
        'escape': 'esc',
        'plus': '+',
        'mod': /Mac|iPod|iPhone|iPad/.test(navigator.platform) ? 'meta' : 'ctrl'
    };
    /**
   * variable to store the flipped version of _MAP from above
   * needed to check if we should use keypress or not when no action
   * is specified
   *
   * @type {Object|undefined}
   */ var _REVERSE_MAP;
    /**
   * loop through the f keys, f1 to f19 and add them to the map
   * programatically
   */ for(var i = 1; i < 20; ++i)_MAP[111 + i] = 'f' + i;
    /**
   * loop through to map numbers on the numeric keypad
   */ for(i = 0; i <= 9; ++i)// This needs to use a string cause otherwise since 0 is falsey
    // mousetrap will never fire for numpad 0 pressed as part of a keydown
    // event.
    //
    // @see https://github.com/ccampbell/mousetrap/pull/258
    _MAP[i + 96] = i.toString();
    /**
   * cross browser add event method
   *
   * @param {Element|HTMLDocument} object
   * @param {string} type
   * @param {Function} callback
   * @returns void
   */ function _addEvent(object, type, callback) {
        if (object.addEventListener) {
            object.addEventListener(type, callback, false);
            return;
        }
        object.attachEvent('on' + type, callback);
    }
    /**
   * takes the event and returns the key character
   *
   * @param {Event} e
   * @return {string}
   */ function _characterFromEvent(e) {
        // for keypress events we should return the character as is
        if (e.type == 'keypress') {
            var character = String.fromCharCode(e.which);
            // if the shift key is not pressed then it is safe to assume
            // that we want the character to be lowercase.  this means if
            // you accidentally have caps lock on then your key bindings
            // will continue to work
            //
            // the only side effect that might not be desired is if you
            // bind something like 'A' cause you want to trigger an
            // event when capital A is pressed caps lock will no longer
            // trigger the event.  shift+a will though.
            if (!e.shiftKey) character = character.toLowerCase();
            return character;
        }
        // for non keypress events the special maps are needed
        if (_MAP[e.which]) return _MAP[e.which];
        if (_KEYCODE_MAP[e.which]) return _KEYCODE_MAP[e.which];
        // if it is not in the special map
        // with keydown and keyup events the character seems to always
        // come in as an uppercase character whether you are pressing shift
        // or not.  we should make sure it is always lowercase for comparisons
        return String.fromCharCode(e.which).toLowerCase();
    }
    /**
   * checks if two arrays are equal
   *
   * @param {Array} modifiers1
   * @param {Array} modifiers2
   * @returns {boolean}
   */ function _modifiersMatch(modifiers1, modifiers2) {
        return modifiers1.sort().join(',') === modifiers2.sort().join(',');
    }
    /**
   * takes a key event and figures out what the modifiers are
   *
   * @param {Event} e
   * @returns {Array}
   */ function _eventModifiers(e) {
        var modifiers = [];
        if (e.shiftKey) modifiers.push('shift');
        if (e.altKey) modifiers.push('alt');
        if (e.ctrlKey) modifiers.push('ctrl');
        if (e.metaKey) modifiers.push('meta');
        return modifiers;
    }
    /**
   * prevents default for this event
   *
   * @param {Event} e
   * @returns void
   */ function _preventDefault(e) {
        if (e.preventDefault) {
            e.preventDefault();
            return;
        }
        e.returnValue = false;
    }
    /**
   * stops propogation for this event
   *
   * @param {Event} e
   * @returns void
   */ function _stopPropagation(e) {
        if (e.stopPropagation) {
            e.stopPropagation();
            return;
        }
        e.cancelBubble = true;
    }
    /**
   * determines if the keycode specified is a modifier key or not
   *
   * @param {string} key
   * @returns {boolean}
   */ function _isModifier(key) {
        return key == 'shift' || key == 'ctrl' || key == 'alt' || key == 'meta';
    }
    /**
   * reverses the map lookup so that we can look for specific keys
   * to see what can and can't use keypress
   *
   * @return {Object}
   */ function _getReverseMap() {
        if (!_REVERSE_MAP) {
            _REVERSE_MAP = {};
            for(var key in _MAP){
                // pull out the numeric keypad from here cause keypress should
                // be able to detect the keys from the character
                if (key > 95 && key < 112) continue;
                if (_MAP.hasOwnProperty(key)) _REVERSE_MAP[_MAP[key]] = key;
            }
        }
        return _REVERSE_MAP;
    }
    /**
   * picks the best action based on the key combination
   *
   * @param {string} key - character for key
   * @param {Array} modifiers
   * @param {string=} action passed in
   */ function _pickBestAction(key, modifiers, action) {
        // if no action was picked in we should try to pick the one
        // that we think would work best for this key
        if (!action) action = _getReverseMap()[key] ? 'keydown' : 'keypress';
        // modifier keys don't work as expected with keypress,
        // switch to keydown
        if (action == 'keypress' && modifiers.length) action = 'keydown';
        return action;
    }
    /**
   * Converts from a string key combination to an array
   *
   * @param  {string} combination like "command+shift+l"
   * @return {Array}
   */ function _keysFromString(combination) {
        if (combination === '+') return [
            '+'
        ];
        combination = combination.replace(/\+{2}/g, '+plus');
        return combination.split('+');
    }
    /**
   * Gets info for a specific key combination
   *
   * @param  {string} combination key combination ("command+s" or "a" or "*")
   * @param  {string=} action
   * @returns {Object}
   */ function _getKeyInfo(combination, action) {
        var keys;
        var key;
        var i;
        var modifiers = [];
        // take the keys from this pattern and figure out what the actual
        // pattern is all about
        keys = _keysFromString(combination);
        for(i = 0; i < keys.length; ++i){
            key = keys[i];
            // normalize key names
            if (_SPECIAL_ALIASES[key]) key = _SPECIAL_ALIASES[key];
            // if this is not a keypress event then we should
            // be smart about using shift keys
            // this will only work for US keyboards however
            if (action && action != 'keypress' && _SHIFT_MAP[key]) {
                key = _SHIFT_MAP[key];
                modifiers.push('shift');
            }
            // if this key is a modifier then add it to the list of modifiers
            if (_isModifier(key)) modifiers.push(key);
        }
        // depending on what the key combination is
        // we will try to pick the best event for it
        action = _pickBestAction(key, modifiers, action);
        return {
            key: key,
            modifiers: modifiers,
            action: action
        };
    }
    function _belongsTo(element, ancestor) {
        if (element === null || element === document1) return false;
        if (element === ancestor) return true;
        return _belongsTo(element.parentNode, ancestor);
    }
    function Mousetrap(targetElement) {
        var self = this;
        targetElement = targetElement || document1;
        if (!(self instanceof Mousetrap)) return new Mousetrap(targetElement);
        /**
     * element to attach key events to
     *
     * @type {Element}
     */ self.target = targetElement;
        /**
     * a list of all the callbacks setup via Mousetrap.bind()
     *
     * @type {Object}
     */ self._callbacks = {};
        /**
     * direct map of string combinations to callbacks used for trigger()
     *
     * @type {Object}
     */ self._directMap = {};
        /**
     * keeps track of what level each sequence is at since multiple
     * sequences can start out with the same sequence
     *
     * @type {Object}
     */ var _sequenceLevels = {};
        /**
     * variable to store the setTimeout call
     *
     * @type {null|number}
     */ var _resetTimer;
        /**
     * temporary state where we will ignore the next keyup
     *
     * @type {boolean|string}
     */ var _ignoreNextKeyup = false;
        /**
     * temporary state where we will ignore the next keypress
     *
     * @type {boolean}
     */ var _ignoreNextKeypress = false;
        /**
     * are we currently inside of a sequence?
     * type of action ("keyup" or "keydown" or "keypress") or false
     *
     * @type {boolean|string}
     */ var _nextExpectedAction = false;
        /**
     * resets all sequence counters except for the ones passed in
     *
     * @param {Object} doNotReset
     * @returns void
     */ function _resetSequences(doNotReset) {
            doNotReset = doNotReset || {};
            var activeSequences = false, key;
            for(key in _sequenceLevels){
                if (doNotReset[key]) {
                    activeSequences = true;
                    continue;
                }
                _sequenceLevels[key] = 0;
            }
            if (!activeSequences) _nextExpectedAction = false;
        }
        /**
     * finds all callbacks that match based on the keycode, modifiers,
     * and action
     *
     * @param {string} character
     * @param {Array} modifiers
     * @param {Event|Object} e
     * @param {string=} sequenceName - name of the sequence we are looking for
     * @param {string=} combination
     * @param {number=} level
     * @returns {Array}
     */ function _getMatches(character, modifiers, e, sequenceName, combination, level) {
            var i;
            var callback;
            var matches = [];
            var action = e.type;
            // if there are no events related to this keycode
            if (!self._callbacks[character]) return [];
            // if a modifier key is coming up on its own we should allow it
            if (action == 'keyup' && _isModifier(character)) modifiers = [
                character
            ];
            // loop through all callbacks for the key that was pressed
            // and see if any of them match
            for(i = 0; i < self._callbacks[character].length; ++i){
                callback = self._callbacks[character][i];
                // if a sequence name is not specified, but this is a sequence at
                // the wrong level then move onto the next match
                if (!sequenceName && callback.seq && _sequenceLevels[callback.seq] != callback.level) continue;
                // if the action we are looking for doesn't match the action we got
                // then we should keep going
                if (action != callback.action) continue;
                // if this is a keypress event and the meta key and control key
                // are not pressed that means that we need to only look at the
                // character, otherwise check the modifiers as well
                //
                // chrome will not fire a keypress if meta or control is down
                // safari will fire a keypress if meta or meta+shift is down
                // firefox will fire a keypress if meta or control is down
                if (action == 'keypress' && !e.metaKey && !e.ctrlKey || _modifiersMatch(modifiers, callback.modifiers)) {
                    // when you bind a combination or sequence a second time it
                    // should overwrite the first one.  if a sequenceName or
                    // combination is specified in this call it does just that
                    //
                    // @todo make deleting its own method?
                    var deleteCombo = !sequenceName && callback.combo == combination;
                    var deleteSequence = sequenceName && callback.seq == sequenceName && callback.level == level;
                    if (deleteCombo || deleteSequence) self._callbacks[character].splice(i, 1);
                    matches.push(callback);
                }
            }
            return matches;
        }
        /**
     * actually calls the callback function
     *
     * if your callback function returns false this will use the jquery
     * convention - prevent default and stop propogation on the event
     *
     * @param {Function} callback
     * @param {Event} e
     * @returns void
     */ function _fireCallback(callback, e, combo, sequence) {
            // if this event should not happen stop here
            if (self.stopCallback(e, e.target || e.srcElement, combo, sequence)) return;
            if (callback(e, combo) === false) {
                _preventDefault(e);
                _stopPropagation(e);
            }
        }
        /**
     * handles a character key event
     *
     * @param {string} character
     * @param {Array} modifiers
     * @param {Event} e
     * @returns void
     */ self._handleKey = function(character, modifiers, e) {
            var callbacks = _getMatches(character, modifiers, e);
            var i;
            var doNotReset = {};
            var maxLevel = 0;
            var processedSequenceCallback = false;
            // Calculate the maxLevel for sequences so we can only execute the longest callback sequence
            for(i = 0; i < callbacks.length; ++i)if (callbacks[i].seq) maxLevel = Math.max(maxLevel, callbacks[i].level);
            // loop through matching callbacks for this key event
            for(i = 0; i < callbacks.length; ++i){
                // fire for all sequence callbacks
                // this is because if for example you have multiple sequences
                // bound such as "g i" and "g t" they both need to fire the
                // callback for matching g cause otherwise you can only ever
                // match the first one
                if (callbacks[i].seq) {
                    // only fire callbacks for the maxLevel to prevent
                    // subsequences from also firing
                    //
                    // for example 'a option b' should not cause 'option b' to fire
                    // even though 'option b' is part of the other sequence
                    //
                    // any sequences that do not match here will be discarded
                    // below by the _resetSequences call
                    if (callbacks[i].level != maxLevel) continue;
                    processedSequenceCallback = true;
                    // keep a list of which sequences were matches for later
                    doNotReset[callbacks[i].seq] = 1;
                    _fireCallback(callbacks[i].callback, e, callbacks[i].combo, callbacks[i].seq);
                    continue;
                }
                // if there were no sequence matches but we are still here
                // that means this is a regular match so we should fire that
                if (!processedSequenceCallback) _fireCallback(callbacks[i].callback, e, callbacks[i].combo);
            }
            // if the key you pressed matches the type of sequence without
            // being a modifier (ie "keyup" or "keypress") then we should
            // reset all sequences that were not matched by this event
            //
            // this is so, for example, if you have the sequence "h a t" and you
            // type "h e a r t" it does not match.  in this case the "e" will
            // cause the sequence to reset
            //
            // modifier keys are ignored because you can have a sequence
            // that contains modifiers such as "enter ctrl+space" and in most
            // cases the modifier key will be pressed before the next key
            //
            // also if you have a sequence such as "ctrl+b a" then pressing the
            // "b" key will trigger a "keypress" and a "keydown"
            //
            // the "keydown" is expected when there is a modifier, but the
            // "keypress" ends up matching the _nextExpectedAction since it occurs
            // after and that causes the sequence to reset
            //
            // we ignore keypresses in a sequence that directly follow a keydown
            // for the same character
            var ignoreThisKeypress = e.type == 'keypress' && _ignoreNextKeypress;
            if (e.type == _nextExpectedAction && !_isModifier(character) && !ignoreThisKeypress) _resetSequences(doNotReset);
            _ignoreNextKeypress = processedSequenceCallback && e.type == 'keydown';
        };
        /**
     * handles a keydown event
     *
     * @param {Event} e
     * @returns void
     */ function _handleKeyEvent(e) {
            // normalize e.which for key events
            // @see http://stackoverflow.com/questions/4285627/javascript-keycode-vs-charcode-utter-confusion
            if (typeof e.which !== 'number') e.which = e.keyCode;
            var character = _characterFromEvent(e);
            // no character found then stop
            if (!character) return;
            // need to use === for the character check because the character can be 0
            if (e.type == 'keyup' && _ignoreNextKeyup === character) {
                _ignoreNextKeyup = false;
                return;
            }
            self.handleKey(character, _eventModifiers(e), e);
        }
        /**
     * called to set a 1 second timeout on the specified sequence
     *
     * this is so after each key press in the sequence you have 1 second
     * to press the next key before you have to start over
     *
     * @returns void
     */ function _resetSequenceTimer() {
            clearTimeout(_resetTimer);
            _resetTimer = setTimeout(_resetSequences, 1000);
        }
        /**
     * binds a key sequence to an event
     *
     * @param {string} combo - combo specified in bind call
     * @param {Array} keys
     * @param {Function} callback
     * @param {string=} action
     * @returns void
     */ function _bindSequence(combo, keys, callback, action) {
            // start off by adding a sequence level record for this combination
            // and setting the level to 0
            _sequenceLevels[combo] = 0;
            /**
       * callback to increase the sequence level for this sequence and reset
       * all other sequences that were active
       *
       * @param {string} nextAction
       * @returns {Function}
       */ function _increaseSequence(nextAction) {
                return function() {
                    _nextExpectedAction = nextAction;
                    ++_sequenceLevels[combo];
                    _resetSequenceTimer();
                };
            }
            /**
       * wraps the specified callback inside of another function in order
       * to reset all sequence counters as soon as this sequence is done
       *
       * @param {Event} e
       * @returns void
       */ function _callbackAndReset(e) {
                _fireCallback(callback, e, combo);
                // we should ignore the next key up if the action is key down
                // or keypress.  this is so if you finish a sequence and
                // release the key the final key will not trigger a keyup
                if (action !== 'keyup') _ignoreNextKeyup = _characterFromEvent(e);
                // weird race condition if a sequence ends with the key
                // another sequence begins with
                setTimeout(_resetSequences, 10);
            }
            // loop through keys one at a time and bind the appropriate callback
            // function.  for any key leading up to the final one it should
            // increase the sequence. after the final, it should reset all sequences
            //
            // if an action is specified in the original bind call then that will
            // be used throughout.  otherwise we will pass the action that the
            // next key in the sequence should match.  this allows a sequence
            // to mix and match keypress and keydown events depending on which
            // ones are better suited to the key provided
            for(var i = 0; i < keys.length; ++i){
                var isFinal = i + 1 === keys.length;
                var wrappedCallback = isFinal ? _callbackAndReset : _increaseSequence(action || _getKeyInfo(keys[i + 1]).action);
                _bindSingle(keys[i], wrappedCallback, action, combo, i);
            }
        }
        /**
     * binds a single keyboard combination
     *
     * @param {string} combination
     * @param {Function} callback
     * @param {string=} action
     * @param {string=} sequenceName - name of sequence if part of sequence
     * @param {number=} level - what part of the sequence the command is
     * @returns void
     */ function _bindSingle(combination, callback, action, sequenceName, level) {
            // store a direct mapped reference for use with Mousetrap.trigger
            self._directMap[combination + ':' + action] = callback;
            // make sure multiple spaces in a row become a single space
            combination = combination.replace(/\s+/g, ' ');
            var sequence = combination.split(' ');
            var info;
            // if this pattern is a sequence of keys then run through this method
            // to reprocess each pattern one key at a time
            if (sequence.length > 1) {
                _bindSequence(combination, sequence, callback, action);
                return;
            }
            info = _getKeyInfo(combination, action);
            // make sure to initialize array if this is the first time
            // a callback is added for this key
            self._callbacks[info.key] = self._callbacks[info.key] || [];
            // remove an existing match if there is one
            _getMatches(info.key, info.modifiers, {
                type: info.action
            }, sequenceName, combination, level);
            // add this call back to the array
            // if it is a sequence put it at the beginning
            // if not put it at the end
            //
            // this is important because the way these are processed expects
            // the sequence ones to come first
            self._callbacks[info.key][sequenceName ? 'unshift' : 'push']({
                callback: callback,
                modifiers: info.modifiers,
                action: info.action,
                seq: sequenceName,
                level: level,
                combo: combination
            });
        }
        /**
     * binds multiple combinations to the same callback
     *
     * @param {Array} combinations
     * @param {Function} callback
     * @param {string|undefined} action
     * @returns void
     */ self._bindMultiple = function(combinations, callback, action) {
            for(var i = 0; i < combinations.length; ++i)_bindSingle(combinations[i], callback, action);
        };
        // start!
        _addEvent(targetElement, 'keypress', _handleKeyEvent);
        _addEvent(targetElement, 'keydown', _handleKeyEvent);
        _addEvent(targetElement, 'keyup', _handleKeyEvent);
    }
    /**
   * binds an event to mousetrap
   *
   * can be a single key, a combination of keys separated with +,
   * an array of keys, or a sequence of keys separated by spaces
   *
   * be sure to list the modifier keys first to make sure that the
   * correct key ends up getting bound (the last key in the pattern)
   *
   * @param {string|Array} keys
   * @param {Function} callback
   * @param {string=} action - 'keypress', 'keydown', or 'keyup'
   * @returns void
   */ Mousetrap.prototype.bind = function(keys, callback, action) {
        var self = this;
        keys = keys instanceof Array ? keys : [
            keys
        ];
        self._bindMultiple.call(self, keys, callback, action);
        return self;
    };
    /**
   * unbinds an event to mousetrap
   *
   * the unbinding sets the callback function of the specified key combo
   * to an empty function and deletes the corresponding key in the
   * _directMap dict.
   *
   * TODO: actually remove this from the _callbacks dictionary instead
   * of binding an empty function
   *
   * the keycombo+action has to be exactly the same as
   * it was defined in the bind method
   *
   * @param {string|Array} keys
   * @param {string} action
   * @returns void
   */ Mousetrap.prototype.unbind = function(keys, action) {
        var self = this;
        return self.bind.call(self, keys, function() {}, action);
    };
    /**
   * triggers an event that has already been bound
   *
   * @param {string} keys
   * @param {string=} action
   * @returns void
   */ Mousetrap.prototype.trigger = function(keys, action) {
        var self = this;
        if (self._directMap[keys + ':' + action]) self._directMap[keys + ':' + action]({}, keys);
        return self;
    };
    /**
   * resets the library back to its initial state.  this is useful
   * if you want to clear out the current keyboard shortcuts and bind
   * new ones - for example if you switch to another page
   *
   * @returns void
   */ Mousetrap.prototype.reset = function() {
        var self = this;
        self._callbacks = {};
        self._directMap = {};
        return self;
    };
    /**
   * should we stop this event before firing off callbacks
   *
   * @param {Event} e
   * @param {Element} element
   * @return {boolean}
   */ Mousetrap.prototype.stopCallback = function(e, element) {
        var self = this;
        // if the element has the class "mousetrap" then no need to stop
        if ((' ' + element.className + ' ').indexOf(' mousetrap ') > -1) return false;
        if (_belongsTo(element, self.target)) return false;
        // stop for input, select, and textarea
        return element.tagName == 'INPUT' || element.tagName == 'SELECT' || element.tagName == 'TEXTAREA' || element.isContentEditable;
    };
    /**
   * exposes _handleKey publicly so it can be overwritten by extensions
   */ Mousetrap.prototype.handleKey = function() {
        var self = this;
        return self._handleKey.apply(self, arguments);
    };
    /**
   * allow custom key mappings
   */ Mousetrap.addKeycodes = function(object) {
        for(var key in object)if (object.hasOwnProperty(key)) _MAP[key] = object[key];
        _REVERSE_MAP = null;
    };
    /**
   * Init the global mousetrap functions
   *
   * This method is needed to allow the global mousetrap functions to work
   * now that mousetrap is a constructor function.
   */ Mousetrap.init = function() {
        var documentMousetrap = Mousetrap(document1);
        for(var method in documentMousetrap)if (method.charAt(0) !== '_') Mousetrap[method] = function(method) {
            return function() {
                return documentMousetrap[method].apply(documentMousetrap, arguments);
            };
        }(method);
    };
    Mousetrap.init();
    // expose mousetrap to the global object
    window1.Mousetrap = Mousetrap;
    // expose as a common js module
    if (0, module.exports) module.exports = Mousetrap;
    // expose mousetrap as an AMD module
    if (typeof define === 'function' && define.amd) define(function() {
        return Mousetrap;
    });
})(typeof window !== 'undefined' ? window : null, typeof window !== 'undefined' ? document : null);

});

parcelRegister("aY6zh", function(module, exports) {

$parcel$export(module.exports, "default", () => $9ff3e07c34644328$export$2e2bcd8739ae039);

var $bqMS3 = parcelRequire("bqMS3");
var $6mYMS = parcelRequire("6mYMS");

var $grTgx = parcelRequire("grTgx");

var $9w35C = parcelRequire("9w35C");

var $f8oLo = parcelRequire("f8oLo");

var $eHWNJ = parcelRequire("eHWNJ");
const $9ff3e07c34644328$var$CONTEXT_TYPE = 'Mentions';
const $9ff3e07c34644328$var$isSmartMentionConfigWithMentionNameResolver = (smartMentionConfig)=>!!smartMentionConfig.mentionNameResolver;
/*
 * This is a provider implementation which calls URS to provide a list of recommended users/teams to mention.
 * The entryPoint hierarchy is : Editor -> editor-core -> plugins -> mentions -> typeAhead -> getItems -> pluginState.pluginProvider.filter
 * The results are then mapped to mentionItems which have a render prop mentionToTypeaheadItem -> MentionItem
 * https://bitbucket.org/atlassian/atlassian-frontend/src/0884032d85f11f43c13532cd21f13f696b0d28a7/packages/editor/editor-core/src/plugins/mentions/index.tsx#lines-219
 *
 */ class $9ff3e07c34644328$var$SmartMentionResource extends (0, $bqMS3.AbstractMentionResource) {
    shouldHighlightMention(mention) {
        if (this.smartMentionConfig.shouldHighlightMention) return this.smartMentionConfig.shouldHighlightMention(mention);
        return false;
    }
    notify(searchTime, mentionResult, query) {
        if (searchTime > this.lastReturnedSearch) {
            this.lastReturnedSearch = searchTime;
            this._notifyListeners(mentionResult, {
                duration: Date.now() - searchTime
            });
        }
        this._notifyAllResultsListeners(mentionResult);
    }
    notifyError(error, query) {
        this._notifyErrorListeners(error, query);
    }
    async filter(query, contextIdentifier) {
        this.contextIdentifier = contextIdentifier;
        const searchTime = Date.now();
        try {
            let results = await this.getRecommendedMentions(query ? query : '', contextIdentifier);
            this.notify(searchTime, results, query);
        } catch (error) {
            this.notifyError(error, query);
        }
    }
    async getRecommendedMentions(query, contextIdentifier) {
        const startTime = window.performance.now();
        const conf = this.smartMentionConfig;
        const maxNumberOfResults = conf.maxNumberOfResults || 100;
        const request = {
            baseUrl: conf.baseUrl,
            context: {
                productKey: conf.productKey,
                contextType: $9ff3e07c34644328$var$CONTEXT_TYPE,
                principalId: conf.principalId || 'context',
                containerId: contextIdentifier && contextIdentifier.containerId,
                siteId: conf.siteId,
                organizationId: conf.orgId,
                objectId: contextIdentifier && contextIdentifier.objectId || 'undefined',
                childObjectId: contextIdentifier && contextIdentifier.childObjectId || 'undefined',
                mentionsSessionId: contextIdentifier && contextIdentifier.sessionId || 'undefined',
                sessionId: contextIdentifier && contextIdentifier.sessionId || 'undefined'
            },
            includeGroups: conf.includeGroups,
            includeTeams: conf.includeTeams,
            includeUsers: typeof conf.includeUsers === 'undefined' ? true : conf.includeUsers,
            maxNumberOfResults: maxNumberOfResults,
            searchQueryFilter: conf.searchQueryFilter,
            query: query
        };
        try {
            this._notifyAnalyticsListeners((0, $9w35C.SMART_EVENT_TYPE), 'users', (0, $9w35C.Actions).REQUESTED, (0, $9w35C.defaultAttributes)(contextIdentifier));
            const users = await (0, $eHWNJ.default)(request);
            const elapsedTimeMilli = window.performance.now() - startTime;
            const usersForAnalytics = (0, $9w35C.getUsersForAnalytics)(users);
            this._notifyAnalyticsListeners((0, $9w35C.SMART_EVENT_TYPE), 'usersRequest', (0, $9w35C.Actions).SUCCESSFUL, {
                elapsedTimeMilli: elapsedTimeMilli,
                users: usersForAnalytics,
                displayedUsers: usersForAnalytics,
                ...(0, $9w35C.defaultAttributes)(contextIdentifier)
            });
            const mentions = this.transformUsersToMentions(users);
            return {
                mentions: mentions,
                query: query
            };
        } catch (e) {
            const elapsedTimeMilli = window.performance.now() - startTime;
            this._notifyAnalyticsListeners((0, $9w35C.SMART_EVENT_TYPE), 'usersRequest', (0, $9w35C.Actions).FAILED, {
                elapsedTimeMilli: elapsedTimeMilli,
                ...(0, $9w35C.defaultAttributes)(contextIdentifier)
            });
            throw e instanceof Error ? e : new Error(String(e));
        }
    }
    transformTeamMember(member) {
        return {
            id: member.id,
            name: member.name
        };
    }
    transformUserToMention(item) {
        const type = item.entityType;
        let defaultVals = {
            source: 'smarts'
        };
        if (type === (0, $grTgx.EntityType).USER) {
            const user = item;
            return {
                ...defaultVals,
                id: user.id,
                accessLevel: user.accessLevel,
                avatarUrl: user.avatarUrl,
                mentionName: user.nickname || '',
                name: user.name,
                userType: user.userType
            };
        }
        if (type === (0, $grTgx.EntityType).TEAM) {
            const team = item;
            let teamLink = '';
            const defaultTeamLink = `${window.location.origin}/people/team/${team.id}`;
            if (typeof this.smartMentionConfig.teamLinkResolver === 'function') teamLink = this.smartMentionConfig.teamLinkResolver(item.id);
            return {
                ...defaultVals,
                id: team.id,
                name: team.displayName || '',
                mentionName: team.displayName,
                avatarUrl: team.smallAvatarImageUrl,
                accessLevel: (0, $6mYMS.UserAccessLevel)[(0, $6mYMS.UserAccessLevel).CONTAINER],
                userType: (0, $6mYMS.UserType)[(0, $6mYMS.UserType).TEAM],
                lozenge: (0, $6mYMS.UserType)[(0, $6mYMS.UserType).TEAM],
                context: {
                    members: team.members ? team.members.map(this.transformTeamMember) : [],
                    includesYou: team.includesYou || false,
                    memberCount: team.memberCount || 0,
                    teamLink: teamLink || defaultTeamLink //OOH HERE Do we pass in resolver or add in provider?
                },
                source: 'smarts'
            };
        }
        if (type === (0, $grTgx.EntityType).GROUP) {
            const group = item;
            return {
                ...defaultVals,
                id: group.id,
                userType: type.toLowerCase(),
                name: group.name || '',
                lozenge: type.toLowerCase()
            };
        }
        return {
            id: item.id,
            userType: (0, $grTgx.EntityType).USER.toLowerCase(),
            avatarUrl: item.avatarUrl,
            name: item.name,
            lozenge: (0, $grTgx.EntityType).USER.toLowerCase()
        };
    }
    transformUsersToMentions(recommendationItems) {
        return (recommendationItems || []).map(this.transformUserToMention, this).filter((user)=>!!user).map((user)=>user);
    }
    cacheMentionName(id, mentionName) {
        this.smartMentionConfig.mentionNameResolver.cacheName(id, mentionName);
    }
    resolveMentionName(id) {
        return this.smartMentionConfig.mentionNameResolver.lookupName(id);
    }
    supportsMentionNameResolving() {
        return true;
    }
    recordMentionSelection(_mention) {
        this._notifyAnalyticsListeners((0, $9w35C.SMART_EVENT_TYPE), 'usersRequest', (0, $9w35C.Actions).SELECTED, {
            selectedOption: _mention.id,
            ...(0, $9w35C.defaultAttributes)(this.contextIdentifier)
        });
    }
    constructor(smartMentionConfig){
        super();
        // If the product doesn't provide a mention name resolve, use the default resolver so that
        // mention names can be looked up from PRS without configuration.
        this.smartMentionConfig = void 0;
        this.lastReturnedSearch = void 0;
        this.contextIdentifier = void 0;
        this.smartMentionConfig = $9ff3e07c34644328$var$isSmartMentionConfigWithMentionNameResolver(smartMentionConfig) ? smartMentionConfig : {
            ...smartMentionConfig,
            mentionNameResolver: new (0, $f8oLo.DefaultMentionNameResolver)(smartMentionConfig.baseUrl)
        };
        this.lastReturnedSearch = 0;
    }
}
var $9ff3e07c34644328$export$2e2bcd8739ae039 = $9ff3e07c34644328$var$SmartMentionResource;

});
parcelRegister("grTgx", function(module, exports) {

$parcel$export(module.exports, "EntityType", () => $066beef4d1f2f02a$export$8eda7e02f8f033b2);
var $066beef4d1f2f02a$export$8eda7e02f8f033b2 = /*#__PURE__*/ function(EntityType) {
    EntityType["USER"] = "USER";
    EntityType["TEAM"] = "TEAM";
    EntityType["GROUP"] = "GROUP";
    return EntityType;
}({});

});

parcelRegister("9w35C", function(module, exports) {

$parcel$export(module.exports, "SMART_EVENT_TYPE", () => $4f1d2b2c69412aab$export$c724588856bbfbcf);
$parcel$export(module.exports, "Actions", () => $4f1d2b2c69412aab$export$b52183d5cfb26dc9);
$parcel$export(module.exports, "defaultAttributes", () => $4f1d2b2c69412aab$export$38cd8db2db178f58);
$parcel$export(module.exports, "getUsersForAnalytics", () => $4f1d2b2c69412aab$export$e8be30a842a4b49d);
const $4f1d2b2c69412aab$export$c724588856bbfbcf = 'smart';
var $4f1d2b2c69412aab$export$b52183d5cfb26dc9 = /*#__PURE__*/ function(Actions) {
    Actions["REQUESTED"] = "requested";
    Actions["SUCCESSFUL"] = "successful";
    Actions["SEARCHED"] = "searched";
    Actions["FAILED"] = "failed";
    Actions["SELECTED"] = "selected";
    return Actions;
}({});
const $4f1d2b2c69412aab$export$38cd8db2db178f58 = (context)=>{
    return {
        context: context?.objectId || '',
        sessionId: context?.sessionId || '',
        pickerType: 'mentions',
        source: 'smarts'
    };
};
const $4f1d2b2c69412aab$export$e8be30a842a4b49d = (users)=>{
    return users ? users.map(({ id: id, entityType: entityType })=>({
            id: id,
            type: entityType.toLowerCase()
        })) : [];
};

});

parcelRegister("f8oLo", function(module, exports) {

$parcel$export(module.exports, "DefaultMentionNameResolver", () => $760648ceb1fc9809$export$2ae0434dccdcb77e);

var $6mYMS = parcelRequire("6mYMS");

var $1NrSh = parcelRequire("1NrSh");

var $9KHZR = parcelRequire("9KHZR");
const $760648ceb1fc9809$var$buildUsersQuery = (accountIds)=>({
        query: `query usersQuery($accountIds: [ID!]!) {
    users(accountIds: $accountIds) {
      name
      accountId
    }
  }`,
        variables: {
            accountIds: accountIds
        }
    });
const $760648ceb1fc9809$var$makeRequest = async (url, accountIds)=>{
    const query = $760648ceb1fc9809$var$buildUsersQuery(accountIds);
    return (0, $9KHZR.graphqlQuery)(url, query);
};
class $760648ceb1fc9809$export$2ae0434dccdcb77e {
    async lookupName(id) {
        try {
            if (this.cache.has(id)) return {
                id: id,
                name: this.cache.get(id),
                status: (0, $6mYMS.MentionNameStatus).OK
            };
            const url = (0, $1NrSh.PRD_CONFIG).getGraphQLUrl(this.baseUrl);
            const data = await $760648ceb1fc9809$var$makeRequest(url, [
                id
            ]);
            const userInfo = data.users?.find((user)=>user.accountId === id);
            return userInfo ? {
                id: id,
                name: userInfo.name,
                status: (0, $6mYMS.MentionNameStatus).OK
            } : {
                id: id,
                status: (0, $6mYMS.MentionNameStatus).UNKNOWN
            };
        } catch (error) {
            // on network error, return original list with label 'Unknown'
            return {
                id: id,
                status: (0, $6mYMS.MentionNameStatus).UNKNOWN
            };
        }
    }
    cacheName(id, name) {
        this.cache.set(id, name);
    }
    constructor(baseUrl){
        this.baseUrl = void 0;
        this.cache = void 0;
        this.baseUrl = baseUrl;
        this.cache = new Map();
    }
}

});
parcelRegister("9KHZR", function(module, exports) {

$parcel$export(module.exports, "graphqlQuery", () => $6d4812bfe02f5ea6$export$74eb8d79ae3e02b5);
const $6d4812bfe02f5ea6$var$buildHeaders = ()=>{
    const headers = new Headers();
    headers.append('Content-Type', 'application/json');
    return headers;
};
function $6d4812bfe02f5ea6$export$74eb8d79ae3e02b5(serviceUrl, query) {
    const headers = $6d4812bfe02f5ea6$var$buildHeaders();
    return fetch(new Request(`${serviceUrl}`, {
        method: 'POST',
        credentials: 'include',
        mode: 'cors',
        headers: headers,
        body: JSON.stringify(query)
    })).then((response)=>{
        if (!response.ok) return Promise.reject({
            code: response.status,
            reason: response.statusText
        });
        return response;
    }).then((response)=>response.json()).then((json)=>{
        if (json.errors) return Promise.reject({
            reason: json.errors[0]?.category || 'default'
        });
        return json.data;
    });
}

});


parcelRegister("eHWNJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $721aad13b249dafb$export$2e2bcd8739ae039);

var $1NrSh = parcelRequire("1NrSh");
const $721aad13b249dafb$var$getUserRecommendations = (request)=>{
    const url = (0, $1NrSh.PRD_CONFIG).getRecommendationServiceUrl(request.baseUrl);
    return fetch(url, {
        method: 'POST',
        credentials: 'include',
        headers: {
            'content-type': 'application/json'
        },
        body: JSON.stringify({
            context: request.context,
            includeUsers: request.includeUsers,
            includeGroups: request.includeGroups,
            includeTeams: request.includeTeams,
            maxNumberOfResults: request.maxNumberOfResults,
            performSearchQueryOnly: false,
            searchQuery: {
                cpusQueryHighlights: {
                    query: '',
                    field: ''
                },
                customQuery: '',
                customerDirectoryId: '',
                filter: request.searchQueryFilter || '',
                minimumAccessLevel: 'APPLICATION',
                queryString: request.query,
                restrictTo: {
                    userIds: [],
                    groupIds: []
                },
                searchUserbase: false
            }
        })
    }).then((response)=>{
        if (response.status === 200) return response.json();
        return Promise.reject({
            message: `error calling smart service, statusCode=${response.status}, statusText=${response.statusText}`
        });
    }).then((response)=>response.recommendedUsers);
};
var $721aad13b249dafb$export$2e2bcd8739ae039 = $721aad13b249dafb$var$getUserRecommendations;

});


parcelRegister("gfcdN", function(module, exports) {

$parcel$export(module.exports, "createAIPromptPreset", () => $6e6979063270e03b$export$cd6e43a807ff0e0d);

var $bupcf = parcelRequire("bupcf");

var $jL0bJ = parcelRequire("jL0bJ");

var $2P8JV = parcelRequire("2P8JV");

var $stVm3 = parcelRequire("stVm3");

var $cNucV = parcelRequire("cNucV");

var $j5BTD = parcelRequire("j5BTD");

var $d2gjm = parcelRequire("d2gjm");

var $1mT7b = parcelRequire("1mT7b");

var $czo2Z = parcelRequire("czo2Z");

var $jiT42 = parcelRequire("jiT42");

var $7aKg5 = parcelRequire("7aKg5");

var $8exqI = parcelRequire("8exqI");

var $12MPQ = parcelRequire("12MPQ");

var $1AOco = parcelRequire("1AOco");

var $h6Mwq = parcelRequire("h6Mwq");

var $bn2AM = parcelRequire("bn2AM");

var $eKfhS = parcelRequire("eKfhS");

var $ebElI = parcelRequire("ebElI");

var $88OoA = parcelRequire("88OoA");

var $dhgPE = parcelRequire("dhgPE");

var $3HEm4 = parcelRequire("3HEm4");

var $lSIzP = parcelRequire("lSIzP");

var $k2RCe = parcelRequire("k2RCe");

var $kPcbV = parcelRequire("kPcbV");

var $cW0VI = parcelRequire("cW0VI");

var $1hEK8 = parcelRequire("1hEK8");

var $7oMzO = parcelRequire("7oMzO");

var $8C4KP = parcelRequire("8C4KP");
function $6e6979063270e03b$export$cd6e43a807ff0e0d({ placeholder: placeholder, onSave: onSave, createAnalyticsEvent: createAnalyticsEvent, allowAnalyticsGASV3: allowAnalyticsGASV3, linkPicker: linkPicker, cardProvider: cardProvider, mentionProvider: mentionProvider }) {
    const preset = new (0, $bupcf.EditorPresetBuilder)()// Most of analytics events in editor are fired by appending
    //  AnalyticsStep in transaction.
    // Without this plugin, none of those events will be fired.
    // If allowAnalyticsGASV3 is truthy, then analytics plugin will be added.
    .maybeAdd([
        (0, $jL0bJ.analyticsPlugin),
        {
            createAnalyticsEvent: createAnalyticsEvent
        }
    ], Boolean(allowAnalyticsGASV3))// Dependency of paste plugin
    .add((0, $stVm3.betterTypeHistoryPlugin))// we need paste plugin to handle paste event.
    .add([
        (0, $3HEm4.pastePlugin),
        {}
    ])// We need clipboard to handle cut and copy and clipboard serialization.
    .add((0, $1mT7b.clipboardPlugin))// Handles focus and blur events.
    .add((0, $h6Mwq.focusPlugin))// This plugin handles composition events and take care nuances of composition.
    // Need this plugin to have sleek composition support for languages such as Japanese, Chinese
    .add((0, $jiT42.compositionPlugin))// Editor can't function without this plugin.
    // It takes care of doc, paragraph and text nodes, backbone of any document.
    .add([
        (0, $2P8JV.basePlugin),
        {}
    ])// Dependency of cardPlugin, floatingToolbarPlugin
    .add((0, $8exqI.decorationsPlugin))// Depdency of undoRedoButtons
    .add((0, $1hEK8.typeAheadPlugin))// Depdency of undoRedoButtons
    .maybeAdd((0, $eKfhS.historyPlugin), true)// We want to support undo/redo through shortcuts.
    .maybeAdd((0, $7oMzO.undoRedoPlugin), true)// We should keep this plugin. It will remove all the marks when doc is empty.
    // It's very lightweight plugin.
    .add((0, $d2gjm.clearMarksOnEmptyDocPlugin))// Dependency of cardPlugin
    .maybeAdd([
        (0, $ebElI.hyperlinkPlugin),
        {
            linkPicker: linkPicker
        }
    ], !!linkPicker).maybeAdd([
        (0, $dhgPE.mentionsPlugin)
    ], !!mentionProvider)// Dependency of cardPlugin, gridPlugin
    .add((0, $8C4KP.widthPlugin))// Need placeholder plugin to show placeholder
    .add([
        (0, $lSIzP.placeholderPlugin),
        placeholder
    ])// Dependency of floatingToolbarPlugin
    .add((0, $12MPQ.editorDisabledPlugin))// Dependency of floatingToolbarPlugin
    .add((0, $7aKg5.copyButtonPlugin))// Dependency of cardPlugin
    .add((0, $1AOco.floatingToolbarPlugin))// Need selections plugin to handle selection nuances in editor, support gap cursor and keyboard handling for selection.
    .add([
        (0, $cW0VI.selectionPlugin),
        {}
    ])// Need to have save on enter functionality. Without this plugin, on enter editor will add line break and then prompt is submited.
    .add([
        (0, $kPcbV.saveOnEnterPlugin),
        onSave
    ])// Dependency of cardPlugin
    .maybeAdd([
        (0, $bn2AM.gridPlugin),
        {}
    ], true)// Need card plugin to show smart links.
    .maybeAdd([
        (0, $j5BTD.cardPlugin),
        {
            provider: cardProvider,
            linkPicker: linkPicker,
            disableFloatingToolbar: false,
            showUpgradeDiscoverability: false,
            allowBlockCards: false,
            allowEmbeds: false
        }
    ], !!cardProvider)// Need this plugin for adding new line on `Shift + Enter` keymap
    .add([
        (0, $cNucV.blockTypePlugin),
        {
            allowBlockType: {
                exclude: [
                    'heading'
                ]
            }
        }
    ]).add([
        (0, $k2RCe.quickInsertPlugin),
        {}
    ]).add([
        (0, $czo2Z.codeBlockPlugin),
        {}
    ]).add((0, $88OoA.listPlugin));
    return preset;
}

});


parcelRegister("hjyG8", function(module, exports) {

$parcel$export(module.exports, "FeedbackActionItem", () => $ca6c5044b54d38ba$export$df335894b91b1826);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $4jR19 = parcelRequire("4jR19");
var $dBxQj = parcelRequire("dBxQj");

var $biiXa = parcelRequire("biiXa");
var $29DUH = parcelRequire("29DUH");

var $6uGcC = parcelRequire("6uGcC");

var $7yOcR = parcelRequire("7yOcR");

var $2Nwuj = parcelRequire("2Nwuj");

var $7TMNL = parcelRequire("7TMNL");
const $ca6c5044b54d38ba$var$FEEDBACK_ENTRYPOINT_ID = '9a6e0f65-eca3-4f73-8e40-5d4c466fee65';
const $ca6c5044b54d38ba$var$FEEDBACK_CONTEXT_CF = 'customfield_10047';
const $ca6c5044b54d38ba$var$LINK_TO_PRIVACY_POLICY = 'https://www.atlassian.com/legal/privacy-policy';
const $ca6c5044b54d38ba$export$a7357cdd1f0b0168 = (0, $2nPZH.defineMessages)({
    giveFeedbackActionTitle: {
        id: "ai-smart-button.feedback-action.title",
        defaultMessage: "Give feedback"
    },
    feedbackIconLabel: {
        id: "ai-smart-button.feedback-item.icon-label",
        defaultMessage: "Feedback icon"
    },
    feedbackModalHeading: {
        id: "ai-smart-button.feedback-action.feedback-modal-heading",
        defaultMessage: "Share your thoughts"
    },
    feedbackModalSelectFeedbackHeading: {
        id: "ai-smart-button.feedback-action.select-feedback-heading",
        defaultMessage: "Select feedback"
    },
    chooseFeedbackOption: {
        id: "ai-smart-button.feedback-action.choose-feedback-option",
        defaultMessage: "Choose one"
    },
    askQuestionOption: {
        id: "ai-smart-button.feedback-action.ask-question-option",
        defaultMessage: "Ask a question"
    },
    leaveCommentOption: {
        id: "ai-smart-button.feedback-action.leave-comment-option",
        defaultMessage: "Leave a comment"
    },
    reportBugOption: {
        id: "ai-smart-button.feedback-action.report-bug-option",
        defaultMessage: "Report a bug"
    },
    suggestImprovementOption: {
        id: "ai-smart-button.feedback-action.suggest-improvement-option",
        defaultMessage: "Suggest an improvement"
    },
    feedbackQuestionHeading: {
        id: "ai-smart-button.feedback-action.feedback-entry-question-heading",
        defaultMessage: "What would you like to know?"
    },
    feedbackCommentHeading: {
        id: "ai-smart-button.feedback-action.feedback-entry-comment-heading",
        defaultMessage: "Let us know what's on your mind"
    },
    feedbackBugHeading: {
        id: "ai-smart-button.feedback-action.feedback-entry-bug-heading",
        defaultMessage: "Describe the bug or issue"
    },
    feedbackSuggestHeading: {
        id: "ai-smart-button.feedback-action.feedback-entry-suggest-heading",
        defaultMessage: "Let us know what you'd like to improve"
    },
    canContactMessage: {
        id: "ai-smart-button.feedback-action.can-contact-message",
        defaultMessage: "Yes, {product} teams can contact me to learn about my experiences to improve Atlassian products and services. I acknowledge the {privacyPolicy}"
    },
    researchParticipationMessage: {
        id: "ai-smart-button.feedback-action.research-participation-message",
        defaultMessage: "I'd like to participate in product research"
    },
    privacyPolicyLink: {
        id: "ai-smart-button.feedback-action.privacy-policy-link",
        defaultMessage: "{product} Privacy Policy."
    },
    submitButtonLabel: {
        id: "ai-smart-button.feedback-action.submit-button-label",
        defaultMessage: "Send feedback"
    },
    cancelButtonLabel: {
        id: "ai-smart-button.feedback-action.cancel-button-label",
        defaultMessage: "Cancel"
    }
});
const $ca6c5044b54d38ba$var$PrivacyPolicyLink = ()=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $2Nwuj.default), {
        target: "_blank",
        href: $ca6c5044b54d38ba$var$LINK_TO_PRIVACY_POLICY,
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
            ...$ca6c5044b54d38ba$export$a7357cdd1f0b0168.privacyPolicyLink,
            values: {
                product: 'Atlassian'
            }
        })
    });
const $ca6c5044b54d38ba$export$df335894b91b1826 = ({ surfaceMetadata: surfaceMetadata, profileData: profileData })=>{
    const ref = (0, $gwFzn.useRef)(null);
    const intl = (0, $dBxQj.default)();
    const { locale: intlLocale } = intl;
    const [isOpen, setIsOpen] = (0, $gwFzn.useState)(false);
    const [displayFlag, setDisplayFlag] = (0, $gwFzn.useState)(false);
    const openFeedbackDialog = ()=>setIsOpen(true);
    const closeFeedbackDialog = ()=>setIsOpen(false);
    const displayFlagTrue = ()=>setDisplayFlag(true);
    const hideFlag = ()=>setDisplayFlag(false);
    const feedbackContext = `product: ${surfaceMetadata.product} \n pageMode: ${surfaceMetadata.pageMode}`;
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $7UHDa.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7TMNL.DynamicSurfaceActionItem), {
                title: intl.formatMessage($ca6c5044b54d38ba$export$a7357cdd1f0b0168.giveFeedbackActionTitle),
                icon: /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7yOcR))), {
                    label: intl.formatMessage($ca6c5044b54d38ba$export$a7357cdd1f0b0168.feedbackIconLabel)
                }),
                status: undefined,
                isSelected: false,
                onClick: openFeedbackDialog
            }),
            isOpen && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $biiXa.default), {
                onClose: closeFeedbackDialog,
                entrypointId: $ca6c5044b54d38ba$var$FEEDBACK_ENTRYPOINT_ID,
                shouldReturnFocusRef: ref,
                onSubmit: displayFlagTrue,
                atlassianAccountId: profileData.aaid ? profileData.aaid : undefined,
                name: profileData.name,
                additionalFields: [
                    {
                        id: $ca6c5044b54d38ba$var$FEEDBACK_CONTEXT_CF,
                        value: feedbackContext
                    }
                ],
                feedbackTitle: intl.formatMessage($ca6c5044b54d38ba$export$a7357cdd1f0b0168.feedbackModalHeading),
                customFeedbackOptions: [
                    {
                        label: intl.formatMessage($ca6c5044b54d38ba$export$a7357cdd1f0b0168.askQuestionOption),
                        value: 'question'
                    },
                    {
                        label: intl.formatMessage($ca6c5044b54d38ba$export$a7357cdd1f0b0168.leaveCommentOption),
                        value: 'comment'
                    },
                    {
                        label: intl.formatMessage($ca6c5044b54d38ba$export$a7357cdd1f0b0168.reportBugOption),
                        value: 'bug'
                    },
                    {
                        label: intl.formatMessage($ca6c5044b54d38ba$export$a7357cdd1f0b0168.suggestImprovementOption),
                        value: 'suggestion'
                    }
                ],
                selectLabel: intl.formatMessage($ca6c5044b54d38ba$export$a7357cdd1f0b0168.feedbackModalSelectFeedbackHeading),
                feedbackGroupLabels: {
                    empty: {
                        fieldLabel: intl.formatMessage($ca6c5044b54d38ba$export$a7357cdd1f0b0168.chooseFeedbackOption),
                        selectOptionLabel: intl.formatMessage($ca6c5044b54d38ba$export$a7357cdd1f0b0168.chooseFeedbackOption)
                    },
                    question: {
                        fieldLabel: intl.formatMessage($ca6c5044b54d38ba$export$a7357cdd1f0b0168.feedbackQuestionHeading),
                        selectOptionLabel: intl.formatMessage($ca6c5044b54d38ba$export$a7357cdd1f0b0168.feedbackQuestionHeading)
                    },
                    comment: {
                        fieldLabel: intl.formatMessage($ca6c5044b54d38ba$export$a7357cdd1f0b0168.feedbackCommentHeading),
                        selectOptionLabel: intl.formatMessage($ca6c5044b54d38ba$export$a7357cdd1f0b0168.feedbackCommentHeading)
                    },
                    bug: {
                        fieldLabel: intl.formatMessage($ca6c5044b54d38ba$export$a7357cdd1f0b0168.feedbackBugHeading),
                        selectOptionLabel: intl.formatMessage($ca6c5044b54d38ba$export$a7357cdd1f0b0168.feedbackBugHeading)
                    },
                    suggestion: {
                        fieldLabel: intl.formatMessage($ca6c5044b54d38ba$export$a7357cdd1f0b0168.feedbackSuggestHeading),
                        selectOptionLabel: intl.formatMessage($ca6c5044b54d38ba$export$a7357cdd1f0b0168.feedbackSuggestHeading)
                    }
                },
                enrolInResearchLabel: intl.formatMessage($ca6c5044b54d38ba$export$a7357cdd1f0b0168.researchParticipationMessage),
                canBeContactedLabel: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                    ...$ca6c5044b54d38ba$export$a7357cdd1f0b0168.canContactMessage,
                    values: {
                        product: 'Atlassian',
                        privacyPolicy: /*#__PURE__*/ (0, $7UHDa.jsx)($ca6c5044b54d38ba$var$PrivacyPolicyLink, {})
                    }
                }),
                cancelButtonLabel: intl.formatMessage($ca6c5044b54d38ba$export$a7357cdd1f0b0168.cancelButtonLabel),
                submitButtonLabel: intl.formatMessage($ca6c5044b54d38ba$export$a7357cdd1f0b0168.submitButtonLabel)
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6uGcC.default), {
                onDismissed: hideFlag,
                children: displayFlag && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $29DUH.default), {
                    locale: intlLocale
                })
            })
        ]
    });
};

});

parcelRegister("b5Yo2", function(module, exports) {

$parcel$export(module.exports, "HeadingSection", () => $4ceb059286af29bd$export$77467aa267b5a56f);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $9QtOT = parcelRequire("9QtOT");

var $1lBqO = parcelRequire("1lBqO");

var $i4y6I = parcelRequire("i4y6I");
function $4ceb059286af29bd$export$77467aa267b5a56f({ name: name }) {
    const context = (0, $9QtOT.useAIContext)();
    return context ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $i4y6I.Reference), {}) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $1lBqO.Greeting), {
        name: name
    });
}

});
parcelRegister("1lBqO", function(module, exports) {

$parcel$export(module.exports, "Greeting", () => $53cd6fd2318e135d$export$8a81f19eda16ba8d);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $gdv5Z = parcelRequire("gdv5Z");
const $53cd6fd2318e135d$export$a7357cdd1f0b0168 = (0, $2nPZH.defineMessages)({
    introTextHeadline: {
        id: "ai-smart-button.ai-dynamic-surface.components.greeting.intro-text-headline",
        defaultMessage: "Hi {name},"
    },
    introSecondline: {
        id: "ai-smart-button.ai-dynamic-surface.components.greeting.intro-second-line",
        defaultMessage: "How can I help?"
    }
});
const $53cd6fd2318e135d$var$styles = {
    greetingText: "_11c8nf1z _k48p1pd9",
    container: "_18zr1ejb _1rjc1b66"
};
function $53cd6fd2318e135d$export$8a81f19eda16ba8d({ name: name }) {
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $gdv5Z.default), {
        xcss: $53cd6fd2318e135d$var$styles.container,
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gdv5Z.default), {
                xcss: $53cd6fd2318e135d$var$styles.greetingText,
                children: formatMessage($53cd6fd2318e135d$export$a7357cdd1f0b0168.introTextHeadline, {
                    name: name
                })
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gdv5Z.default), {
                xcss: $53cd6fd2318e135d$var$styles.greetingText,
                children: formatMessage($53cd6fd2318e135d$export$a7357cdd1f0b0168.introSecondline)
            })
        ]
    });
}

});

parcelRegister("i4y6I", function(module, exports) {

$parcel$export(module.exports, "Reference", () => $a90892031bc3542b$export$e0be378c32fb70a7);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $1qfLF = parcelRequire("1qfLF");

var $5H7UU = parcelRequire("5H7UU");

var $gdv5Z = parcelRequire("gdv5Z");
var $1s5hv = parcelRequire("1s5hv");
var $u9agA = parcelRequire("u9agA");
var $iXCQx = parcelRequire("iXCQx");

var $9QtOT = parcelRequire("9QtOT");
const $a90892031bc3542b$export$a7357cdd1f0b0168 = (0, $2nPZH.defineMessages)({
    closeButtonLabel: {
        id: "ai-smart-button.reference.close-button-label",
        defaultMessage: "Close"
    }
});
const $a90892031bc3542b$var$styles = {
    reference: "_2rkoiti9 _1rjcu2gc _18zrutpp _1dqonqa1 _189ee4h9 _1h6dmuej _bfhkvuon",
    container: "_ca0qv77o _n3tdv47k _19bv1ejb _u5f31ejb"
};
function $a90892031bc3542b$export$e0be378c32fb70a7() {
    const context = (0, $9QtOT.useAIContext)();
    const intl = (0, $dBxQj.default)();
    const reference = context?.reference;
    const onRemove = context?.onRemove;
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gdv5Z.default), {
        xcss: $a90892031bc3542b$var$styles.container,
        backgroundColor: "elevation.surface.sunken",
        children: /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $1s5hv.default), {
            xcss: $a90892031bc3542b$var$styles.reference,
            alignItems: "center",
            children: [
                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $u9agA.default), {
                    grow: "fill",
                    children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $iXCQx.default), {
                        size: "medium",
                        weight: "semibold",
                        maxLines: 1,
                        children: reference
                    })
                }),
                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $1qfLF.default), {
                    testId: "remove-reference-button",
                    appearance: "subtle",
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($5H7UU))),
                    label: intl.formatMessage($a90892031bc3542b$export$a7357cdd1f0b0168.closeButtonLabel),
                    spacing: "compact",
                    onClick: onRemove
                })
            ]
        })
    });
}

});


parcelRegister("izicj", function(module, exports) {

$parcel$export(module.exports, "NoResults", () => $de905dc99f5ce786$export$ef6006467f04ee41);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $gj7hi = parcelRequire("gj7hi");

var $gdv5Z = parcelRequire("gdv5Z");
var $eyWa4 = parcelRequire("eyWa4");
var $iXCQx = parcelRequire("iXCQx");

var $aRXqc = parcelRequire("aRXqc");

var $leYng = parcelRequire("leYng");

var $l1zQL = parcelRequire("l1zQL");

var $fmJ20 = parcelRequire("fmJ20");
const $de905dc99f5ce786$export$a7357cdd1f0b0168 = (0, $2nPZH.defineMessages)({
    aiActionsSectionText: {
        id: "ai-smart-button.ai-actions.actions.section.text",
        defaultMessage: "Actions"
    },
    aiStudioSectionText: {
        id: "ai-smart-button.ai-actions.rovo-agents.section.text",
        defaultMessage: "Studio"
    },
    noResultsHeading: {
        id: "ai-smart-button.ai-actions.no-results-heading",
        defaultMessage: "Ask Rovo"
    },
    noResultsText: {
        id: "ai-smart-button.ai-actions.no-results-text",
        defaultMessage: "Send your prompt to Rovo to start a chat."
    }
});
const $de905dc99f5ce786$var$styles = {
    imageContainer: "_p12fautk",
    gesturalLinesContainer: "_kqswh2mm",
    gesturalLines: "_kqswstnw _p12f1tcg _154ize3t _1ltvze3t _t9ec12fj",
    heading: "_11c8lodh _k48p1wq8"
};
function $de905dc99f5ce786$export$ef6006467f04ee41() {
    const intl = (0, $dBxQj.default)();
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $eyWa4.default), {
        alignInline: "center",
        grow: "fill",
        children: /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $eyWa4.default), {
            space: "space.200",
            alignInline: "center",
            children: [
                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gdv5Z.default), {
                    xcss: $de905dc99f5ce786$var$styles.imageContainer,
                    children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gj7hi.default), {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($fmJ20))),
                        srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($l1zQL)))
                    })
                }),
                /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $gdv5Z.default), {
                    xcss: $de905dc99f5ce786$var$styles.gesturalLinesContainer,
                    children: [
                        /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gdv5Z.default), {
                            xcss: $de905dc99f5ce786$var$styles.gesturalLines,
                            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gj7hi.default), {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($leYng))),
                                srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($aRXqc)))
                            })
                        }),
                        /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gdv5Z.default), {
                            xcss: $de905dc99f5ce786$var$styles.heading,
                            children: intl.formatMessage($de905dc99f5ce786$export$a7357cdd1f0b0168.noResultsHeading)
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $iXCQx.default), {
                    size: "medium",
                    color: "color.text.subtle",
                    align: "center",
                    children: intl.formatMessage($de905dc99f5ce786$export$a7357cdd1f0b0168.noResultsText)
                })
            ]
        })
    });
}

});
parcelRegister("aRXqc", function(module, exports) {
module.exports = new URL("dark.6d30a270.svg", import.meta.url).toString();

});

parcelRegister("leYng", function(module, exports) {
module.exports = new URL("light.936b96f7.svg", import.meta.url).toString();

});

parcelRegister("l1zQL", function(module, exports) {
module.exports = new URL("dark.90199792.svg", import.meta.url).toString();

});

parcelRegister("fmJ20", function(module, exports) {
module.exports = new URL("light.5ffcf568.svg", import.meta.url).toString();

});


parcelRegister("6X9ch", function(module, exports) {

$parcel$export(module.exports, "useNavigateActions", () => $6c48ecd206e4ad0d$export$fd774fe4affd5347);

var $gwFzn = parcelRequire("gwFzn");
const $6c48ecd206e4ad0d$export$eb2078a154b033cb = (length, currentIndex, direction)=>{
    // Got nothing to do
    if (length === 0) return undefined;
    if (direction === 'ArrowUp') {
        // If the index has been reset, navigate to the last item
        if (currentIndex === undefined) return length - 1;
        /**
		 * Visualisation of what the scenarios are covering
		 * - Left = out of bounds negative indexes
		 * - Right = out of bounds positive indexes
		 * - 0-9 = example of valid suggestion indexes
		 *       Array items
		 * -----[0123456789]++++++
		 * <----DCB------>A-->
				 Scenarios
		*/ // A: Out of bounds
        if (currentIndex > length - 1) return 0;
        else if (currentIndex > 0) return currentIndex - 1;
        else if (currentIndex === 0) return length - 1;
        else return 0;
    } else if (direction === 'ArrowDown') {
        // If the index has been reset, navigate to the first item
        if (currentIndex === undefined) return 0;
        /**
		 * Visualisation of what the scenarios are covering
		 * - Left = out of bounds negative indexes
		 * - Right = out of bounds positive indexes
		 * - 0-9 = example of valid suggestion indexes
		 *       Array items
		 * -----[0123456789]++++++
		 * <----BC------->A-->
				 Scenarios
		*/ // A: Last item or out of bounds
        if (currentIndex >= length - 1) return 0;
        else if (currentIndex < 0) return 0;
        else if (currentIndex < length - 1) return currentIndex + 1;
    } else throw new Error('Unknown direction');
    return 0;
};
const $6c48ecd206e4ad0d$export$fd774fe4affd5347 = (listLength)=>{
    const [selectedIndex, setSelectedIndex] = (0, $gwFzn.useState)();
    (0, $gwFzn.useEffect)(()=>{
        setSelectedIndex(undefined);
    }, [
        listLength
    ]);
    const handleArrowDown = ()=>{
        const newIndex = $6c48ecd206e4ad0d$export$eb2078a154b033cb(listLength, selectedIndex, 'ArrowDown');
        setSelectedIndex(newIndex);
    };
    const handleArrowUp = ()=>{
        const newIndex = $6c48ecd206e4ad0d$export$eb2078a154b033cb(listLength, selectedIndex, 'ArrowUp');
        setSelectedIndex(newIndex);
    };
    return {
        handleArrowDown: handleArrowDown,
        handleArrowUp: handleArrowUp,
        selectedIndex: selectedIndex
    };
};

});

parcelRegister("6yGtw", function(module, exports) {

$parcel$export(module.exports, "getStudioActions", () => $d098d01eb5e4aff1$export$5570338f6cad3a4a);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");

var $g5gZt = parcelRequire("g5gZt");

var $hge3g = parcelRequire("hge3g");

var $fxBfz = parcelRequire("fxBfz");
const $d098d01eb5e4aff1$export$a7357cdd1f0b0168 = (0, $2nPZH.defineMessages)({
    aiStudioCreateAgentAction: {
        id: "ai-smart-button.ai-actions.rovo-agents.create-agent.text",
        defaultMessage: "Create agent"
    },
    aiStudioBrowseAgentAction: {
        id: "ai-smart-button.ai-actions.rovo-agents.create-agent.text",
        defaultMessage: "Browse agents"
    },
    aiStudioAutomationsAction: {
        id: "ai-smart-button.ai-actions.rovo-agents.automations.text",
        defaultMessage: "Automations"
    },
    aiStudioCreateAutomationAction: {
        id: "ai-smart-button.ai-actions.rovo-agents.create-automation.text",
        defaultMessage: "Create automation"
    },
    addIconLabel: {
        id: "ai-smart-button.ai-actions.rovo-agents.add-icon-label",
        defaultMessage: "Add icon"
    },
    agentIconLabel: {
        id: "ai-smart-button.ai-actions.rovo-agents.agent-icon-label",
        defaultMessage: "Agent icon"
    },
    automationIconLabel: {
        id: "ai-smart-button.ai-actions.rovo-agents.automation-icon-label",
        defaultMessage: "Automation icon"
    }
});
function $d098d01eb5e4aff1$export$5570338f6cad3a4a({ intl: intl, createAgentUrl: createAgentUrl, handleBrowseAgent: handleBrowseAgent, renderUserAutomations: renderUserAutomations, onCreateAutomation: onCreateAutomation }) {
    return [
        {
            id: 'create-agent',
            title: intl.formatMessage($d098d01eb5e4aff1$export$a7357cdd1f0b0168.aiStudioCreateAgentAction),
            href: createAgentUrl,
            icon: /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($g5gZt))), {
                label: intl.formatMessage($d098d01eb5e4aff1$export$a7357cdd1f0b0168.addIconLabel)
            })
        },
        {
            id: 'browse-agent',
            title: intl.formatMessage($d098d01eb5e4aff1$export$a7357cdd1f0b0168.aiStudioBrowseAgentAction),
            onClick: handleBrowseAgent,
            icon: /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hge3g))), {
                label: intl.formatMessage($d098d01eb5e4aff1$export$a7357cdd1f0b0168.agentIconLabel)
            })
        },
        ...onCreateAutomation ? [
            {
                id: 'create-automations',
                title: intl.formatMessage($d098d01eb5e4aff1$export$a7357cdd1f0b0168.aiStudioCreateAutomationAction),
                icon: /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($g5gZt))), {
                    label: ""
                }),
                onClick: onCreateAutomation
            }
        ] : [],
        ...renderUserAutomations ? [
            {
                id: 'user-automations',
                title: intl.formatMessage($d098d01eb5e4aff1$export$a7357cdd1f0b0168.aiStudioAutomationsAction),
                icon: /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fxBfz))), {
                    label: intl.formatMessage($d098d01eb5e4aff1$export$a7357cdd1f0b0168.automationIconLabel)
                }),
                viewConfig: {
                    render: renderUserAutomations
                }
            }
        ] : []
    ];
}

});


parcelRegister("8cOg1", function(module, exports) {

$parcel$export(module.exports, "AIFeatureView", () => $7bf3d73267cf0b04$export$fd12b3c4ccd128bd);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $1qfLF = parcelRequire("1qfLF");

var $bPdpL = parcelRequire("bPdpL");

var $gdv5Z = parcelRequire("gdv5Z");
var $eyWa4 = parcelRequire("eyWa4");

var $4acD6 = parcelRequire("4acD6");
var $9QtOT = parcelRequire("9QtOT");
var $glqpS = parcelRequire("glqpS");

var $9j9JP = parcelRequire("9j9JP");
const $7bf3d73267cf0b04$var$atlaskitCssStyles = {
    heightStyles: "_4t3i1osq"
};
const $7bf3d73267cf0b04$export$fd12b3c4ccd128bd = ({ view: view, objectSidebar: objectSidebar })=>{
    const { changeView: changeView } = (0, $glqpS.useViewAIActions)();
    const context = (0, $9QtOT.useAIContext)();
    const { changeHeaderElements: changeHeaderElements } = objectSidebar.actions;
    const panelTitle = context?.reference ? (0, $9j9JP.i18n).referencingPanelTitle : undefined;
    (0, $gwFzn.useEffect)(()=>{
        changeHeaderElements((0, $9j9JP.DYNAMIC_SURFACE_PANEL_ID), {
            HeaderIcon: ()=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $1qfLF.default), {
                    testId: "ai-feature-view-back-button",
                    appearance: "subtle",
                    label: "",
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($bPdpL))),
                    onClick: ()=>changeView((0, $4acD6.DynamicSurfaceView).Default)
                })
        });
    }, [
        changeHeaderElements,
        changeView
    ]);
    (0, $gwFzn.useEffect)(()=>{
        return ()=>{
            changeHeaderElements((0, $9j9JP.DYNAMIC_SURFACE_PANEL_ID), (0, $9j9JP.getDynamicSurfacePanelHeaderElements)({
                panelTitle: panelTitle
            }));
        };
    // Reset Header Elements on unmount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    if (!view) return null;
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $eyWa4.default), {
        xcss: $7bf3d73267cf0b04$var$atlaskitCssStyles.heightStyles,
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gdv5Z.default), {
            paddingInline: "space.200",
            xcss: $7bf3d73267cf0b04$var$atlaskitCssStyles.heightStyles,
            children: view?.render()
        })
    });
};

});



parcelRegister("fQDx6", function(module, exports) {

$parcel$export(module.exports, "PageAutomationRovoButton", () => $df9d4a807fec50c1$export$63905d5efedacfa0);

var $gwFzn = parcelRequire("gwFzn");

var $ixUm0 = parcelRequire("ixUm0");

var $dIouf = parcelRequire("dIouf");

var $bQm3c = parcelRequire("bQm3c");

var $b1JUJ = parcelRequire("b1JUJ");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");
const $df9d4a807fec50c1$var$i18n = (0, $2nPZH.defineMessages)({
    rovoButtonTitle: {
        id: "automation-menu.page-rovo-button-menu.title",
        defaultMessage: "Page automations"
    }
});
const $df9d4a807fec50c1$export$63905d5efedacfa0 = ({ pageId: pageId, spaceKey: spaceKey, contentTitle: contentTitle })=>{
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const pageAri = (0, $ixUm0.ConfluencePageAri).create({
        siteId: cloudId,
        pageId: pageId
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.ErrorBoundary), {
        attribution: (0, $dIouf.Attribution).AUTOMATION_FOR_CONFLUENCE
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $b1JUJ.AutomationRovoButton), {
        spaceKey: spaceKey,
        aris: [
            pageAri
        ],
        analyticsSource: "pageRovoButtonManualTriggers",
        title: formatMessage($df9d4a807fec50c1$var$i18n.rovoButtonTitle),
        contentTitle: contentTitle ?? ''
    }));
};

});
parcelRegister("b1JUJ", function(module, exports) {

$parcel$export(module.exports, "AutomationRovoButton", () => $afaa567cbb16c592$export$b589f5161ccc12e9);

var $gwFzn = parcelRequire("gwFzn");

var $inPa6 = parcelRequire("inPa6");

var $6f0Oj = parcelRequire("6f0Oj");
var $bUlM5 = parcelRequire("bUlM5");
var $1GzhS = parcelRequire("1GzhS");
var $ecnYn = parcelRequire("ecnYn");

var $1fOao = parcelRequire("1fOao");

var $bAfzr = parcelRequire("bAfzr");

var $gRtNT = parcelRequire("gRtNT");

var $wzGVC = parcelRequire("wzGVC");
const $afaa567cbb16c592$var$BodyStyles = (0, $ecnYn.xcss)({
    maxHeight: '600px',
    overflowY: 'auto',
    overflowX: 'hidden'
});
const $afaa567cbb16c592$var$ContainerStyles = (0, $ecnYn.xcss)({
    height: '100%',
    paddingBottom: 'space.200',
    paddingInline: 'space.100'
});
const $afaa567cbb16c592$export$b589f5161ccc12e9 = ({ aris: aris, analyticsSource: analyticsSource, spaceKey: spaceKey, title: title, contentTitle: contentTitle })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [selectedRuleId, setSelectedRuleId] = (0, $gwFzn.useState)();
    (0, $gwFzn.useEffect)(()=>{
        createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: analyticsSource
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        analyticsSource
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1fOao.ConfluenceManualRulesContainer), {
        aris: aris,
        analyticsSource: analyticsSource,
        spaceKey: spaceKey,
        singleSpace: true
    }, ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1GzhS.default), {
            spread: "space-between",
            xcss: $afaa567cbb16c592$var$ContainerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1GzhS.default), {
            space: "space.200"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $wzGVC.AutomationRovoButtonHeader), {
            title: title,
            contentTitle: contentTitle
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
            xcss: $afaa567cbb16c592$var$BodyStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $bAfzr.AutomationModalBody), {
            selectedRuleId: selectedRuleId,
            setSelectedRuleId: setSelectedRuleId
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $bUlM5.default), {
            justifyContent: "end"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gRtNT.AutomationModalFooter), {
            selectedRuleId: selectedRuleId,
            onClose: ()=>{},
            inRovoButton: true
        })));
    });
};

});
parcelRegister("bAfzr", function(module, exports) {

$parcel$export(module.exports, "AutomationModalBody", () => $ee2730b2a96335c8$export$7fe81a1a9142c622);

var $gwFzn = parcelRequire("gwFzn");

var $1fOao = parcelRequire("1fOao");

var $kT5zt = parcelRequire("kT5zt");

var $4Ry1a = parcelRequire("4Ry1a");

var $3bNXk = parcelRequire("3bNXk");
const $ee2730b2a96335c8$export$7fe81a1a9142c622 = ({ selectedRuleId: selectedRuleId, setSelectedRuleId: setSelectedRuleId })=>{
    const { triggerFetch: triggerFetch, initialised: initialised, rules: rules, error: error, aris: aris } = (0, $1fOao.useAutomationMenu)();
    (0, $gwFzn.useEffect)(()=>{
        triggerFetch();
    // Want to ensure that triggerFetch is only called once when the component is mounted.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    if (aris.length === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $kT5zt.Skeleton), {
        lineCount: 10
    });
    if (!initialised) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $kT5zt.Skeleton), {
        lineCount: 10
    });
    else if (error && rules.length === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $3bNXk.AutomationModalErrorState), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4Ry1a.AutomationModalRuleList), {
        selectedRuleId: selectedRuleId,
        setSelectedRuleId: setSelectedRuleId
    });
};

});
parcelRegister("4Ry1a", function(module, exports) {

$parcel$export(module.exports, "AutomationModalRuleList", () => $d4ab595ed4722bec$export$8e77116ea9034760);

var $gwFzn = parcelRequire("gwFzn");

var $2SlZp = parcelRequire("2SlZp");

var $eyWa4 = parcelRequire("eyWa4");

var $irVI7 = parcelRequire("irVI7");
var $1kHsc = parcelRequire("1kHsc");

var $1fOao = parcelRequire("1fOao");

var $2Q65G = parcelRequire("2Q65G");

var $6NORa = parcelRequire("6NORa");
const $d4ab595ed4722bec$export$8e77116ea9034760 = ({ selectedRuleId: selectedRuleId, setSelectedRuleId: setSelectedRuleId })=>{
    const { rules: rules, analyticsSource: analyticsSource } = (0, $1fOao.useAutomationMenu)();
    const experienceTracker = (0, $gwFzn.useContext)((0, $1kHsc.ExperienceTrackerContext));
    (0, $gwFzn.useEffect)(()=>{
        experienceTracker.succeed({
            name: (0, $irVI7.AUTOMATION_MANUAL_TRIGGERS),
            attributes: {
                source: analyticsSource,
                ruleCount: rules.length
            }
        });
    }, [
        experienceTracker,
        analyticsSource,
        rules.length
    ]);
    if (rules.length === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $2Q65G.AutomationModalEmptyState), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $2SlZp.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $eyWa4.default), {
        space: "space.050"
    }, rules.map((rule)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6NORa.AutomationModalRule), {
            key: `manual-rule-${rule.id}`,
            rule: rule,
            selectedRuleId: selectedRuleId,
            setSelectedRuleId: setSelectedRuleId
        }))));
};

});
parcelRegister("2Q65G", function(module, exports) {

$parcel$export(module.exports, "AutomationModalEmptyState", () => $b5d0b0d9ee119881$export$6875eeaa0fa7363c);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $4jR19 = parcelRequire("4jR19");
var $dBxQj = parcelRequire("dBxQj");

var $inPa6 = parcelRequire("inPa6");

var $eEA8O = parcelRequire("eEA8O");

var $gj7hi = parcelRequire("gj7hi");

var $6f0Oj = parcelRequire("6f0Oj");
var $1GzhS = parcelRequire("1GzhS");
var $ecnYn = parcelRequire("ecnYn");

var $dIouf = parcelRequire("dIouf");

var $irVI7 = parcelRequire("irVI7");
var $gfIPU = parcelRequire("gfIPU");

var $hxUWO = parcelRequire("hxUWO");

var $1fOao = parcelRequire("1fOao");

var $jXEWW = parcelRequire("jXEWW");
const $b5d0b0d9ee119881$var$i18n = (0, $2nPZH.defineMessages)({
    emptyAutomationModalAdminDescription: {
        id: "automation-menu.modal.empty.automations.admin.description",
        defaultMessage: "Use the manual trigger to populate a menu of selections that anyone, or people you specify, can apply as one-click automations to a page."
    },
    emptyAutomationsUserDescription: {
        id: "automation-menu.modal.empty.automations.user.description",
        defaultMessage: "Admins haven\u2019t configured any page automations for this space yet. When they do, it might include one-click actions like changing page restrictions."
    },
    learnMoreLink: {
        id: "automation-menu.empty-state.learn-more.link",
        defaultMessage: "Learn more about the manual trigger"
    },
    emptyAutomationListImageAlt: {
        id: "automation-menu.empty-state.image.alt",
        defaultMessage: "Empty automation list image"
    }
});
const $b5d0b0d9ee119881$var$emptyStateStyles = (0, $ecnYn.xcss)({
    paddingLeft: 'space.300',
    paddingRight: 'space.300',
    marginTop: 'space.500'
});
const $b5d0b0d9ee119881$var$imageStyles = (0, $ecnYn.xcss)({
    marginTop: 'space.050',
    marginBottom: 'space.300'
});
const $b5d0b0d9ee119881$var$descriptionStyles = (0, $ecnYn.xcss)({
    width: '360px',
    textAlign: 'center'
});
const $b5d0b0d9ee119881$export$6875eeaa0fa7363c = ()=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { spaceKey: spaceKey, analyticsSource: analyticsSource } = (0, $1fOao.useAutomationMenu)();
    const { canManageAutomations: canManageAutomations, error: permissionServiceError } = (0, $jXEWW.useAutomationPermissionService)(spaceKey);
    const descriptionContent = canManageAutomations ? $b5d0b0d9ee119881$var$i18n.emptyAutomationModalAdminDescription : $b5d0b0d9ee119881$var$i18n.emptyAutomationsUserDescription;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1GzhS.default), {
        xcss: $b5d0b0d9ee119881$var$emptyStateStyles,
        alignInline: "center",
        alignBlock: "center",
        grow: "fill"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: $b5d0b0d9ee119881$var$imageStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gj7hi.default), {
        alt: formatMessage($b5d0b0d9ee119881$var$i18n.emptyAutomationListImageAlt),
        src: (0, (/*@__PURE__*/$parcel$interopDefault($hxUWO)))
    })), permissionServiceError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.ErrorDisplay), {
        error: permissionServiceError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gfIPU.ExperienceFailure), {
        name: (0, $irVI7.AUTOMATION_MANUAL_TRIGGERS),
        error: permissionServiceError,
        attributes: {
            location: 'emptyState',
            source: analyticsSource
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: $b5d0b0d9ee119881$var$descriptionStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), descriptionContent), canManageAutomations && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $eEA8O.default), {
        appearance: "link",
        spacing: "none",
        href: "https://www.atlassian.com/platform/automation",
        target: "_blank",
        onClick: ()=>{
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'clicked',
                    actionSubject: 'link',
                    actionSubjectId: 'learnMore',
                    source: analyticsSource
                }
            }).fire();
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $b5d0b0d9ee119881$var$i18n.learnMoreLink)))));
};

});
parcelRegister("hxUWO", function(module, exports) {
module.exports = new URL("empty-automation-list.9c7d0496.png", import.meta.url).toString();

});


parcelRegister("6NORa", function(module, exports) {

$parcel$export(module.exports, "AutomationModalRule", () => $db84ea11aa8c2ada$export$5f0f1183c836984b);

var $gwFzn = parcelRequire("gwFzn");

var $inPa6 = parcelRequire("inPa6");

var $56M4r = parcelRequire("56M4r");

var $9hlns = parcelRequire("9hlns");

var $6f0Oj = parcelRequire("6f0Oj");
var $1GzhS = parcelRequire("1GzhS");
var $ecnYn = parcelRequire("ecnYn");

var $1fOao = parcelRequire("1fOao");
const $db84ea11aa8c2ada$var$ruleButtonStyle = (0, $ecnYn.xcss)({
    borderColor: 'color.border',
    borderStyle: 'solid',
    borderWidth: 'border.width',
    borderRadius: 'border.radius'
});
const $db84ea11aa8c2ada$var$selectedRuleButtonStyle = (0, $ecnYn.xcss)({
    backgroundColor: 'color.background.accent.blue.subtlest',
    borderColor: 'color.border.accent.blue',
    borderStyle: 'solid',
    borderWidth: 'border.width.outline',
    borderRadius: 'border.radius'
});
const $db84ea11aa8c2ada$var$ruleNameStyle = (0, $ecnYn.xcss)({
    // Using this to increase the height of the button itself.
    height: '28px'
});
const $db84ea11aa8c2ada$export$5f0f1183c836984b = ({ rule: rule, selectedRuleId: selectedRuleId, setSelectedRuleId: setSelectedRuleId })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { analyticsSource: analyticsSource, invokingRuleId: invokingRuleId } = (0, $1fOao.useAutomationMenu)();
    const isSelectedRule = selectedRuleId === rule.id;
    const isExecuting = rule.id === invokingRuleId;
    const ruleOnClick = ()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'selectManualTriggerAutomation',
                source: analyticsSource,
                attributes: {
                    ruleId: rule.id.toString()
                }
            }
        }).fire();
        setSelectedRuleId(rule.id);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: isSelectedRule ? $db84ea11aa8c2ada$var$selectedRuleButtonStyle : $db84ea11aa8c2ada$var$ruleButtonStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $56M4r.default), {
        isDisabled: !!invokingRuleId,
        iconBefore: isExecuting ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $9hlns.default), {
            size: "small"
        }) : null,
        onClick: ruleOnClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1GzhS.default), {
        xcss: $db84ea11aa8c2ada$var$ruleNameStyle,
        alignBlock: "center"
    }, rule.name)));
};

});


parcelRegister("3bNXk", function(module, exports) {

$parcel$export(module.exports, "AutomationModalErrorState", () => $6677b9d7ee6df920$export$99d5fcf082612abf);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $gj7hi = parcelRequire("gj7hi");

var $6f0Oj = parcelRequire("6f0Oj");
var $1GzhS = parcelRequire("1GzhS");
var $ecnYn = parcelRequire("ecnYn");

var $irVI7 = parcelRequire("irVI7");
var $1kHsc = parcelRequire("1kHsc");

var $gyz3B = parcelRequire("gyz3B");

var $1fOao = parcelRequire("1fOao");
const $6677b9d7ee6df920$var$i18n = (0, $2nPZH.defineMessages)({
    errorDescription: {
        id: "automation-menu.modal.error.description",
        defaultMessage: "This is taking awhile to load. Try refreshing the page."
    },
    errorImageAlt: {
        id: "automation-menu.modal.error.image.alt",
        defaultMessage: "Error image"
    }
});
const $6677b9d7ee6df920$var$errorStateStyles = (0, $ecnYn.xcss)({
    textAlign: 'center',
    marginTop: 'space.500'
});
const $6677b9d7ee6df920$var$imageContainerStyles = (0, $ecnYn.xcss)({
    display: 'block',
    maxWidth: '116px',
    maxHeight: '156px',
    marginBottom: 'space.300',
    marginTop: 'space.050'
});
const $6677b9d7ee6df920$var$descriptionStyles = (0, $ecnYn.xcss)({
    maxWidth: '360px'
});
const $6677b9d7ee6df920$export$99d5fcf082612abf = ()=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const experienceTracker = (0, $gwFzn.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { analyticsSource: analyticsSource } = (0, $1fOao.useAutomationMenu)();
    (0, $gwFzn.useEffect)(()=>{
        experienceTracker.fail({
            name: (0, $irVI7.AUTOMATION_MANUAL_TRIGGERS),
            error: new Error('Failed to fetch manual rules'),
            attributes: {
                source: analyticsSource
            }
        });
    }, [
        experienceTracker,
        analyticsSource
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1GzhS.default), {
        xcss: $6677b9d7ee6df920$var$errorStateStyles,
        alignInline: "center",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: $6677b9d7ee6df920$var$imageContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gj7hi.default), {
        alt: formatMessage($6677b9d7ee6df920$var$i18n.errorImageAlt),
        src: (0, (/*@__PURE__*/$parcel$interopDefault($gyz3B)))
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: $6677b9d7ee6df920$var$descriptionStyles
    }, formatMessage($6677b9d7ee6df920$var$i18n.errorDescription)));
};

});
parcelRegister("gyz3B", function(module, exports) {
module.exports = new URL("error.b6351f9e.svg", import.meta.url).toString();

});



parcelRegister("gRtNT", function(module, exports) {

$parcel$export(module.exports, "AutomationModalFooter", () => $4dfde97d0570aaab$export$8bebd64914280cf9);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $4jR19 = parcelRequire("4jR19");

var $inPa6 = parcelRequire("inPa6");

var $ccHMk = parcelRequire("ccHMk");
var $7p4As = parcelRequire("7p4As");

var $irVI7 = parcelRequire("irVI7");
var $1kHsc = parcelRequire("1kHsc");

var $1fOao = parcelRequire("1fOao");

var $jXEWW = parcelRequire("jXEWW");
const $4dfde97d0570aaab$var$i18n = (0, $2nPZH.defineMessages)({
    modalFooterCancelButton: {
        id: "automation-menu.modal.footer.cancel-button",
        defaultMessage: "Cancel"
    },
    modalFooterAutomateButton: {
        id: "automation-menu.modal.footer.automate-button",
        defaultMessage: "Automate"
    },
    modalFooterCreateAutomationButton: {
        id: "automation-menu.modal.footer.get-started-button",
        defaultMessage: "Create automation"
    },
    modalFooterOkButton: {
        id: "automation-menu.modal.footer.ok-button",
        defaultMessage: "Ok"
    }
});
const $4dfde97d0570aaab$export$8bebd64914280cf9 = ({ selectedRuleId: selectedRuleId, onClose: onClose, inRovoButton: inRovoButton })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { spaceKey: spaceKey, aris: aris, initialised: initialised, invokeRuleOrShowDialog: invokeRuleOrShowDialog, invokingRuleId: invokingRuleId, rules: rules, error: error, baseAutomationUrl: baseAutomationUrl, analyticsSource: analyticsSource } = (0, $1fOao.useAutomationMenu)();
    const { canManageAutomations: canManageAutomations, error: permissionServiceError } = (0, $jXEWW.useAutomationPermissionService)(spaceKey);
    const experienceTracker = (0, $gwFzn.useContext)((0, $1kHsc.ExperienceTrackerContext));
    // Just to signal undesired footer results due to permission service failing.
    (0, $gwFzn.useEffect)(()=>{
        if (permissionServiceError) experienceTracker.fail({
            name: (0, $irVI7.AUTOMATION_MANUAL_TRIGGERS),
            error: permissionServiceError,
            attributes: {
                source: analyticsSource,
                location: 'footer'
            }
        });
    }, [
        experienceTracker,
        analyticsSource,
        permissionServiceError
    ]);
    const sendFooterAnalyticsEvent = (actionSubjectId, ruleId)=>{
        const event = createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: actionSubjectId,
                source: analyticsSource
            }
        });
        if (ruleId) event.payload.data.attributes = {
            ruleId: ruleId
        };
        event.fire();
    };
    const okButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ccHMk.default), {
        key: "automation-modal-footer-ok",
        appearance: "primary",
        onClick: ()=>{
            sendFooterAnalyticsEvent('ok');
            onClose();
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $4dfde97d0570aaab$var$i18n.modalFooterOkButton));
    const cancelButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ccHMk.default), {
        key: "automation-modal-footer-cancel",
        appearance: "subtle",
        onClick: ()=>{
            sendFooterAnalyticsEvent('cancel');
            onClose();
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $4dfde97d0570aaab$var$i18n.modalFooterCancelButton));
    const createAutomationButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $7p4As.default), {
        key: "automation-modal-footer-create-automation",
        appearance: "primary",
        href: `${baseAutomationUrl}#rule/new`,
        onClick: ()=>{
            sendFooterAnalyticsEvent('createAutomation');
        },
        target: "_blank"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $4dfde97d0570aaab$var$i18n.modalFooterCreateAutomationButton));
    const automateButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ccHMk.default), {
        key: "automation-modal-footer-automate",
        appearance: "primary",
        onClick: ()=>{
            if (selectedRuleId) {
                sendFooterAnalyticsEvent('executeManualTriggerAutomation', selectedRuleId.toString());
                invokeRuleOrShowDialog(selectedRuleId, aris.map(String));
            }
        },
        isDisabled: !selectedRuleId || !!invokingRuleId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $4dfde97d0570aaab$var$i18n.modalFooterAutomateButton));
    const modalButtons = [];
    if (!initialised) return null;
    // Populated rule list -> cancel and automate buttons
    // Empty admin scenario -> cancel and Create Automation buttons
    // Empty end user and error scenario -> Ok button
    if (rules.length < 1) {
        if (error || !canManageAutomations) modalButtons.push(okButton);
        else modalButtons.push(cancelButton, createAutomationButton);
    } else modalButtons.push(cancelButton, automateButton);
    // Don't show cancel and Ok button in Rovo Button experience
    if (inRovoButton) {
        const okIndex = modalButtons.indexOf(okButton);
        const cancelIndex = modalButtons.indexOf(cancelButton);
        if (okIndex > -1) modalButtons.splice(okIndex, 1);
        if (cancelIndex > -1) modalButtons.splice(cancelIndex, 1);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, modalButtons);
};

});

parcelRegister("wzGVC", function(module, exports) {

$parcel$export(module.exports, "AutomationRovoButtonHeader", () => $6a2ac1456b0c95bf$export$a6767c5ec70200e);
/* AutomationRovoButtonHeader.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $35pXk = parcelRequire("35pXk");

var $gwFzn = parcelRequire("gwFzn");

var $dBxQj = parcelRequire("dBxQj");

var $7hXDW = parcelRequire("7hXDW");

var $6f0Oj = parcelRequire("6f0Oj");
var $dcJ7R = parcelRequire("dcJ7R");
var $1GzhS = parcelRequire("1GzhS");
var $5dK2X = parcelRequire("5dK2X");
var $ecnYn = parcelRequire("ecnYn");

var $5OHon = parcelRequire("5OHon");

var $3KUzn = parcelRequire("3KUzn");

var $1fOao = parcelRequire("1fOao");
const $6a2ac1456b0c95bf$var$iconStyle = (0, $ecnYn.xcss)({
    marginRight: 'space.150',
    backgroundColor: 'color.background.accent.green.subtlest',
    borderRadius: 'border.radius'
});
const $6a2ac1456b0c95bf$var$contextHintStyle = (0, $ecnYn.xcss)({
    marginTop: 'space.150'
});
const $6a2ac1456b0c95bf$var$HeadingStyles = null;
const $6a2ac1456b0c95bf$export$a6767c5ec70200e = ({ contentTitle: contentTitle, title: title })=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const { initialised: initialised, rules: rules } = (0, $1fOao.useAutomationMenu)();
    const showHint = initialised && rules.length > 0;
    const contextHint = formatMessage((0, $5OHon.i18n).modalHeaderContextHint, {
        contentTitle: contentTitle,
        b: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5dK2X.default), {
                weight: "bold"
            }, chunks)
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1GzhS.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dcJ7R.default), {
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: $6a2ac1456b0c95bf$var$iconStyle,
        paddingInline: "space.050",
        paddingBlock: "space.025",
        testId: "automation-header-icon"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3KUzn))), {
        label: "",
        color: "var(--ds-icon-accent-green, #22A06B)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
        className: (0, $35pXk.default)([
            "_ggmh1txs"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $7hXDW.default), {
        size: "medium"
    }, title))), showHint && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: $6a2ac1456b0c95bf$var$contextHintStyle
    }, contextHint, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", null, formatMessage((0, $5OHon.i18n).modalHeaderContextDescription))));
};

});
parcelRegister("5OHon", function(module, exports) {

$parcel$export(module.exports, "i18n", () => $3cdf698150a3fbb9$export$a7357cdd1f0b0168);
$parcel$export(module.exports, "AutomationModalHeader", () => $3cdf698150a3fbb9$export$918c7c2e2d7f0bfd);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $9ot3w = parcelRequire("9ot3w");
var $804cB = parcelRequire("804cB");

var $7hXDW = parcelRequire("7hXDW");

var $6f0Oj = parcelRequire("6f0Oj");
var $dcJ7R = parcelRequire("dcJ7R");
var $1GzhS = parcelRequire("1GzhS");
var $5dK2X = parcelRequire("5dK2X");
var $ecnYn = parcelRequire("ecnYn");

var $Ij2L0 = parcelRequire("Ij2L0");

var $1fOao = parcelRequire("1fOao");
const $3cdf698150a3fbb9$export$a7357cdd1f0b0168 = (0, $2nPZH.defineMessages)({
    modalHeaderIconLabel: {
        id: "automation-menu.modal.header.icon.label",
        defaultMessage: "Automation modal header icon"
    },
    modalHeaderTitle: {
        id: "automation-menu.modal.header.title",
        defaultMessage: "Automate"
    },
    modalHeaderLearnMore: {
        id: "automation-menu.modal.header.learn-more",
        defaultMessage: "Learn more about manual triggers"
    },
    modalHeaderContextHint: {
        id: "automation-menu.modal.header.context-hint",
        defaultMessage: "Apply an automation to <b>{contentTitle}</b>."
    },
    modalHeaderContextDescription: {
        id: "automation-menu.modal.header.description",
        defaultMessage: "The available selections are controlled by Confluence and space administrators."
    }
});
const $3cdf698150a3fbb9$var$iconStyle = (0, $ecnYn.xcss)({
    marginRight: 'space.150',
    backgroundColor: 'color.background.accent.green.subtlest',
    borderRadius: 'border.radius'
});
const $3cdf698150a3fbb9$var$contextHintStyle = (0, $ecnYn.xcss)({
    marginTop: 'space.150'
});
const $3cdf698150a3fbb9$export$918c7c2e2d7f0bfd = ({ contentTitle: contentTitle, modalTitle: modalTitle })=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const { initialised: initialised, rules: rules } = (0, $1fOao.useAutomationMenu)();
    const { titleId: titleId } = (0, $804cB.useModal)();
    const showHint = initialised && rules.length > 0;
    const contextHint = formatMessage($3cdf698150a3fbb9$export$a7357cdd1f0b0168.modalHeaderContextHint, {
        contentTitle: contentTitle,
        b: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5dK2X.default), {
                weight: "bold"
            }, chunks)
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $9ot3w.default), {
        hasCloseButton: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1GzhS.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dcJ7R.default), {
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: $3cdf698150a3fbb9$var$iconStyle,
        paddingInline: "space.050",
        paddingBlock: "space.025"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $Ij2L0.ManualTriggerIcon), {
        size: "small",
        label: formatMessage($3cdf698150a3fbb9$export$a7357cdd1f0b0168.modalHeaderIconLabel),
        primaryColor: "var(--ds-icon-accent-green, #22A06B)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $7hXDW.default), {
        size: "medium",
        id: titleId
    }, modalTitle)), showHint && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: $3cdf698150a3fbb9$var$contextHintStyle
    }, contextHint, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", null, formatMessage($3cdf698150a3fbb9$export$a7357cdd1f0b0168.modalHeaderContextDescription)))));
};

});






parcelRegister("5PobO", function(module, exports) {

$parcel$export(module.exports, "AISmartButtonWrapper", () => $78fdc0b3db730c49$export$f7d346730580e70);

var $gwFzn = parcelRequire("gwFzn");

var $eCCQx = parcelRequire("eCCQx");

var $8ETUZ = parcelRequire("8ETUZ");

var $lzcvT = parcelRequire("lzcvT");

var $7mpOv = parcelRequire("7mpOv");

var $bQm3c = parcelRequire("bQm3c");

var $13dFh = parcelRequire("13dFh");
function $78fdc0b3db730c49$export$f7d346730580e70({ contentId: contentId, contentType: contentType, pageMode: pageMode }) {
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const { setSurfaceMetadata: setSurfaceMetadata } = (0, $8ETUZ.useSurfaceAIActions)();
    const { isAIEnabledForContent: isAIEnabledForContent, isRovoEnabledForContent: isRovoEnabledForContent } = (0, $7mpOv.useIsAIEnabledForContent)({
        contentId: contentId
    });
    const isEnabled = !(0, $lzcvT.isFedRamp)() && isAIEnabledForContent && isRovoEnabledForContent;
    (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).useEffect(()=>{
        setSurfaceMetadata({
            siteId: cloudId,
            product: 'confluence',
            contentType: contentType,
            pageMode: pageMode
        });
    }, [
        cloudId,
        setSurfaceMetadata,
        contentType,
        pageMode
    ]);
    const objectSidebar = (0, $13dFh.useCreateObjectSidebarProp)();
    if (!isEnabled) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $eCCQx.AISmartButton), {
        objectSidebar: objectSidebar
    });
}

});
parcelRegister("eCCQx", function(module, exports) {

$parcel$export(module.exports, "AISmartButton", () => $683d8974f1c85970$export$2b989c5e58d6ba9);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $inPa6 = parcelRequire("inPa6");

var $u9agA = parcelRequire("u9agA");

var $9QtOT = parcelRequire("9QtOT");
var $glqpS = parcelRequire("glqpS");

var $1uunn = parcelRequire("1uunn");

var $3DxCm = parcelRequire("3DxCm");

var $9j9JP = parcelRequire("9j9JP");

var $bFN4w = parcelRequire("bFN4w");
const $683d8974f1c85970$var$styles = {
    buttonWrapper: "_kqswh2mm"
};
const $683d8974f1c85970$export$2b989c5e58d6ba9 = ({ objectSidebar: objectSidebar })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const dynamicSurfacePanel = (0, $9j9JP.useDynamicSurfacePanel)(objectSidebar);
    const { setProfileData: setProfileData } = (0, $glqpS.useViewAIActions)();
    const surfaceMetadata = (0, $9QtOT.useAISurfaceMetadata)();
    const profileData = (0, $1uunn.useProfileController)();
    (0, $gwFzn.useEffect)(()=>{
        if (profileData) setProfileData(profileData);
    }, [
        profileData,
        setProfileData
    ]);
    const onAISmartButtonClick = (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).useCallback(()=>{
        const { isObjectSidebarShown: isObjectSidebarShown, panel: panel } = objectSidebar.state;
        const { hideObjectSidebar: hideObjectSidebar, showObjectSidebar: showObjectSidebar } = objectSidebar.actions;
        if (isObjectSidebarShown && panel?.id === dynamicSurfacePanel.id) hideObjectSidebar();
        else showObjectSidebar(dynamicSurfacePanel, 'push');
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: surfaceMetadata.contentType,
                action: 'clicked',
                actionSubject: 'rovoButton',
                actionSubjectId: 'aiRovoSmartButton',
                attributes: {
                    pageMode: surfaceMetadata.pageMode
                }
            }
        }).fire();
    }, [
        dynamicSurfacePanel,
        objectSidebar,
        createAnalyticsEvent,
        surfaceMetadata
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $u9agA.default), {
        space: "space.100",
        alignBlock: "center",
        xcss: $683d8974f1c85970$var$styles.buttonWrapper,
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $bFN4w.AIProactiveNudge), {}),
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $3DxCm.AIButton), {
                onClick: onAISmartButtonClick
            })
        ]
    });
};

});
parcelRegister("3DxCm", function(module, exports) {

$parcel$export(module.exports, "AIButton", () => $8ae48bddb3670e27$export$a51986b9c6d9ac89);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $lAFHW = parcelRequire("lAFHW");

var $fVUfS = parcelRequire("fVUfS");
const $8ae48bddb3670e27$var$atlaskitCssStyles = {
    pressableStyles: "_2rkob7nn _1e0c1txw _4cvr1h6o _1bah1h6o _kqswh2mm _4t3i1a70 _1bsb1a70 _bfhk18uv",
    boxStyles: "_2rkob7nn _p12f1a70 _kqswh2mm _pdyk1y4g _rfx3b7nn _1cs8stnw _1kt9b3bt _txdon80n _kfgt1a70 _1mp41a70 _1rus15mt _qc5os58n _14mj9duq _uoe3t94y _1rect94y _70xrt94y _1k96t94y _18postnw _3p6m17h5 _aetrb3bt _1bqq1mrw _z0ai1osq _1qdg1osq _15l21n1a _19do1n1a _1b1b120f _19si120f _1xqc1uwk"
};
const $8ae48bddb3670e27$export$a51986b9c6d9ac89 = ({ onClick: onClick })=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
        className: (0, $35pXk.default)([
            $8ae48bddb3670e27$var$atlaskitCssStyles.boxStyles
        ]),
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $fVUfS.default), {
            testId: "platform-ai-button",
            xcss: $8ae48bddb3670e27$var$atlaskitCssStyles.pressableStyles,
            onClick: onClick,
            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $lAFHW.RovoIcon), {
                size: "small",
                iconColor: "var(--ds-icon-inverse, #FFFFFF)"
            })
        })
    });
};

});

parcelRegister("bFN4w", function(module, exports) {

$parcel$export(module.exports, "AIProactiveNudge", () => $30abac664b6119e1$export$50a342ac0fc7ff57);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $inPa6 = parcelRequire("inPa6");

var $9QtOT = parcelRequire("9QtOT");
var $glqpS = parcelRequire("glqpS");

var $hbE6H = parcelRequire("hbE6H");
const $30abac664b6119e1$var$NUDGE_DISMISS_TIMEOUT = 30000;
const $30abac664b6119e1$var$ANIMATION_DURATION = 200;
const $30abac664b6119e1$export$50a342ac0fc7ff57 = ()=>{
    const { changeView: changeView } = (0, $glqpS.useViewAIActions)();
    const surfaceMetadata = (0, $9QtOT.useAISurfaceMetadata)();
    const [isNudgeVisible, setIsNudgeVisible] = (0, $gwFzn.useState)(false);
    const [dismissedIds, setDismissedIds] = (0, $gwFzn.useState)([]);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const selectedNudges = (0, $9QtOT.useAINudges)();
    const [acceptedIds, setAcceptedIds] = (0, $gwFzn.useState)([]);
    const [prevNudge, setPrevNudge] = (0, $gwFzn.useState)(null);
    const [isMouseHovering, setIsMouseHovering] = (0, $gwFzn.useState)(false);
    const activeNudge = (0, $gwFzn.useMemo)(()=>/**
   * Nudge must not be previously dismissed or accepted
   * to be considered active.
   */ selectedNudges.find((nudge)=>!dismissedIds.includes(nudge.id) && !acceptedIds.includes(nudge.id)), [
        selectedNudges,
        dismissedIds,
        acceptedIds
    ]);
    (0, $gwFzn.useEffect)(()=>{
        if (activeNudge !== prevNudge) {
            setPrevNudge(activeNudge);
            if (activeNudge && activeNudge?.id !== prevNudge?.id) {
                const nudgeId = `${activeNudge.title} - ${activeNudge.id}`;
                createAnalyticsEvent({
                    type: 'sendTrackEvent',
                    data: {
                        action: 'shown',
                        actionSubject: 'rovoButton',
                        actionSubjectId: 'aiRovoProactiveNudge',
                        source: surfaceMetadata.contentType,
                        attributes: {
                            pageMode: surfaceMetadata.pageMode,
                            id: activeNudge.id,
                            nudgeId: nudgeId
                        }
                    }
                }).fire();
                window.requestAnimationFrame(()=>{
                    /**
           * Needs to be set to visible in next tick, otherwise
           * it will not animate
           */ setIsNudgeVisible(true);
                });
            }
        }
    }, [
        activeNudge,
        prevNudge,
        createAnalyticsEvent,
        surfaceMetadata
    ]);
    const onDismissClick = (0, $gwFzn.useCallback)(()=>{
        if (activeNudge) {
            setDismissedIds((ids)=>{
                return [
                    ...ids,
                    activeNudge.id
                ];
            });
            const nudgeId = `${activeNudge.title} - ${activeNudge.id}`;
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    source: surfaceMetadata.contentType,
                    action: 'dismissed',
                    actionSubject: 'rovoButton',
                    actionSubjectId: 'aiRovoProactiveNudge',
                    attributes: {
                        pageMode: surfaceMetadata.pageMode,
                        id: activeNudge.id,
                        dismissedMethod: 'manual',
                        nudgeId: nudgeId
                    }
                }
            }).fire();
        }
    }, [
        activeNudge,
        createAnalyticsEvent,
        surfaceMetadata
    ]);
    const onNudgeClick = (0, $gwFzn.useCallback)(()=>{
        if (activeNudge) {
            const nudgeId = `${activeNudge.title} - ${activeNudge.id}`;
            if (activeNudge.viewConfig) changeView(activeNudge);
            activeNudge.onClick?.();
            setAcceptedIds((ids)=>{
                return [
                    ...ids,
                    activeNudge.id
                ];
            });
            setDismissedIds((ids)=>{
                return [
                    ...ids,
                    activeNudge.id
                ];
            });
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    source: surfaceMetadata.contentType,
                    action: 'clicked',
                    actionSubject: 'rovoButton',
                    actionSubjectId: 'aiRovoProactiveNudge',
                    attributes: {
                        pageMode: surfaceMetadata.pageMode,
                        id: activeNudge.id,
                        nudgeId: nudgeId
                    }
                }
            }).fire();
        }
    }, [
        activeNudge,
        changeView,
        createAnalyticsEvent,
        surfaceMetadata
    ]);
    const onWrapperMouseEnter = (0, $gwFzn.useCallback)(()=>{
        setIsMouseHovering(true);
    }, []);
    const onWrapperMouseLeave = (0, $gwFzn.useCallback)(()=>{
        setIsMouseHovering(false);
    }, []);
    (0, $gwFzn.useEffect)(()=>{
        let timeoutId;
        let slideoutTimeoutId;
        if (activeNudge && !isMouseHovering) {
            timeoutId = setTimeout(()=>{
                setDismissedIds((ids)=>[
                        ...ids,
                        activeNudge.id
                    ]);
                createAnalyticsEvent({
                    type: 'sendUIEvent',
                    data: {
                        source: surfaceMetadata.contentType,
                        action: 'dismissed',
                        actionSubject: 'rovoButton',
                        actionSubjectId: 'aiRovoProactiveNudge',
                        attributes: {
                            pageMode: surfaceMetadata.pageMode,
                            id: activeNudge.id,
                            timerDuration: $30abac664b6119e1$var$NUDGE_DISMISS_TIMEOUT,
                            dismissedMethod: 'timer_expired'
                        }
                    }
                }).fire();
            }, $30abac664b6119e1$var$NUDGE_DISMISS_TIMEOUT);
            slideoutTimeoutId = setTimeout(()=>{
                setIsNudgeVisible(false);
            }, $30abac664b6119e1$var$NUDGE_DISMISS_TIMEOUT - $30abac664b6119e1$var$ANIMATION_DURATION);
        }
        /**
     * On mouse enter, isMouseHovering is set to true, will trigger
     *  cleanup function to clear timeout.
     */ return ()=>{
            if (timeoutId) clearTimeout(timeoutId);
            if (slideoutTimeoutId) clearTimeout(slideoutTimeoutId);
        };
    }, [
        activeNudge,
        createAnalyticsEvent,
        isMouseHovering,
        surfaceMetadata.contentType,
        surfaceMetadata.pageMode
    ]);
    if (!activeNudge) return null;
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $hbE6H.NudgeContent), {
        activeNudge: activeNudge,
        isNudgeVisible: isNudgeVisible,
        onWrapperMouseEnter: onWrapperMouseEnter,
        onWrapperMouseLeave: onWrapperMouseLeave,
        onNudgeClick: onNudgeClick,
        onDismissClick: onDismissClick
    });
};

});
parcelRegister("hbE6H", function(module, exports) {

$parcel$export(module.exports, "NudgeContent", () => $22dbc203b8994948$export$9b98f181754d0f50);
/* NudgeContent.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $ccHMk = parcelRequire("ccHMk");
var $1qfLF = parcelRequire("1qfLF");

var $5H7UU = parcelRequire("5H7UU");

var $gdv5Z = parcelRequire("gdv5Z");
var $u9agA = parcelRequire("u9agA");
const $22dbc203b8994948$export$a7357cdd1f0b0168 = (0, $2nPZH.defineMessages)({
    aiProactiveNudgeDismiss: {
        id: "ai-smart-button.ai-proactive-nudge.dismiss",
        defaultMessage: "Dismiss"
    }
});
const $22dbc203b8994948$var$ANIMATION_DURATION = 200;
const $22dbc203b8994948$var$styles = {
    wrapperStyles: "_2rkopd34 _v5644nwb _kqswstnw _1ltvidpf _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66 _1e0c1o8l _16qs1cd0 _bfhkhp5a _ta6yglyw",
    invisibleNudge: "_tzy4idpf _t9ecjq3t",
    visibleNudge: "_t9eci6v2 _tzy4kb7n"
};
const $22dbc203b8994948$export$9b98f181754d0f50 = /*#__PURE__*/ (0, $gwFzn.memo)(({ activeNudge: activeNudge, isNudgeVisible: isNudgeVisible, onWrapperMouseEnter: onWrapperMouseEnter, onWrapperMouseLeave: onWrapperMouseLeave, onNudgeClick: onNudgeClick, onDismissClick: onDismissClick })=>{
    const intl = (0, $dBxQj.default)();
    return /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
        "data-testid": "platform-ai-proactive-nudge",
        onMouseEnter: onWrapperMouseEnter,
        onMouseLeave: onWrapperMouseLeave,
        className: (0, $35pXk.default)([
            $22dbc203b8994948$var$styles.wrapperStyles,
            isNudgeVisible ? $22dbc203b8994948$var$styles.visibleNudge : $22dbc203b8994948$var$styles.invisibleNudge
        ]),
        children: /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $u9agA.default), {
            grow: "fill",
            space: "space.025",
            children: [
                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gdv5Z.default), {
                    children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $ccHMk.default), {
                        iconBefore: ()=>activeNudge.icon,
                        appearance: "subtle",
                        onClick: onNudgeClick,
                        children: activeNudge.title
                    })
                }),
                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $1qfLF.default), {
                    testId: "platform-ai-proactive-nudge-dismiss",
                    appearance: "subtle",
                    label: intl.formatMessage($22dbc203b8994948$export$a7357cdd1f0b0168.aiProactiveNudgeDismiss),
                    isTooltipDisabled: false,
                    tooltip: {
                        position: 'top'
                    },
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($5H7UU))),
                    onClick: onDismissClick
                })
            ]
        })
    });
});

});






//# sourceMappingURL=cardWithMediaClient.a99853e1.js.map
